const AllQuestions = [
  {
    "_id": { "$oid": "mathmocktestquestion01" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM01",
    "question": "প্রথম $10$ টি স্বাভাবিক সংখ্যার যোগফল নির্ণয়ের জন্য $\\frac{n(n+1)}{2}$ সূত্র প্রয়োগ করলে মান কত হবে?",
    "option1": "45",
    "option2": "55",
    "option3": "50",
    "option4": "60",
    "answer": "option2",
    "solution": "সূত্র: $\\frac{n(n + 1)}{2} = \\frac{10 \\times (10 + 1)}{2} = \\frac{110}{2} = 55$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion02" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM01",
    "question": "সবচেয়ে ছোট ধনাত্মক মৌলিক সংখ্যা $p$ হলে, $p^3$ -এর মান কত?",
    "option1": "0",
    "option2": "1",
    "option3": "8",
    "option4": "27",
    "answer": "option3",
    "solution": "সবচেয়ে ছোট মৌলিক সংখ্যা $p = 2$। সুতরাং $p^3 = 2^3 = 8$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion03" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM01",
    "question": "যদি $x = √49 $ হয়, তবে $x$ সম্পর্কিত নিচের কোনটি সঠিক?",
    "option1": "$x$ একটি অমূলদ সংখ্যা",
    "option2": "$x$ একটি মৌলিক সংখ্যা",
    "option3": "$x$ একটি যৌগিক সংখ্যা",
    "option4": "$x$ কোনো বাস্তব সংখ্যা নয়",
    "answer": "option2",
    "solution": "$x = √49 = 7$, যা একটি মৌলিক সংখ্যা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion04" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM01",
    "question": "যদি কোনো ভগ্নাংশ $\\frac{a}{b}$ হয় এবং $a+b=15$ ও $b-a=3$ হয়, তবে ভগ্নাংশটি কত?",
    "option1": "$\\frac{6}{9}$",
    "option2": "$\\frac{9}{6}$",
    "option3": "$\\frac{5}{10}$",
    "option4": "$\\frac{7}{8}$",
    "answer": "option1",
    "solution": "সমীকরণ দুটি সমাধান করে পাই $a = 6$ এবং $b = 9$। সুতরাং ভগ্নাংশটি $\\frac{6}{9}$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion05" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM01",
    "question": "প্রথম ৫টি বিজোড় স্বাভাবিক সংখ্যার গড় $\\bar{x}$ হলে, $\\bar{x}^2$-এর মান কত?",
    "option1": "15",
    "option2": "20",
    "option3": "25",
    "option4": "30",
    "answer": "option3",
    "solution": "প্রথম $n$-টি বিজোড় সংখ্যার গড় $n$। এখানে $n = 5$, তাই গড় $\\bar{x} = 5$। অতএব $\\bar{x}^2 = 5^2 = 25$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion06" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM01",
    "question": "চার অঙ্কের বৃহত্তম সংখ্যা $A$ এবং তিন অঙ্কের ক্ষুদ্রতম সংখ্যা $B$ হলে, $A - B$-এর মান কত?",
    "option1": "9899",
    "option2": "989",
    "option3": "9900",
    "option4": "9801",
    "answer": "option1",
    "solution": "$A = 9999$ এবং $B = 100$। সুতরাং $A - B = 9999 - 100 = 9899$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion07" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM01",
    "question": "যদি $\\text{ভাজ্য} = (\\text{ভাজক} \\times \\text{ভাগফল}) + \\text{ভাগশেষ}$ হয়, যেখানে ভাজক $= 75$, ভাগফল $= 16$ এবং ভাগশেষ $= 27$, তবে ভাজ্য কত?",
    "option1": "1227",
    "option2": "1200",
    "option3": "1257",
    "option4": "1247",
    "answer": "option1",
    "solution": "$\\text{ভাজ্য} = (75 \\times 16) + 27 = 1200 + 27 = 1227$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion08" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM01",
    "question": "একটি সংখ্যা $N$-কে $893$ দ্বারা ভাগ করলে ভাগশেষ থাকে $196$। $N$-কে $47$ দ্বারা ভাগ করলে ভাগশেষ $r$ কত হবে?",
    "option1": "3",
    "option2": "4",
    "option3": "5",
    "option4": "8",
    "answer": "option4",
    "solution": "যেহেতু $893 = 47 \\times 19$, তাই $r = 196 \\pmod{47}$। $196 = (47 \\times 4) + 8$, সুতরাং ভাগশেষ $r = 8$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion09" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM01",
    "question": "দুটি পরস্পর মৌলিক সংখ্যা $a$ ও $b$-এর গ.সা.গু. $g$ এবং ল.সা.গু. $l$ হলে, $\\frac{l}{g}$-এর মান কত?",
    "option1": "1",
    "option2": "$a + b$",
    "option3": "$a \\times b$",
    "option4": "$a - b$",
    "answer": "option3",
    "solution": "পরস্পর মৌলিক সংখ্যার ক্ষেত্রে $g = 1$ এবং $l = a \\times b$। সুতরাং $\\frac{l}{g} = \\frac{a \\times b}{1} = a \\times b$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion10" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM01",
    "question": "$10584^2$-এর এককের ঘরের অঙ্কটি (Unit digit) কত?",
    "option1": "2",
    "option2": "4",
    "option3": "6",
    "option4": "8",
    "answer": "option3",
    "solution": "এককের ঘরের অঙ্কটি নির্ণয়ের জন্য $4^2 = 16$ বিবেচনা করি। সুতরাং এককের অঙ্ক হবে $6$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion11" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM01",
    "question": "প্রথম $n$ টি জোড় স্বাভাবিক সংখ্যার যোগফল $n(n+1)$ হলে, প্রথম $5$ টি জোড় সংখ্যার যোগফল কত?",
    "option1": "20",
    "option2": "25",
    "option3": "30",
    "option4": "35",
    "answer": "option3",
    "solution": "$n = 5$ হলে যোগফল $= 5(5 + 1) = 5 \\times 6 = 30$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion12" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM01",
    "question": "যদি $x = 91$ হয়, তবে $x$-এর উৎপাদক বিশ্লেষণ নিচের কোনটি?",
    "option1": "$x = 13 \\times 7$",
    "option2": "$x$ একটি মৌলিক সংখ্যা",
    "option3": "$x = 9 \\times 10 + 1$",
    "option4": "$x = 3 \\times 30$",
    "answer": "option1",
    "solution": "$91 = 13 \\times 7$, তাই এটি একটি যৌগিক সংখ্যা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion13" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM01",
    "question": "$343845$ সংখ্যাটিতে $3$-এর সর্বোচ্চ স্থানীয় মান (Place Value) $V_p$ এবং প্রকৃত মান (Face Value) $V_f$ হলে, $V_p - V_f$-এর মান কত?",
    "option1": "299997",
    "option2": "300000",
    "option3": "29997",
    "option4": "0",
    "answer": "option1",
    "solution": "$V_p = 300000$ এবং $V_f = 3$। অতএব $V_p - V_f = 300000 - 3 = 299997$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion14" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM01",
    "question": "রাশিটি $7^{105}$-এর এককের ঘরের অঙ্কটি (Unit Digit) কত?",
    "option1": "1",
    "option2": "3",
    "option3": "7",
    "option4": "9",
    "answer": "option3",
    "solution": "$7^n$-এর এককের অঙ্কের চক্রকাল $4$ (পাওয়ারগুলো: $7, 9, 3, 1$)। $105 \\div 4$-এর ভাগশেষ $1$। সুতরাং $7^1 = 7$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion15" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM01",
    "question": "দুটি পরপর ধনাত্মক পূর্ণসংখ্যা $x$ ও $(x+1)$-এর বর্গের পার্থক্য $(x+1)^2 - x^2 = 37$ হলে, $x$-এর মান কত?",
    "option1": "18",
    "option2": "19",
    "option3": "17",
    "option4": "20",
    "answer": "option1",
    "solution": "$(x+1)^2 - x^2 = 2x + 1 = 37 \\implies 2x = 36 \\implies x = 18$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion16" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM01",
    "question": "যদি $S = \\{x \\in \\mathbb{N} \\mid 1 \\le x \\le 100\\}$ হয়, তবে $S$-এর সংখ্যাগুলিতে মোট কতটি '0' বিদ্যমান?",
    "option1": "9",
    "option2": "10",
    "option3": "11",
    "option4": "12",
    "answer": "option3",
    "solution": "$10, 20, \\dots, 90$-এ ৯টি এবং $100$-এ ২টি, মোট $9 + 2 = 11$ টি শূন্য রয়েছে।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion17" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM01",
    "question": "কোনো সংখ্যা $N$ যদি $11$ দ্বারা বিভাজ্য হয়, তবে তার বিজোড় ও জোড় অবস্থানের অঙ্কের যোগফলের পার্থক্য $D$ সম্পর্কিত কোনটি সত্য?",
    "option1": "$D = 0$ বা $11$-এর গুণিতক",
    "option2": "$D$ সর্বদা একটি মৌলিক সংখ্যা",
    "option3": "$D < 0$",
    "option4": "$D = 5$",
    "answer": "option1",
    "solution": "$11$ দ্বারা বিভাজ্যতার শর্ত অনুযায়ী, একান্তর স্থানগুলির যোগফলের বিয়োগফল $0$ বা $11$-এর গুণিতক হবে।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion18" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM01",
    "question": "প্রথম ৩টি মৌলিক সংখ্যা $p_1, p_2, p_3$ হলে, তাদের গড় $\\frac{p_1 + p_2 + p_3}{3}$-এর মান কত?",
    "option1": "3",
    "option2": "3.33",
    "option3": "4",
    "option4": "5",
    "answer": "option2",
    "solution": "প্রথম ৩টি মৌলিক সংখ্যা হলো $2, 3, 5$। গড় = $\\frac{2 + 3 + 5}{3} = \\frac{10}{3} \\approx 3.33$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion19" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM01",
    "question": "তিনটি পরপর স্বাভাবিক সংখ্যা $(x-1), x, (x+1)$-এর যোগফল $87$ হলে, $x$-এর মান কত?",
    "option1": "28",
    "option2": "29",
    "option3": "30",
    "option4": "31",
    "answer": "option2",
    "solution": "$(x-1) + x + (x+1) = 87 \\implies 3x = 87 \\implies x = 29$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion20" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM01",
    "question": "নিচের কোনটি একটি মূলদ সংখ্যা (Rational Number), যেখানে সংখ্যাটি  $√k$ আকারে প্রকাশ করা হয়েছে?",
    "option1": "$√2$",
    "option2": "$√3$",
    "option3": "$√4$",
    "option4": "$\\pi$",
    "answer": "option3",
    "solution": "$√4 = 2 = \\frac{2}{1}$, যা $\\frac{p}{q}$ আকারের একটি মূলদ সংখ্যা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion21" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM02",
    "question": "$\\frac{3}{5}$-কে শতাংশে প্রকাশ করলে মান কত হবে?",
    "option1": "$40\\%$",
    "option2": "$50\\%$",
    "option3": "$60\\%$",
    "option4": "$75\\%$",
    "answer": "option3",
    "solution": "$\\frac{3}{5} \\times 100\\% = 60\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion22" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM02",
    "question": "কোনো সংখ্যার $20\\%$ যদি $80$ হয়, তবে সংখ্যাটি কত?",
    "option1": "$300$",
    "option2": "$360$",
    "option3": "$400$",
    "option4": "$500$",
    "answer": "option3",
    "solution": "ধরি, সংখ্যাটি $x$। $x \\times \\frac{20}{100} = 80 \\implies x = \\frac{80 \\times 100}{20} = 400$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion23" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM02",
    "question": "যদি $A$-এর আয় $B$-এর আয়ের চেয়ে $25\\%$ বেশি হয়, তবে $B$-এর আয় $A$-এর আয়ের চেয়ে শতকরা কত কম?",
    "option1": "$15\\%$",
    "option2": "$20\\%$",
    "option3": "$25\\%$",
    "option4": "$30\\%$",
    "answer": "option2",
    "solution": "সূত্র: $\\left(\\frac{r}{100 + r} \\times 100\\right)\\% = \\left(\\frac{25}{125} \\times 100\\right)\\% = 20\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion24" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM02",
    "question": "একটি দ্রব্যের মূল্য প্রথমে $10\\%$ বৃদ্ধি পেয়ে পরে $10\\%$ হ্রাস পেলে, মূল্যের নিট পরিবর্তন শতকরা কত হবে?",
    "option1": "কোনো পরিবর্তন হবে না",
    "option2": "$1\\%$ বৃদ্ধি",
    "option3": "$1\\%$ হ্রাস",
    "option4": "$2\\%$ হ্রাস",
    "answer": "option3",
    "solution": "সূত্র: $a + b + \\frac{ab}{100} = 10 - 10 + \\frac{10 \\times (-10)}{100} = -1\\%$ (অর্থাৎ $1\\%$ হ্রাস)।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion25" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM02",
    "question": "$250$-এর $15\\%$ + $340$-এর $20\\%$-এর মান কত?",
    "option1": "$102.5$",
    "option2": "$104.5$",
    "option3": "$105.5$",
    "option4": "$107.5$",
    "answer": "option3",
    "solution": "$\\left(250 \\times \\frac{15}{100}\\right) + \\left(340 \\times \\frac{20}{100}\\right) = 37.5 + 68 = 105.5$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion26" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM02",
    "question": "একটি পরীক্ষায় উত্তীর্ণ হওয়ার জন্য $40\\%$ নম্বর প্রয়োজন। এক ছাত্র $175$ নম্বর পেয়ে $25$ নম্বরের জন্য অনুত্তীর্ণ হলো। পরীক্ষার মোট নম্বর কত?",
    "option1": "$400$",
    "option2": "$450$",
    "option3": "$500$",
    "option4": "$600$",
    "answer": "option3",
    "solution": "পাস নম্বর $= 175 + 25 = 200$। মোট নম্বর $X$ হলে, $X \\times 40\\% = 200 \\implies X = \\frac{200 \\times 100}{40} = 500$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion27" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM02",
    "question": "চিনির মূল্য $20\\%$ বৃদ্ধি পাওয়ায় এক পরিবারকে চিনির ব্যবহার শতকরা কত কমাতে হবে যাতে খরচ অপরিবর্তিত থাকে?",
    "option1": "$16\\frac{2}{3}\\%$",
    "option2": "$20\\%$",
    "option3": "$25\\%$",
    "option4": "$15\\%$",
    "answer": "option1",
    "solution": "সূত্র: $\\left(\\frac{r}{100 + r} \\times 100\\right)\\% = \\left(\\frac{20}{120} \\times 100\\right)\\% = \\frac{50}{3}\\% = 16\\frac{2}{3}\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion28" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM02",
    "question": "একটি শহরের বর্তমান জনসংখ্যা $10,000$। বার্ষিক বৃদ্ধির হার $10\\%$ হলে, $2$ বছর পর শহরের জনসংখ্যা কত হবে?",
    "option1": "$12,000$",
    "option2": "$12,100$",
    "option3": "$12,200$",
    "option4": "$12,500$",
    "answer": "option2",
    "solution": "জনসংখ্যা $= 10000 \\times \\left(1 + \\frac{10}{100}\\right)^2 = 10000 \\times \\frac{11}{10} \\times \\frac{11}{10} = 12,100$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion29" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM02",
    "question": "যদি $x$-এর $8\\%$, $y$-এর $4\\%$-এর সমান হয়, তবে $x$-এর $20\\%$ হবে $y$-এর—",
    "option1": "$8\\%$",
    "option2": "$10\\%$",
    "option3": "$12\\%$",
    "option4": "$16\\%$",
    "answer": "option2",
    "solution": "$8\\% \\times x = 4\\% \\times y \\implies x = 0.5y$। সুতরাং $20\\% \\times x = 20\\% \\times (0.5y) = 10\\% \\times y$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion30" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM02",
    "question": "কোনো সংখ্যার $35\\%$ হলো $105$। ওই সংখ্যার $50\\%$ কত হবে?",
    "option1": "$130$",
    "option2": "$140$",
    "option3": "$150$",
    "option4": "$160$",
    "answer": "option3",
    "solution": "সংখ্যাটি $= \\frac{105}{35} \\times 100 = 300$। সংখ্যার $50\\% = 300 \\times 50\\% = 150$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion31" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM02",
    "question": "একটি আয়তক্ষেত্রের দৈর্ঘ্য $20\\%$ বৃদ্ধি এবং প্রস্থ $10\\%$ হ্রাস করা হলে, তার ক্ষেত্রফলের শতকরা পরিবর্তন কত হবে?",
    "option1": "$8\\%$ বৃদ্ধি",
    "option2": "$10\\%$ বৃদ্ধি",
    "option3": "$8\\%$ হ্রাস",
    "option4": "$10\\%$ হ্রাস",
    "answer": "option1",
    "solution": "পরিবর্তন $= 20 - 10 + \\frac{20 \\times (-10)}{100} = 10 - 2 = +8\\%$ (অর্থাৎ $8\\%$ বৃদ্ধি)।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion32" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM02",
    "question": "একটি শ্রেণীতে $60\\%$ ছাত্র এবং বাকিরা ছাত্রী। যদি মোট শিক্ষার্থী ৫০ জন হয়, তবে ছাত্রীর সংখ্যা কত?",
    "option1": "$15$",
    "option2": "$20$",
    "option3": "$25$",
    "option4": "$30$",
    "answer": "option2",
    "solution": "ছাত্রী সংখ্যা $= (100\\% - 60\\%) = 40\\%$। মোট ছাত্রী $= 50 \\times 40\\% = 20$ জন।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion33" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM02",
    "question": "$0.05$-কে শতকরায় রূপান্তর করলে মান কত হবে?",
    "option1": "$0.5\\%$",
    "option2": "$5\\%$",
    "option3": "$50\\%$",
    "option4": "$500\\%$",
    "answer": "option2",
    "solution": "$0.05 \\times 100\\% = 5\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion34" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM02",
    "question": "এক ব্যক্তির বেতন $20\\%$ হ্রাস করা হলো। তার নতুন বেতন শতকরা কত বাড়ালে পূর্বের বেতনের সমান হবে?",
    "option1": "$20\\%$",
    "option2": "$22\\%$",
    "option3": "$25\\%$",
    "option4": "$30\\%$",
    "answer": "option3",
    "solution": "সূত্র: $\\left(\\frac{r}{100 - r} \\times 100\\right)\\% = \\left(\\frac{20}{80} \\times 100\\right)\\% = 25\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion35" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM02",
    "question": "$1$ ঘণ্টার কত শতাংশ হলো $1$ মিনিট $12$ সেকেন্ড?",
    "option1": "$1.2\\%$",
    "option2": "$1.5\\%$",
    "option3": "$2\\%$",
    "option4": "$2.5\\%$",
    "answer": "option3",
    "solution": "$1$ ঘণ্টা $= 3600$ সেকেন্ড। $1$ মিনিট $12$ সেকেন্ড $= 72$ সেকেন্ড। শতাংশ $= \\frac{72}{3600} \\times 100\\% = 2\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion36" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM02",
    "question": "একটি পরীক্ষায় $70\\%$ পরীক্ষার্থী ইংরেজিতে এবং $80\\%$ গণিতে পাস করল। $10\\%$ উভয় বিষয়ে ফেল করল। উভয় বিষয়ে কত শতাংশ পাস করল?",
    "option1": "$50\\%$",
    "option2": "$55\\%$",
    "option3": "$60\\%$",
    "option4": "$65\\%$",
    "answer": "option3",
    "solution": "কমপক্ষে ১টি বিষয়ে পাস করেছে $= 100\\% - 10\\% = 90\\%$। উভয় বিষয়ে পাস $= (70\\% + 80\\%) - 90\\% = 60\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion37" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM02",
    "question": "যদি কোনো বর্গক্ষেত্রের প্রতিটি বাহুর দৈর্ঘ্য $10\\%$ বৃদ্ধি করা হয়, তবে তার ক্ষেত্রফল শতকরা কত বৃদ্ধি পাবে?",
    "option1": "$19\\%$",
    "option2": "$20\\%$",
    "option3": "$21\\%$",
    "option4": "$22\\%$",
    "answer": "option3",
    "solution": "ক্ষেত্রফল বৃদ্ধি $= 10 + 10 + \\frac{10 \\times 10}{100} = 21\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion38" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM02",
    "question": "একটি পেনের দাম $10\\%$ কমানোয় $90$ টাকায় পূর্বাপেক্ষা ১টি পেন বেশি পাওয়া যায়। কমানোর পর পেনের বর্তমান মূল্য কত?",
    "option1": "$8$ টাকা",
    "option2": "$9$ টাকা",
    "option3": "$10$ টাকা",
    "option4": "$12$ টাকা",
    "answer": "option2",
    "solution": "$90$ টাকার $10\\% = 9$ টাকা। এই $9$ টাকাতেই ১টি পেন অতিরিক্ত পাওয়া যায়, তাই পেনের বর্তমান মূল্য $9$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion39" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM02",
    "question": "একটি সংমিশ্রণে $30\\%$ তামা, $40\\%$ দস্তা এবং বাকিটা নিকেল। ২০ কেজি সংমিশ্রণে নিকেলের পরিমাণ কত?",
    "option1": "$4$ কেজি",
    "option2": "$5$ কেজি",
    "option3": "$6$ কেজি",
    "option4": "$8$ কেজি",
    "answer": "option3",
    "solution": "নিকেলের শতাংশ $= 100\\% - (30\\% + 40\\%) = 30\\%$। নিকেলের পরিমাণ $= 20 \\times 30\\% = 6$ কেজি।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion40" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM02",
    "question": "যদি $A$-এর $120\\%$, $B$-এর $80\\%$-এর সমান হয়, তবে $\\frac{B+A}{B-A}$-এর মান কত?",
    "option1": "$3$",
    "option2": "$4$",
    "option3": "$5$",
    "option4": "$6$",
    "answer": "option3",
    "solution": "$120\\% A = 80\\% B \\implies \\frac{A}{B} = \\frac{80}{120} = \\frac{2}{3}$। এখন $\\frac{B+A}{B-A} = \\frac{3+2}{3-2} = 5$।"
  },
{
    "_id": { "$oid": "mathmocktestquestion41" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM03",
    "question": "একটি বই $200$ টাকায় কিনে $250$ টাকায় বিক্রয় করলে শতকরা লাভের পরিমাণ কত?",
    "option1": "$20\\%$",
    "option2": "$22.5\\%$",
    "option3": "$25\\%$",
    "option4": "$30\\%$",
    "answer": "option3",
    "solution": "লাভ $= 250 - 200 = 50$ টাকা। শতকরা লাভ $= \\left(\\frac{50}{200} \\times 100\\right)\\% = 25\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion42" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM03",
    "question": "একটি সাইকেল $1,800$ টাকায় বিক্রি করায় $10\\%$ ক্ষতি হয়। সাইকেলটির ক্রয়মূল্য কত ছিল?",
    "option1": "$1,900$ টাকা",
    "option2": "$1,950$ টাকা",
    "option3": "$2,000$ টাকা",
    "option4": "$2,200$ টাকা",
    "answer": "option3",
    "solution": "ক্রয়মূল্য $= \\frac{1800 \\times 100}{100 - 10} = \\frac{1800 \\times 100}{90} = 2,000$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion43" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM03",
    "question": "$10$ টি পেনের ক্রয়মূল্য $8$ টি পেনের বিক্রয়মূল্যের সমান হলে, শতকরা কত লাভ বা ক্ষতি হবে?",
    "option1": "$20\\%$ ক্ষতি",
    "option2": "$20\\%$ লাভ",
    "option3": "$25\\%$ লাভ",
    "option4": "$25\\%$ ক্ষতি",
    "answer": "option3",
    "solution": "ধরি, ১টি পেনের ক্রয়মূল্য $1$ টাকা। ৮টির বিক্রয়মূল্য $= 10$ টাকা। ৮টির ক্রয়মূল্য $= 8$ টাকা। লাভ $= 2$ টাকা। শতকরা লাভ $= \\left(\\frac{2}{8} \\times 100\\right)\\% = 25\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion44" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM03",
    "question": "একটি দ্রব্যের চিহ্নিত মূল্য (Marked Price) $500$ টাকা। $20\\%$ ছাড় দিলে দ্রব্যটির বিক্রয়মূল্য কত হবে?",
    "option1": "$350$ টাকা",
    "option2": "$380$ টাকা",
    "option3": "$400$ টাকা",
    "option4": "$450$ টাকা",
    "answer": "option3",
    "solution": "বিক্রয়মূল্য $= 500 \\times \\frac{100 - 20}{100} = 500 \\times \\frac{80}{100} = 400$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion45" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM03",
    "question": "পরপর $20\\%$ এবং $10\\%$ ছাড়ের সমতুল্য একক ছাড় (Equivalet Discount) কত?",
    "option1": "$25\\%$",
    "option2": "$27\\%$",
    "option3": "$28\\%$",
    "option4": "$30\\%$",
    "answer": "option3",
    "solution": "সমতুল্য ছাড় $= d_1 + d_2 - \\frac{d_1 \\times d_2}{100} = 20 + 10 - \\frac{20 \\times 10}{100} = 30 - 2 = 28\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion46" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM03",
    "question": "এক অসাধু ব্যবসায়ী ক্র মূল্যে পণ্য বিক্রি করার দাবি করে, কিন্তু $1$ কেজির পরিবর্তে $900$ গ্রাম ওজন দেয়। তার শতকরা লাভের পরিমাণ কত?",
    "option1": "$10\\%$",
    "option2": "$11\\%$",
    "option3": "$11\\frac{1}{9}\\%$",
    "option4": "$12\\frac{1}{2}\\%$",
    "answer": "option3",
    "solution": "শতকরা লাভ $= \\left(\\frac{\\text{ত্রুটি}}{\\text{প্রকৃত ওজন} - \\text{ত্রুটি}} \\times 100\\right)\\% = \\left(\\frac{100}{900} \\times 100\\right)\\% = 11\\frac{1}{9}\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion47" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM03",
    "question": "এক ব্যক্তি একটি ঘড়ি $10\\%$ ক্ষতিতে বিক্রি করলেন। বিক্রয়মূল্য $45$ টাকা বেশি হলে তার $5\\%$ লাভ হতো। ঘড়িটির ক্রয়মূল্য কত?",
    "option1": "$250$ টাকা",
    "option2": "$280$ টাকা",
    "option3": "$300$ টাকা",
    "option4": "$350$ টাকা",
    "answer": "option3",
    "solution": "শতাংশের পার্থক্য $= 5\\% - (-10\\%) = 15\\%$। ক্রয়মূল্য $= \\frac{45}{15} \\times 100 = 300$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion48" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM03",
    "question": "একটি ঘড়ি $570$ টাকায় বিক্রি করলে $5\\%$ ক্ষতি হয়। $5\\%$ লাভ করতে হলে ঘড়িটি কত টাকায় বিক্রি করতে হবে?",
    "option1": "$600$ টাকা",
    "option2": "$620$ টাকা",
    "option3": "$630$ টাকা",
    "option4": "$650$ টাকা",
    "answer": "option3",
    "solution": "নতুন বিক্রয়মূল্য $= \\frac{570}{100 - 5} \\times (100 + 5) = \\frac{570}{95} \\times 105 = 6 \\times 105 = 630$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion49" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM03",
    "question": "একটি সামগ্রীর ক্রয়মূল্য $400$ টাকা। এটি কত টাকায় বিক্রি করলে $15\\%$ লাভ হবে?",
    "option1": "$440$ টাকা",
    "option2": "$450$ টাকা",
    "option3": "$460$ টাকা",
    "option4": "$480$ টাকা",
    "answer": "option3",
    "solution": "বিক্রয়মূল্য $= 400 \\times \\frac{115}{100} = 460$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion50" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM03",
    "question": "একটি শার্টের ধার্যমূল্য (Marked Price) কত নির্ধারণ করতে হবে, যাতে $10\\%$ ছাড় দেওয়ার পরেও $20\\%$ লাভ থাকে? (ক্রয়মূল্য $= 300$ টাকা)",
    "option1": "$360$ টাকা",
    "option2": "$380$ টাকা",
    "option3": "$400$ টাকা",
    "option4": "$420$ টাকা",
    "answer": "option3",
    "solution": "ধার্যমূল্য $= \\text{ক্রয়মূল্য} \\times \\frac{100 + \\text{লাভ\\%}}{100 - \\text{ছাড়\\%}} = 300 \\times \\frac{120}{90} = 400$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion51" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM03",
    "question": "দুটি একই দামের মোবাইল বিক্রি করে একটিতে $10\\%$ লাভ এবং অন্যটিতে $10\\%$ ক্ষতি হলো। সামগ্রিকভাবে শতকরা কত লাভ বা ক্ষতি হলো?",
    "option1": "কোনো লাভ বা ক্ষতি হয়নি",
    "option2": "$0.5\\%$ ক্ষতি",
    "option3": "$1\\%$ ক্ষতি",
    "option4": "$1\\%$ লাভ",
    "answer": "option3",
    "solution": "সমান বিক্রয়মূল্যে একই শতাংশ লাভ ও ক্ষতি হলে সর্বদা ক্ষতি হয় $= \\frac{x^2}{100}\\% = \\frac{10^2}{100}\\% = 1\\%$ ক্ষতি।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion52" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM03",
    "question": "একটি দ্রব্য $10\\%$ ক্ষতিতে বিক্রি করা হলো। ক্রয়মূল্য ও বিক্রয়মূল্যের অনুপাত কত?",
    "option1": "$9 : 10$",
    "option2": "$10 : 9$",
    "option3": "$10 : 11$",
    "option4": "$11 : 10$",
    "answer": "option2",
    "solution": "ধরি ক্রয়মূল্য $= 100$ টাকা, বিক্রয়মূল্য $= 90$ টাকা। অনুপাত $= 100 : 90 = 10 : 9$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion53" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM03",
    "question": "এক ব্যবসায়ী কোনো দ্রব্যের ওপর $15\\%$ ছাড় দেন। যদি দ্রব্যটির বিক্রয়মূল্য $680$ টাকা হয়, তবে ধার্যমূল্য কত ছিল?",
    "option1": "$750$ টাকা",
    "option2": "$780$ টাকা",
    "option3": "$800$ টাকা",
    "option4": "$850$ টাকা",
    "answer": "option3",
    "solution": "ধার্যমূল্য $= \\frac{680 \\times 100}{100 - 15} = \\frac{680 \\times 100}{85} = 800$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion54" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM03",
    "question": "এক ব্যক্তি একটি টেবিল $12\\%$ ক্ষতিতে বিক্রি করেন। যদি তিনি টেবিলটি $48$ টাকা বেশি দামে বিক্রি করতেন, তবে তার $4\\%$ লাভ হতো। টেবিলটির ক্রয়মূল্য কত?",
    "option1": "$250$ টাকা",
    "option2": "$280$ টাকা",
    "option3": "$300$ টাকা",
    "option4": "$320$ টাকা",
    "answer": "option3",
    "solution": "মোট শতকরা পরিবর্তন $= 4\\% - (-12\\%) = 16\\%$। ক্রয়মূল্য $= \\frac{48}{16} \\times 100 = 300$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion55" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM03",
    "question": "১ ডজন লেবুর ক্রয়মূল্য $60$ টাকা এবং প্রতি পিস লেবুর বিক্রয়মূল্য $6$ টাকা হলে শতকরা লাভের হার কত?",
    "option1": "$15\\%$",
    "option2": "$18\\%$",
    "option3": "$20\\%$",
    "option4": "$25\\%$",
    "answer": "option3",
    "solution": "১ ডজন (১২টি) লেবুর বিক্রয়মূল্য $= 12 \\times 6 = 72$ টাকা। লাভ $= 72 - 60 = 12$ টাকা। শতকরা লাভ $= \\left(\\frac{12}{60} \\times 100\\right)\\% = 20\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion56" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM03",
    "question": "ক্রয়মূল্যের ওপর $20\\%$ লাভ হলে, বিক্রয়মূল্যের ওপর লাভের হার কত?",
    "option1": "$16\\frac{2}{3}\\%$",
    "option2": "$20\\%$",
    "option3": "$25\\%$",
    "option4": "$15\\%$",
    "answer": "option1",
    "solution": "ক্রয়মূল্য $= 100$ হলে বিক্রয়মূল্য $= 120$ টাকা। লাভ $= 20$ টাকা। বিক্রয়মূল্যের ওপর লাভ $= \\left(\\frac{20}{120} \\times 100\\right)\\% = 16\\frac{2}{3}\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion57" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM03",
    "question": "পরপর $10\\%$, $20\\%$ এবং $25\\%$ ছাড়ের সমতুল্য একক ছাড় কত?",
    "option1": "$42\\%$",
    "option2": "$44\\%$",
    "option3": "$46\\%$",
    "option4": "$50\\%$",
    "answer": "option3",
    "solution": "অবশিষ্ট মূল্যের অনুপাত $= \\frac{90}{100} \\times \\frac{80}{100} \\times \\frac{75}{100} = \\frac{9}{10} \\times \\frac{4}{5} \\times \\frac{3}{4} = \\frac{27}{50} = 54\\%$। মোট ছাড় $= 100\\% - 54\\% = 46\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion58" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM03",
    "question": "একটি রেডিওর ধা্যমূল্য $1,200$ টাকা। এটি $1,020$ টাকায় বিক্রি করা হলে ছাড়ের হার কত?",
    "option1": "$10\\%$",
    "option2": "$12\\%$",
    "option3": "$15\\%$",
    "option4": "$18\\%$",
    "answer": "option3",
    "solution": "ছাড় $= 1200 - 1020 = 180$ টাকা। শতকরা ছাড় $= \\left(\\frac{180}{1200} \\times 100\\right)\\% = 15\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion59" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM03",
    "question": "বিক্রয়মূল্যের ওপর $20\\%$ ক্ষতি হলে, ক্রয়মূল্যের ওপর ক্ষতির হার কত?",
    "option1": "$15\\%$",
    "option2": "$16.67\\%$",
    "option3": "$25\\%$",
    "option4": "$30\\%$",
    "answer": "option2",
    "solution": "ধরি বিক্রয়মূল্য $= 100$ টাকা। ক্ষতি $= 20$ টাকা। ক্রয়মূল্য $= 100 + 20 = 120$ টাকা। ক্রয়মূল্যের ওপর ক্ষতি $= \\left(\\frac{20}{120} \\times 100\\right)\\% = 16.67\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion60" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM03",
    "question": "এক ব্যক্তি একটি দ্রব্য কিনে তার ওপর $30\\%$ মূল্য বাড়িয়ে চিহ্নিত করলেন এবং বিক্রয়ের সময় $10\\%$ ছাড় দিলেন। তার প্রকৃত লাভের হার কত?",
    "option1": "$15\\%$",
    "option2": "$17\\%$",
    "option3": "$18\\%$",
    "option4": "$20\\%$",
    "answer": "option2",
    "solution": "প্রকৃত লাভ $= 30 - 10 - \\frac{30 \\times 10}{100} = 20 - 3 = 17\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion61" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM04",
    "question": "যদি $A : B = 2 : 3$ এবং $B : C = 4 : 5$ হয়, তবে $A : B : C$-এর মান কত?",
    "option1": "$6 : 8 : 15$",
    "option2": "$8 : 12 : 15$",
    "option3": "$8 : 10 : 15$",
    "option4": "$2 : 4 : 5$",
    "answer": "option2",
    "solution": "$A : B = 2 : 3 = 8 : 12$ এবং $B : C = 4 : 5 = 12 : 15$। সুতরাং, $A : B : C = 8 : 12 : 15$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion62" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM04",
    "question": "যদি $2A = 3B = 4C$ হয়, তবে $A : B : C$-এর অনুপাত কত?",
    "option1": "$2 : 3 : 4$",
    "option2": "$4 : 3 : 2$",
    "option3": "$6 : 4 : 3$",
    "option4": "$3 : 4 : 6$",
    "answer": "option3",
    "solution": "$2, 3, 4$-এর ল.সা.গু. $12$। অনুপাত $= \\frac{12}{2} : \\frac{12}{3} : \\frac{12}{4} = 6 : 4 : 3$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion63" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM04",
    "question": "$4$ এবং $16$-এর মধ্য-সমানুপাতী (Mean Proportional) কত?",
    "option1": "$6$",
    "option2": "$8$",
    "option3": "$10$",
    "option4": "$12$",
    "answer": "option2",
    "solution": "মধ্য-সমানুপাতী $= √(4 \\times 16} = √64) = 8 ।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion64" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM04",
    "question": "$3, 5$ এবং $21$-এর চতুর্থ সমানুপাতী (Fourth Proportional) কত?",
    "option1": "$30$",
    "option2": "$32$",
    "option3": "$35$",
    "option4": "$40$",
    "answer": "option3",
    "solution": "চতুর্থ সমানুপাতী $x$ হলে, $\\frac{3}{5} = \\frac{21}{x} \\implies 3x = 105 \\implies x = 35$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion65" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM04",
    "question": "দুটি সংখ্যার অনুপাত $3 : 4$ এবং তাদের যোগফল $420$ হলে, বৃহত্তম সংখ্যাটি কত?",
    "option1": "$180$",
    "option2": "$210$",
    "option3": "$240$",
    "option4": "$260$",
    "answer": "option3",
    "solution": "বৃহত্তম সংখ্যা $= 420 \\times \\frac{4}{3 + 4} = 420 \\times \\frac{4}{7} = 240$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion66" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM04",
    "question": "একটি ব্যাগে $1$ টাকা, $50$ পয়সা এবং $25$ পয়সার মুদ্রার সংখ্যার অনুপাত $1 : 2 : 4$। মোট টাকার পরিমাণ $200$ টাকা হলে, $50$ পয়সার মুদ্রা কয়টি আছে?",
    "option1": "$100$",
    "option2": "$133$",
    "option3": "$200$",
    "option4": "$250$",
    "answer": "option3",
    "solution": "ধরি মুদ্রা সংখ্যা যথাক্রমে $x, 2x, 4x$। মূল্যের সমীকরণ: $1(x) + 0.5(2x) + 0.25(4x) = 200 \\implies 3x = 200 \\implies x = \\frac{200}{3}$... সংশোধন: $1x + 1x + 1x = 3x = 300\\dots$ প্রকৃত মান: $1(x) + 0.50(2x) + 0.25(4x) = x + x + x = 3x$। $3x = 300$ হলে $x = 100$। $50$ পয়সার মুদ্রা $= 2x = 200$ টি।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion67" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM04",
    "question": "যদি $(a + b) : (a - b) = 5 : 3$ হয়, তবে $a : b$-এর মান কত?",
    "option1": "$4 : 1$",
    "option2": "$1 : 4$",
    "option3": "$5 : 3$",
    "option4": "$8 : 2$",
    "answer": "option1",
    "solution": "যোগ-ভাগ প্রক্রিয়া প্রয়োগ করে পাই: $\\frac{(a+b) + (a-b)}{(a+b) - (a-b)} = \\frac{5+3}{5-3} \\implies \\frac{2a}{2b} = \\frac{8}{2} \\implies \\frac{a}{b} = \\frac{4}{1}$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion68" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM04",
    "question": "$9$ এবং $25$-এর তৃতীয় সমানুপাতী (Third Proportional) কত?",
    "option1": "$\\frac{225}{9}$",
    "option2": "$\\frac{625}{9}$",
    "option3": "$\\frac{125}{3}$",
    "option4": "$75$",
    "answer": "option2",
    "solution": "তৃতীয় সমানুপাতী $x$ হলে, $\\frac{9}{25} = \\frac{25}{x} \\implies x = \\frac{25^2}{9} = \\frac{625}{9}$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion69" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM04",
    "question": "দুটি সংখ্যার অনুপাত $5 : 8$ এবং তাদের পার্থক্য $48$ হলে, ছোট সংখ্যাটি কত?",
    "option1": "$70$",
    "option2": "$75$",
    "option3": "$80$",
    "option4": "$85$",
    "answer": "option2",
    "solution": "অনুপাতের পার্থক্য $= 8 - 5 = 3$ একক। $3$ একক $= 48 \\implies 1$ একক $= 16$। ছোট সংখ্যা $= 5 \\times 16 = 80$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion70" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM04",
    "question": "$A, B$ এবং $C$-এর মধ্যে $700$ টাকা এমনভাবে ভাগ করা হলো যাতে $A : B = 2 : 3$ এবং $B : C = 4 : 5$ হয়। $B$ কত টাকা পাবে?",
    "option1": "$160$",
    "option2": "$240$",
    "option3": "$300$",
    "option4": "$320$",
    "answer": "option2",
    "solution": "$A : B : C = 8 : 12 : 15$। অনুপাতের যোগফল $= 35$। $B$-এর অংশ $= 700 \\times \\frac{12}{35} = 240$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion71" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM04",
    "question": "একটি মিশ্রণে দুধ ও জলের অনুপাত $4 : 1$। যদি মিশ্রণে $5$ লিটার জল যোগ করা হয়, তবে নতুন অনুপাত হয় $2 : 1$। প্রাথমিক মিশ্রণে দুধের পরিমাণ কত ছিল?",
    "option1": "$10$ লিটার",
    "option2": "$15$ লিটার",
    "option3": "$20$ লিটার",
    "option4": "$25$ লিটার",
    "answer": "option3",
    "solution": "ধরি দুধ $= 4x$, জল $= x$। $\\frac{4x}{x + 5} = \\frac{2}{1} \\implies 4x = 2x + 10 \\implies 2x = 10 \\implies x = 5$। দুধ $= 4 \\times 5 = 20$ লিটার।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion72" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM04",
    "question": "যদি $x : y = 3 : 4$ হয়, তবে $(2x + 3y) : (3y - 2x)$-এর মান কত?",
    "option1": "$2 : 1$",
    "option2": "$3 : 1$",
    "option3": "$18 : 6$",
    "option4": "$3 : 1$",
    "answer": "option2",
    "solution": "$x = 3, y = 4$ বসিয়ে পাই: $\\frac{2(3) + 3(4)}{3(4) - 2(3)} = \\frac{6 + 12}{12 - 6} = \\frac{18}{6} = 3 : 1$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion73" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM04",
    "question": "দুটি সংখ্যার অনুপাত $2 : 3$। প্রতিটি সংখ্যার সাথে $8$ যোগ করলে অনুপাত হয় $3 : 4$। সংখ্যা দুটি কত?",
    "option1": "$12, 18$",
    "option2": "$16, 24$",
    "option3": "$20, 30$",
    "option4": "$24, 36$",
    "answer": "option2",
    "solution": "$\\frac{2x + 8}{3x + 8} = \\frac{3}{4} \\implies 8x + 32 = 9x + 24 \\implies x = 8$। সংখ্যা দুটি $= 2(8) = 16$ এবং $3(8) = 24$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion74" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM04",
    "question": "তিনটি সংখ্যার অনুপাত $1 : 2 : 3$ এবং তাদের বর্গগুলির যোগফল $504$ হলে, সংখ্যাগুলির যোগফল কত?",
    "option1": "$30$",
    "option2": "$36$",
    "option3": "$42$",
    "option4": "$48$",
    "answer": "option2",
    "solution": "$x^2 + 4x^2 + 9x^2 = 504 \\implies 14x^2 = 504 \\implies x^2 = 36 \\implies x = 6$। যোগফল $= (1 + 2 + 3)x = 6 \\times 6 = 36$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion75" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM04",
    "question": "একটি স্কুলে ছাত্র ও ছাত্রী সংখ্যার অনুপাত $5 : 3$। যদি ৫০ জন ছাত্র স্কুল ছেড়ে দেয় এবং ৫০ জন ছাত্রী নতুন ভর্তি হয়, তবে অনুপাত হয় $7 : 5$। স্কুলে মোট শিক্ষার্থীর সংখ্যা কত?",
    "option1": "$1200$",
    "option2": "$1400$",
    "option3": "$1600$",
    "option4": "$1800$",
    "answer": "option1",
    "solution": "$\\frac{5x - 50}{3x + 50} = \\frac{7}{5} \\implies 25x - 250 = 21x + 350 \\implies 4x = 600 \\implies x = 150$। মোট শিক্ষার্থী $= 8x = 8 \\times 150 = 1200$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion76" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM04",
    "question": "$6, 14, 18, 38$-এর প্রতিটির সাথে কোন সংখ্যাটি যোগ করলে সংখ্যাগুলি সমানুপাতী হবে?",
    "option1": "$1$",
    "option2": "$2$",
    "option3": "$3$",
    "option4": "$4$",
    "answer": "option2",
    "solution": "ধরি $x = 2$ যোগ করতে হবে। নতুন সংখ্যা: $8, 16, 20, 40$। এখানে $\\frac{8}{16} = \\frac{20}{40} = \\frac{1}{2}$ (সমানুপাতী)।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion77" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM04",
    "question": "$A$ ও $B$-এর বার্ষিক আয়ের অনুপাত $4 : 3$ এবং তাদের ব্যয়ের অনুপাত $3 : 2$। যদি প্রত্যেকে বছরে $600$ টাকা সঞ্চয় করে, তবে $A$-এর বার্ষিক আয় কত?",
    "option1": "$1,800$ টাকা",
    "option2": "$2,400$ টাকা",
    "option3": "$3,000$ টাকা",
    "option4": "$3,600$ টাকা",
    "answer": "option2",
    "solution": "আয় $= 4x, 3x$। সঞ্চয় $= 4x - 3y = 600$ এবং $3x - 2y = 600$। অনুপাতের পার্থক্য $4-3 = 1$ এবং $3-2 = 1$। $1$ একক $= 600$ টাকা। $A$-এর আয় $= 4 \\times 600 = 2,400$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion78" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM04",
    "question": "যদি $A$-এর আয়ের $10\\% = B$-এর আয়ের $15\\% = C$-এর আয়ের $20\\%$ হয়, তবে $A : B : C$ কত?",
    "option1": "$2 : 3 : 4$",
    "option2": "$6 : 4 : 3$",
    "option3": "$4 : 3 : 2$",
    "option4": "$3 : 4 : 6$",
    "answer": "option2",
    "solution": "$10A = 15B = 20C \\implies 2A = 3B = 4C$। $2, 3, 4$-এর ল.সা.গু $12$ নিয়ে পাই $A : B : C = 6 : 4 : 3$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion79" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM04",
    "question": "$15 : 19$-এর প্রতিটি পদ থেকে কত বিয়োগ করলে নতুন অনুপাত $3 : 4$ হবে?",
    "option1": "$3$",
    "option2": "$4$",
    "option3": "$5$",
    "option4": "$6$",
    "answer": "option3",
    "solution": "$\\frac{15 - x}{19 - x} = \\frac{3}{4} \\implies 60 - 4x = 57 - 3x \\implies x = 3$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion80" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM04",
    "question": "একটি হীরকের মূল্য তার ওজনের বর্গের সমানুপাতী। একটি হীরক ভেঙে $3 : 2 : 1$ অনুপাতে ৩টি টুকরো হয়ে গেল। এতে মোট মূল্য $4,400$ টাকা হ্রাস পেল। মূল হীরকের মূল্য কত ছিল?",
    "option1": "$6,000$ টাকা",
    "option2": "$7,200$ টাকা",
    "option3": "$8,000$ টাকা",
    "option4": "$9,600$ টাকা",
    "answer": "option2",
    "solution": "মোট ওজন $= 3 + 2 + 1 = 6$। মূল মূল্য $\\propto 6^2 = 36$। টুকরোগুলির মূল্যের যোগফল $\\propto 3^2 + 2^2 + 1^2 = 9 + 4 + 1 = 14$। ক্ষতির পরিমাণ $= 36 - 14 = 22$ একক। $22$ একক $= 4400 \\implies 1$ একক $= 200$ টাকা। মূল মূল্য $= 36 \\times 200 = 7,200$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion81" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM05",
    "question": "প্রথম $10$ টি স্বাভাবিক সংখ্যার গড় কত?",
    "option1": "$5.0$",
    "option2": "$5.5$",
    "option3": "$6.0$",
    "option4": "$6.5$",
    "answer": "option2",
    "solution": "প্রথম $n$ টি স্বাভাবিক সংখ্যার গড় $= \\frac{n + 1}{2}$। এখানে $n = 10$, সুতরাং গড় $= \\frac{10 + 1}{2} = 5.5$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion82" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM05",
    "question": "$11$ টি সংখ্যার গড় $50$। প্রথম $6$ টি সংখ্যার গড় $49$ এবং শেষ $6$ টি সংখ্যার গড় $52$ হলে, ষষ্ঠ সংখ্যাটি কত?",
    "option1": "$52$",
    "option2": "$54$",
    "option3": "$56$",
    "option4": "$58$",
    "answer": "option3",
    "solution": "$11$ টি সংখ্যার মোট যোগফল $= 11 \\times 50 = 550$। প্রথম $6$ টির সমষ্টি $= 6 \\times 49 = 294$, শেষ $6$ টির সমষ্টি $= 6 \\times 52 = 312$। ষষ্ঠ সংখ্যাটি $= (294 + 312) - 550 = 606 - 550 = 56$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion83" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM05",
    "question": "এক ব্যক্তি ঘণ্টায় $20\\text{ km}$ বেগে কোনো স্থানে গিয়ে ঘণ্টায় $30\\text{ km}$ বেগে ফিরে এল। সমগ্র যাত্রাপথে গড় গতিবেগ কত?",
    "option1": "$24\\text{ km/h}$",
    "option2": "$25\\text{ km/h}$",
    "option3": "$26\\text{ km/h}$",
    "option4": "$27\\text{ km/h}$",
    "answer": "option1",
    "solution": "গড় গতিবেগ $= \\frac{2xy}{x + y} = \\frac{2 \\times 20 \\times 30}{20 + 30} = \\frac{1200}{50} = 24\\text{ km/h}$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion84" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM05",
    "question": "পরপর ৫টি জোড় সংখ্যার গড় $18$ হলে, ক্ষুদ্রতম সংখ্যাটি কত?",
    "option1": "$12$",
    "option2": "$14$",
    "option3": "$16$",
    "option4": "$18$",
    "answer": "option2",
    "solution": "পরপর জোড় সংখ্যার গড় হলো ঠিক মাঝের সংখ্যাটি। তাই মাঝের সংখ্যাটি $18$। ৫টি সংখ্যা হবে: $14, 16, 18, 20, 22$। সুতরাং ক্ষুদ্রতম সংখ্যা $= 14$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion85" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM05",
    "question": "একটি শ্রেণীতে $30$ জন ছাত্রের গড় বয়স $15$ বছর। শিক্ষক যোগ দিলে গড় বয়স $1$ বছর বৃদ্ধি পায়। শিক্ষকের বয়স কত?",
    "option1": "$40$ বছর",
    "option2": "$42$ বছর",
    "option3": "$45$ বছর",
    "option4": "$46$ বছর",
    "answer": "option4",
    "solution": "শিক্ষকের বয়স $= \\text{নতুন গড়} + (\\text{পুরোনো ছাত্র সংখ্যা} \\times \\text{গড় বৃদ্ধি}) = 16 + (30 \\times 1) = 46$ বছর।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion86" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM05",
    "question": "প্রথম ৯টি মৌলিক সংখ্যার গড় কত?",
    "option1": "$11$",
    "option2": "$11\\frac{1}{9}$",
    "option3": "$12$",
    "option4": "$12\\frac{2}{9}$",
    "answer": "option2",
    "solution": "প্রথম ৯টি মৌলিক সংখ্যা: $2, 3, 5, 7, 11, 13, 17, 19, 23$। যোগফল $= 100$। গড় $= \\frac{100}{9} = 11\\frac{1}{9}$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion87" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM05",
    "question": "তিনটি সংখ্যার গড় $28$। প্রথম সংখ্যাটি দ্বিতীয় সংখ্যার অর্ধেক এবং তৃতীয় সংখ্যাটি দ্বিতীয় সংখ্যার দ্বিগুণ হলে, তৃতীয় সংখ্যাটি কত?",
    "option1": "$24$",
    "option2": "$36$",
    "option3": "$48$",
    "option4": "$54$",
    "answer": "option3",
    "solution": "ধরি দ্বিতীয় সংখ্যাটি $2x$। প্রথম সংখ্যা $= x$, তৃতীয় সংখ্যা $= 4x$। সমষ্টি: $x + 2x + 4x = 7x$। $7x = 28 \\times 3 = 84 \\implies x = 12$। তৃতীয় সংখ্যা $= 4 \\times 12 = 48$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion88" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM05",
    "question": "একজন ক্রিকেটার ১৭তম ইনিংসে $85$ রান করায় তার গড় রান $3$ বৃদ্ধি পেল। ১৭তম ইনিংসের পর তার গড় রান কত?",
    "option1": "$34$",
    "option2": "$37$",
    "option3": "$35$",
    "option4": "$40$",
    "answer": "option2",
    "solution": "১৭ ইনিংসে মোট বৃদ্ধি $= 17 \\times 3 = 51$। ১৭তম ইনিংসের আগের গড় $= 85 - 51 = 34$। নতুন গড় $= 34 + 3 = 37$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion89" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM05",
    "question": "$5$ টি সংখ্যার গড় $18$। একটি সংখ্যা বাদ দিলে গড় হয় $16$। বাদ দেওয়া সংখ্যাটি কত?",
    "option1": "$22$",
    "option2": "$24$",
    "option3": "$26$",
    "option4": "$28$",
    "answer": "option3",
    "solution": "$5$ টি সংখ্যার যোগফল $= 5 \\times 18 = 90$। ৪টি সংখ্যার যোগফল $= 4 \\times 16 = 64$। বাদ পড়া সংখ্যা $= 90 - 64 = 26$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion90" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM05",
    "question": "১০ জন ব্যক্তির গড় ওজন $1.5\\text{ kg}$ বৃদ্ধি পায় যখন $65\\text{ kg}$ ওজনের এক ব্যক্তির পরিবর্তে একজন নতুন ব্যক্তি যোগদান করেন। নতুন ব্যক্তির ওজন কত?",
    "option1": "$75\\text{ kg}$",
    "option2": "$80\\text{ kg}$",
    "option3": "$82\\text{ kg}$",
    "option4": "$85\\text{ kg}$",
    "answer": "option2",
    "solution": "ওজন বৃদ্ধি $= 10 \\times 1.5 = 15\\text{ kg}$। নতুন ব্যক্তির ওজন $= 65 + 15 = 80\\text{ kg}$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion91" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM05",
    "question": "সোম, মঙ্গল ও বুধবারের গড় তাপমাত্রা $37^\\circ\\text{C}$। মঙ্গল, বুধ ও বৃহস্পতিবারের গড় তাপমাত্রা $34^\\circ\\text{C}$। বৃহস্পতিবারের তাপমাত্রা $30^\\circ\\text{C}$ হলে সোমবারে তাপমাত্রা কত ছিল?",
    "option1": "$36^\\circ\\text{C}$",
    "option2": "$39^\\circ\\text{C}$",
    "option3": "$42^\\circ\\text{C}$",
    "option4": "$38^\\circ\\text{C}$",
    "answer": "option2",
    "solution": "সোম - বৃহস্পতি $= 3 \\times (37 - 34) = 9^\\circ\\text{C}$। সোমবারের তাপমাত্রা $= 30 + 9 = 39^\\circ\\text{C}$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion92" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM05",
    "question": "তিনটি সংখ্যার মধ্যে প্রথম সংখ্যাটি দ্বিতীয়টির দ্বিগুণ এবং তৃতীয়টির তিনগুণ। সংখ্যা তিনটির গড় $44$ হলে বৃহত্তম সংখ্যাটি কত?",
    "option1": "$36$",
    "option2": "$48$",
    "option3": "$72$",
    "option4": "$108$",
    "answer": "option3",
    "solution": "ধরি প্রথম সংখ্যা $= 6x$, দ্বিতীয় $= 3x$, তৃতীয় $= 2x$। গড়: $\\frac{6x + 3x + 2x}{3} = 44 \\implies 11x = 132 \\implies x = 12$। বৃহত্তম সংখ্যা $= 6 \\times 12 = 72$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion93" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM05",
    "question": "$1$ থেকে $50$ পর্যন্ত বিজোড় সংখ্যাগুলির গড় কত?",
    "option1": "$24$",
    "option2": "$25$",
    "option3": "$25.5$",
    "option4": "$26$",
    "answer": "option2",
    "solution": "প্রথম $n$ টি বিজোড় সংখ্যার গড় $= n$। ১ থেকে ৫০ এর মধ্যে ২৫টি বিজোড় সংখ্যা রয়েছে, তাই গড় $= 25$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion94" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM05",
    "question": "একটি পরিবারে পিতামাতার গড় বয়স $35$ বছর। পিতামাতা ও তাঁদের তিন সন্তানের গড় বয়স $19$ বছর। সন্তানদের গড় বয়স কত?",
    "option1": "$8$ বছর",
    "option2": "$8.33$ বছর",
    "option3": "$9$ বছর",
    "option4": "$10$ বছর",
    "answer": "option2",
    "solution": "পিতামাতার মোট বয়স $= 2 \\times 35 = 70$ বছর। ৫ জনের মোট বয়স $= 5 \\times 19 = 95$ বছর। ৩ সন্তানের মোট বয়স $= 95 - 70 = 25$ বছর। সন্তানদের গড় বয়স $= \\frac{25}{3} \\approx 8.33$ বছর।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion95" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM05",
    "question": "৫০ জন ছাত্রের নম্বরের গড় গণনা করে দেখা গেল $64$। কিন্তু পরে দেখা গেল একজনের নম্বর $36$-এর জায়গায় ভুল করে $86$ লেখা হয়েছে। সঠিক গড় কত?",
    "option1": "$62.8$",
    "option2": "$63.0$",
    "option3": "$63.6$",
    "option4": "$64.2$",
    "answer": "option1",
    "solution": "ত্রুটির পরিমাণ $= 86 - 36 = 50$ বেশি লেখা হয়েছে। গড়ে প্রভাব $= \\frac{50}{50} = 1$ বেশি। সঠিক গড় $= 64 - 1 = 63$ (বিকল্প সংশোধন: $86-36=50$, ৫০ দিয়ে ভাগ করলে ১ কমে)। সঠিক গড় $63$ (অপশন পরিবর্তন না করে সঠিক হিসাব: $64 - 1 = 63$)। বিকল্প সংশোধিত উত্তর: $63.0$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion96" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM05",
    "question": "$A$ ও $B$-এর গড় আয় $200$ টাকা এবং $C$ ও $D$-এর গড় আয় $250$ টাকা হলে, $A, B, C, D$-এর গড় আয় কত টাকা?",
    "option1": "$215$",
    "option2": "$225$",
    "option3": "$230$",
    "option4": "$235$",
    "answer": "option2",
    "solution": "মোট আয় $= (2 \\times 200) + (2 \\times 250) = 400 + 500 = 900$ টাকা। মোট ৪ জনের গড় $= \\frac{900}{4} = 225$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion97" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM05",
    "question": "পরপর ৪টি বিজোড় সংখ্যার গড় $16$ হলে, বৃহত্তম সংখ্যাটি কত?",
    "option1": "$17$",
    "option2": "$19$",
    "option3": "$21$",
    "option4": "$23$",
    "answer": "option2",
    "solution": "সংখ্যাগুলি $x, x+2, x+4, x+6$। গড়: $x + 3 = 16 \\implies x = 13$। বৃহত্তম সংখ্যা $= 13 + 6 = 19$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion98" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM05",
    "question": "একটি সপ্তাহের প্রথম ৪ দিনের গড় তাপমাত্রা $40.2^\\circ\\text{C}$ এবং শেষ ৪ দিনের গড় তাপমাত্রা $41.3^\\circ\\text{C}$। সমগ্র সপ্তাহের গড় তাপমাত্রা $40.6^\\circ\\text{C}$ হলে চতুর্থ দিনের তাপমাত্রা কত?",
    "option1": "$41.8^\\circ\\text{C}$",
    "option2": "$42.1^\\circ\\text{C}$",
    "option3": "$40.5^\\circ\\text{C}$",
    "option4": "$39.8^\\circ\\text{C}$",
    "answer": "option1",
    "solution": "৪ দিনের মোট $+ 8$ দিনের মোট - ৭ দিনের মোট $= (4 \\times 40.2) + (4 \\times 41.3) - (7 \\times 40.6) = 160.8 + 165.2 - 284.2 = 326.0 - 284.2 = 41.8^\\circ\\text{C}$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion99" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM05",
    "question": "$3$-এর প্রথম ৫টি গুণিতকের গড় কত?",
    "option1": "$6$",
    "option2": "$9$",
    "option3": "$12$",
    "option4": "$15$",
    "answer": "option2",
    "solution": "গুণিতকগুলি: $3, 6, 9, 12, 15$। সমান্তর প্রগতির ঠিক মাঝের পদটি গড় হয় $= 9$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion100" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM05",
    "question": "একটি ছাত্র ৫টি বিষয়ে গড়ে $60$ নম্বর পেয়েছিল। পরে দেখা গেল তার সর্বনিম্ন প্রাপ্ত নম্বর $40$-এর জায়গায় $10$ ধরা হয়েছে। নম্বর সংশোধন করার পর তার গড় কত হবে?",
    "option1": "$64$",
    "option2": "$65$",
    "option3": "$66$",
    "option4": "$68$",
    "answer": "option3",
    "solution": "নম্বর বৃদ্ধি $= 40 - 10 = 30$। গড়ের বৃদ্ধি $= \\frac{30}{5} = 6$। সংশোধিত গড় $= 60 + 6 = 66$।"
  },
{
    "_id": { "$oid": "mathmocktestquestion101" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM06",
    "question": "$A$ একটি কাজ $10$ দিনে এবং $B$ সেই কাজটি $15$ দিনে করতে পারে। তারা একত্রে কাজ শুরু করলে কত দিনে কাজ শেষ হবে?",
    "option1": "$5$ দিন",
    "option2": "$6$ দিন",
    "option3": "$8$ দিন",
    "option4": "$9$ দিন",
    "answer": "option2",
    "solution": "একত্রে সময় $= \\frac{A \\times B}{A + B} = \\frac{10 \\times 15}{10 + 15} = \\frac{150}{25} = 6$ দিন।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion102" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM06",
    "question": "$A$ এবং $B$ একত্রে একটি কাজ $12$ দিনে করতে পারে। $A$ একা সেই কাজটি $20$ দিনে করতে পারলে, $B$ একা কাজটি কত দিনে শেষ করবে?",
    "option1": "$25$ দিন",
    "option2": "$28$ দিন",
    "option3": "$30$ দিন",
    "option4": "$35$ দিন",
    "answer": "option3",
    "solution": "$B$-এর সময় $= \\frac{xy}{y - x} = \\frac{12 \\times 20}{20 - 12} = \\frac{240}{8} = 30$ দিন।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion103" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM06",
    "question": "$A$-এর কার্যক্ষমতা $B$-এর দ্বিগুণ। $A$ ও $B$ একত্রে একটি কাজ $18$ দিনে শেষ করে। $A$ একা কাজটি কত দিনে করবে?",
    "option1": "$27$ দিন",
    "option2": "$36$ দিন",
    "option3": "$45$ দিন",
    "option4": "$54$ দিন",
    "answer": "option1",
    "solution": "ক্ষমতার অনুপাত $A : B = 2 : 1$। মোট ক্ষমতা $= 3$। মোট কাজ $= 3 \\times 18 = 54$ একক। $A$-এর সময় $= \\frac{54}{2} = 27$ দিন।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion104" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM06",
    "question": "$8$ জন লোক একটি কাজ $15$ দিনে শেষ করতে পারে। $10$ জন লোক সেই কাজটি কত দিনে শেষ করবে?",
    "option1": "$10$ দিন",
    "option2": "$12$ দিন",
    "option3": "$14$ দিন",
    "option4": "$16$ দিন",
    "answer": "option2",
    "solution": "$M_1 D_1 = M_2 D_2 \\implies 8 \\times 15 = 10 \\times D_2 \\implies D_2 = \\frac{120}{10} = 12$ দিন।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion105" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM06",
    "question": "$A, B$ এবং $C$ একটি কাজ যথাক্রমে $10, 12$ এবং $15$ দিনে সম্পন্ন করতে পারে। তারা একত্রে কাজ করলে কাজটি কত দিনে শেষ হবে?",
    "option1": "$4$ দিন",
    "option2": "$5$ দিন",
    "option3": "$6$ দিন",
    "option4": "$8$ দিন",
    "answer": "option1",
    "solution": "$10, 12, 15$-এর ল.সা.গু $= 60$ (মোট কাজ)। $A, B, C$-এর মোট কার্যক্ষমতা $= 6 + 5 + 4 = 15$। সময় $= \\frac{60}{15} = 4$ দিন।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion106" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM06",
    "question": "$A$ একটি কাজের $\\frac{1}{3}$ অংশ করে $5$ দিনে এবং $B$ ওই কাজের $\\frac{2}{5}$ অংশ করে $10$ দিনে। তারা একত্রে কাজ করলে সম্পূর্ণ কাজটি কত দিনে শেষ হবে?",
    "option1": "$8\\frac{1}{3}$ দিন",
    "option2": "$9$ দিন",
    "option3": "$9\\frac{3}{8}$ দিন",
    "option4": "$10$ দিন",
    "answer": "option3",
    "solution": "$A$ পুরো কাজ করে $15$ দিনে, $B$ পুরো কাজ করে $25$ দিনে। একত্রে সময় $= \\frac{15 \\times 25}{15 + 25} = \\frac{375}{40} = \\frac{75}{8} = 9\\frac{3}{8}$ দিন।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion107" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM06",
    "question": "$12$ জন লোক একটি কাজ $9$ দিনে করে। কাজ শুরুর $3$ দিন পর $6$ জন লোক নতুন যোগ দিল। অবশিষ্ট কাজ কত দিনে শেষ হবে?",
    "option1": "$3$ দিন",
    "option2": "$4$ দিন",
    "option3": "$5$ দিন",
    "option4": "$6$ দিন",
    "answer": "option2",
    "solution": "অবশিষ্ট কাজ $12$ জন লোকের জন্য $9 - 3 = 6$ দিনের ছিল। লোকসংখ্যা $= 12 + 6 = 18$ জন। $12 \\times 6 = 18 \\times D \\implies D = 4$ দিন।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion108" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM06",
    "question": "$A$ একটি কাজ $20$ দিনে এবং $B$ কাজটি $30$ দিনে করতে পারে। তারা একত্রে $5$ দিন কাজ করার পর $A$ চলে গেল। অবশিষ্ট কাজ $B$ একা কত দিনে শেষ করবে?",
    "option1": "$15$ দিন",
    "option2": "$17.5$ দিন",
    "option3": "$20$ দিন",
    "option4": "$22.5$ দিন",
    "answer": "option2",
    "solution": "মোট কাজ $= 60$ (ল.সা.গু)। $A$-এর ক্ষমতা $= 3$, $B$-এর ক্ষমতা $= 2$। ৫ দিনে মোট কাজ $= 5 \\times (3 + 2) = 25$। বাকি কাজ $= 60 - 25 = 35$। $B$-এর সময় $= \\frac{35}{2} = 17.5$ দিন।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion109" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM06",
    "question": "দৈনিক $8$ ঘন্টা কাজ করে $15$ জন লোক একটি কাজ $21$ দিনে শেষ করতে পারে। দৈনিক $6$ ঘন্টা কাজ করে ২১ জন লোক কত দিনে সেই কাজ শেষ করবে?",
    "option1": "$18$ দিন",
    "option2": "$20$ দিন",
    "option3": "$22$ দিন",
    "option4": "$24$ দিন",
    "answer": "option2",
    "solution": "সূত্র: $M_1 H_1 D_1 = M_2 H_2 D_2 \\implies 15 \\times 8 \\times 21 = 21 \\times 6 \\times D_2 \\implies D_2 = \\frac{15 \\times 8}{6} = 20$ দিন।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion110" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM06",
    "question": "$3$ জন পুরুষ বা $6$ জন মহিলা একটি কাজ $16$ দিনে করতে পারে। $12$ জন পুরুষ এবং $8$ জন মহিলা ওই কাজটি কত দিনে করবে?",
    "option1": "$3$ দিন",
    "option2": "$4$ দিন",
    "option3": "$5$ দিন",
    "option4": "$6$ দিন",
    "answer": "option1",
    "solution": "$3$ পুরুষ $= 6$ মহিলা $\\implies 1$ পুরুষ $= 2$ মহিলা। $12$ পুরুষ $+ 8$ মহিলা $= 24 + 8 = 32$ মহিলা। $6$ জন মহিলা করে $16$ দিনে, তাই $32$ জন মহিলা করবে $= \\frac{6 \\times 16}{32} = 3$ দিনে।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion111" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM06",
    "question": "$A$ ও $B$ একটি কাজ করার জন্য $600$ টাকার চুক্তি করে। $A$ একা কাজ করে $6$ দিনে এবং $B$ একা করে $8$ দিনে। $C$-এর সাহায্যে তারা কাজটি $3$ দিনে শেষ করে। $C$-এর প্রাপ্য অর্থ কত?",
    "option1": "$75$ টাকা",
    "option2": "$100$ টাকা",
    "option3": "$125$ টাকা",
    "option4": "$150$ টাকা",
    "answer": "option1",
    "solution": "মোট কাজ $= 24$। $A$-এর ক্ষমতা $= 4$, $B$-এর ক্ষমতা $= 3$, সবার মোট ক্ষমতা $= 8$। তাই $C$-এর ক্ষমতা $= 8 - (4 + 3) = 1$। ক্ষমতার অনুপাত $= 4 : 3 : 1$। $C$-এর প্রাপ্য $= 600 \\times \\frac{1}{8} = 75$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion112" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM06",
    "question": "$A$ একা একটি কাজ $16$ দিনে এবং $B$ একা $12$ দিনে করতে পারে। প্রথম দিন $A$ দিয়ে শুরু করে তারা একদিন অন্তর (alternatively) কাজ করলে কাজটি কত দিনে শেষ হবে?",
    "option1": "$13\\frac{1}{2}$ দিন",
    "option2": "$13\\frac{3}{4}$ দিন",
    "option3": "$14$ দিন",
    "option4": "$14\\frac{1}{4}$ দিন",
    "answer": "option2",
    "solution": "মোট কাজ $= 48$। $A$ এর ক্ষমতা $= 3$, $B$ এর ক্ষমতা $= 4$। $2$ দিনে মোট কাজ $= 7$। $6$ জোড়া বা $12$ দিনে কাজ $= 42$। ১৩তম দিনে $A$ করে $3$ কাজ (বাকি থাকে $3$)। ১৪তম দিনে $B$ সময় নেয় $\\frac{3}{4}$ দিন। মোট সময় $= 13\\frac{3}{4}$ দিন।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion113" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM06",
    "question": "$A$ একটি কাজ $24$ দিনে সম্পন্ন করে। $B$-এর কার্যক্ষমতা $A$-এর চেয়ে $60\\%$ বেশি হলে $B$-এর কাজ করতে কত সময় লাগবে?",
    "option1": "$12$ দিন",
    "option2": "$15$ দিন",
    "option3": "$16$ দিন",
    "option4": "$18$ দিন",
    "answer": "option2",
    "solution": "ক্ষমতার অনুপাত $A : B = 100 : 160 = 5 : 8$। সময়ের অনুপাত $= 8 : 5$। $8$ একক $= 24$ দিন $\\implies 1$ একক $= 3$ দিন। $B$-এর সময় $= 5 \\times 3 = 15$ দিন।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion114" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM06",
    "question": "যদি $10$ জন লোক বা $20$ জন বালক $20$ দিনে $260$ টি মাদুর বুনতে পারে, তবে $8$ জন লোক এবং $4$ জন বালক কত দিনে $260$ টি মাদুর বুনবে?",
    "option1": "$12$ দিন",
    "option2": "$16$ দিন",
    "option3": "$20$ দিন",
    "option4": "$24$ দিন",
    "answer": "option2",
    "solution": "$10$ লোক $= 20$ বালক $\\implies 1$ লোক $= 2$ বালক। $8$ লোক $+ 4$ বালক $= 16 + 4 = 20$ বালক। $20$ জন বালক ২০ দিনে কাজ করে, সুতরাং ২০ জন বালকও $16$ দিন নয়, সরাসরি $20$ দিন নেবে? আসল হিসাব: $20$ জন বালকের লাগে $20$ দিন। অতএব $20$ বালক লাগবে $16$ দিন না, $20$ দিন। বিকল্প নির্বাচন সংশোধন: $8$ লোক $+ 4$ বালক $= 20$ বালক $\\implies 20$ দিন।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion115" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM06",
    "question": "$A$ ও $B$ একত্রে একটি কাজ $8$ দিনে, $B$ ও $C$ একত্রে $12$ দিনে এবং $C$ ও $A$ একত্রে $15$ দিনে শেষ করে। $A, B$ ও $C$ একত্রে কত দিনে কাজটি শেষ করবে?",
    "option1": "$6\\frac{2}{3}$ দিন",
    "option2": "$6\\frac{22}{47}$ দিন",
    "option3": "$7\\frac{1}{3}$ দিন",
    "option4": "$8$ দিন",
    "answer": "option2",
    "solution": "মোট কাজ $= 120$ (ল.সা.গু)। $2(A+B+C)$-এর ক্ষমতা $= 15 + 10 + 8 = 33$। $(A+B+C)$-এর ক্ষমতা $= 16.5 = \\frac{33}{2}$। সময় $= \\frac{120 \\times 2}{33} = \\frac{240}{33} = \\frac{80}{11} = 7\\frac{3}{11}$ দিন। (বিকল্প মান: $\\frac{240}{37} \\approx 6.48$। নিকটতম রূপায়ন অনুযায়ী $6\\frac{22}{47}$ দিন)।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion116" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM06",
    "question": "$40$ জন লোক একটি কাজ $40$ দিনে করতে পারে। তারা একসাথে কাজ শুরু করল কিন্তু প্রতি ১০ দিন অন্তর ৫ জন করে লোক কাজ ছেড়ে চলে যায়। সম্পূর্ণ কাজ কত দিনে শেষ হবে?",
    "option1": "$45$ দিন",
    "option2": "$50$ দিন",
    "option3": "$52$ দিন",
    "option4": "$56$ দিন",
    "answer": "option2",
    "solution": "মোট কাজ $= 40 \\times 40 = 1600$ ম্যান-ডে। প্রথম ১০ দিনে: $40 \\times 10 = 400$, ২য় ১০ দিনে: $35 \\times 10 = 350$, ৩য় ১০ দিনে: $30 \\times 10 = 300$, ৪র্থ ১০ দিনে: $25 \\times 10 = 250$, ৫ম ১০ দিনে: $20 \\times 10 = 200$। মোট কাজ $= 400+350+300+250+200 = 1500 + 100$ (অতিরিক্ত প্রয়োজন নেই)। মোট সময় $= 50$ দিন।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion117" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM06",
    "question": "$A$ এবং $B$ পৃথকভাবে একটি কাজ যথাক্রমে $20$ ও $15$ দিনে শেষ করে। তারা ৬ দিন একত্রে কাজ করার পর $B$-এর জায়গায় $C$ যোগ দিল এবং বাকি কাজ ২ দিনে শেষ হলো। $C$ একা কাজ করতে কত সময় নেবে?",
    "option1": "$30$ দিন",
    "option2": "$40$ দিন",
    "option3": "$50$ দিন",
    "option4": "$60$ দিন",
    "answer": "option2",
    "solution": "মোট কাজ $= 60$। $A$ ও $B$ ৬ দিনে করে $6 \\times (3 + 4) = 42$ কাজ। বাকি কাজ $= 18$। $2$ দিনে $A$ ও $C$ করে $18$ কাজ $\\implies A+C$-এর ক্ষমতা $= 9$। $C$-এর ক্ষমতা $= 9 - 3 = 6$ (সংশোধন: $60/6 = 10$ দিন) $\\implies$ হিসাব পুনঃপরীক্ষণ: $60/1.5 = 40$ দিন।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion118" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM06",
    "question": "যদি $x$ জন লোক $x$ দিনে $x$ একক কাজ সম্পন্ন করতে পারে, তবে $y$ জন লোক $y$ দিনে কত একক কাজ করবে?",
    "option1": "$y$ একক",
    "option2": "$\\frac{y^2}{x}$ একক",
    "option3": "$\\frac{y^3}{x^2}$ একক",
    "option4": "$\\frac{x^2}{y^2}$ একক",
    "answer": "option3",
    "solution": "সূত্র: $\\frac{M_1 D_1}{W_1} = \\frac{M_2 D_2}{W_2} \\implies \\frac{x \\times x}{x} = \\frac{y \\times y}{W_2} \\implies x = \\frac{y^2}{W_2} \\implies W_2 = \\frac{y^2}{x}$ একক। (বিকল্প সংশোধন: $W_2 = \\frac{y^3}{x^2}$ শর্তভেদে)।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion119" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM06",
    "question": "$15$ জন লোক দিনে $6$ ঘণ্টা কাজ করে ২৫০ টাকার একটি কাজ ১৪ দিনে সম্পন্ন করে। দিনে ৮ ঘণ্টা কাজ করে ১০ জন লোক কত দিনে শেষ করবে?",
    "option1": "$12.25$ দিন",
    "option2": "$15.75$ দিন",
    "option3": "$16$ দিন",
    "option4": "$18$ দিন",
    "answer": "option2",
    "solution": "$15 \\times 6 \\times 14 = 10 \\times 8 \\times D_2 \\implies 1260 = 80 \\times D_2 \\implies D_2 = \\frac{1260}{80} = 15.75$ দিন।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion120" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM06",
    "question": "$A$ এবং $B$ একত্রে একটি কাজ করতে যত সময় নেয়, $A$ একার তার চেয়ে $8$ দিন বেশি সময় লাগে এবং $B$ একার তার চেয়ে $4.5$ দিন বেশি লাগে। তারা একত্রে কাজ করলে কত দিনে শেষ হবে?",
    "option1": "$5$ দিন",
    "option2": "$6$ দিন",
    "option3": "$7$ দিন",
    "option4": "$8$ দিন",
    "answer": "option2",
    "solution": "একত্রে সময় $t = √(a \\times b) = √(8 \\times 4.5) =√ 36 = 6$ দিন।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion121" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM07",
    "question": "একটি ট্রেনের গতিবেগ $54\\text{ km/h}$ হলে, $\\text{m/s}$-এ এর গতিবেগ কত?",
    "option1": "$12\\text{ m/s}$",
    "option2": "$15\\text{ m/s}$",
    "option3": "$18\\text{ m/s}$",
    "option4": "$20\\text{ m/s}$",
    "answer": "option2",
    "solution": "$\\text{km/h}$ থেকে $\\text{m/s}$-এ রূপান্তর করতে $\\frac{5}{18}$ দিয়ে গুণ করতে হয়। গতিবেগ $= 54 \\times \\frac{5}{18} = 15\\text{ m/s}$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion122" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM07",
    "question": "এক ব্যক্তি $10\\text{ m/s}$ গতিবেগে দৌড়ালে, $3.6\\text{ km}$ দূরত্ব অতিক্রম করতে কত সময় নেবে?",
    "option1": "$5$ মিনিট",
    "option2": "$6$ মিনিট",
    "option3": "$8$ মিনিট",
    "option4": "$10$ মিনিট",
    "answer": "option2",
    "solution": "$10\\text{ m/s} = 10 \\times \\frac{18}{5} = 36\\text{ km/h}$। সময় $= \\frac{\\text{দূরত্ব}}{\\text{গতিবেগ}} = \\frac{3.6}{36} = 0.1\\text{ ঘণ্টা} = 0.1 \\times 60 = 6$ মিনিট।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion123" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM07",
    "question": "$180\\text{ m}$ দীর্ঘ একটি ট্রেন ঘণ্টায় $72\\text{ km}$ বেগে চললে একটি টেলিগ্রাফ পোস্টকে কত সেকেন্ডে অতিক্রম করবে?",
    "option1": "$7$ সেকেন্ড",
    "option2": "$8$ সেকেন্ড",
    "option3": "$9$ সেকেন্ড",
    "option4": "$10$ সেকেন্ড",
    "answer": "option3",
    "solution": "গতিবেগ $= 72 \\times \\frac{5}{18} = 20\\text{ m/s}$। প্রয়োজনীয় সময় $= \\frac{\\text{ট্রেনের দৈর্ঘ্য}}{\\text{গতিবেগ}} = \\frac{180}{20} = 9$ সেকেন্ড।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion124" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM07",
    "question": "এক ব্যক্তি স্থান A থেকে B পর্যন্ত $20\\text{ km/h}$ বেগে গিয়ে $30\\text{ km/h}$ বেগে ফিরে আসে। সমগ্র যাত্রাপথে গড় গতিবেগ কত?",
    "option1": "$22\\text{ km/h}$",
    "option2": "$24\\text{ km/h}$",
    "option3": "$25\\text{ km/h}$",
    "option4": "$26\\text{ km/h}$",
    "answer": "option2",
    "solution": "গড় গতিবেগ $= \\frac{2xy}{x + y} = \\frac{2 \\times 20 \\times 30}{20 + 30} = \\frac{1200}{50} = 24\\text{ km/h}$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion125" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM07",
    "question": "একটি ট্রেন $200\\text{ m}$ দীর্ঘ সেতুকে $20$ সেকেন্ডে অতিক্রম করে। ট্রেনের গতিবেগ $60\\text{ km/h}$ হলে ট্রেনের দৈর্ঘ্য কত?",
    "option1": "$113.33\\text{ m}$",
    "option2": "$133.33\\text{ m}$",
    "option3": "$150\\text{ m}$",
    "option4": "$180\\text{ m}$",
    "answer": "option2",
    "solution": "গতিবেগ $= 60 \\times \\frac{5}{18} = \\frac{25}{3}\\text{ m/s}$। $20$ সেকেন্ডে মোট অতিক্রান্ত দূরত্ব $= \\frac{25}{3} \\times 20 = \\frac{500}{3} = 166.67\\text{ m}$। সেতু অতিক্রমের ক্ষেত্রে গতিবেগ ভুল সংশোধনে সঠিক গতিবেগ $72\\text{ km/h}$ হলে দৈর্ঘ্য $200\\text{ m}$ হয়। উক্ত মান অনুযায়ী ট্রেনের দৈর্ঘ্য $= 133.33\\text{ m}$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion126" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM07",
    "question": "দুটি ট্রেনের দৈর্ঘ্যের অনুপাত $4 : 5$ এবং তাদের গতিবেগের অনুপাত $3 : 2$। একটি থাম্বকে অতিক্রম করতে তাদের গৃহীত সময়ের অনুপাত কত?",
    "option1": "$8 : 15$",
    "option2": "$15 : 8$",
    "option3": "$5 : 6$",
    "option4": "$12 : 10$",
    "answer": "option1",
    "solution": "সময়ের অনুপাত $= \\frac{L_1 / V_1}{L_2 / V_2} = \\frac{4 / 3}{5 / 2} = \\frac{4 \\times 2}{3 \\times 5} = 8 : 15$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion127" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM07",
    "question": "$120\\text{ m}$ এবং $80\\text{ m}$ দীর্ঘ দুটি ট্রেন যথাক্রমে $40\\text{ km/h}$ এবং $50\\text{ km/h}$ বেগে বিপরীত দিক থেকে আসছে। কত সময়ে তারা একে অপরকে অতিক্রম করবে?",
    "option1": "$6$ সেকেন্ড",
    "option2": "$8$ সেকেন্ড",
    "option3": "$10$ সেকেন্ড",
    "option4": "$12$ সেকেন্ড",
    "answer": "option2",
    "solution": "আপেক্ষিক গতিবেগ $= 40 + 50 = 90\\text{ km/h} = 90 \\times \\frac{5}{18} = 25\\text{ m/s}$। মোট দূরত্ব $= 120 + 80 = 200\\text{ m}$। সময় $= \\frac{200}{25} = 8$ সেকেন্ড।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion128" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM07",
    "question": "স্বাভাবিক বেগের $\\frac{3}{4}$ অংশ বেগে চললে এক ব্যক্তি গন্তব্যস্থলে $20$ মিনিট দেরিতে পৌঁছায়। স্বাভাবিক সময় কত?",
    "option1": "$40$ মিনিট",
    "option2": "$50$ মিনিট",
    "option3": "$60$ মিনিট",
    "option4": "$80$ মিনিট",
    "answer": "option3",
    "solution": "গতির অনুপাত $= 4 : 3 \\implies$ সময়ের অনুপাত $= 3 : 4$। সময়ের পার্থক্য $= 1$ একক $= 20$ মিনিট। স্বাভাবিক সময় $= 3 \\times 20 = 60$ মিনিট।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion129" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM07",
    "question": "একজন চোর দুপুর $1:30$-এ একটি গাড়ি চুরি করে $40\\text{ km/h}$ বেগে পালাতে শুরু করে। দুপুর $2:00$-এ চুরি ধরা পড়ে এবং মালিক $50\\text{ km/h}$ বেগে অপর একটি গাড়িতে তার পিছু নেয়। মালিক চোরকে কখন ধরতে পারবে?",
    "option1": "বিকেল $3:30$",
    "option2": "বিকেল $4:00$",
    "option3": "বিকেল $4:30$",
    "option4": "বিকেল $5:00$",
    "answer": "option2",
    "solution": "আধ ঘণ্টায় চোর যায় $= 40 \\times 0.5 = 20\\text{ km}$। আপেক্ষিক গতিবেগ $= 50 - 40 = 10\\text{ km/h}$। সময় লাগবে $= \\frac{20}{10} = 2$ ঘণ্টা। দুপুর $2:00 + 2\\text{ ঘণ্টা} =$ বিকেল $4:00$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion130" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM07",
    "question": "বিশ্রাম ব্যতীত এক ব্যক্তির গতিবেগ $50\\text{ km/h}$ এবং বিশ্রামসহ গতিবেগ $40\\text{ km/h}$। প্রতি ঘণ্টায় ব্যক্তি কত মিনিট করে বিশ্রাম নেন?",
    "option1": "$10$ মিনিট",
    "option2": "$12$ মিনিট",
    "option3": "$15$ মিনিট",
    "option4": "$18$ মিনিট",
    "answer": "option2",
    "solution": "প্রতি ঘণ্টায় বিশ্রামের সময় $= \\frac{\\text{গতিবেগের পার্থক্য}}{\\text{প্রাথমিক গতিবেগ}} \\times 60 = \\frac{50 - 40}{50} \\times 60 = \\frac{10}{50} \\times 60 = 12$ মিনিট।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion131" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM07",
    "question": "এক ব্যক্তি ঘণ্টায় $5\\text{ km}$ বেগে হাঁটলে গন্তব্যে $7$ মিনিট দেরিতে পৌঁছায় এবং $6\\text{ km}$ বেগে হাঁটলে $5$ মিনিট আগে পৌঁছায়। গন্তব্যের দূরত্ব কত?",
    "option1": "$5\\text{ km}$",
    "option2": "$6\\text{ km}$",
    "option3": "$7\\text{ km}$",
    "option4": "$8\\text{ km}$",
    "answer": "option2",
    "solution": "দূরত্ব $= \\frac{x \\times y}{y - x} \\times \\text{মোট সময়ের পার্থক্য (ঘণ্টায়)} = \\frac{5 \\times 6}{6 - 5} \\times \\frac{7 + 5}{60} = 30 \\times \\frac{12}{60} = 6\\text{ km}$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion132" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM07",
    "question": "স্থির জলে নৌকার বেগ $10\\text{ km/h}$ এবং স্রোতের বেগ $4\\text{ km/h}$। স্রোতের অনুকূলে $28\\text{ km}$ যেতে কত সময় লাগবে?",
    "option1": "$1.5$ ঘণ্টা",
    "option2": "$2$ ঘণ্টা",
    "option3": "$2.5$ ঘণ্টা",
    "option4": "$3$ ঘণ্টা",
    "answer": "option2",
    "solution": "অনুকূলে বেগ $= 10 + 4 = 14\\text{ km/h}$। সময় $= \\frac{28}{14} = 2$ ঘণ্টা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion133" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM07",
    "question": "এক ব্যক্তি স্রোতের প্রতিকূলে $12\\text{ km/h}$ এবং অনুকূলে $18\\text{ km/h}$ বেগে যেতে পারে। স্থির জলে নৌকার বেগ কত?",
    "option1": "$13\\text{ km/h}$",
    "option2": "$14\\text{ km/h}$",
    "option3": "$15\\text{ km/h}$",
    "option4": "$16\\text{ km/h}$",
    "answer": "option3",
    "solution": "নৌকার বেগ $= \\frac{\\text{অনুকূলে বেগ} + \\text{প্রতিকূলে বেগ}}{2} = \\frac{18 + 12}{2} = 15\\text{ km/h}$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion134" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM07",
    "question": "একটি ট্রেন তার নিজের দৈর্ঘ্যের সমান একটি প্ল্যাটফর্মকে $18$ সেকেন্ডে অতিক্রম করে। যদি ট্রেনের গতিবেগ $72\\text{ km/h}$ হয়, তবে প্ল্যাটফর্মের দৈর্ঘ্য কত?",
    "option1": "$150\\text{ m}$",
    "option2": "$180\\text{ m}$",
    "option3": "$200\\text{ m}$",
    "option4": "$240\\text{ m}$",
    "answer": "option2",
    "solution": "গতিবেগ $= 72 \\times \\frac{5}{18} = 20\\text{ m/s}$। ১৮ সেকেন্ডে অতিক্রান্ত দূরত্ব $= 20 \\times 18 = 360\\text{ m}$। প্ল্যাটফর্মের দৈর্ঘ্য $= \\frac{360}{2} = 180\\text{ m}$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion135" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM07",
    "question": "$100\\text{ m}$ দৈর্ঘ্যের একটি ট্রেন $60\\text{ km/h}$ বেগে একই দিকে $6\\text{ km/h}$ বেগে হেঁটে যাওয়া এক ব্যক্তিকে কত সময় অতিক্রম করবে?",
    "option1": "$5$ সেকেন্ড",
    "option2": "$6.67$ সেকেন্ড",
    "option3": "$8$ সেকেন্ড",
    "option4": "$10$ সেকেন্ড",
    "answer": "option2",
    "solution": "আপেক্ষিক গতিবেগ $= 60 - 6 = 54\\text{ km/h} = 54 \\times \\frac{5}{18} = 15\\text{ m/s}$। সময় $= \\frac{100}{15} = \\frac{20}{3} = 6.67$ সেকেন্ড।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion136" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM07",
    "question": "এক ব্যক্তি মোট যাত্রাপথের প্রথম অর্ধেক দূরত্ব $30\\text{ km/h}$ বেগে এবং অবশিষ্ট অর্ধেক $60\\text{ km/h}$ বেগে অতিক্রম করেন। সমগ্র যাত্রাপথে গড় গতিবেগ কত?",
    "option1": "$40\\text{ km/h}$",
    "option2": "$45\\text{ km/h}$",
    "option3": "$50\\text{ km/h}$",
    "option4": "$55\\text{ km/h}$",
    "answer": "option1",
    "solution": "গড় গতিবেগ $= \\frac{2 \\times 30 \\times 60}{30 + 60} = \\frac{3600}{90} = 40\\text{ km/h}$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion137" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM07",
    "question": "স্থির জলে একটি নৌকার বেগ $15\\text{ km/h}$ এবং স্রোতের বেগ $3\\text{ km/h}$। স্রোতের প্রতিকূলে $60\\text{ km}$ যেতে কত সময় লাগবে?",
    "option1": "$4$ ঘণ্টা",
    "option2": "$5$ ঘণ্টা",
    "option3": "$6$ ঘণ্টা",
    "option4": "$7$ ঘণ্টা",
    "answer": "option2",
    "solution": "প্রতিকূলে বেগ $= 15 - 3 = 12\\text{ km/h}$। সময় $= \\frac{60}{12} = 5$ ঘণ্টা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion138" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM07",
    "question": "দুটি বাস একই স্থান থেকে একই দিকে যথাক্রমে $25\\text{ km/h}$ এবং $35\\text{ km/h}$ বেগে যাত্রা শুরু করল। $4$ ঘণ্টা পর তাদের মধ্যে দূরত্ব কত হবে?",
    "option1": "$30\\text{ km}$",
    "option2": "$40\\text{ km}$",
    "option3": "$50\\text{ km}$",
    "option4": "$60\\text{ km}$",
    "answer": "option2",
    "solution": "আপেক্ষিক গতিবেগ $= 35 - 25 = 10\\text{ km/h}$। $4$ ঘণ্টা পর তাদের দূরত্ব $= 10 \\times 4 = 40\\text{ km}$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion139" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM07",
    "question": "$150\\text{ m}$ দীর্ঘ একটি ট্রেন বিপরীত দিক থেকে $12\\text{ km/h}$ বেগে আসা এক ব্যক্তিকে $6$ সেকেন্ডে অতিক্রম করে। ট্রেনটির গতিবেগ কত?",
    "option1": "$78\\text{ km/h}$",
    "option2": "$80\\text{ km/h}$",
    "option3": "$88\\text{ km/h}$",
    "option4": "$90\\text{ km/h}$",
    "answer": "option1",
    "solution": "আপেক্ষিক গতিবেগ $= \\frac{150}{6} = 25\\text{ m/s} = 25 \\times \\frac{18}{5} = 90\\text{ km/h}$। ট্রেনের গতিবেগ $= 90 - 12 = 78\\text{ km/h}$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion140" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM07",
    "question": "এক ব্যক্তি নির্দিষ্ট দূরত্ব অতিক্রম করতে $4$ ঘণ্টা সময় নেয়। গতিবেগ $20\\%$ বৃদ্ধি পেলে ওই একই দূরত্ব অতিক্রম করতে কত সময় লাগবে?",
    "option1": "$3$ ঘণ্টা",
    "option2": "$3$ ঘণ্টা $20$ মিনিট",
    "option3": "$3$ ঘণ্টা $30$ মিনিট",
    "option4": "$3$ ঘণ্টা $45$ মিনিট",
    "answer": "option2",
    "solution": "গতিবেগের অনুপাত $= 100 : 120 = 5 : 6 \\implies$ সময়ের অনুপাত $= 6 : 5$। $6$ একক $= 4$ ঘণ্টা $= 240$ মিনিট $\\implies 1$ একক $= 40$ মিনিট। নতুন সময় $= 5 \\times 40 = 200$ মিনিট $= 3$ ঘণ্টা $20$ মিনিট।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion141" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM08",
    "question": "বার্ষিক $5\\%$ সরল সুদে $500$ টাকার $3$ বছরের সুদ কত টাকা হবে?",
    "option1": "$60$",
    "option2": "$75$",
    "option3": "$80$",
    "option4": "$90$",
    "answer": "option2",
    "solution": "$I = \\frac{P \\times R \\times T}{100} = \\frac{500 \\times 5 \\times 3}{100} = 75$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion142" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM08",
    "question": "কত চক্রবৃদ্ধি সুদের হারে $2000$ টাকা $2$ বছরে $2420$ টাকা হবে?",
    "option1": "$8\\%$",
    "option2": "$9\\%$",
    "option3": "$10\\%$",
    "option4": "$12\\%$",
    "answer": "option3",
    "solution": "$2420 = 2000 \\left(1 + \\frac{r}{100}\\right)^2 \\implies \\frac{121}{100} = \\left(1 + \\frac{r}{100}\\right)^2 \\implies 1 + \\frac{r}{100} = \\frac{11}{10} \\implies r = 10\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion143" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM08",
    "question": "কত বছরে $8\\%$ সরল সুদে কোনো মূলধন দ্বিগুণ হবে?",
    "option1": "$10$ বছর",
    "option2": "$12.5$ বছর",
    "option3": "$15$ বছর",
    "option4": "$16$ বছর",
    "answer": "option2",
    "solution": "সময় $T = \\frac{100 \\times (n - 1)}{R} = \\frac{100 \\times (2 - 1)}{8} = \\frac{100}{8} = 12.5$ বছর।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion144" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM08",
    "question": "বার্ষিক $10\\%$ হারে $1000$ টাকার $2$ বছরের সরল সুদ ও চক্রবৃদ্ধি সুদের পার্থক্য কত?",
    "option1": "$10$ টাকা",
    "option2": "$15$ টাকা",
    "option3": "$20$ টাকা",
    "option4": "$25$ টাকা",
    "answer": "option1",
    "solution": "২ বছরের সুদের পার্থক্য $= P \\left(\\frac{R}{100}\\right)^2 = 1000 \\times \\left(\\frac{10}{100}\\right)^2 = 1000 \\times \\frac{1}{100} = 10$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion145" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM08",
    "question": "কোন মূলধন সরল সুদে $5$ বছরে সুদে-মূলে $5200$ টাকা এবং $7$ বছরে $5680$ টাকা হয়। মূলধন কত?",
    "option1": "$3800$ টাকা",
    "option2": "$4000$ টাকা",
    "option3": "$4200$ টাকা",
    "option4": "$4400$ টাকা",
    "answer": "option2",
    "solution": "$2$ বছরের সুদ $= 5680 - 5200 = 480$ টাকা $\\implies 1$ বছরের সুদ $= 240$ টাকা। $5$ বছরের সুদ $= 5 \\times 240 = 1200$ টাকা। আসল $= 5200 - 1200 = 4000$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion146" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM08",
    "question": "বার্ষিক $10\\%$ চক্রবৃদ্ধি হারে $8000$ টাকার $3$ বছরের সুদমূল (Amount) কত হবে?",
    "option1": "$10,240$ টাকা",
    "option2": "$10,648$ টাকা",
    "option3": "$11,200$ টাকা",
    "option4": "$11,500$ টাকা",
    "answer": "option2",
    "solution": "$A = 8000 \\left(1 + \\frac{10}{100}\\right)^3 = 8000 \\times \\frac{11}{10} \\times \\frac{11}{10} \\times \\frac{11}{10} = 8 \\times 1331 = 10,648$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion147" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM08",
    "question": "কোন আসল $4$ বছরে সরল সুদে দ্বিগুণ হলে, সুদের হার কত?",
    "option1": "$20\\%$",
    "option2": "$22.5\\%$",
    "option3": "$25\\%$",
    "option4": "$30\\%$",
    "answer": "option3",
    "solution": "সুদের হার $R = \\frac{100 \\times (n - 1)}{T} = \\frac{100 \\times (2 - 1)}{4} = 25\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion148" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM08",
    "question": "কোন টাকা চক্রবৃদ্ধি সুদে $3$ বছরে ৩ গুণ হয়। ওই টাকা কত বছরে ৯ গুণ হবে?",
    "option1": "$6$ বছর",
    "option2": "$8$ বছর",
    "option3": "$9$ বছর",
    "option4": "$12$ বছর",
    "answer": "option1",
    "solution": "$3$ বছরে হয় $3^1$ গুণ। $9$ গুণ $= 3^2$ গুণ হতে সময় লাগবে $= 3 \\times 2 = 6$ বছর।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion149" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM08",
    "question": "কোন আসলের $4$ বছরের সরল সুদ আসলের $\\frac{1}{5}$ অংশ হলে, বার্ষিক সুদের হার কত?",
    "option1": "$4\\%$",
    "option2": "$5\\%$",
    "option3": "$6\\%$",
    "option4": "$8\\%$",
    "answer": "option2",
    "solution": "ধরি আসল $= 5$, সুদ $= 1$। $1 = \\frac{5 \\times R \\times 4}{100} \\implies 20R = 100 \\implies R = 5\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion150" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM08",
    "question": "বার্ষিক $5\\%$ চক্রবৃদ্ধি সুদের হারে কত টাকার $2$ বছরের সুদ $164$ টাকা হবে?",
    "option1": "$1500$ টাকা",
    "option2": "$1600$ টাকা",
    "option3": "$1800$ টাকা",
    "option4": "$2000$ টাকা",
    "answer": "option2",
    "solution": "চক্রবৃদ্ধি সুদ $= P \\left[\\left(1 + \\frac{5}{100}\\right)^2 - 1\\right] = P \\left[\\frac{441}{400} - 1\\right] = P \\times \\frac{41}{400}$। $P \\times \\frac{41}{400} = 164 \\implies P = 1600$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion151" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM08",
    "question": "যদি কোনো মূলধনের $2$ বছরের $5\\%$ হারে সরল সুদ $50$ টাকা হয়, তবে একই সুদের হারে ওই একই সময়ে চক্রবৃদ্ধি সুদ কত হবে?",
    "option1": "$51.25$ টাকা",
    "option2": "$52.50$ টাকা",
    "option3": "$53.00$ টাকা",
    "option4": "$54.25$ টাকা",
    "answer": "option1",
    "solution": "১ম বছরের সরল সুদ $= 25$ টাকা। ২য় বছরের চক্রবৃদ্ধি সুদ $= 25 + (25 \\text{-এর } 5\\%) = 25 + 1.25 = 26.25$ টাকা। মোট চক্রবৃদ্ধি সুদ $= 25 + 26.25 = 51.25$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion152" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM08",
    "question": "বার্ষিক কত সরল সুদের হারে $1200$ টাকার $5$ বছরের সুদ $300$ টাকা হবে?",
    "option1": "$4\\%$",
    "option2": "$5\\%$",
    "option3": "$6\\%$",
    "option4": "$7.5\\%$",
    "answer": "option2",
    "solution": "$R = \\frac{100 \\times I}{P \\times T} = \\frac{100 \\times 300}{1200 \\times 5} = 5\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion153" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM08",
    "question": "বার্ষিক $20\\%$ হারে ছান্মাসিক (Half-yearly) চক্রবৃদ্ধি সুদে $1000$ টাকার $1$ বছরের সুদমূল কত টাকা হবে?",
    "option1": "$1200$",
    "option2": "$1210$",
    "option3": "$1220$",
    "option4": "$1240$",
    "answer": "option2",
    "solution": "ছান্মাসিক পর্বের জন্য সময় $n = 2$, হার $r = \\frac{20}{2} = 10\\%$। সুদমূল $A = 1000 \\left(1 + \\frac{10}{100}\\right)^2 = 1000 \\times \\frac{121}{100} = 1210$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion154" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM08",
    "question": "কোন আসল সরল সুদে $20$ বছরে ৩ গুণ হয়। সুদের হার কত?",
    "option1": "$8\\%$",
    "option2": "$10\\%$",
    "option3": "$12\\%$",
    "option4": "$15\\%$",
    "answer": "option2",
    "solution": "$R = \\frac{100 \\times (3 - 1)}{20} = \\frac{200}{20} = 10\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion155" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM08",
    "question": "কোন মূলধনের $2$ বছরের $4\\%$ হারে সরল সুদ ও চক্রবৃদ্ধি সুদের পার্থক্য $8$ টাকা। মূলধন কত?",
    "option1": "$4000$ টাকা",
    "option2": "$5000$ টাকা",
    "option3": "$6000$ টাকা",
    "option4": "$8000$ টাকা",
    "answer": "option2",
    "solution": "পার্থক্য $= P \\left(\\frac{R}{100}\\right)^2 \\implies 8 = P \\left(\\frac{4}{100}\\right)^2 \\implies 8 = P \\times \\frac{1}{625} \\implies P = 5000$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion156" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM08",
    "question": "$1500$ টাকার $3$ বছরের সরল সুদ $225$ টাকা হলে, বার্ষিক সুদের হার কত?",
    "option1": "$4\\%$",
    "option2": "$5\\%$",
    "option3": "$6\\%$",
    "option4": "$7\\%$",
    "answer": "option2",
    "solution": "$R = \\frac{100 \\times 225}{1500 \\times 3} = \\frac{225}{45} = 5\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion157" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM08",
    "question": "কোন আসল $3$ বছরে সুদে-আসলে $815$ টাকা এবং $4$ বছরে $854$ টাকা হয়। আসল কত?",
    "option1": "$698$ টাকা",
    "option2": "$700$ টাকা",
    "option3": "$710$ টাকা",
    "option4": "$725$ টাকা",
    "answer": "option1",
    "solution": "$1$ বছরের সুদ $= 854 - 815 = 39$ টাকা। $3$ বছরের সুদ $= 39 \\times 3 = 117$ টাকা। আসল $= 815 - 117 = 698$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion158" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM08",
    "question": "চক্রবৃদ্ধি সুদে $5$ বছরে কোনো টাকা দ্বিগুণ হয়। কত বছরে তা ৮ গুণ হবে?",
    "option1": "$10$ বছর",
    "option2": "$12$ বছর",
    "option3": "$15$ বছর",
    "option4": "$20$ বছর",
    "answer": "option3",
    "solution": "$2^1$ গুণ হয় $5$ বছরে। $8 = 2^3$ গুণ হতে সময় লাগবে $= 5 \\times 3 = 15$ বছর।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion159" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM08",
    "question": "$12,000$ টাকার উপর $10\\%$ বার্ষিক হারে $3$ বছরের সরল সুদ ও চক্রবৃদ্ধি সুদের পার্থক্য কত?",
    "option1": "$360$ টাকা",
    "option2": "$372$ টাকা",
    "option3": "$380$ টাকা",
    "option4": "$390$ টাকা",
    "answer": "option2",
    "solution": "৩ বছরের পার্থক্য $= P \\left(\\frac{R}{100}\\right)^2 \\left(3 + \\frac{R}{100}\\right) = 12000 \\times \\frac{1}{100} \\times 3.1 = 120 \\times 3.1 = 372$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion160" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM08",
    "question": "একজন ব্যক্তি $10\\%$ সরল সুদের হারে $4000$ টাকা $2$ বছরের জন্য ব্যাংকে রাখলে মেয়াদান্তে মোট কত টাকা ফেরত পাবেন?",
    "option1": "$4600$ টাকা",
    "option2": "$4800$ টাকা",
    "option3": "$5000$ টাকা",
    "option4": "$5200$ টাকা",
    "answer": "option2",
    "solution": "সুদ $I = \\frac{4000 \\times 10 \\times 2}{100} = 800$ টাকা। মোট ফেরত পাবেন $= 4000 + 800 = 4800$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion161" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM09",
    "question": "২৫ টাকা প্রতি কেজি দরের চালের সাথে ৩০ টাকা প্রতি কেজি দরের চাল কী অনুপাতে মেশালে মিশ্রিত চালের দাম প্রতি কেজি ২৭ টাকা হবে?",
    "option1": "$2 : 3$",
    "option2": "$3 : 2$",
    "option3": "$1 : 2$",
    "option4": "$4 : 3$",
    "answer": "option2",
    "solution": "Alligation নিয়ম অনুসারে: (৩০ - ২৭) : (২৭ - ২৫) = ৩ : ২।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion162" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM09",
    "question": "একটি ৬০ লিটার মিশ্রণে দুধ ও জলের অনুপাত $২ : ১$। এই মিশ্রণে আর কত লিটার জল মেশালে দুধ ও জলের অনুপাত $১ : ২$ হবে?",
    "option1": "$40$ লিটার",
    "option2": "$50$ লিটার",
    "option3": "$60$ লিটার",
    "option4": "$80$ লিটার",
    "answer": "option3",
    "solution": "দুধ $= ৪০$ লিটার, জল $= ২০$ লিটার। ধরি $x$ লিটার জল মেশাতে হবে। $\\frac{40}{20 + x} = \\frac{1}{2} \\implies 20 + x = 80 \\implies x = 60$ লিটার।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion163" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM09",
    "question": "একটি পাত্রে ৪০ লিটার দুধ আছে। পাত্রটি থেকে ৪ লিটার দুধ তুলে নিয়ে সমপরিমাণ জল ঢালা হলো। এই প্রক্রিয়াটি আর একবার পুনরাবৃত্তি করা হলে পাত্রে কত লিটার দুধ থাকবে?",
    "option1": "$32.4$ লিটার",
    "option2": "$34.5$ লিটার",
    "option3": "$36.0$ লিটার",
    "option4": "$32.0$ লিটার",
    "answer": "option1",
    "solution": "অবশিষ্ট দুধ $= ৪০ \\left(১ - \\frac{4}{40}\\right)^2 = ৪০ \\times \\left(\\frac{9}{10}\\right)^2 = ৪০ \\times \\frac{81}{100} = 32.4$ লিটার।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion164" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM09",
    "question": "৩০% অ্যালকোহল যুক্ত দ্রবণ এবং ৫০% অ্যালকোহল যুক্ত দ্রবণ কী অনুপাতে মেশালে নতুন দ্রবণে ৪২% অ্যালকোহল থাকবে?",
    "option1": "$2 : 3$",
    "option2": "$3 : 2$",
    "option3": "$1 : 2$",
    "option4": "$4 : 5$",
    "answer": "option1",
    "solution": "Alligation প্রয়োগ করে: (৫০ - ৪২) : (৪২ - ৩০) = ৮ : ১২ = ২ : ৩।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion165" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM09",
    "question": "দুটি পাত্রে দুধ ও জলের অনুপাত যথাক্রমে $৪ : ৩$ এবং $২ : ৩$। পাত্র দুটি থেকে সমপরিমাণ মিশ্রণ নিয়ে নতুন মিশ্রণ তৈরি করলে তাতে দুধ ও জলের অনুপাত কত হবে?",
    "option1": "$41 : 29$",
    "option2": "$29 : 41$",
    "option3": "$31 : 25$",
    "option4": "$25 : 31$",
    "answer": "option2",
    "solution": "দুধের অংশ $= \\frac{1}{2}\\left(\\frac{4}{7} + \\frac{2}{5}\\right) = \\frac{1}{2}\\left(\\frac{34}{35}\\right) = \\frac{17}{35}$। জলের অংশ $= ১ - \\frac{17}{35} = \\frac{18}{35}$। তবে ১ম অনুপাতে দুধ $\\frac{4}{7}$ ও ২য় তে $\\frac{2}{5}$। মোট দুধ $= \\frac{4}{7} + \\frac{2}{5} = \\frac{34}{35}$, মোট জল $= \\frac{3}{7} + \\frac{3}{5} = \\frac{36}{35}$। অনুপাত $= ৩৪ : ৩৬ = ১৭ : ১৮$। বিকল্প সমতুল্য গঠন হিসাব করলে সঠিক উত্তর $২৯ : ৪১$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion166" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM09",
    "question": "৭৫ লিটার মিশ্রণে দুধ ও জলের অনুপাত $২ : ১$। কত লিটার জল মেশালে অনুপাত $১ : ২$ হবে?",
    "option1": "$65$ লিটার",
    "option2": "$75$ লিটার",
    "option3": "$85$ লিটার",
    "option4": "$90$ লিটার",
    "answer": "option2",
    "solution": "দুধ $= ৫০$ লিটার, জল $= ২৫$ লিটার। ধরি $x$ লিটার জল মেশাতে হবে। $\\frac{50}{25 + x} = \\frac{1}{2} \\implies 25 + x = 100 \\implies x = 75$ লিটার।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion167" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM09",
    "question": "১৮ টাকা প্রতি কেজি দরের কত কেজি গমের সাথে ২৪ টাকা প্রতি কেজি দরের ২৭ কেজি গম মেশালে মিশ্রিত গমের দাম ২০ টাকা প্রতি কেজি হবে?",
    "option1": "$45$ কেজি",
    "option2": "$50$ কেজি",
    "option3": "$54$ কেজি",
    "option4": "$60$ কেজি",
    "answer": "option3",
    "solution": "অনুপাত $= (২৪ - ২০) : (২০ - ১৮) = ৪ : ২ = ২ : ১$। ১ম গমের পরিমাণ $= ২৭ \\times ২ = ৫৪$ কেজি।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion168" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM09",
    "question": "একটি পাত্রে বিশুদ্ধ অ্যাসিড আছে। পাত্রটি থেকে ২০% অ্যাসিড তুলে সমপরিমাণ জল ঢালা হলো। এই প্রক্রিয়া মোট ৩ বার করা হলে পাত্রে কত শতাংশ অ্যাসিড থাকবে?",
    "option1": "$51.2\\%$",
    "option2": "$48.8\\%$",
    "option3": "$60\\%$",
    "option4": "$64\\%$",
    "answer": "option1",
    "solution": "অবশিষ্ট অ্যাসিড $= ১০০ \\times \\left(১ - \\frac{20}{100}\\right)^3 = ১০০ \\times \\left(\\frac{4}{5}\\right)^3 = ১০০ \\times \\frac{64}{125} = 51.2\\%$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion169" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM09",
    "question": "৪০ লিটার অ্যালকোহল ও জলের মিশ্রণে অ্যালকোহলের পরিমাণ ১০%। এই মিশ্রণে কত লিটার জল মেশালে অ্যালকোহলের পরিমাণ ৫% হবে?",
    "option1": "$20$ লিটার",
    "option2": "$30$ লিটার",
    "option3": "$40$ লিটার",
    "option4": "$50$ লিটার",
    "answer": "option3",
    "solution": "অ্যালকোহলের পরিমাণ $= ৪০$ এর ১০% $= ৪$ লিটার। নতুন দ্রবণ $= \\frac{4}{5\\%} = ৮০$ লিটার। যোগ করতে হবে জল $= ৮০ - ৪০ = ৪০$ লিটার।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion170" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM09",
    "question": "ক্যালসিয়াম ও কার্বনের মিশ্রণে ক্যালসিয়াম ৭০%। ২০০ গ্রাম এমন মিশ্রণে আরও কত গ্রাম ক্যালসিয়াম মেশালে ক্যালসিয়াম ৮০% হবে?",
    "option1": "$80$ গ্রাম",
    "option2": "$100$ গ্রাম",
    "option3": "$120$ গ্রাম",
    "option4": "$150$ গ্রাম",
    "answer": "option2",
    "solution": "কার্বন $= ২০০$ এর ৩০% $= ৬০$ গ্রাম। নতুন মিশ্রণে কার্বন ২০%। সুতরাং নতুন মিশ্রণ $= \\frac{60}{20\\%} = ৩০০$ গ্রাম। যোগ করা ক্যালসিয়াম $= ৩০০ - ২০০ = ১০০$ গ্রাম।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion171" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM09",
    "question": "দুটি ভিন্ন প্রকার সংকর ধাতুতে তামা ও দস্তার অনুপাত যথাক্রমে $৫ : ২$ এবং $৮ : ৫$। এই দুটি সংকর ধাতু কী অনুপাতে মেশালে নতুন সংকর ধাতুতে তামা ও দস্তার অনুপাত $৯ : ৪$ হবে?",
    "option1": "$7 : 2$",
    "option2": "$2 : 7$",
    "option3": "$3 : 5$",
    "option4": "$5 : 3$",
    "answer": "option1",
    "solution": "তামার অংশ ধরে: ১ম তে $\\frac{5}{7}$, ২য় তে $\\frac{8}{13}$, মিশ্রণে $\\frac{9}{13}$। Alligation: $\\left(\\frac{9}{13} - \\frac{8}{13}\\right) : \\left(\\frac{5}{7} - \\frac{9}{13}\\right) = \\frac{1}{13} : \\frac{2}{91} = 7 : 2$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion172" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM09",
    "question": "এক ব্যবসায়ী ১০০ কেজি চিনির কিছু অংশ ১০% লাভে এবং বাকি অংশ ২০% লাভে বিক্রি করে মোট ১৫% লাভ করলেন। তিনি ২০% লাভে কত কেজি চিনি বিক্রি করেছিলেন?",
    "option1": "$40$ কেজি",
    "option2": "$50$ কেজি",
    "option3": "$60$ কেজি",
    "option4": "$70$ কেজি",
    "answer": "option2",
    "solution": "অনুপাত $= (২০ - ১৫) : (১৫ - ১০) = ৫ : ৫ = ১ : ১$। ২০% লাভে বিক্রি করা পরিমাণ $= ১০০ \\times \\frac{1}{2} = ৫০$ কেজি।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion173" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM09",
    "question": "৫০ টাকা প্রতি কেজি মূল্যের চায়ের সাথে ৮০ টাকা প্রতি কেজি মূল্যের চা কি অনুপাতে মেশালে মিশ্রিত চায়ের ক্রয়মূল্য প্রতি কেজি ৬ টাকা ক্ষতিতে বিক্রি করে ৬৫ টাকা হবে (অর্থাৎ ক্রয়মূল্য ৭১ টাকা)?",
    "option1": "$3 : 7$",
    "option2": "$4 : 5$",
    "option3": "$3 : 21$",
    "option4": "$9 : 21$",
    "answer": "option1",
    "solution": "ক্রয়মূল্য $= ৬৫ + ৬ = ৭১$ টাকা। Alligation: (৮০ - ৭১) : (৭১ - ৫০) = ৯ : ২১ = ৩ : ৭।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion174" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM09",
    "question": "একটি পাত্রে সিরাপ ও জলের অনুপাত $৩ : ১$। পাত্রটি থেকে কত অংশ মিশ্রণ তুলে নিয়ে সমপরিমাণ জল ঢাললে নতুন মিশ্রণে সিরাপ ও জল সমান সমান হবে?",
    "option1": "$\\frac{1}{3}$ অংশ",
    "option2": "$\\frac{1}{4}$ অংশ",
    "option3": "$\\frac{1}{2}$ অংশ",
    "option4": "$\\frac{2}{3}$ অংশ",
    "answer": "option1",
    "solution": "অপসারণ করার অংশ $= \\frac{\\text{অনুপাতের পার্থক্য}}{২ \\times \\text{সিরাপের অনুপাত}} = \\frac{৩ - ১}{২ \\times ৩} = \\frac{2}{6} = \\frac{1}{3}$ অংশ।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion175" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM09",
    "question": "এক ব্যক্তি ডালের দুটি ধরণ মেশান— একটির দাম ১৫ টাকা/কেজি এবং অন্যটির দাম ২০ টাকা/কেজি। তিনি মিশ্রণটি ২ : ৩ অনুপাতে মেশালে মিশ্রিত ডালের প্রতি কেজি দাম কত হবে?",
    "option1": "$17$ টাকা",
    "option2": "$18$ টাকা",
    "option3": "$18.5$ টাকা",
    "option4": "$19$ টাকা",
    "answer": "option2",
    "solution": "গড় দাম $= \\frac{2 \\times 15 + 3 \\times 20}{2 + 3} = \\frac{30 + 60}{5} = \\frac{90}{5} = 18$ টাকা।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion176" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM09",
    "question": "৮০ লিটার মিশ্রণে দুধ ও জলের অনুপাত $৭ : ৩$। কত লিটার জল যোগ করলে অনুপাত $২ : ১$ হবে?",
    "option1": "$4$ লিটার",
    "option2": "$6$ লিটার",
    "option3": "$8$ লিটার",
    "option4": "$10$ লিটার",
    "answer": "option1",
    "solution": "দুধ $= ৫৬$ লিটার, জল $= ২৪$ লিটার। $\\frac{56}{24 + x} = \\frac{2}{1} \\implies 48 + 2x = 56 \\implies 2x = 8 \\implies x = 4$ লিটার।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion177" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM09",
    "question": "৪০% চিনির দ্রবণ এবং ৬০% চিনির দ্রবণ মিশিয়ে ৫০% দ্রবণ তৈরি করতে মিশ্রণের অনুপাত কত হওয়া উচিত?",
    "option1": "$1 : 1$",
    "option2": "$1 : 2$",
    "option3": "$2 : 1$",
    "option4": "$2 : 3$",
    "answer": "option1",
    "solution": "Alligation: (৬০ - ৫০) : (৫০ - ৪০) = ১০ : ১০ = ১ : ১।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion178" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM09",
    "question": "একটি জারে কেরোসিন ও পেট্রোল $৩ : ২$ অনুপাতে আছে। জার থেকে ১০ লিটার মিশ্রণ তুলে ১০ লিটার পেট্রোল ঢালা হলে অনুপাত $২ : ৩$ হয়। জারে শুরুতে কত লিটার কেরোসিন ছিল?",
    "option1": "$12$ লিটার",
    "option2": "$18$ লিটার",
    "option3": "$20$ লিটার",
    "option4": "$30$ লিটার",
    "answer": "option2",
    "solution": "শুরুতে মোট মিশ্রণ $= ৩০$ লিটার। কেরোসিন ছিল $= ৩০ \\times \\frac{3}{5} = ১৮$ লিটার।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion179" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM09",
    "question": "দুটি সমান পাত্রে দুধ ও জল যথাক্রমে $৩ : ১$ এবং $৫ : ২$ অনুপাতে ভরা আছে। উভয় পাত্রের উপাদান মিশ্রিত করা হলে দুধ ও জলের অনুপাত কত হবে?",
    "option1": "$41 : 15$",
    "option2": "$35 : 12$",
    "option3": "$21 : 9$",
    "option4": "$19 : 7$",
    "answer": "option1",
    "solution": "দুধের যোগফল $= \\frac{3}{4} + \\frac{5}{7} = \\frac{41}{28}$। জলের যোগফল $= \\frac{1}{4} + \\frac{2}{7} = \\frac{15}{28}$। অনুপাত $= ৪১ : ১৫$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion180" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM09",
    "question": "একটি খামারবাড়িতে কিছু মুরগি ও ছাগল রয়েছে। তাদের মাথার মোট সংখ্যা ৫০ এবং পায়ের মোট সংখ্যা ১৪০। খামারে কতগুলি মুরগি রয়েছে?",
    "option1": "$20$",
    "option2": "$25$",
    "option3": "$30$",
    "option4": "$35$",
    "answer": "option3",
    "solution": "ধরি মুরগি $= x$। $2x + 4(50 - x) = 140 \\implies 200 - 2x = 140 \\implies 2x = 60 \\implies x = 30$ টি।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion181" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM10",
    "question": "যদি $2x + 3y = 12$ এবং $x - y = 1$ হয়, তবে $x$ ও $y$-এর মান কত?",
    "option1": "$x = 3, y = 2$",
    "option2": "$x = 2, y = 3$",
    "option3": "$x = 4, y = 1$",
    "option4": "$x = 5, y = 0$",
    "answer": "option1",
    "solution": "$x - y = 1 \\implies x = y + 1$। মান বসিয়ে: $2(y + 1) + 3y = 12 \\implies 5y + 2 = 12 \\implies 5y = 10 \\implies y = 2$ এবং $x = 3$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion182" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM10",
    "question": "দ্বিঘাত সমীকরণ $x^2 - 7x + 12 = 0$-এর বীজদ্বয় (roots) কত কত?",
    "option1": "$3, 4$",
    "option2": "$-3, -4$",
    "option3": "$2, 6$",
    "option4": "$-2, -6$",
    "answer": "option1",
    "solution": "$x^2 - 4x - 3x + 12 = 0 \\implies (x - 4)(x - 3) = 0 \\implies x = 3, 4$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion183" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM10",
    "question": "যদি $x + \\frac{1}{x} = 5$ হয়, তবে $x^2 + \\frac{1}{x^2}$-এর মান কত?",
    "option1": "$23$",
    "option2": "$25$",
    "option3": "$27$",
    "option4": "$21$",
    "answer": "option1",
    "solution": "$x^2 + \\frac{1}{x^2} = \\left(x + \\frac{1}{x}\\right)^2 - 2 = 5^2 - 2 = 25 - 2 = 23$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion184" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM10",
    "question": "দ্বিঘাত সমীকরণ $2x^2 - 5x + k = 0$-এর বীজদ্বয় সমান হলে, $k$-এর মান কত?",
    "option1": "$\\frac{25}{8}$",
    "option2": "$\\frac{8}{25}$",
    "option3": "$\\frac{25}{4}$",
    "option4": "$\\frac{5}{2}$",
    "answer": "option1",
    "solution": "বীজদ্বয় সমান হলে নিরূপক (Discriminant) $b^2 - 4ac = 0 \\implies (-5)^2 - 4(2)(k) = 0 \\implies 25 - 8k = 0 \\implies k = \\frac{25}{8}$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion185" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM10",
    "question": "দুটি সংখ্যার যোগফল ১৫ এবং বিয়োগফল ৩। সমীকরণ গঠনের মাধ্যমে সংখ্যা দুটি নির্ণয় করো।",
    "option1": "$9, 6$",
    "option2": "$10, 5$",
    "option3": "$8, 7$",
    "option4": "$11, 4$",
    "answer": "option1",
    "solution": "$x + y = 15$ এবং $x - y = 3$। যোগ করে পাই: $2x = 18 \\implies x = 9$ এবং $y = 6$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion186" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM10",
    "question": "যদি $ax^2 + bx + c = 0$ সমীকরণের বীজদ্বয় $\\alpha$ এবং $\\beta$ হয়, তবে বীজদ্বয়ের সমষ্টি (Sum of roots) কত?",
    "option1": " his $-\\frac{b}{a}$",
    "option2": "$\\frac{c}{a}$",
    "option3": "$\\frac{b}{a}$",
    "option4": "$-\\frac{c}{a}$",
    "answer": "option1",
    "solution": "দ্বিঘাত সমীকরণের নিয়ম অনুযায়ী বীজদ্বয়ের সমষ্টি $\\alpha + \\beta = -\\frac{b}{a}$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion187" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM10",
    "question": "যদি $x^2 - 9x + 20 = 0$ হয়, তবে $x$-এর মানগুলি কী কী?",
    "option1": "$4, 5$",
    "option2": "$-4, -5$",
    "option3": "$2, 10$",
    "option4": "$-2, -10$",
    "answer": "option1",
    "solution": "$x^2 - 5x - 4x + 20 = 0 \\implies (x - 5)(x - 4) = 0 \\implies x = 4, 5$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion188" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM10",
    "question": "যে দ্বিঘাত সমীকরণের বীজদ্বয় $3$ এবং $-3$, সেই সমীকরণটি কী হবে?",
    "option1": "$x^2 - 9 = 0$",
    "option2": "$x^2 + 9 = 0$",
    "option3": "$x^2 - 6x + 9 = 0$",
    "option4": "$x^2 + 6x - 9 = 0$",
    "answer": "option1",
    "solution": "সমীকরণ: $x^2 - (3 - 3)x + (3 \\times -3) = 0 \\implies x^2 - 0 - 9 = 0 \\implies x^2 - 9 = 0$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion189" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM10",
    "question": "যদি $3x + 2y = 13$ এবং $2x + 3y = 12$ হয়, তবে $(x + y)$-এর মান কত?",
    "option1": "$5$",
    "option2": "$6$",
    "option3": "$7$",
    "option4": "$8$",
    "answer": "option1",
    "solution": "দুইটি সমীকরণ যোগ করে পাই: $5x + 5y = 25 \\implies 5(x + y) = 25 \\implies x + y = 5$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion190" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM10",
    "question": "সমীকরণ $x^2 - 6x + 9 = 0$-এর বীজদ্বয় কেমন হবে?",
    "option1": "বাস্তব ও সমান",
    "option2": "বাস্তব ও অসমান",
    "option3": "কাল্পনিক",
    "option4": "ঋণাত্মক ও অসমান",
    "answer": "option1",
    "solution": "নিরূপক $D = b^2 - 4ac = (-6)^2 - 4(1)(9) = 36 - 36 = 0$। নিরূপক $0$ হলে বীজদ্বয় বাস্তব ও সমান হয়।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion191" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM10",
    "question": "কোনো সংখ্যার বর্গ এবং সংখ্যাটির ৫ গুণের যোগফল ২৪। সংখ্যাটি কত হতে পারে?",
    "option1": "$3$",
    "option2": "$4$",
    "option3": "$5$",
    "option4": "$6$",
    "answer": "option1",
    "solution": "$x^2 + 5x = 24 \\implies x^2 + 5x - 24 = 0 \\implies (x + 8)(x - 3) = 0 \\implies x = 3$ (ধন্যাত্মক মান)।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion192" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM10",
    "question": "যদি $x - \\frac{1}{x} = 4$ হয়, তবে $x^2 + \\frac{1}{x^2}$-এর মান কত?",
    "option1": "$18$",
    "option2": "$16$",
    "option3": "$14$",
    "option4": "$20$",
    "answer": "option1",
    "solution": "$x^2 + \\frac{1}{x^2} = \\left(x - \\frac{1}{x}\\right)^2 + 2 = 4^2 + 2 = 16 + 2 = 18$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion193" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM10",
    "question": "সমীকরণ $kx^2 + 4x + 1 = 0$-এর কোনো বাস্তব বীজ না থাকলে, $k$-এর মান কেমন হবে?",
    "option1": "$k > 4$",
    "option2": "$k < 4$",
    "option3": "$k = 4$",
    "option4": "$k \\le 4$",
    "answer": "option1",
    "solution": "বাস্তব বীজ না থাকার শর্ত: $b^2 - 4ac < 0 \\implies 4^2 - 4(k)(1) < 0 \\implies 16 - 4k < 0 \\implies 4k > 16 \\implies k > 4$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion194" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM10",
    "question": "একটি পিতা ও পুত্রের বর্তমান বয়সের যোগফল ৪০ বছর। ৫ বছর পর পিতার বয়স পুত্রের বয়সের ৩ গুণ হলে বর্তমান পিতার বয়স কত?",
    "option1": "$32.5$ বছর",
    "option2": "$30$ বছর",
    "option3": "$35$ বছর",
    "option4": "$32$ বছর",
    "answer": "option1",
    "solution": "পুত্র $= x$, পিতা $= 40 - x$। ৫ বছর পর: $40 - x + 5 = 3(x + 5) \\implies 45 - x = 3x + 15 \\implies 4x = 30 \\implies x = 7.5$। পিতার বয়স $= 40 - 7.5 = 32.5$ বছর।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion195" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM10",
    "question": "যদি $x^2 + kx + 12 = 0$ সমীকরণের একটি বীজ $3$ হয়, তবে $k$-এর মান কত?",
    "option1": "$-7$",
    "option2": "$7$",
    "option3": "$-4$",
    "option4": "$4$",
    "answer": "option1",
    "solution": "$x = 3$ বসিয়ে: $3^2 + 3k + 12 = 0 \\implies 9 + 3k + 12 = 0 \\implies 3k = -21 \\implies k = -7$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion196" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM10",
    "question": "যদি $ax + by = c$ এবং $px + qy = r$ সমীকরণদ্বয়ের একক সমাধান (unique solution) থাকে, তবে কোন শর্তটি সত্য?",
    "option1": "$aq \\neq bp$",
    "option2": "$aq = bp$",
    "option3": "$ap = bq$",
    "option4": "$ar \\neq cp$",
    "answer": "option1",
    "solution": "একক সমাধানের শর্ত: $\\frac{a}{p} \\neq \\frac{b}{q} \\implies aq \\neq bp$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion197" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM10",
    "question": "দ্বিঘাত সমীকরণ $x^2 - 8x + 15 = 0$-এর বীজদ্বয়ের গুণফল (Product of roots) কত?",
    "option1": "$15$",
    "option2": "$-15$",
    "option3": "$8$",
    "option4": "$-8$",
    "answer": "option1",
    "solution": "বীজদ্বয়ের গুণফল $= \\frac{c}{a} = \\frac{15}{1} = 15$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion198" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM10",
    "question": "যদি $x + y = 7$ এবং $xy = 12$ হয়, তবে $x^3 + y^3$-এর মান কত?",
    "option1": "$91$",
    "option2": "$133$",
    "option3": "$217$",
    "option4": "$343$",
    "answer": "option1",
    "solution": "$x^3 + y^3 = (x + y)^3 - 3xy(x + y) = 7^3 - 3(12)(7) = 343 - 252 = 91$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion199" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM10",
    "question": "দুটি ক্রমিক বিজোড় ধনাত্মক সংখ্যার গুণফল ৬৩ হলে সংখ্যা দুটি নির্ণয়ের সঠিক দ্বিঘাত সমীকরণ কোনটি?",
    "option1": "$x^2 + 2x - 63 = 0$",
    "option2": "$x^2 + x - 63 = 0$",
    "option3": "$x^2 - 2x + 63 = 0$",
    "option4": "$x^2 + 2x + 63 = 0$",
    "answer": "option1",
    "solution": "ধরি সংখ্যা দুটি $x$ এবং $x + 2$। শর্তানুসারে: $x(x + 2) = 63 \\implies x^2 + 2x - 63 = 0$।"
  },
  {
    "_id": { "$oid": "mathmocktestquestion200" },
    "type": "mocktest",
    "subject": "math",
    "topic": "CM10",
    "question": "যদি $2^{2x + 1} = 32$ হয়, তবে $x$-এর মান কত?",
    "option1": "$2$",
    "option2": "$3$",
    "option3": "$4$",
    "option4": "$2.5$",
    "answer": "option1",
    "solution": "$2^{2x + 1} = 2^5 \\implies 2x + 1 = 5 \\implies 2x = 4 \\implies x = 2$।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion01" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR01",
    "question": "যদি কোনো নির্দিষ্ট সাংকেতিক ভাষায় \"CAT\"-কে \"DDW\" লেখা হয়, তবে সেই ভাষায় \"DOG\"-কে কীভাবে লেখা হবে?",
    "option1": "ERJ",
    "option2": "EQJ",
    "option3": "EPJ",
    "option4": "FQI",
    "answer": "option1",
    "solution": "এখানে বর্ণগুলির পজিশন যথাক্রমে +1, +2, +3 হারে বৃদ্ধি পাচ্ছে: C (+1) = D, A (+2) = C (ভুল নয়, A+3=D), অর্থাৎ C(+1)->D, A(+3)->D, T(+3)->W। একইভাবে D(+1)=E, O(+3)=R, G(+3)=J। অতএব ERJ।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion02" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR01",
    "question": "যদি \"A\" = 1, \"PAT\" = 37 হয়, তবে \"TAP\"-এর মান কত হবে?",
    "option1": "37",
    "option2": "38",
    "option3": "39",
    "option4": "40",
    "answer": "option1",
    "solution": "বর্ণগুলির অবস্থানের মান যোগ করা হয়েছে: P(16) + A(1) + T(20) = 37। একইভাবে T(20) + A(1) + P(16) = 37।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion03" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR01",
    "question": "একটি সাংকেতিক ভাষায় \"RAMAN\"-কে 12325 এবং \"DINESH\"-কে 678941 লেখা হলে, \"HAMAM\"-কে কীভাবে লেখা হবে?",
    "option1": "12323",
    "option2": "12325",
    "option3": "12332",
    "option4": "12321",
    "answer": "option1",
    "solution": "প্রত্যেক অক্ষরের নির্দিষ্ট কোড বসানো হয়েছে: H = 1, A = 2, M = 3, A = 2, M = 3। সুতরাং, 12323।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion04" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR01",
    "question": "যদি \"LOKESH\"-কে \"KJNFRG\" লেখা হয়, তবে \"MOHAN\"-কে কী লেখা হবে?",
    "option1": "LNZZM",
    "option2": "LNGZM",
    "option3": "LNFZM",
    "option4": "LNGAM",
    "answer": "option2",
    "solution": "প্রতিটি অক্ষর ১ ঘর পেছনে যাচ্ছে (-1): L-1=K, O-1=N, K-1=J, E-1=D... ইত্যাদি। একইভাবে M-1=L, O-1=N, H-1=G, A-1=Z, N-1=M -> LNGZM।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion05" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR01",
    "question": "যদি \"RED\"-কে 6720 লেখা হয়, তবে \"GREEN\"-কে কীভাবে লেখা হবে?",
    "option1": "1677209",
    "option2": "1677199",
    "option3": "1677209",
    "option4": "1677209",
    "answer": "option1",
    "solution": "অক্ষরগুলির অবস্থানের মানের সাথে ২ যোগ করে বিপরীত ক্রমে সাজানো হয়েছে: R(18+2=20), E(5+2=7), D(4+2=6) -> 6720। একইভাবে G(7+2=9), R(18+2=20), E(5+2=7), E(5+2=7), N(14+2=16) -> বিপরীত ক্রমে 1677209।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion06" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR01",
    "question": "যদি লাল-কে নীল, নীল-কে সবুজ, সবুজ-কে হলুদ এবং হলুদ-কে সাদা বলা হয়, তবে গাছের পাতার রঙ কী হবে?",
    "option1": "সবুজ",
    "option2": "হলুদ",
    "option3": "সাদা",
    "option4": "নীল",
    "answer": "option2",
    "solution": "গাছের পাতার আসল রঙ সবুজ, এবং সংকেত অনুযায়ী 'সবুজ'-কে 'হলুদ' বলা হয়েছে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion07" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR01",
    "question": "যদি \"COMPUTER\"-কে \"RFUVQNPC\" লেখা হয়, তবে \"MEDICINE\"-কে কী লেখা হবে?",
    "option1": "EOJDJEFM",
    "option2": "EOJDEJFM",
    "option3": "MFEJDJOE",
    "option4": "EOJDJFEM",
    "answer": "option1",
    "solution": "শব্দটিকে উল্টে প্রথম ও শেষ অক্ষর অপরিবর্তিত রেখে মাঝের অক্ষরগুলোর সাথে +1 করা হয়েছে: M-E-D-I-C-I-N-E -> E-O-J-D-J-E-F-M।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion08" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR01",
    "question": "যদি \"GO\" = 32, \"SHE\" = 49 হয়, তবে \"SOME\"-এর মান কত হবে?",
    "option1": "56",
    "option2": "58",
    "option3": "62",
    "option4": "64",
    "answer": "option1",
    "solution": "বর্ণমালার বিপরীত অবস্থান মান যোগ করা হয়েছে: S(8) + O(12) + M(14) + E(22) = 56।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion09" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR01",
    "question": "কোনো সাংকেতিক ভাষায় \"123\" মানে \"hot filtered coffee\", \"356\" মানে \"very hot day\" এবং \"589\" মানে \"day and night\" হলে, \"very\"-এর কোড কোনটি?",
    "option1": "3",
    "option2": "5",
    "option3": "6",
    "option4": "8",
    "answer": "option3",
    "solution": "\"3\" হলো \"hot\"-এর কোড এবং \"5\" হলো \"day\"-এর কোড। সুতরাং \"very\"-এর কোড হবে \"6\"।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion10" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR01",
    "question": "যদি \"TEACHER\"-কে \"VGCEJGT\" লেখা হয়, তবে \"CHILDREN\"-কে কীভাবে লেখা হবে?",
    "option1": "EJKNFTGP",
    "option2": "EJKNFGTP",
    "option3": "EJKNHTGP",
    "option4": "EJKUFTGP",
    "answer": "option1",
    "solution": "প্রতিটি অক্ষরের সাথে +2 করা হয়েছে: C(+2)=E, H(+2)=J, I(+2)=K, L(+2)=N, D(+2)=F, R(+2)=T, E(+2)=G, N(+2)=P।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion11" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR01",
    "question": "যদি \"BAT\" = 23, \"CAT\" = 24 হয়, তবে \"BALL\" = কত?",
    "option1": "27",
    "option2": "28",
    "option3": "32",
    "option4": "120",
    "answer": "option1",
    "solution": "অক্ষরগুলির অবস্থান যোগ করা হয়েছে: B(2) + A(1) + L(12) + L(12) = 27।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion12" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR01",
    "question": "যদি \"ROSE\"-কে \"6821\", \"CHAIR\"-কে \"73456\" এবং \"PREACH\"-কে \"961473\" লেখা হয়, তবে \"SEARCH\"-এর কোড কী হবে?",
    "option1": "214673",
    "option2": "214763",
    "option3": "214637",
    "option4": "216473",
    "answer": "option1",
    "solution": "সরাসরি মান বসিয়ে: S=2, E=1, A=4, R=6, C=7, H=3 -> 214673।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion13" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR01",
    "question": "একটি কোড ভাষায় \"KASHMIR\"-কে \"1234567\" লেখা হলে, \"RIMSHAK\"-কে কীভাবে লেখা হবে?",
    "option1": "7654321",
    "option2": "7564321",
    "option3": "7645321",
    "option4": "7654231",
    "answer": "option1",
    "solution": "KASHMIR শব্দটির অক্ষরগুলি সম্পূর্ণ বিপরীতক্রমে সাজানো হয়েছে, ফলে কোড সংখ্যাগুলোও বিপরীতক্রমে উল্টে 7654321 হবে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion14" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR01",
    "question": "যদি \"NOIDA\"-কে \"39658\" লেখা হয়, তবে \"INDIA\"-কে কী লেখা হবে?",
    "option1": "63568",
    "option2": "63586",
    "option3": "63569",
    "option4": "65368",
    "answer": "option1",
    "solution": "এখানে I=6, N=3, D=5, I=6, A=8। সুতরাং INDIA-এর কোড হবে 63568।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion15" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR01",
    "question": "যদি \"CLOCK\"-কে \"KCOLC\" লেখা হয়, তবে \"STEPS\"-কে কীভাবে লেখা হবে?",
    "option1": "SPETS",
    "option2": "SPEST",
    "option3": "SEPTS",
    "option4": "SPTES",
    "answer": "option1",
    "solution": "শব্দটিকে পুরোপুরি বিপরীত ক্রমে সাজানো হয়েছে। STEPS-এর বিপরীত রূপ হবে SPETS।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion16" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR01",
    "question": "যদি \"Z\" = 52 এবং \"ACT\" = 48 হয়, তবে \"BAT\" = কত?",
    "option1": "46",
    "option2": "50",
    "option3": "52",
    "option4": "54",
    "answer": "option1",
    "solution": "প্রতিটি অক্ষরের অবস্থানের মানকে ২ দিয়ে গুণ করা হয়েছে: B(2x2=4) + A(1x2=2) + T(20x2=40) = 46।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion17" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR01",
    "question": "যদি \"GIRL\"-কে \"HJSM\" লেখা হয়, তবে \"BOY\"-কে কী লেখা হবে?",
    "option1": "CPZ",
    "option2": "CPX",
    "option3": "CQZ",
    "option4": "DPZ",
    "answer": "option1",
    "solution": "প্রতিটি অক্ষরের সাথে +1 করা হয়েছে: B+1=C, O+1=P, Y+1=Z -> CPZ।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion18" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR01",
    "question": "যদি \"MAN\" = 28 হয়, তবে \"SUN\" = কত?",
    "option1": "54",
    "option2": "52",
    "option3": "50",
    "option4": "56",
    "answer": "option1",
    "solution": "অক্ষরগুলির পজিশন যোগফল: M(13) + A(1) + N(14) = 28। একইভাবে S(19) + U(21) + N(14) = 54।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion19" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR01",
    "question": "কোনো কোডে \"WORK\"-কে \"4-12-9-16\" লেখা হলে, \"WOMAN\"-কে কীভাবে লেখা হবে?",
    "option1": "4-12-14-26-13",
    "option2": "4-12-13-26-14",
    "option3": "12-4-14-26-13",
    "option4": "4-12-14-25-13",
    "answer": "option1",
    "solution": "বর্ণমালার বিপরীত অবস্থানের মান ব্যবহার করা হয়েছে: W=4, O=12, M=14, A=26, N=13।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion20" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR01",
    "question": "যদি \"FLOWER\"-কে \"UOLDVI\" লেখা হয়, তবে \"TERMINAL\"-কে কীভাবে লেখা হবে?",
    "option1": "GVIORMZO",
    "option2": "GVIORMZP",
    "option3": "GVIROAMZ",
    "option4": "GVMORRZO",
    "answer": "option1",
    "solution": "প্রতিটি অক্ষরের বিপরীত বর্ণ (Opposite Letter) বসানো হয়েছে: T->G, E->V, R->I, M->N, I->R, N->M, A->Z, L->O।"
  },
{
    "_id": { "$oid": "reasoningmocktestquestion21" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR02",
    "question": "এক ব্যক্তির ছবি দেখিয়ে এক মহিলা বললেন, \"ওঁর মায়ের একমাত্র ভাই হলেন আমার একমাত্র ছেলের বাবা।\" ওই ব্যক্তি মহিলার কে হন?",
    "option1": "ভাই",
    "option2": "ছেলে",
    "option3": "বোনপো / ভাগ্নে",
    "option4": "স্বামী",
    "answer": "option3",
    "solution": "মহিলার একমাত্র ছেলের বাবা হলেন মহিলার স্বামী। সুতরাং, ছবির ব্যক্তির মায়ের একমাত্র ভাই হলেন মহিলার স্বামী। অর্থাৎ ছবির ব্যক্তির মা হলেন ওই মহিলার ননদ। অতএব, ব্যক্তিটি ওই মহিলার ভাগ্নে/বোনপো।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion22" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR02",
    "question": "A হলো B-এর ভাই, C হলো A-এর বাবা, D হলো E-এর বোন এবং E হলো B-এর মেয়ে। তবে D-এর দাদু/দাদা (Grandfather) কে?",
    "option1": "A",
    "option2": "B",
    "option3": "C",
    "option4": "D",
    "answer": "option3",
    "solution": "E হলো B-এর সন্তান এবং D হলো E-এর বোন, অর্থাৎ D হলো B-এর সন্তান। A হলো B-এর ভাই এবং C হলো A ও B-এর বাবা। অতএব, D-এর দাদু/দাদামশাই হলেন C।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion23" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR02",
    "question": "P হলো Q-এর মা, কিন্তু Q, P-এর মেয়ে নয়। তবে Q, P-এর কে হন?",
    "option1": "ছেলে",
    "option2": "ভাতিজি",
    "option3": "বোন",
    "option4": "শ্বাশুড়ি",
    "answer": "option1",
    "solution": "P যদি Q-এর মা হন এবং Q যদি মেয়ে না হয়, তবে সন্তান হিসেবে Q অবশ্যই P-এর ছেলে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion24" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR02",
    "question": "এক পুরুষকে দেখিয়ে এক মহিলা বললেন, \"ওঁর স্ত্রী হলেন আমার বাবার একমাত্র কন্যা।\" পুরুষটি ওই মহিলার কে হন?",
    "option1": "ভাই",
    "option2": "বাবা",
    "option3": "স্বামী",
    "option4": "শ্বশুর",
    "answer": "option3",
    "solution": "মহিলার বাবার একমাত্র কন্যা হলেন মহিলা নিজে। অতএব, পুরুষটির স্ত্রী হলেন ওই মহিলা নিজেই। অর্থাৎ পুরুষটি ওই মহিলার স্বামী।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion25" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR02",
    "question": "X এবং Y হলো দুই ভাই। R হলো Y-এর বাবা। S হলো T-এর ভাই এবং X-এর মামা। T-এর সাথে R-এর সম্পর্ক কী?",
    "option1": "মা",
    "option2": "স্ত্রী",
    "option3": "বোন",
    "option4": "পিসি",
    "answer": "option2",
    "solution": "R হলো X ও Y-এর বাবা। S হলো X-এর মামা, অর্থাৎ S হলো X-এর মায়ের ভাই। বলা আছে S হলো T-এর ভাই, সুতরাং T হলো X-এর মা। অতএব T হলো R-এর স্ত্রী।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion26" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR02",
    "question": "A হলো B-এর বোন। C হলো B-এর মা। D হলো C-এর বাবা। E হলো D-এর মা। তবে A-এর সাথে D-এর সম্পর্ক কী?",
    "option1": "নাতনি (Granddaughter)",
    "option2": "মেয়ে",
    "option3": "পিসি",
    "option4": "মা",
    "answer": "option1",
    "solution": "C হলো A-এর মা। D হলো C-এর বাবা, অর্থাৎ D হলো A-এর দাদামশাই (Maternal Grandfather)। সুতরাং A হলেন D-এর নাতনি।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion27" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR02",
    "question": "একটি মেয়েকে দেখিয়ে অরুণ বলল, \"এ হলো আমার মায়ের নাতির স্ত্রী।\" অরুণ ওই মেয়েটির কে হন?",
    "option1": "বাবা",
    "option2": "শ্বশুর",
    "option3": "স্বামী",
    "option4": "দাদু",
    "answer": "option2",
    "solution": "অরুণের মায়ের নাতি মানে হলো অরুণের ছেলে। ওই মেয়েটি অরুণের ছেলের স্ত্রী, অর্থাৎ অরুণের পুত্রবধূ। সুতরাং অরুণ হলেন মেয়েটির শ্বশুর।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion28" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR02",
    "question": "যদি A + B মানে A হলো B-এর ভাই; A - B মানে A হলো B-এর বোন; A × B মানে A হলো B-এর বাবা হয়, তবে P × Q - R সংকেতের অর্থ কী?",
    "option1": "P হলো R-এর কাকা",
    "option2": "P হলো R-এর বাবা",
    "option3": "P হলো R-এর ভাই",
    "option4": "P হলো R-এর ছেলে",
    "answer": "option2",
    "solution": "P × Q মানে P হলো Q-এর বাবা। Q - R মানে Q হলো R-এর বোন। সুতরাং P হলেন R-এরও বাবা।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion29" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR02",
    "question": "B-এর ভাই হলো A, C-এর কন্যা হলো B, এবং A-এর বাবা হলো D। C এবং D-এর মধ্যে সম্পর্ক কী?",
    "option1": "ভাই-বোন",
    "option2": "স্বামী-স্ত্রী",
    "option3": "কাকা-ভাইঝি",
    "option4": "মা-ছেলে",
    "answer": "option2",
    "solution": "A এবং B হলো ভাই-বোন। C হলো B-এর মা/বাবা এবং D হলো A-এর বাবা। সুতরাং C ও D হলেন দম্পতি বা স্বামী-স্ত্রী।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion30" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR02",
    "question": "এক বালকের দিকে আঙুল তুলে এক বালিকা বলল, \"ও আমার কাকার বাবার একমাত্র মেয়ের ছেলে।\" বালকটির সাথে বালিকাটির সম্পর্ক কী?",
    "option1": "ভাই (খুড়তুতো/পিসতুতো)",
    "option2": "কাকা",
    "option3": "বাবা",
    "option4": "মামা",
    "answer": "option1",
    "solution": "বালিকার কাকার বাবা হলেন বালিকার দাদু/ঠাকুরদা। দাদুর একমাত্র মেয়ে হলেন বালিকার পিসি। পিসির ছেলে হলো বালিকার পিসতুতো ভাই।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion31" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR02",
    "question": "A এবং B হলো দম্পতি (Couple)। X এবং Y হলো ভাই-ভাই। X যদি A-এর ভাই হয়, তবে Y-এর সাথে B-এর সম্পর্ক কী?",
    "option1": "দেওর / ভাসুর / শালা",
    "option2": "ভাই",
    "option3": "ছেলে",
    "option4": "বাবা",
    "answer": "option1",
    "solution": "X এবং Y উভয়ই A-এর ভাই। B হলো A-এর জীবনসঙ্গী (স্বামী বা স্ত্রী)। সুতরাং Y হলেন B-এর দেওর/ভাসুর/শালা (Brother-in-law)।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion32" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR02",
    "question": "যদি M হলো N-এর বোন, O হলো N-এর মা, এবং P হলো O-এর বাবা হয়, তবে M-এর সাথে P-এর সম্পর্ক কী?",
    "option1": "নাতনি (Granddaughter)",
    "option2": "মেয়ে",
    "option3": "পিসি",
    "option4": "মা",
    "answer": "option1",
    "solution": "M এবং N হলো ভাই-বোন। O হলো তাদের মা। P হলো O-এর বাবা, অর্থাৎ P হলেন M-এর দাদামশাই। সুতরাং M হলেন P-এর নাতনি।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion33" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR02",
    "question": "ছবিতে এক মহিলার দিকে তাকিয়ে সীমা বলল, \"ওঁর ছেলের বাবা হলেন আমার জামাই।\" সীমা ওই মহিলার কে হন?",
    "option1": "শ্বাশুড়ি",
    "option2": "মা",
    "option3": "বোন",
    "option4": "মেয়ে",
    "answer": "option1",
    "solution": "মহিলার ছেলের বাবা হলেন মহিলার স্বামী। সীমার জামাই হলেন ওই মহিলার স্বামী, যার অর্থ মহিলাটি হলেন সীমার মেয়ে। ফলে সীমা হলেন ওই মহিলার মা (অথবা প্রশ্নের গঠন অনুযায়ী সীমা হলেন শ্বাশুড়ি/মা)।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion34" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR02",
    "question": "K হলো L-এর ভাই। M হলো K-এর বোন। N হলো P-এর ভাই। P হলো L-এর কন্যা। N-এর কাকা/মামা কে?",
    "option1": "K",
    "option2": "L",
    "option3": "M",
    "option4": "P",
    "answer": "option1",
    "solution": "N এবং P হলো L-এর সন্তান। K হলো L-এর ভাই। সুতরাং N-এর কাকা বা মামা হলেন K।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion35" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR02",
    "question": "এক বৃদ্ধের দিকে নির্দেশ করে বিকাশ বলল, \"ওঁর ছেলে হলো আমার ছেলের মামা।\" বৃদ্ধটি বিকাশের কে হন?",
    "option1": "শ্বশুর",
    "option2": "বাবা",
    "option3": "কাকা",
    "option4": "দাদু",
    "answer": "option1",
    "solution": "বিকাশের ছেলের মামা হলো বিকাশের স্ত্রী-এর ভাই (শ্যালক)। বৃদ্ধের ছেলে যদি বিকাশের স্ত্রীর ভাই হয়, তবে বৃদ্ধটি হলেন বিকাশের শ্বশুর।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion36" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR02",
    "question": "যদি P + Q মানে P হলো Q-এর মা এবং P - Q মানে P হলো Q-এর ভাই হয়, তবে A + B - C দিয়ে কী বোঝায়?",
    "option1": "A হলো C-এর মা",
    "option2": "A হলো C-এর বোন",
    "option3": "A হলো C-এর পিসি",
    "option4": "A হলো C-এর কাকা",
    "answer": "option1",
    "solution": "A + B মানে A হলো B-এর মা। B - C মানে B হলো C-এর ভাই। সুতরাং, A হলেন C-এরও মা।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion37" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR02",
    "question": "A হলো B-এর একমাত্র বোন। B-এর বিয়ে হয়েছে C-এর সাথে। C-এর ছেলে হলো D। D-এর সাথে A-এর সম্পর্ক কী?",
    "option1": "পিসি / মাসি",
    "option2": "মা",
    "option3": "বোন",
    "option4": "শ্বাশুড়ি",
    "answer": "option1",
    "solution": "C ও B হলো D-এর পিতা-মাতা। A হলো B-এর বোন। সুতরাং A হলেন D-এর পিসি বা মাসি।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion38" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR02",
    "question": "রীনা বলল, \"অঞ্জলি আমার বোনের একমাত্র ভাইয়ের মেয়ে।\" অঞ্জলি রীনার কে হয়?",
    "option1": "ভাইঝি / ভাতিজি",
    "option2": "মেয়ে",
    "option3": "বোন",
    "option4": "পিসি",
    "answer": "option1",
    "solution": "রীনার বোনের একমাত্র ভাই হলো রীনার নিজের ভাই। অঞ্জলি হলো রীনার ভাইয়ের মেয়ে, অর্থাৎ রীনার ভাইঝি।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion39" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR02",
    "question": "E হলো A-এর পুত্র। B হলো D-এর পুত্র। A-এর সাথে C-এর বিবাহ হয়েছে। C হলো D-এর কন্যা। E-এর সাথে B-এর সম্পর্ক কী?",
    "option1": "মামাতো / পিসতুতো / মাসতুতো ভাই",
    "option2": "ভাই",
    "option3": "কাকা",
    "option4": "বাবা",
    "answer": "option1",
    "solution": "C হলো D-এর কন্যা এবং B হলো D-এর পুত্র, অর্থাৎ C ও B হলো ভাই-বোন। E হলো C-এর পুত্র। সুতরাং E ও B এর সম্পর্ক হলো মামা-ভাগ্নে বা মাসতুতো/মামাতো ভাই (Cousin)।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion40" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR02",
    "question": "এক ভদ্রলোককে দেখিয়ে এক নারী বললেন, \"ওঁর বাবা হলেন আমার বাবার একমাত্র ছেলে।\" ভদ্রলোকটির সাথে নারীর সম্পর্ক কী?",
    "option1": "ভাইপো / ভাতিজা",
    "option2": "ছেলে",
    "option3": "ভাই",
    "option4": "বাবা",
    "answer": "option1",
    "solution": "নারীর বাবার একমাত্র ছেলে হলেন নারীর নিজের ভাই। ওই ভদ্রলোকের বাবা হলেন নারীর ভাই। সুতরাং ভদ্রলোকটি ওই নারীর ভাইপো।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion41" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR03",
    "question": "এক ব্যক্তি উত্তর দিকে ৫ কিমি হাঁটার পর ডানদিকে ঘুরে ৩ কিমি হাঁটলেন। তারপর আবার ডানদিকে ঘুরে ৫ কিমি হাঁটলেন। তিনি শুরুর স্থান থেকে কোন দিকে এবং কত দূরে আছেন?",
    "option1": "পূর্ব দিকে, ৩ কিমি",
    "option2": "পশ্চিম দিকে, ৩ কিমি",
    "option3": "উত্তর দিকে, ৫ কিমি",
    "option4": "দক্ষিণ দিকে, ৫ কিমি",
    "answer": "option1",
    "solution": "উত্তর দিকে ৫ কিমি যাওয়ার পর ডানদিকে ঘুরলে দিক হয় পূর্ব (৩ কিমি)। সেখান থেকে আবার ডানদিকে ঘুরলে দিক হয় দক্ষিণ (৫ কিমি)। উত্তর ও দক্ষিণ দিকের ৫ কিমি দূরত্ব পরস্পরকে বাতিল করে। ফলে ব্যক্তিটি শুরুর স্থান থেকে পূর্ব দিকে ৩ কিমি দূরে অবস্থান করছেন।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion42" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR03",
    "question": "রাহুল পশ্চিম দিকে ১০ মি হাঁটলো, তারপর বামদিকে ঘুরে ১০ মি হাঁটলো। আবার বামদিকে ঘুরে ১০ মি হাঁটলো। এখন সে শুরুর স্থান থেকে কত দূরে আছে?",
    "option1": "১০ মি",
    "option2": "২০ মি",
    "option3": "৩০ মি",
    "option4": "০ মি",
    "answer": "option1",
    "solution": "পশ্চিম দিকে ১০ মি যাওয়ার পর বামদিকে ঘুরলে দিক হয় দক্ষিণ (১০ মি)। পুনরায় বামদিকে ঘুরলে দিক হয় পূর্ব (১০ মি)। পশ্চিম ও পূর্বের ১০ মি দূরত্ব সমতা আনে, ফলে সে শুরুর স্থান থেকে দক্ষিণে ১০ মি দূরে থাকে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion43" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR03",
    "question": "রিয়া বাড়ি থেকে বেরিয়ে প্রথমে দক্ষিণ দিকে ৪ কিমি গেল, তারপর পূর্ব দিকে ৩ কিমি গেল। সোজা পথে হাঁটলে শুরুর স্থান থেকে তার সর্বনিম্ন দূরত্ব কত?",
    "option1": "৫ কিমি",
    "option2": "৭ কিমি",
    "option3": "১ কিমি",
    "option4": "৬ কিমি",
    "answer": "option1",
    "solution": "পিথাগোরাসের উপপাদ্য অনুযায়ী, সর্বনিম্ন দূরত্ব = √(৪² + ৩²) = √(১৬ + ৯) = √২৫ = ৫ কিমি।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion44" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR03",
    "question": "যদি 'দক্ষিণ-পূর্ব' দিকটি 'উত্তর' হয় এবং 'উত্তর-পূর্ব' দিকটি 'পশ্চিম' হয়, তবে 'পশ্চিম' দিকটি কী হবে?",
    "option1": "দক্ষিণ-পূর্ব",
    "option2": "উত্তর-পূর্ব",
    "option3": "দক্ষিণ-পশ্চিম",
    "option4": "উত্তর-পশ্চিম",
    "answer": "option1",
    "solution": "দক্ষিণ-পূর্ব থেকে উত্তর মানে ১৩৫ ডিগ্রি ঘড়ির কাটার বিপরীত দিকে (Counter-clockwise) ঘোরা। একইভাবে পশ্চিম দিককে ১৩৫ ডিগ্রি ঘড়ির কাটার বিপরীত দিকে ঘোরালে তা 'দক্ষিণ-পূর্ব' দিক নির্দেশ করবে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion45" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR03",
    "question": "এক ব্যক্তি পূর্ব দিকে মুখ করে দাঁড়িয়ে আছেন। তিনি ঘড়ির কাঁটার দিকে (Clockwise) ৪৫° ঘুরলেন এবং তারপর ঘড়ির কাঁটার বিপরীত দিকে (Anticlockwise) ১৩৫° ঘুরলেন। এখন তিনি কোন দিকে মুখ করে আছেন?",
    "option1": "উত্তর",
    "option2": "উত্তর-পূর্ব",
    "option3": "উত্তর-পশ্চিম",
    "option4": "পশ্চিম",
    "answer": "option1",
    "solution": "মোট ঘূর্ণন = ১৩৫° (Anticlockwise) - ৪৫° (Clockwise) = ৯০° (Anticlockwise)। পূর্ব দিক থেকে ৯০° ঘড়ির কাঁটার বিপরীতে ঘুরলে দিক হয় 'উত্তর'।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion46" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR03",
    "question": "এক সকালে সূর্যোদয়ের পর রাম ও শ্যাম মুখোমুখি দাঁড়িয়ে কথা বলছিল। যদি রামের ছায়া ঠিক তার বামপাশে পড়ে, তবে শ্যাম কোন দিকে মুখ করে দাঁড়িয়ে ছিল?",
    "option1": "দক্ষিণ",
    "option2": "উত্তর",
    "option3": "পূর্ব",
    "option4": "পশ্চিম",
    "answer": "option1",
    "solution": "সকালে সূর্য পূর্বে থাকে, তাই ছায়া পশ্চিমে পড়ে। ছায়া বামপাশে পড়ার অর্থ রাম উত্তর দিকে মুখ করে আছে। যেহেতু শ্যাম রামের মুখোমুখি দাঁড়িয়ে আছে, তাই শ্যাম দক্ষিণ দিকে মুখ করে দাঁড়িয়ে আছে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion47" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR03",
    "question": "অয়ন উত্তর দিকে ৩ কিমি গেল, তারপর বামদিকে ঘুরে ২ কিমি গেল। আবার বামদিকে ঘুরে ৩ কিমি গেল। শেষে ডানদিকে ঘুরে ৩ কিমি গেল। সে এখন শুরুর স্থান থেকে মোট কত দূরে আছে?",
    "option1": "৫ কিমি",
    "option2": "২ কিমি",
    "option3": "৮ কিমি",
    "option4": "৩ কিমি",
    "answer": "option1",
    "solution": "উত্তর ৩ কিমি ও পরের বামদিকের (দক্ষিণ) ৩ কিমি পরস্পরকে বাতিল করে। প্রথম বামে ঘোরা (পশ্চিম) ২ কিমি এবং শেষের ডানে ঘোরা (পশ্চিম) ৩ কিমি যুক্ত হয়ে মোট দূরত্ব হয় (২ + ৩) = ৫ কিমি (পশ্চিম দিকে)।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion48" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR03",
    "question": "একটি ঘড়িতে বিকেল ৪:৩০ বাজে। যদি ঘণ্টার কাঁটাটি দক্ষিণ-পূর্ব দিক নির্দেশ করে, তবে মিনিটের কাঁটাটি কোন দিক নির্দেশ করবে?",
    "option1": "দক্ষিণ",
    "option2": "উত্তর",
    "option3": "পূর্ব",
    "option4": "পশ্চিম",
    "answer": "option1",
    "solution": "৪:৩০ মিনিটে মিনিটের কাঁটাটি স্বাভাবিকভাবে ৬-এর ঘরে অর্থাৎ ঠিক দক্ষিণ দিকে থাকে এবং ঘণ্টার কাঁটাটি ৪ ও ৫-এর মাঝে অর্থাৎ দক্ষিণ-পূর্বে থাকে। এখানে ঘণ্টার কাঁটার দিক অপরিবর্তিত আছে, ফলে মিনিটের কাঁটাটি ঠিক দক্ষিণ দিকেই নির্দেশ করবে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion49" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR03",
    "question": "সৌরভ পশ্চিম দিকে চলা শুরু করলো। পরপর দুইবার ডানদিকে ঘোরার পর সে এখন কোন দিকে মুখ করে হাঁটছে?",
    "option1": "পূর্ব",
    "option2": "উত্তর",
    "option3": "দক্ষিণ",
    "option4": "পশ্চিম",
    "answer": "option1",
    "solution": "যেকোনো দিক থেকে পর পর দুইবার ডানদিকে (বা বামদিকে) ঘুরলে মূল দিকের ঠিক বিপরীত দিকে পৌঁছানো যায়। পশ্চিমের বিপরীত দিক হলো 'পূর্ব'।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion50" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR03",
    "question": "বিকাশ বাড়ি থেকে বেরিয়ে উত্তর দিকে ১৫ মিটার গেল, তারপর পশ্চিম দিকে ১০ মিটার গেল, এরপর দক্ষিণ দিকে ৫ মিটার গেল এবং শেষে পূর্ব দিকে ১০ মিটার গেল। সে এখন বাড়ি থেকে কোন দিকে আছে?",
    "option1": "উত্তর",
    "option2": "দক্ষিণ",
    "option3": "পূর্ব",
    "option4": "পশ্চিম",
    "answer": "option1",
    "solution": "পশ্চিমের ১০ মি এবং পূর্বের ১০ মি দূরত্ব সমান হয়ে বাতিল হয়ে যায়। উত্তরে ১৫ মি গিয়ে দক্ষিণে ৫ মি ফিরে আসায় সে এখনও বাড়ি থেকে (১৫ - ৫) = ১০ মি উত্তর দিকে অবস্থান করছে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion51" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR03",
    "question": "প্রিয়াঙ্ক উত্তর-পূর্ব দিকে মুখ করে দাঁড়িয়ে আছে। সে প্রথমে ৯০° ডানদিকে এবং তারপর ১৮০° বামদিকে ঘোরে। এখন সে কোন দিকে মুখ করে আছে?",
    "option1": "উত্তর-পশ্চিম",
    "option2": "দক্ষিণ-পশ্চিম",
    "option3": "দক্ষিণ-পূর্ব",
    "option4": "উত্তর-পূর্ব",
    "answer": "option1",
    "solution": "লব্ধি ঘূর্ণন = ১৮০° (Left) - ৯০° (Right) = ৯০° (Left বা Anticlockwise)। উত্তর-পূর্ব দিক থেকে ৯০° বামদিকে (Anticlockwise) ঘুরলে দিক হয় 'উত্তর-পশ্চিম'।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion52" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR03",
    "question": "এক ব্যক্তি বিন্দু X থেকে যাত্রা শুরু করে দক্ষিণ দিকে ৮ কিমি গিয়ে Y বিন্দুতে পৌঁছাল। তারপর বামদিকে ঘুরে ৬ কিমি গিয়ে Z বিন্দুতে পৌঁছাল। X এবং Z বিন্দুর মধ্যে সরলরৈখিক দূরত্ব কত?",
    "option1": "১০ কিমি",
    "option2": "১৪ কিমি",
    "option3": "২ কিমি",
    "option4": "১২ কিমি",
    "answer": "option1",
    "solution": "সরলরৈখিক দূরত্ব = √(৮² + ৬²) = √(৬৪ + ৩৬) = √১০০ = ১০ কিমি।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion53" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR03",
    "question": "বিকালে সূর্যাস্তের পূর্বে সুমিত ও অমিত একে অপরের দিকে মুখ করে কথা বলছিল। যদি অমিতের ছায়া সুমিতের ঠিক ডানপাশে পড়ে, তবে সুমিত কোন দিকে মুখ করে ছিল?",
    "option1": "দক্ষিণ",
    "option2": "উত্তর",
    "option3": "পূর্ব",
    "option4": "পশ্চিম",
    "answer": "option1",
    "solution": "বিকালে সূর্য পশ্চিমে থাকে, তাই ছায়া পূর্বে পড়ে। ছায়া ডানপাশে পড়ার অর্থ ব্যক্তিটি দক্ষিণ দিকে মুখ করে আছে। যেহেতু সুমিতের ডানপাশে ছায়া পড়েছে, তাই সুমিত দক্ষিণ দিকে মুখ করে আছে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion54" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR03",
    "question": "A-এর বাড়ি B-এর বাড়ির পশ্চিমে। C-এর বাড়ি B-এর বাড়ির দক্ষিণে। D-এর বাড়ি C-এর বাড়ির পূর্বে হলে, A-এর বাড়ি D-এর বাড়ির সাপেক্ষে কোন দিকে অবস্থিত?",
    "option1": "উত্তর-পশ্চিম",
    "option2": "দক্ষিণ-পূর্ব",
    "option3": "উত্তর-পূর্ব",
    "option4": "দক্ষিণ-পশ্চিম",
    "answer": "option1",
    "solution": "স্থানাঙ্ক অনুযায়ী A উত্তর-পশ্চিমে এবং D দক্ষিণ-পূর্বে অবস্থান করে। ফলে D বিন্দুর সাপেক্ষে A-এর অবস্থান হলো 'উত্তর-পশ্চিম' দিক।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion55" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR03",
    "question": "কোনো ব্যক্তি যদি মাথা নিচে ও পা উপরে দিয়ে যোগ ব্যায়াম করেন এবং তাঁর মুখ যদি দক্ষিণ দিকে থাকে, তবে তাঁর ডানহাতটি কোন দিকে থাকবে?",
    "option1": "পূর্ব",
    "option2": "পশ্চিম",
    "option3": "উত্তর",
    "option4": "দক্ষিণ",
    "answer": "option1",
    "solution": "সাধারণভাবে দক্ষিণ দিকে মুখ করলে ডানহাত থাকে পশ্চিমে। কিন্তু মাথা নিচে রেখে উল্টো অবস্থায় মুখ দক্ষিণে থাকলে ডানহাত বিপরীত দিকে অর্থাৎ 'পূর্ব' দিকে থাকবে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion56" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR03",
    "question": "কমল পূর্ব দিকে ১০ মিটার হাঁটার পর বামদিকে ঘুরে ৫ মিটার হাঁটলো। তারপর আবার বামদিকে ঘুরে ১০ মিটার হাঁটলো। শুরুর স্থান থেকে কমল কত দূরে আছে?",
    "option1": "৫ মিটার",
    "option2": "১০ মিটার",
    "option3": "১৫ মিটার",
    "option4": "২০ মিটার",
    "answer": "option1",
    "solution": "পূর্বে ১০ মি এবং শেষে বামে ঘুরে পশ্চিমে ১০ মি হাঁটায় পূর্ব-পশ্চিমের দূরত্ব শূন্য হয়ে যায়। শুধু মাঝে বামে ঘুরে উত্তর দিকে যাওয়া ৫ মি দূরত্ব অবশিষ্ট থাকে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion57" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR03",
    "question": "উত্তর দিককে যদি উত্তর-পূর্ব বলা হয়, তবে দক্ষিণ দিককে কী বলা হবে?",
    "option1": "দক্ষিণ-পশ্চিম",
    "option2": "দক্ষিণ-পূর্ব",
    "option3": "উত্তর-পশ্চিম",
    "option4": "পশ্চিম",
    "answer": "option1",
    "solution": "উত্তর থেকে উত্তর-পূর্ব মানে ৪৫° ঘড়ির কাঁটার দিকে (Clockwise) পরিবর্তন। সুতরাং দক্ষিণ দিককে ৪৫° ঘড়ির কাঁটার দিকে ঘোরালে তা 'দক্ষিণ-পশ্চিম' হবে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion58" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR03",
    "question": "পিটার ১২ কিমি উত্তরে যাওয়ার পর ৯ কিমি পূর্বে গেল। এরপর ১২ কিমি দক্ষিণে গেল। শুরুর বিন্দু থেকে পিটার এখন কত দূরে আছে?",
    "option1": "৯ কিমি",
    "option2": "১২ কিমি",
    "option3": "২১ কিমি",
    "option4": "১৫ কিমি",
    "answer": "option1",
    "solution": "১২ কিমি উত্তর এবং ১২ কিমি দক্ষিণ যাত্রা পরস্পর সমতা বজায় রাখে। ফলে শুধু পূর্বাংশের ৯ কিমি দূরত্বই অবশিষ্ট থাকে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion59" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR03",
    "question": "এক ব্যক্তি দক্ষিণ দিকে মুখ করে দাঁড়িয়ে আছেন। তিনি প্রথমে ১৩৫° ঘড়ির কাঁটার বিপরীতে এবং তারপর ১৮০° ঘড়ির কাঁটার দিকে ঘুরলেন। এখন তিনি কোন দিকে মুখ করে আছেন?",
    "option1": "দক্ষিণ-পশ্চিম",
    "option2": "দক্ষিণ-পূর্ব",
    "option3": "উত্তর-পশ্চিম",
    "option4": "উত্তর-পূর্ব",
    "answer": "option1",
    "solution": "লব্ধি ঘূর্ণন = ১৮০° (Clockwise) - ১৩৫° (Anticlockwise) = ৪৫° (Clockwise)। দক্ষিণ দিক থেকে ৪৫° ঘড়ির কাঁটার দিকে ঘুরলে মুখ হবে 'দক্ষিণ-পশ্চিম' দিকে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion60" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR03",
    "question": "অমিত উত্তর দিকে ১২ মিটার গিয়ে ডানদিকে ঘুরে ৫ মিটার গেল। সেখান থেকে ডানদিকে ঘুরে ১২ মিটার গিয়ে থেমে গেল। সে শুরুর স্থান থেকে কোন দিকে এবং কত মিটার দূরে আছে?",
    "option1": "পূর্ব দিকে, ৫ মিটার",
    "option2": "পশ্চিম দিকে, ৫ মিটার",
    "option3": "দক্ষিণ দিকে, ১২ মিটার",
    "option4": "উত্তর দিকে, ১২ মিটার",
    "answer": "option1",
    "solution": "উত্তরের ১২ মিটার এবং দক্ষিণের ১২ মিটার দূরত্ব বাতিল হয়। অবশিষ্ট থাকে পূর্বের ৫ মিটার। সুতরাং সে শুরুর স্থান থেকে পূর্ব দিকে ৫ মিটার দূরে আছে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion61" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR04",
    "question": "বিবৃতি:\n১. সকল কলম হয় পেন্সিল।\n২. সকল পেন্সিল হয় বই।\n\nউপসংহার:\nI. সকল কলম হয় বই।\nII. কিছু বই হয় কলম।",
    "option1": "কেবলমাত্র সিদ্ধান্ত I সঠিক",
    "option2": "কেবলমাত্র সিদ্ধান্ত II সঠিক",
    "option3": "I এবং II উভয় সিদ্ধান্তই সঠিক",
    "option4": "কোনো সিদ্ধান্তই সঠিক নয়",
    "answer": "option3",
    "solution": "সকল কলম যদি পেন্সিল হয় এবং সকল পেন্সিল যদি বই হয়, তবে সব কলমই বইয়ের অংশ (সিদ্ধান্ত I সঠিক)। আবার সব কলম বই হলে, বইয়ের কিছু অংশ অবশ্যই কলম হবে (সিদ্ধান্ত II সঠিক)।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion62" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR04",
    "question": "বিবৃতি:\n১. কিছু বিড়াল হয় কুকুর।\n২. কিছু কুকুর হয় সিংহ।\n\nউপসংহার:\nI. কিছু বিড়াল হয় সিংহ।\nII. কোনো বিড়াল সিংহ নয়।",
    "option1": "কেবলমাত্র সিদ্ধান্ত I সঠিক",
    "option2": "কেবলমাত্র সিদ্ধান্ত II সঠিক",
    "option3": "হয় সিদ্ধান্ত I অথবা II সঠিক (Either I or II)",
    "option4": "I এবং II উভয় সিদ্ধান্তই সঠিক",
    "answer": "option3",
    "solution": "বিড়াল ও সিংহের মধ্যে সরাসরি কোনো সম্পর্ক বিবৃতিতে দেওয়া নেই। সুতরাং তাদের মধ্যে 'কিছু হয়' এবং 'কোনোটিই নয়'—এই দুটি পরিপূরক জোড় (Complementary Pair) তৈরি করে। তাই হয় I অথবা II সত্য হবে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion63" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR04",
    "question": "বিবৃতি:\n১. সকল আম হয় ফল।\n২. কোনো ফল মিষ্টি নয়।\n\nউপসংহার:\nI. কোনো আম মিষ্টি নয়।\nII. কিছু মিষ্টি হয় আম।",
    "option1": "কেবলমাত্র সিদ্ধান্ত I সঠিক",
    "option2": "কেবলমাত্র সিদ্ধান্ত II সঠিক",
    "option3": "I এবং II উভয় সিদ্ধান্তই সঠিক",
    "option4": "কোনো সিদ্ধান্তই সঠিক নয়",
    "answer": "option1",
    "solution": "সকল আম ফলের অন্তর্গত, আর ফলের সাথে মিষ্টির কোনো সম্পর্ক নেই। সুতরাং আমের সাথেও মিষ্টির কোনো সম্পর্ক থাকতে পারে না (সিদ্ধান্ত I সঠিক)। সিদ্ধান্ত II ভুল।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion64" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR04",
    "question": "বিবৃতি:\n১. কিছু শিক্ষক হয় ডাক্তার।\n২. সকল ডাক্তার হয় বিজ্ঞানী।\n\nউপসংহার:\nI. কিছু শিক্ষক হয় বিজ্ঞানী।\nII. সকল শিক্ষক হয় বিজ্ঞানী।",
    "option1": "কেবলমাত্র সিদ্ধান্ত I সঠিক",
    "option2": "কেবলমাত্র সিদ্ধান্ত II সঠিক",
    "option3": "I এবং II উভয় সিদ্ধান্তই সঠিক",
    "option4": "কোনো সিদ্ধান্তই সঠিক নয়",
    "answer": "option1",
    "solution": "ডাক্তারদের অংশটি বিজ্ঞানের অন্তর্ভুক্ত। যেসব শিক্ষক ডাক্তার, তারা আবশ্যিকভাবে বিজ্ঞানী হবে। ফলে 'কিছু শিক্ষক হয় বিজ্ঞানী' সত্য। কিন্তু সকল শিক্ষক বিজ্ঞানী—এমন দাবি করা যায় না।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion65" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR04",
    "question": "বিবৃতি:\n১. সকল পাখি হয় উড়তে পারে।\n২. বাদুড় উড়তে পারে।\n\nউপসংহার:\nI. বাদুড় একটি পাখি।\nII. কিছু পাখি বাদুড় নয়।",
    "option1": "কেবলমাত্র সিদ্ধান্ত I সঠিক",
    "option2": "কেবলমাত্র সিদ্ধান্ত II সঠিক",
    "option3": "I এবং II উভয়ই ভুল",
    "option4": "I এবং II উভয়ই সঠিক",
    "answer": "option3",
    "solution": "উড়তে পারার গুণের ওপর ভিত্তি করে বাদুড়কে নিশ্চিতভাবে পাখি বলা যায় না (ভেন চিত্রে বাদুড় পাখির বাইরেও থাকতে পারে)। যৌক্তিকভাবে প্রদত্ত বিবৃতি থেকে কোনো সিদ্ধান্তই ১০০% নিশ্চিত বলা সম্ভব নয়।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion66" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR04",
    "question": "বিবৃতি:\n১. কোনো মানুষ অমর নয়।\n২. রাম হয় একজন মানুষ।\n\nউপসংহার:\nI. রাম অমর নয়।\nII. সকল মানুষ হয় রাম।",
    "option1": "কেবলমাত্র সিদ্ধান্ত I সঠিক",
    "option2": "কেবলমাত্র সিদ্ধান্ত II সঠিক",
    "option3": "I এবং II উভয় সিদ্ধান্তই সঠিক",
    "option4": "কোনো সিদ্ধান্তই সঠিক নয়",
    "answer": "option1",
    "solution": "মানুষ শ্রেণির কেউই অমর নয়। রাম যেহেতু মানুষের অন্তর্ভুক্ত, তাই রামও অমর নয় (সিদ্ধান্ত I সঠিক)। কিন্তু সকল মানুষ রাম—এটি যুক্তিহীন।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion67" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR04",
    "question": "বিবৃতি:\n১. কিছু টেবিল হয় চেয়ার।\n২. কিছু চেয়ার হয় বেঞ্চ।\n\nউপসংহার:\nI. কিছু টেবিল হয় বেঞ্চ।\nII. কোনো টেবিল বেঞ্চ নয়।",
    "option1": "কেবলমাত্র সিদ্ধান্ত I সঠিক",
    "option2": "কেবলমাত্র সিদ্ধান্ত II সঠিক",
    "option3": "হয় সিদ্ধান্ত I অথবা II সঠিক (Either I or II)",
    "option4": "I এবং II উভয়ই সঠিক",
    "answer": "option3",
    "solution": "টেবিল ও বেঞ্চের মধ্যে সরাসরি সম্পর্ক বলা নেই। দুটি অনিশ্চিত রূপের ক্ষেত্রে 'কিছু হয়' এবং 'কোনোটি নয়' থাকলে তাদের মধ্যে হয় I অথবা II সত্য হবে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion68" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR04",
    "question": "বিবৃতি:\n১. সকল কাগজ হয় পাতা।\n২. কোনো পাতা সবুজ নয়।\n\nউপসংহার:\nI. কোনো কাগজ সবুজ নয়।\nII. কিছু সবুজ হয় পাতা।",
    "option1": "কেবলমাত্র সিদ্ধান্ত I সঠিক",
    "option2": "কেবলমাত্র সিদ্ধান্ত II সঠিক",
    "option3": "I এবং II উভয় সিদ্ধান্তই সঠিক",
    "option4": "কোনো সিদ্ধান্তই সঠিক নয়",
    "answer": "option1",
    "solution": "পাতা এবং সবুজের মধ্যে কোনো সম্পর্ক নেই। কাগজ পুরোপুরি পাতার ভেতরের অংশ, তাই কাগজের সাথেও সবুজের কোনো সম্পর্ক থাকবে না (সিদ্ধান্ত I সঠিক)।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion69" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR04",
    "question": "বিবৃতি:\n১. সকল ফুল হয় সুন্দর।\n২. গোলাপ হয় একটি ফুল।\n\nউপসংহার:\nI. গোলাপ হয় সুন্দর।\nII. কিছু সুন্দর জিনিস ফুল নয়।",
    "option1": "কেবলমাত্র সিদ্ধান্ত I সঠিক",
    "option2": "কেবলমাত্র সিদ্ধান্ত II সঠিক",
    "option3": "I এবং II উভয় সিদ্ধান্তই সঠিক",
    "option4": "কোনো সিদ্ধান্তই সঠিক নয়",
    "answer": "option1",
    "solution": "গোলাপ যেহেতু ফুল এবং সকল ফুল সুন্দর, তাই গোলাপ নিশ্চিতভাবেই সুন্দর (সিদ্ধান্ত I সঠিক)। সুন্দর জিনিসের অন্য অংশ সম্বন্ধে বিবৃতিতে কিছু নির্দিষ্ট করা নেই।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion70" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR04",
    "question": "বিবৃতি:\n১. কিছু মোবাইল হয় ল্যাপটপ।\n২. সকল ল্যাপটপ হয় কম্পিউটার।\n\nউপসংহার:\nI. কিছু মোবাইল হয় কম্পিউটার।\nII. সকল কম্পিউটার হয় ল্যাপটপ।",
    "option1": "কেবলমাত্র সিদ্ধান্ত I সঠিক",
    "option2": "কেবলমাত্র সিদ্ধান্ত II সঠিক",
    "option3": "I এবং II উভয় সিদ্ধান্তই সঠিক",
    "option4": "কোনো সিদ্ধান্তই সঠিক নয়",
    "answer": "option1",
    "solution": "ল্যাপটপের সম্পূর্ণ অংশ কম্পিউটারের অধীনে। মোবাইলের যে অংশটি ল্যাপটপ, সেটি স্বয়ংক্রিয়ভাবে কম্পিউটার হবে (সিদ্ধান্ত I সঠিক)। কিন্তু সব কম্পিউটার ল্যাপটপ হবে এমন নিশ্চয়তা নেই।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion71" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR04",
    "question": "বিবৃতি:\n১. কোনো নদী মহাসাগর নয়।\n২. সকল খাল হয় নদী।\n\nউপসংহার:\nI. কোনো খাল মহাসাগর নয়।\nII. কিছু নদী হয় খাল।",
    "option1": "কেবলমাত্র সিদ্ধান্ত I সঠিক",
    "option2": "কেবলমাত্র সিদ্ধান্ত II সঠিক",
    "option3": "I এবং II উভয় সিদ্ধান্তই সঠিক",
    "option4": "কোনো সিদ্ধান্তই সঠিক নয়",
    "answer": "option3",
    "solution": "খাল পুরোপুরি নদীর ভেতরে থাকে। নদী যদি মহাসাগর না হতে পারে, তবে খালও কখনো মহাসাগর হবে না (I সঠিক)। আবার সব খাল নদী হলে, নদীর কিছু অংশ খাল হতেই হবে (II সঠিক)।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion72" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR04",
    "question": "বিবৃতি:\n১. সকল অভিনেতা হয় সুন্দর।\n২. কিছু সুন্দর মানুষ হয় গায়ক।\n\nউপসংহার:\nI. কিছু অভিনেতা হয় গায়ক।\nII. কোনো অভিনেতা গায়ক নয়।",
    "option1": "কেবলমাত্র সিদ্ধান্ত I সঠিক",
    "option2": "কেবলমাত্র সিদ্ধান্ত II সঠিক",
    "option3": "হয় সিদ্ধান্ত I অথবা II সঠিক (Either I or II)",
    "option4": "I এবং II উভয় সিদ্ধান্তই সঠিক",
    "answer": "option3",
    "solution": "অভিনেতা ও গায়কের মাঝে প্রত্যক্ষ কোনো সম্পর্ক নিশ্চিতভাবে দেওয়া নেই। তাই তাদের মধ্যকার সম্পর্ক হয় 'কিছু হবে' অথবা 'কোনোটিই হবে না'—অর্থাৎ হয় I অথবা II সত্য।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion73" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR04",
    "question": "বিবৃতি:\n১. কিছু বই হয় খাতা।\n২. কিছু খাতা হয় পেন্সিল।\n\nউপসংহার:\nI. কিছু বই হয় পেন্সিল।\nII. সকল খাতা হয় বই।",
    "option1": "কেবলমাত্র সিদ্ধান্ত I সঠিক",
    "option2": "কেবলমাত্র সিদ্ধান্ত II সঠিক",
    "option3": "I এবং II উভয়ই ভুল",
    "option4": "I এবং II উভয়ই সঠিক",
    "answer": "option3",
    "solution": "বইয়ের সাথে পেন্সিলের বা খাতার সাথে বইয়ের সার্বিক (All) কোনো সম্পর্কের নিশ্চয়তা প্রদত্ত আংশিক বিবৃতিগুলি থেকে পাওয়া যায় না। ফলে উভয় সিদ্ধান্তই ভুল।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion74" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR04",
    "question": "বিবৃতি:\n১. সকল গাড়ি হয় চারচাকা।\n২. কোনো চারচাকা বাইক নয়।\n\nউপসংহার:\nI. কোনো গাড়ি বাইক নয়।\nII. কিছু চারচাকা হয় গাড়ি।",
    "option1": "কেবলমাত্র সিদ্ধান্ত I সঠিক",
    "option2": "কেবলমাত্র সিদ্ধান্ত II সঠিক",
    "option3": "I এবং II উভয় সিদ্ধান্তই সঠিক",
    "option4": "কোনো সিদ্ধান্তই সঠিক নয়",
    "answer": "option3",
    "solution": "চারচাকার সাথে বাইকের সম্পর্ক না থাকায় তার ভেতরের অংশ 'গাড়ি'র সাথেও বাইকের সম্পর্ক থাকবে না (I সঠিক)। আবার সকল গাড়ি চারচাকা হলে চারচাকার একটি অংশ গাড়ি অবশ্যই হবে (II সঠিক)।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion75" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR04",
    "question": "বিবৃতি:\n১. কিছু পেন হয় পেন্সিল।\n২. কোনো পেন্সিল ইরেজার নয়।\n\nউপসংহার:\nI. কিছু পেন ইরেজার নয়।\nII. সকল পেন হয় ইরেজার।",
    "option1": "কেবলমাত্র সিদ্ধান্ত I সঠিক",
    "option2": "কেবলমাত্র সিদ্ধান্ত II সঠিক",
    "option3": "I এবং II উভয় সিদ্ধান্তই সঠিক",
    "option4": "কোনো সিদ্ধান্তই সঠিক নয়",
    "answer": "option1",
    "solution": "পেনের যে অংশটি পেন্সিলের সাথে ওভারল্যাপ করেছে, সেই অংশটি কখনোই ইরেজার হতে পারবে না। অতএব 'কিছু পেন ইরেজার নয়' নিশ্চিতভাবে সঠিক।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion76" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR04",
    "question": "বিবৃতি:\n১. সকল মিষ্টি হয় সুস্বাদু।\n২. সকল জিলিপি হয় মিষ্টি।\n\nউপসংহার:\nI. সকল জিলিপি হয় সুস্বাদু।\nII. কিছু সুস্বাদু খাবার হয় মিষ্টি।",
    "option1": "কেবলমাত্র সিদ্ধান্ত I সঠিক",
    "option2": "কেবলমাত্র সিদ্ধান্ত II সঠিক",
    "option3": "I এবং II উভয় সিদ্ধান্তই সঠিক",
    "option4": "কোনো সিদ্ধান্তই সঠিক নয়",
    "answer": "option3",
    "solution": "জিলিপি মিষ্টির ভেতরে, আর মিষ্টি সুস্বাদূর ভেতরে থাকে। তাই সব জিলিপি সুস্বাদু (I সঠিক)। আবার মিষ্টি যেহেতু সুস্বাদুর অংশ, তাই কিছু সুস্বাদু জিনিস মিষ্টি হবেই (II সঠিক)।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion77" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR04",
    "question": "বিবৃতি:\n১. কিছু ঘড়ি হয় মোবাইল।\n২. কোনো মোবাইল ঘড়ি নয়।\n\nউপসংহার:\nI. কিছু মোবাইল হয় ঘড়ি।\nII. কোনো ঘড়ি মোবাইল নয়।",
    "option1": "কেবলমাত্র সিদ্ধান্ত I সঠিক",
    "option2": "বিবৃতিসমূহ পরস্পর বিরোধী",
    "option3": "কেবলমাত্র সিদ্ধান্ত II সঠিক",
    "option4": "উভয় সিদ্ধান্তই সঠিক",
    "answer": "option2",
    "solution": "বিবৃতি ১-এ বলা হয়েছে 'কিছু ঘড়ি হয় মোবাইল' এবং বিবৃতি ২-এ বলা হয়েছে 'কোনো মোবাইল ঘড়ি নয়'। এই দুটি বিবৃতি পরস্পর সম্পূর্ণ বিরোধী (Contradictory), তাই এটি একটি স্ববিরোধী যুক্তিকাঠামো।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion78" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR04",
    "question": "বিবৃতি:\n১. সকল ডাক্তার হয় সৎ।\n২. সকল সৎ মানুষ হয় দয়ালু।\n\nউপসংহার:\nI. সকল ডাক্তার হয় দয়ালু।\nII. কিছু দয়ালু মানুষ হয় ডাক্তার।",
    "option1": "কেবলমাত্র সিদ্ধান্ত I সঠিক",
    "option2": "কেবলমাত্র সিদ্ধান্ত II সঠিক",
    "option3": "I এবং II উভয় সিদ্ধান্তই সঠিক",
    "option4": "কোনো সিদ্ধান্তই সঠিক নয়",
    "answer": "option3",
    "solution": "ডাক্তার পদটি সৎ এবং সৎ পদটি দয়ালু এর ভেতরে পড়ে। ফলে সকল ডাক্তার দয়ালু (I সঠিক) এবং দয়ালু মানুষদের মধ্যে কিছু অংশ নিশ্চয়ই ডাক্তার (II সঠিক)।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion79" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR04",
    "question": "বিবৃতি:\n১. কিছু সোনা হয় রুপো।\n২. কিছু রুপো হয় হিরে।\n\nউপসংহার:\nI. কিছু সোনা হয় হিরে।\nII. সকল হিরে হয় সোনা।",
    "option1": "কেবলমাত্র সিদ্ধান্ত I সঠিক",
    "option2": "কেবলমাত্র সিদ্ধান্ত II সঠিক",
    "option3": "I এবং II উভয়ই ভুল",
    "option4": "I এবং II উভয় সিদ্ধান্তই সঠিক",
    "answer": "option3",
    "solution": "সোনা ও হিরের মাঝে সম্পর্কের সরাসরি নিশ্চিত ঘোষণা বিবৃতিগুলোতে নেই। তাই নিশ্চিতভাবে কোনোটিই সিদ্ধান্ত হিসেবে টানা যায় না।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion80" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR04",
    "question": "বিবৃতি:\n১. সকল গ্রহ হয় তারা।\n২. কোনো তারা উপগ্রহ নয়।\n\nউপসংহার:\nI. কোনো গ্রহ উপগ্রহ নয়।\nII. কিছু তারা হয় গ্রহ।",
    "option1": "কেবলমাত্র সিদ্ধান্ত I সঠিক",
    "option2": "কেবলমাত্র সিদ্ধান্ত II সঠিক",
    "option3": "I এবং II উভয় সিদ্ধান্তই সঠিক",
    "option4": "কোনো সিদ্ধান্তই সঠিক নয়",
    "answer": "option3",
    "solution": "গ্রহ তারা-র ভেতরের অংশ। তারা যদি উপগ্রহের সঙ্গে সম্পর্কযুক্ত না হয়, তবে গ্রহও উপগ্রহের বাইরে থাকবে (I সঠিক)। আর সকল গ্রহ তারা হলে, তারার কিছু অংশ অবশ্যই গ্রহ (II সঠিক)।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion81" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR05",
    "question": "শ্রেণিটির শূন্যস্থান পূরণ করো: 2, 6, 12, 20, 30, ?",
    "option1": "36",
    "option2": "40",
    "option3": "42",
    "option4": "48",
    "answer": "option3",
    "solution": "পার্থক্য ক্রমটি হলো: +4, +6, +8, +10, +12। সুতরাং, পরবর্তী পদটি হবে 30 + 12 = 42।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion82" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR05",
    "question": "শ্রেণিটির শূন্যস্থান পূরণ করো: 3, 5, 9, 17, 33, ?",
    "option1": "65",
    "option2": "60",
    "option3": "50",
    "option4": "49",
    "answer": "option1",
    "solution": "পার্থক্য ক্রমটি হলো: +2, +4, +8, +16, +32 (দ্বিগুণ হচ্ছে)। সুতরাং, পরবর্তী পদটি হবে 33 + 32 = 65।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion83" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR05",
    "question": "শ্রেণিটির শূন্যস্থান পূরণ করো: 1, 4, 9, 16, 25, 36, ?",
    "option1": "42",
    "option2": "49",
    "option3": "54",
    "option4": "64",
    "answer": "option2",
    "solution": "সংখ্যাগুলি হলো পরপর স্বাভাবিক সংখ্যার বর্গ: 1², 2², 3², 4², 5², 6²। সুতরাং, পরবর্তী পদটি হবে 7² = 49।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion84" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR05",
    "question": "শ্রেণিটির শূন্যস্থান পূরণ করো: 2, 3, 5, 7, 11, 13, ?",
    "option1": "15",
    "option2": "17",
    "option3": "19",
    "option4": "21",
    "answer": "option2",
    "solution": "শ্রেণিটি হলো পরপর মৌলিক সংখ্যার (Prime Numbers) সিরিজ। 13-এর পরের মৌলিক সংখ্যাটি হলো 17।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion85" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR05",
    "question": "শ্রেণিটির শূন্যস্থান পূরণ করো: 0, 7, 26, 63, 124, ?",
    "option1": "215",
    "option2": "216",
    "option3": "210",
    "option4": "195",
    "answer": "option1",
    "solution": "প্যাটার্নটি হলো n³ - 1। যথা: 1³ - 1 = 0, 2³ - 1 = 7, 3³ - 1 = 26, 4³ - 1 = 63, 5³ - 1 = 124। সুতরাং, 6³ - 1 = 216 - 1 = 215।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion86" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR05",
    "question": "শ্রেণিটির শূন্যস্থান পূরণ করো: 2, 5, 10, 17, 26, ?",
    "option1": "35",
    "option2": "37",
    "option3": "36",
    "option4": "38",
    "answer": "option2",
    "solution": "প্যাটার্নটি হলো n² + 1। যথা: 1²+1, 2²+1, 3²+1, 4²+1, 5²+1। সুতরাং, 6² + 1 = 36 + 1 = 37।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion87" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR05",
    "question": "শ্রেণিটির শূন্যস্থান পূরণ করো: A, C, F, J, O, ?",
    "option1": "U",
    "option2": "V",
    "option3": "T",
    "option4": "S",
    "answer": "option1",
    "solution": "বর্ণগুলির অবস্থানের পার্থক্য: +2, +3, +4, +5, +6। O (15) + 6 = U (21)।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion88" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR05",
    "question": "শ্রেণিটির শূন্যস্থান পূরণ করো: Z, X, V, T, R, ?",
    "option1": "P",
    "option2": "O",
    "option3": "N",
    "option4": "Q",
    "answer": "option1",
    "solution": "বর্ণগুলি রিভার্স অর্ডারে -2 করে কমছে: Z(26) - 2 = X(24) - 2 = V(22)... R(18) - 2 = P(16)।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion89" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR05",
    "question": "শ্রেণিটির শূন্যস্থান পূরণ করো: 100, 90, 81, 73, 66, ?",
    "option1": "60",
    "option2": "59",
    "option3": "58",
    "option4": "61",
    "answer": "option1",
    "solution": "পার্থক্য ক্রমটি হলো: -10, -9, -8, -7, -6। সুতরাং, 66 - 6 = 60।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion90" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR05",
    "question": "শ্রেণিটির শূন্যস্থান পূরণ করো: 1, 1, 2, 3, 5, 8, 13, ?",
    "option1": "21",
    "option2": "20",
    "option3": "19",
    "option4": "22",
    "answer": "option1",
    "solution": "এটি একটি ফিবোনাচি শ্রেণি (Fibonacci Series), যেখানে প্রতিটি পদ আগের দুটি পদের যোগফল। 8 + 13 = 21।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion91" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR05",
    "question": "শ্রেণিটির শূন্যস্থান পূরণ করো: B3M, E6P, H12S, K24V, ?",
    "option1": "N48Y",
    "option2": "N48X",
    "option3": "M48Y",
    "option4": "N36Y",
    "answer": "option1",
    "solution": "প্রথম অক্ষর: +3 (B, E, H, K -> N)। মাঝের সংখ্যা: ×2 (3, 6, 12, 24 -> 48)। শেষ অক্ষর: +3 (M, P, S, V -> Y)। সুতরাং N48Y।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion92" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR05",
    "question": "শ্রেণিটির শূন্যস্থান পূরণ করো: 4, 9, 19, 39, 79, ?",
    "option1": "159",
    "option2": "149",
    "option3": "150",
    "option4": "169",
    "answer": "option1",
    "solution": "প্যাটার্নটি হলো: (× 2 + 1)। 4×2+1=9, 9×2+1=19, 19×2+1=39, 39×2+1=79। সুতরাং, 79×2 + 1 = 159।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion93" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR05",
    "question": "শ্রেণিটির শূন্যস্থান পূরণ করো: 121, 144, 169, 196, ?",
    "option1": "225",
    "option2": "256",
    "option3": "210",
    "option4": "240",
    "answer": "option1",
    "solution": "পরপর সংখ্যার বর্গ: 11², 12², 13², 14²। সুতরাং, পরবর্তী পদটি হবে 15² = 225।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion94" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR05",
    "question": "শ্রেণিটির শূন্যস্থান পূরণ করো: AZ, CX, EV, GT, ?",
    "option1": "HS",
    "option2": "IR",
    "option3": "JQ",
    "option4": "KP",
    "answer": "option2",
    "solution": "প্রথম বর্ণগুলি +2 করে বাড়ছে (A, C, E, G -> I)। দ্বিতীয় বর্ণগুলি রিভার্স পেয়ার/বর্ণমালার বিপরীত স্থান নির্দেশ করে (A-Z, C-X, E-V, G-T, I-R)। সুতরাং IR।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion95" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR05",
    "question": "শ্রেণিটির শূন্যস্থান পূরণ করো: 7, 10, 8, 11, 9, 12, ?",
    "option1": "10",
    "option2": "13",
    "option3": "14",
    "option4": "11",
    "answer": "option1",
    "solution": "পর্যায়ক্রমিক ধারা: +3, -1, +3, -1, +3। অতএব, 12 - 1 = 10।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion96" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR05",
    "question": "শ্রেণিটির শূন্যস্থান পূরণ করো: 6, 12, 21, 33, 48, ?",
    "option1": "66",
    "option2": "65",
    "option3": "63",
    "option4": "60",
    "answer": "option1",
    "solution": "পার্থক্য ক্রমটি হলো: +6, +9, +12, +15, +18। সুতরাং, 48 + 18 = 66।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion97" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR05",
    "question": "শ্রেণিটির শূন্যস্থান পূরণ করো: 2, 8, 18, 32, 50, ?",
    "option1": "72",
    "option2": "64",
    "option3": "70",
    "option4": "68",
    "answer": "option1",
    "solution": "প্যাটার্নটি হলো 2 × n²। 2×1²=2, 2×2²=8, 2×3²=18, 2×4²=32, 2×5²=50। সুতরাং, 2 × 6² = 2 × 36 = 72।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion98" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR05",
    "question": "শ্রেণিটির শূন্যস্থান পূরণ করো: WTP, QNK, HEB, ?",
    "option1": "BYV",
    "option2": "YVR",
    "option3": "XUQ",
    "option4": "CZW",
    "answer": "option1",
    "solution": "প্রতিটি গ্রুপের ভেতরের বর্ণগুলির পার্থক্য -3 (W -3 = T, T -3 = P)। প্রথম অক্ষরগুলোর মধ্যে পার্থক্য: W -6 = Q, Q -9 = H, H -6 = B। B থেকে -3 করলে Y, Y থেকে -3 করলে V হয়। সুতরাং BYV।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion99" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR05",
    "question": "শ্রেণিটির শূন্যস্থান পূরণ করো: 1, 8, 27, 64, 125, ?",
    "option1": "216",
    "option2": "343",
    "option3": "225",
    "option4": "256",
    "answer": "option1",
    "solution": "পরপর ঘন (Cube) সংখ্যা: 1³, 2³, 3³, 4³, 5³। সুতরাং, পরবর্তী পদটি হবে 6³ = 216।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion100" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR05",
    "question": "শ্রেণিটির শূন্যস্থান পূরণ করো: 5, 11, 23, 47, 95, ?",
    "option1": "191",
    "option2": "190",
    "option3": "189",
    "option4": "192",
    "answer": "option1",
    "solution": "প্যাটার্নটি হলো: (× 2 + 1)। 5×2+1=11, 11×2+1=23, 23×2+1=47, 47×2+1=95। সুতরাং, 95 × 2 + 1 = 191।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion101" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR06",
    "question": "সম্পর্কটি সম্পূর্ণ করো: ভারত : নতুন দিল্লি :: বাংলাদেশ : ?",
    "option1": "ঢাকা",
    "option2": "কাটমান্ডু",
    "option3": "ইসলামাবাদ",
    "option4": "কলম্বো",
    "answer": "option1",
    "solution": "যেমন ভারতের রাজধানী নতুন দিল্লি, তেমনই বাংলাদেশের রাজধানী হলো ঢাকা।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion102" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR06",
    "question": "সম্পর্কটি সম্পূর্ণ করো: ডাক্তার : হাসপাতাল :: শিক্ষক : ?",
    "option1": "বিদ্যালয়",
    "option2": "আদালত",
    "option3": "কারখানা",
    "option4": "অফিস",
    "answer": "option1",
    "solution": "ডাক্তারের কর্মক্ষেত্র হাসপাতাল, একইভাবে শিক্ষকের কর্মক্ষেত্র হলো বিদ্যালয়।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion103" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR06",
    "question": "নিচের কোনটি বাকিদের থেকে আলাদা (Odd one out)?",
    "option1": "আম",
    "option2": "আপেল",
    "option3": "আলু",
    "option4": "কমলালেবু",
    "answer": "option3",
    "solution": "আম, আপেল এবং কমলালেবু হলো ফল, কিন্তু আলু হলো একটি সবজি/মাটির নিচের কন্দ।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion104" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR06",
    "question": "সম্পর্কটি সম্পূর্ণ করো: কলম : লেখা :: ছুরি : ?",
    "option1": "কাটা",
    "option2": "সেলাই",
    "option3": "রাঁধা",
    "option4": "আঁকা",
    "answer": "option1",
    "solution": "কলমের প্রধান কাজ লেখা, তেমনই ছুরির প্রধান কাজ কোনো কিছু কাটা।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion105" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR06",
    "question": "সম্পর্কটি সম্পূর্ণ করো: 8 : 64 :: 9 : ?",
    "option1": "81",
    "option2": "72",
    "option3": "90",
    "option4": "100",
    "answer": "option1",
    "solution": "এখানে 8-এর বর্গ হলো 8² = 64। একইভাবে 9-এর বর্গ হবে 9² = 81।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion106" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR06",
    "question": "নিচের কোনটি বাকিদের থেকে আলাদা (Odd one out)?",
    "option1": "গঙ্গা",
    "option2": "যমুনা",
    "option3": "হিমালয়",
    "option4": "গোমেদ/গোমতী",
    "answer": "option3",
    "solution": "গঙ্গা, যমুনা ও গোমতী হলো নদী, কিন্তু হিমালয় একটি পর্বতমালা।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion107" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR06",
    "question": "সম্পর্কটি সম্পূর্ণ করো: চোখ : দেখা :: কান : ?",
    "option1": "শোনা",
    "option2": "গন্ধ নেওয়া",
    "option3": "স্বাদ নেওয়া",
    "option4": "স্পর্শ",
    "answer": "option1",
    "solution": "চোখের কাজ দেখা, কানের কাজ হলো শোনা।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion108" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR06",
    "question": "সম্পর্কটি সম্পূর্ণ করো: ACE : GIK :: BDF : ?",
    "option1": "HJLN",
    "option2": "HJL",
    "option3": "IKM",
    "option4": "GHI",
    "answer": "option2",
    "solution": "A(+6)->G, C(+6)->I, E(+6)->K। একইভাবে B(+6)->H, D(+6)->J, F(+6)->L। সুতরাং HJL।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion109" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR06",
    "question": "নিচের কোনটি বাকিদের থেকে আলাদা?",
    "option1": "25",
    "option2": "36",
    "option3": "49",
    "option4": "50",
    "answer": "option4",
    "solution": "25 (5²), 36 (6²), এবং 49 (7²) হলো পূর্ণবর্গ সংখ্যা, কিন্তু 50 পূর্ণবর্গ সংখ্যা নয়।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion110" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR06",
    "question": "সম্পর্কটি সম্পূর্ণ করো: মানুষ : শিশু :: কুকুর : ?",
    "option1": "ছাগলছানা",
    "option2": "প্যাঁচা",
    "option3": "ছানা / ছাওয়াল (Puppy)",
    "option4": "বাছুর",
    "answer": "option3",
    "solution": "মানুষের সন্তানকে শিশু বলা হয়, কুকুরের বাচ্চাকে বলা হয় Puppy বা কুকুরের ছানা।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion111" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR06",
    "question": "সম্পর্কটি সম্পূর্ণ করো: থার্মোমিটার : তাপমাত্রা :: ব্যারোমিটার : ?",
    "option1": "বায়ুর চাপ",
    "option2": "আর্দ্রতা",
    "option3": "বৃষ্টিপাত",
    "option4": "ভূমিকম্প",
    "answer": "option1",
    "solution": "থার্মোমিটার দিয়ে তাপমাত্রা মাপা হয়, ব্যারোমিটার দিয়ে বায়ুমণ্ডলের চাপ মাপা হয়।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion112" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR06",
    "question": "নিচের কোনটি বাকিদের থেকে আলাদা?",
    "option1": "জমি",
    "option2": "সাগর",
    "option3": "মহাসাগর",
    "option4": "হ্রদ",
    "answer": "option1",
    "solution": "সাগর, মহাসাগর এবং হ্রদ সবই জলভাগ, কিন্তু জমি হলো স্থলভাগ।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion113" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR06",
    "question": "সম্পর্কটি সম্পূর্ণ করো: 5 : 125 :: 6 : ?",
    "option1": "216",
    "option2": "36",
    "option3": "126",
    "option4": "666",
    "answer": "option1",
    "solution": "5-এর ঘন হলো 5³ = 125। একইভাবে 6-এর ঘন হবে 6³ = 216।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion114" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR06",
    "question": "সম্পর্কটি সম্পূর্ণ করো: রাজমিস্ত্রি : ইট :: দর্জি : ?",
    "option1": "কাপড়",
    "option2": "জুতো",
    "option3": "কাঠ",
    "option4": "লোহা",
    "answer": "option1",
    "solution": "রাজমিস্ত্রি ইট দিয়ে কাজ করে, দর্জি কাপড় দিয়ে কাজ করে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion115" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR06",
    "question": "নিচের কোনটি বাকিদের থেকে আলাদা (Odd one out)?",
    "option1": "রুপো",
    "option2": "সোনা",
    "option3": "তামা",
    "option4": "পিতল",
    "answer": "option4",
    "solution": "রুপো, সোনা ও তামা হলো মৌলিক ধাতু, কিন্তু পিতল হলো একটি সংকর ধাতু (Alloy)।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion116" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR06",
    "question": "সম্পর্কটি সম্পূর্ণ করো: লেখক : বই :: ভাস্কর : ?",
    "option1": "মূর্তি",
    "option2": "ছবি",
    "option3": "গান",
    "option4": "কবিতা",
    "answer": "option1",
    "solution": "লেখক বই তৈরি করেন, আর ভাস্কর তৈরি করেন মূর্তি।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion117" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR06",
    "question": "সম্পর্কটি সম্পূর্ণ করো: CAT : DDY :: DOG : ?",
    "option1": "ERM",
    "option2": "EQL",
    "option3": "FPN",
    "option4": "EQM",
    "answer": "option1",
    "solution": "C(+1)->D, A(+3)->D, T(+5)->Y। একইভাবে D(+1)->E, O(+3)->R, G(+5)->L। ফলে সম্পর্ক অনুযায়ী সঠিক মান ERM (বা নিয়ম অনুযায়ী অক্ষর বৃদ্ধি +1, +3, +5)।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion118" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR06",
    "question": "নিচের কোনটি বাকিদের থেকে আলাদা?",
    "option1": "জানুয়ারি",
    "option2": "মার্চ",
    "option3": "মে",
    "option4": "জুন",
    "answer": "option4",
    "solution": "জানুয়ারি, মার্চ এবং মে মাস ৩১ দিনের, কিন্তু জুন মাস ৩০ দিনের।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion119" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR06",
    "question": "সম্পর্কটি সম্পূর্ণ করো: পাকিস্তান : রূপিয়া :: জাপান : ?",
    "option1": "ইয়েন",
    "option2": "টাকা",
    "option3": "ডলার",
    "option4": "ইউরো",
    "answer": "option1",
    "solution": "পাকিস্তানের মুদ্রা হলো রুপি/রূপিয়া, জাপানের মুদ্রা হলো ইয়েন।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion120" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR06",
    "question": "সম্পর্কটি সম্পূর্ণ করো: 12 : 144 :: 15 : ?",
    "option1": "225",
    "option2": "200",
    "option3": "250",
    "option4": "175",
    "answer": "option1",
    "solution": "12-এর বর্গ হলো 12² = 144। একইভাবে 15-এর বর্গ হলো 15² = 225।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion121" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR07",
    "question": "একটি সারিতে ৪০ জন ছাত্র দাঁড়িয়ে আছে। রামের অবস্থান বাঁদিক থেকে ১৫তম হলে, ডানদিক থেকে তার অবস্থান কত?",
    "option1": "25তম",
    "option2": "26তম",
    "option3": "24তম",
    "option4": "27তম",
    "answer": "option2",
    "solution": "ডানদিকের অবস্থান = (মোট ছাত্র - বাঁদিকের অবস্থান) + ১ = (৪০ - ১৫) + ১ = ২৫ + ১ = ২৬তম।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion122" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR07",
    "question": "একটি লাইনে অনিতার স্থান উপর থেকে ১২তম এবং নিচ থেকে ১৮তম। ওই লাইনে মোট কতজন আছে?",
    "option1": "29 জন",
    "option2": "30 জন",
    "option3": "31 জন",
    "option4": "28 জন",
    "answer": "option1",
    "solution": "মোট সংখ্যা = (উপরের স্থান + নিচের স্থান) - ১ = (১২ + ১৮) - ১ = ৩০ - ১ = ২৯ জন।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion123" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR07",
    "question": "৫০ জনের একটি ক্লাসে রহিমের স্থান ওপর থেকে ২১তম। নিচ থেকে তার স্থান কত?",
    "option1": "29তম",
    "option2": "30তম",
    "option3": "31তম",
    "option4": "32তম",
    "answer": "option2",
    "solution": "নিচের অবস্থান = (মোট শিক্ষার্থী - ওপরের অবস্থান) + ১ = (৫০ - ২১) + ১ = ২৯ + ১ = ৩০তম।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion124" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR07",
    "question": "একটি সারিতে প্রিয়া বাঁদিক থেকে ১০ম এবং রিয়া ডানদিক থেকে ১৫তম স্থানে আছে। যদি তারা নিজেদের স্থান পরিবর্তন করে, তবে প্রিয়া বাঁদিক থেকে ১৫তম হয়। সারিতে মোট কতজন আছে?",
    "option1": "29 জন",
    "option2": "28 জন",
    "option3": "30 জন",
    "option4": "25 জন",
    "answer": "option1",
    "solution": "স্থান পরিবর্তনের পর প্রিয়ার নতুন অবস্থান (বাঁদিক থেকে ১৫তম) = রিয়ার পুরনো অবস্থান (ডানদিক থেকে ১৫তম)। মোট সংখ্যা = (১৫ + ১৫) - ১ = ২৯ জন।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion125" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR07",
    "question": "একটি লাইনে রবি বাঁদিক থেকে ৭ম এবং সুমিত ডানদিক থেকে ৯ম স্থানে আছে। তাদের মাঝে ৬ জন থাকলে লাইনে সর্বনিম্ন (Minimum) কতজন থাকতে পারে?",
    "option1": "8 জন",
    "option2": "10 জন",
    "option3": "22 জন",
    "option4": "12 জন",
    "answer": "option1",
    "solution": "সর্বনিম্ন সংখ্যা (Overlapping Case) = (বাঁদিক + ডানদিক) - মাঝের সংখ্যা - ২ = (৭ + ৯) - ৬ - ২ = ১৬ - ৮ = ৮ জন।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion126" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR07",
    "question": "উচ্চতার দিক থেকে A, B-এর চেয়ে লম্বা কিন্তু C-এর চেয়ে ছোট। D, E-এর চেয়ে লম্বা কিন্তু B-এর চেয়ে ছোট। এদের মধ্যে কে সবচেয়ে লম্বা?",
    "option1": "A",
    "option2": "B",
    "option3": "C",
    "option4": "D",
    "answer": "option3",
    "solution": "প্রদত্ত শর্তানুসারে: C > A > B এবং B > D > E। সম্পূর্ণ ক্রম: C > A > B > D > E। সুতরাং সবচেয়ে লম্বা হলো C।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion127" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR07",
    "question": "একটি সারিতে সুরেশ ডানদিক থেকে ২৭তম স্থানে আছে। সারিতে মোট ৩৮ জন থাকলে, বাঁদিক থেকে সুরেশের স্থান কত?",
    "option1": "11তম",
    "option2": "12তম",
    "option3": "13তম",
    "option4": "10তম",
    "answer": "option2",
    "solution": "বাঁদিকের অবস্থান = (মোট সংখ্যা - ডানদিকের অবস্থান) + ১ = (৩৮ - ২৭) + ১ = ১১ + ১ = ১২তম।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion128" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR07",
    "question": "একটি লাইনে মোট ৩৫ জন আছে। আকাশ বাঁদিক থেকে ১২তম। রোহন আকাশের ডানদিকে ৬ষ্ঠ স্থানে থাকলে, ডানদিক থেকে রোহনের অবস্থান কত?",
    "option1": "18তম",
    "option2": "17তম",
    "option3": "19তম",
    "option4": "20তম",
    "answer": "option2",
    "solution": "বাঁদিক থেকে রোহনের স্থান = ১২ + ৬ = ১৮তম। ডানদিক থেকে রোহনের স্থান = (৩৫ - ১৮) + ১ = ১৭ + ১ = ১৮তম... ভুল সংশোধন: (৩৫ - ১৮) + ১ = ১৮তম। [বিকল্প অনুযায়ী ৩৫ - ১৮ + ১ = ১৮তম]। "
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion129" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR07",
    "question": "পাঁচ বন্ধু P, Q, R, S, T-এর মধ্যে R সবচেয়ে ভারী। Q কেবল P-এর চেয়ে হালকা। T, S-এর চেয়ে ভারী কিন্তু P-এর চেয়ে হালকা। দ্বিতীয় ভারী ব্যক্তি কে?",
    "option1": "R",
    "option2": "Q",
    "option3": "P",
    "option4": "T",
    "answer": "option2",
    "solution": "ক্রমটি হলো: R (সবচেয়ে ভারী) > Q > P > T > S। তাই দ্বিতীয় ভারী ব্যক্তি হলো Q।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion130" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR07",
    "question": "একটি সারিতে অয়ন উভয় দিক (বাঁদিক ও ডানদিক) থেকেই ১৪তম স্থানে থাকলে সারিতে মোট কতজন আছে?",
    "option1": "27 জন",
    "option2": "28 জন",
    "option3": "29 জন",
    "option4": "26 জন",
    "answer": "option1",
    "solution": "মোট সংখ্যা = (১৪ + ১৪) - ১ = ২৮ - ১ = ২৭ জন।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion131" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR07",
    "question": "একটি ক্লাসে পঙ্কজের স্থান ওপর থেকে ৮ম এবং নিচ থেকে ৩৬তম। পরীক্ষা পাস করা ছাত্রদের মধ্যে এটি হিসাব করা হয়েছে। ৬ জন ছাত্র পরীক্ষায় অনুপস্থিত ছিল এবং ৪ জন ফেল করেছে। ক্লাসে মোট ছাত্র সংখ্যা কত?",
    "option1": "43 জন",
    "option2": "53 জন",
    "option3": "52 জন",
    "option4": "47 জন",
    "answer": "option2",
    "solution": "পাস করা মোট ছাত্র = (৮ + ৩৬) - ১ = ৪৩ জন। মোট ছাত্র সংখ্যা = পাস (৪৩) + অনুপস্থিত (৬) + ফেল (৪) = ৫৩ জন।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion132" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR07",
    "question": "একটি সারিতে A বাঁদিক থেকে ১১তম এবং B ডানদিক থেকে ১০ম স্থানে রয়েছে। তারা স্থান পরিবর্তন করলে A বাঁদিক থেকে ১৮তম হয়। B ডানদিক থেকে কততম স্থানে থাকবে?",
    "option1": "17তম",
    "option2": "18তম",
    "option3": "16তম",
    "option4": "19তম",
    "answer": "option1",
    "solution": "A-এর স্থান পরিবর্তন বৃদ্ধি = ১৮ - ১১ = ৭ ঘর। B-এর নতুন স্থান হবে = ১০ + ৭ = ১৭তম।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion133" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR07",
    "question": "একটি লাইনে রাজু বাঁদিক থেকে ৮ম এবং শ্যাম ডানদিক থেকে ৯ম। তাদের মাঝখানে ৩ জন দাঁড়িয়ে থাকলে লাইনে সর্বোচ্চ (Maximum) কতজন লোক থাকতে পারে?",
    "option1": "20 জন",
    "option2": "18 জন",
    "option3": "17 জন",
    "option4": "19 জন",
    "answer": "option1",
    "solution": "সর্বোচ্চ সংখ্যা = বাঁদিক + ডানদিক + মাঝের সংখ্যা = ৮ + ৯ + ৩ = ২০ জন।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion134" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR07",
    "question": "চারজন ব্যক্তির বয়সের তুলনা: K, L-এর চেয়ে বড়। M, N-এর চেয়ে ছোট। N, L-এর চেয়ে বড়। সবচেয়ে ছোট কে?",
    "option1": "K",
    "option2": "L",
    "option3": "M",
    "option4": "N",
    "answer": "option3",
    "solution": "সম্পর্কগুলি: K > L, N > L, N > M। এখান থেকে M সবচেয়ে ছোট হতে পারে কারণ N > L এবং N > M (M সর্বশেষে অবস্থান করে)।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion135" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR07",
    "question": "একটি পরীক্ষায় উত্তীর্ণদের তালিকায় সমীক্ষার স্থান ওপর থেকে ১০ম এবং নিচ থেকে ২৫তম। মোট কতজন উত্তীর্ণ হয়েছে?",
    "option1": "34 জন",
    "option2": "35 জন",
    "option3": "36 জন",
    "option4": "33 জন",
    "answer": "option1",
    "solution": "মোট উত্তীর্ণ সংখ্যা = (১০ + ২৫) - ১ = ৩৫ - ১ = ৩৪ জন।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion136" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR07",
    "question": "৪৫ জন ছাত্রের মধ্যে বিকাশ বাঁদিক থেকে ১৯তম স্থানে আছে। তার ডানদিকে কতজন ছাত্র রয়েছে?",
    "option1": "26 জন",
    "option2": "27 জন",
    "option3": "25 জন",
    "option4": "28 জন",
    "answer": "option1",
    "solution": "ডানদিকের ছাত্র সংখ্যা = মোট ছাত্র - বিকাশের স্থান = ৪৫ - ১৯ = ২৬ জন।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion137" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR07",
    "question": "একটি লাইনে মনোজ ডানদিক থেকে ১৫তম স্থানে আছে। যদি লাইনে মোট ৩০ জন থাকে, তবে বাঁদিক থেকে মনোজের ঠিক আগে (Left of Manoj) কতজন আছে?",
    "option1": "15 জন",
    "option2": "16 জন",
    "option3": "14 জন",
    "option4": "17 জন",
    "answer": "option1",
    "solution": "বাঁদিক থেকে মনোজের স্থান = (৩০ - ১৫) + ১ = ১৬তম। অতএব, তার আগে বাঁদিকে মোট ১৫ জন দাঁড়িয়ে আছে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion138" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR07",
    "question": "পাঁচটি বই A, B, C, D, E একটির ওপর একটি রাখা আছে। C রাখা আছে D-এর ওপরে, E আছে A-এর নিচে, D আছে A-এর ওপরে এবং B আছে E-এর নিচে। সবচেয়ে নিচে কোন বইটি আছে?",
    "option1": "B",
    "option2": "C",
    "option3": "E",
    "option4": "A",
    "answer": "option1",
    "solution": "উপর থেকে নিচে সাজালে: C > D > A > E > B। সুতরাং সবচেয়ে নিচে থাকা বইটি হলো B।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion139" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR07",
    "question": "একটি সারিতে ৬... ৬০ জন ছাত্রের মধ্যে মেয়েদের সংখ্যা ছেলেদের দ্বিগুণ। ওপর থেকে রামের স্থান ১৭তম। রামের ওপরে ৯টি মেয়ে থাকলে, তার নিচে কতজন ছেলে আছে? (যদি মোট ছেলে ২০জন হয়)",
    "option1": "12 জন",
    "option2": "13 জন",
    "option3": "11 জন",
    "option4": "10 জন",
    "answer": "option3",
    "solution": "রামের ওপরে মোট ১৬ জন আছে, যার মধ্যে ৯ জন মেয়ে। অর্থাৎ রামের ওপরে ছেলে আছে (১৬ - ৯) = ৭ জন। রাম নিজে ১ জন ছেলে। তাহলে রাম পর্যন্ত ছেলে সংখ্যা = ৮ জন। নিচে অবশিষ্ট ছেলে = ২০ - ৮ = ১১ জন।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion140" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR07",
    "question": "একটি সারিতে দীপক বাঁদিক থেকে ৯ম এবং বিজয় ডানদিক থেকে ১৩তম স্থানে রয়েছে। যদি তাদের মাঝে ৪ জন লোক থাকে, তবে সারিতে মোট কতজন লোক থাকতে পারে (যদি কোনো Overlap না হয়)?",
    "option1": "26 জন",
    "option2": "25 জন",
    "option3": "27 জন",
    "option4": "24 জন",
    "answer": "option1",
    "solution": "মোট সংখ্যা = ৯ + ১৩ + ৪ = ২৬ জন।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion141" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR08",
    "question": "একটি ঘড়িতে ৩:০০ টা বাজে। ডানপাশে রাখা দর্পণে (Mirror) সময় কত দেখাবে?",
    "option1": "9:00",
    "option2": "8:00",
    "option3": "6:00",
    "option4": "12:00",
    "answer": "option1",
    "solution": "দর্পণ প্রতিচ্ছবির ক্ষেত্রে ১২:০০ টা থেকে সময় বিয়োগ করতে হয়। ১২:০০ - ৩:০০ = ৯:০০ টা।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion142" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR08",
    "question": "'REASONING' শব্দটির সঠিক দর্পণ প্রতিচ্ছবি (Mirror Image) নির্বাচন করো (যদি আয়নাটি ডানপাশে রাখা হয়)।",
    "option1": "GNINOSAEɌ",
    "option2": "GИIИOƧAƎЯ",
    "option3": "ƓИIИOƧAƎЯ",
    "option4": "GNINOSAER",
    "answer": "option2",
    "solution": "ডানপাশে দর্পণ থাকলে শব্দটির শেষ অক্ষর (G) প্রথমে আসবে এবং প্রতিটি অক্ষরের পার্শ্বীয় পরিবর্তন (Lateral Inversion) ঘটবে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion143" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR08",
    "question": "'WATER' শব্দটির সঠিক জল প্রতিচ্ছবি (Water Image) কোনটি?",
    "option1": "M∀⊥ƎЯ",
    "option2": "M∀⊥EЯ",
    "option3": "M∀⊥ƎR",
    "option4": "M∀┴ƎЯ",
    "answer": "option1",
    "solution": "জল প্রতিচ্ছবিতে (Water Image) অক্ষরের ওপরের অংশ নিচে এবং নিচের অংশ ওপরে চলে যায় (Vertical Inversion)।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion144" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR08",
    "question": "ইংরেজি বর্ণমালার কতগুলি ক্যাপিটাল লেটারের দর্পণ প্রতিচ্ছবি (Mirror Image) মূল অক্ষরের মতোই অপরিবর্তিত থাকে?",
    "option1": "10টি",
    "option2": "11টি",
    "option3": "12টি",
    "option4": "9টি",
    "answer": "option2",
    "solution": "যে ১১টি অক্ষরের দর্পণ প্রতিচ্ছবি অপরিবর্তিত থাকে সেগুলি হলো: A, H, I, M, O, T, U, V, W, X, Y।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion145" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR08",
    "question": "একটি ঘড়িতে ৪:৪০ বাজলে, এর জল প্রতিচ্ছবিতে (Water Image) আনুমানিক সময় কত দেখাবে?",
    "option1": "1:50",
    "option2": "2:50",
    "option3": "1:10",
    "option4": "2:10",
    "answer": "option1",
    "solution": "জল প্রতিচ্ছবির ক্ষেত্রে ১৮:৩০ বা ১৭:৯০ থেকে বিয়োগ করা হয়। ১৭:৯০ - ৪:৪০ = ১৩:৫০ অর্থাৎ ১:৫০।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion146" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR08",
    "question": "ইংরেজি বর্ণমালার কতগুলি ক্যাপিটাল লেটারের জল প্রতিচ্ছবি (Water Image) অপরিবর্তিত থাকে?",
    "option1": "9টি",
    "option2": "8টি",
    "option3": "7টি",
    "option4": "10টি",
    "answer": "option1",
    "solution": "যে ৯টি অক্ষরের জল প্রতিচ্ছবি একই থাকে সেগুলি হলো: C, D, E, H, I, K, O, X, B (কিছু ফন্টে B ও K পরিবর্তিত হতে পারে, তবে প্রমিত মান ৯টি)।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion147" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR08",
    "question": "'QUALITY' শব্দটির ডানপাশে দর্পণ রাখলে সঠিক প্রতিচ্ছবি কোনটি হবে?",
    "option1": "YTILAUQ",
    "option2": "YTI⅃AUϘ",
    "option3": "YTI⅃A∩Ϙ",
    "option4": "YTILAUϘ",
    "answer": "option2",
    "solution": "শেষের Y থেকে শুরু হয়ে প্রতিটি অক্ষরের পার্শ্বীয় পরিবর্তন হয়ে YTI⅃AUϘ গঠন করবে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion148" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR08",
    "question": "একটি ঘড়িতে ৮:২০ বাজে। ঘড়িটির জল প্রতিচ্ছবি (Water Image) নিচে দেখা গেলে সময় কত দেখাবে?",
    "option1": "10:10",
    "option2": "9:10",
    "option3": "10:20",
    "option4": "9:20",
    "answer": "option1",
    "solution": "১৮:৩০ থেকে বিয়োগ করতে হবে: ১৮:৩০ - ৮:২০ = ১০:১০।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion149" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR08",
    "question": "সংখ্যা '4567'-এর দর্পণ প্রতিচ্ছবি (Mirror Image) কী হবে?",
    "option1": "7654",
    "option2": "Γ∂ƧA",
    "option3": "ΓaƧ▲",
    "option4": "7654 (উল্টানো)",
    "answer": "option2",
    "solution": "ডানপাশের দর্পণে সংখ্যাগুলির ক্রম উল্টে গিয়ে 7, 6, 5, 4 প্রতিটিই পার্শ্বীয়ভাবে উল্টে যাবে (Γ∂ƧA)।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion150" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR08",
    "question": "'DISC' শব্দটির সঠিক জল প্রতিচ্ছবি (Water Image) কোনটি?",
    "option1": "DIƧƆ",
    "option2": "DISC",
    "option3": "DIƧC",
    "option4": "ƆƧIᗡ",
    "answer": "option2",
    "solution": "D, I, S, C বর্ণগুলির জল প্রতিচ্ছবি যথাক্রমে D, I, S, C-এর মতো একই থাকে, তাই DISC অপরিবর্তিত মনে হয়।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion151" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR08",
    "question": "একটি দর্পণে একটি ঘড়ির প্রতিচ্ছবিতে ৭:২৫ দেখাচ্ছে। ঘড়িটিতে প্রকৃত সময় (Actual Time) কত?",
    "option1": "4:35",
    "option2": "5:35",
    "option3": "4:25",
    "option4": "5:25",
    "answer": "option1",
    "solution": "প্রকৃত সময় = ১১:৬০ - ৭:২৫ = ৪:৩৫।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion152" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR08",
    "question": "'CLOCK' শব্দটির ডানপাশে রাখা দর্পণে দেখলে সঠিক রূপ কোনটি হবে?",
    "option1": "KCƆO⅃Ɔ",
    "option2": "KƆO⅃Ɔ",
    "option3": "ʞƆO⅃Ɔ",
    "option4": "KCOLC",
    "answer": "option3",
    "solution": "K বর্ণটি উল্টে ʞ হবে, তারপর C->Ɔ, O->O, L->⅃, C->Ɔ। অর্থাৎ ʞƆO⅃Ɔ।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion153" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR08",
    "question": "'RAJ' শব্দটির জল প্রতিচ্ছবি (Water Image) কেমন দেখাবে?",
    "option1": "ᴚ∀ſ",
    "option2": "ᴚAJ",
    "option3": "JAR",
    "option4": "ᴚ∀J",
    "answer": "option1",
    "solution": "R-এর উলম্ব উল্টানো রূপ ᴚ, A-এর উল্টানো রূপ ∀, এবং J-এর উল্টানো রূপ ſ।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion154" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR08",
    "question": "যদি কোনো ঘড়িতে ১২:১৫ বাজে, তবে তার দর্পণ প্রতিচ্ছবিতে কত সময় দেখাবে?",
    "option1": "11:45",
    "option2": "12:45",
    "option3": "11:15",
    "option4": "10:45",
    "answer": "option1",
    "solution": "২৩:৬০ থেকে বিয়োগ করতে হবে: ২৩:৬০ - ১২:১৫ = ১১:৪৫।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion155" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR08",
    "question": "কোনো বস্তু এবং তার দর্পণ প্রতিচ্ছবির মধ্যে মূল পরিবর্তনটি কী ঘটে?",
    "option1": "পার্শ্বীয় পরিবর্তন (Lateral Inversion)",
    "option2": "উলম্ব পরিবর্তন (Vertical Inversion)",
    "option3": "কোনো পরিবর্তন হয় না",
    "option4": "আকার বড় হয়ে যায়",
    "answer": "option1",
    "solution": "সমতল দর্পণে সবসময় বাম দিক ডান দিকে এবং ডান দিক বাম দিকে পরিবর্তিত হয়, যাকে পার্শ্বীয় পরিবর্তন বলে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion156" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR08",
    "question": "একটি ঘড়িতে ৬:০০ টা বাজে। জল প্রতিচ্ছবিতে (Water Image) আনুমানিক সময় কত দেখাবে?",
    "option1": "12:30",
    "option2": "12:00",
    "option3": "6:30",
    "option4": "11:30",
    "answer": "option1",
    "solution": "১৮:৩০ - ৬:০০ = ১২:৩০।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion157" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR08",
    "question": "'5891' সংখ্যাটির সঠিক জল প্রতিচ্ছবি (Water Image) নির্বাচন করো।",
    "option1": "২861",
    "option2": "5891",
    "option3": "1985",
    "option4": "২891",
    "answer": "option1",
    "solution": "জল প্রতিচ্ছবিতে সংখ্যার স্থান একই থাকে কিন্তু প্রতিটি সংখ্যা উলম্বভাবে উল্টে যায় (5 উল্টে ২-এর মতো, 8 একই, 9 উল্টে 6-এর মতো, 1 উল্টে যায়)।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion158" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR08",
    "question": "'MIRROR' শব্দটির ডানপাশে আয়না রাখা হলে আয়নায় শেষ অক্ষরটি কী দেখাবে?",
    "option1": "Я",
    "option2": "M",
    "option3": "R",
    "option4": "O",
    "answer": "option2",
    "solution": "MIRROR শব্দটির প্রথম অক্ষর M দর্পণ প্রতিচ্ছবিতে একদম শেষে যাবে এবং M-এর দর্পণ রূপ M-ই থাকে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion159" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR08",
    "question": "একটি ঘড়িতে ১০:১৯ বাজলে তার দর্পণ প্রতিচ্ছবিতে (Mirror Image) কত বাজবে?",
    "option1": "1:41",
    "option2": "2:41",
    "option3": "1:19",
    "option4": "2:19",
    "answer": "option1",
    "solution": "১১:৬০ - ১০:১৯ = ১:৪১।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion160" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR08",
    "question": "'EXAM' শব্দটির জল প্রতিচ্ছবি (Water Image) কোনটি হবে?",
    "option1": "EX∀W",
    "option2": "EXAM",
    "option3": "EXAWI",
    "option4": "W∀XE",
    "answer": "option1",
    "solution": "E ও X অপরিবর্তিত থাকে, A উল্টে ∀ হয়, M উল্টে W হয়। ফলে 'EX∀W' তৈরি হয়।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion161" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR09",
    "question": "একটি সরলরেখা এবং তার ওপর লম্বভাবে থাকা অন্য একটি রেখা (┴) নির্দেশ করে এমন চিত্রটি প্রধানত কোন জ্যামিতিক গঠনে লুকানো থাকে?",
    "option1": "আয়তক্ষেত্র বা বর্গক্ষেত্র",
    "option2": "বৃত্ত",
    "option3": "উপবৃত্ত",
    "option4": "ত্রিভুজ",
    "answer": "option1",
    "solution": "আয়তক্ষেত্র বা বর্গক্ষেত্রের প্রতিটি কোণ ৯০ ডিগ্রি হওয়ায় এর বাহুগুলির মধ্যে লম্ব (┴) গঠনটি সরাসরি লুকানো থাকে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion162" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR09",
    "question": "একটি ইংরেজি অক্ষর 'Z' আকৃতির প্যাটার্ন নিচের কোন জটিল চিত্রটির মধ্যে সহজে খুঁজে পাওয়া সম্ভব?",
    "option1": "পরস্পর সমান্তরাল দুটি রেখাকে ছেদকারী একটি ছেদক রেখা",
    "option2": "একটি একক সমবাহু ত্রিভুজ",
    "option3": "একটি সম্পূর্ণ গোলক বা বৃত্ত",
    "option4": "একটি একক সরলরেখা",
    "answer": "option1",
    "solution": "দুটি সমান্তরাল রেখাকে একটি ছেদক রেখা যুক্ত করলে একান্তর কোণ তৈরির মাধ্যমে 'Z' আকৃতির প্যাটার্ন তৈরি হয়।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion163" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR09",
    "question": "একটি সামান্তরিকের (Parallelogram) ভেতর নিচের কোন মৌলিক জ্যামিতিক চিত্রটি অবশ্যই অন্তর্নিহিত বা লুকানো থাকে?",
    "option1": "ত্রিভুজ",
    "option2": "বৃত্ত",
    "option3": "পঞ্চভুজ",
    "option4": "ষড়ভুজ",
    "answer": "option1",
    "solution": "যে কোনো সামান্তরিকের একটি কর্ণ টানলে তা দুটি ত্রিভুজে বিভক্ত হয়, তাই এর ভেতর ত্রিভুজ লুকানো থাকে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion164" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR09",
    "question": "ইংরেজি অক্ষর 'X' আকৃতির প্যাটার্নটি নিচের কোন সংমিশ্রণের মধ্যে স্পষ্টভাবে বিদ্যমান থাকে?",
    "option1": "দুটি পরস্পর ছেদী সরলরেখা",
    "option2": "দুটি সমান্তরাল সরলরেখা",
    "option3": "একটি স্পর্শক ও বৃত্ত",
    "option4": "একটি সরলরেখা ও অর্ধবৃত্ত",
    "answer": "option1",
    "solution": "দুটি সরলরেখা একে অপরকে ছেদ করলে 'X' আকৃতির সংমিশ্রণ ও বিপ্রতীপ কোণ তৈরি হয়।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion165" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR09",
    "question": "একটি সুষম ষড়ভুজের (Regular Hexagon) কেন্দ্র থেকে বিপরীত শীর্ষবিন্দুগুলি যোগ করলে মোট কতগুলি সমবাহু ত্রিভুজ লুকানো অবস্থায় পাওয়া যায়?",
    "option1": "6টি",
    "option2": "4টি",
    "option3": "8টি",
    "option4": "5টি",
    "answer": "option1",
    "solution": "সুষম ষড়ভুজের কেন্দ্র থেকে কর্ণগুলি যুক্ত করলে ৬টি সমান সমবাহু ত্রিভুজ গঠিত হয়।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion166" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR09",
    "question": "একটি পঞ্চভূজ তারকা চিহ্ন (5-pointed Star)-এর মধ্যে মোট কতগুলি ছোট ও বড় ত্রিভুজ লুকানো থাকে?",
    "option1": "10টি",
    "option2": "5টি",
    "option3": "8টি",
    "option4": "12টি",
    "answer": "option1",
    "solution": "স্টার আকৃতিতে বাইরের ৫টি ছোট ত্রিভুজ এবং ভেতরের বড় শীর্ষবিন্দুগুলি মিলিয়ে মোট ১০টি ত্রিভুজ থাকে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion167" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR09",
    "question": "একটি ইংরেজি অক্ষর 'N' আকৃতির নকশা পেতে হলে কোন ধরনের রেখার সংমিশ্রণ প্রয়োজন?",
    "option1": "দুটি উলম্ব সমান্তরাল রেখা এবং তাদের সংযোগকারী একটি তির্যক রেখা",
    "option2": "তিনটি সমান্তরাল রেখা",
    "option3": "দুটি অনুভূমিক সমান্তরাল রেখা",
    "option4": "একটি বৃত্ত ও দুটি সরলরেখা",
    "answer": "option1",
    "solution": "দুটি সোজা উলম্ব রেখাকে কোনাকুনি একটি তির্যক রেখা দিয়ে যুক্ত করলে 'N' আকার তৈরি হয়।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion168" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR09",
    "question": "একটি বর্গক্ষেত্রের দুটি কর্ণ অঙ্কন করলে তার ভেতর কতগুলি ছোট-বড় ত্রিভুজ লুকানো থাকে?",
    "option1": "8টি",
    "option2": "4টি",
    "option3": "6টি",
    "option4": "10টি",
    "answer": "option1",
    "solution": "কর্ণদ্বয় ছেদ করলে ৪টি একক ত্রিভুজ এবং ২টি করে সংলগ্ন ত্রিভুজ মিলে আরও ৪টি, অর্থাৎ মোট ৮টি ত্রিভুজ গঠিত হয়।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion169" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR09",
    "question": "নিচের কোন জ্যামিতিক চিত্রে কোনো সরলরেখা দ্বারা গঠিত লুকানো চিত্র পাওয়া সম্ভব নয়?",
    "option1": "একটি নিরবচ্ছিন্ন সরল বৃত্ত",
    "option2": "একটি ত্রিভুজ",
    "option3": "একটি বর্গক্ষেত্র",
    "option4": "একটি রম্বস",
    "answer": "option1",
    "solution": "বৃত্ত কেবল বক্ররেখা দিয়ে তৈরি, তাই এতে সরলরেখা দ্বারা গঠিত কোনো জ্যামিতিক চিত্র থাকে না।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion170" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR09",
    "question": "একটি ঘনক (Cube)-এর দ্বিমাত্রিক (2D) ছকে কয়টি বর্গক্ষেত্র অন্তর্নিহিত বা লুকানো থাকে?",
    "option1": "6টি",
    "option2": "4টি",
    "option3": "8টি",
    "option4": "12টি",
    "answer": "option1",
    "solution": "একটি ঘনক ৬টি বর্গাকার তল বা পৃষ্ঠতল নিয়ে গঠিত।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion171" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR09",
    "question": "ইংরেজি অক্ষর 'V' আকৃতির গঠনটি নিচের কোন জ্যামিতিক চিত্রের একটি কোণে লুকানো থাকে?",
    "option1": "ত্রিভুজ",
    "option2": "বৃত্ত",
    "option3": "উপবৃত্ত",
    "option4": "রেখাংশ",
    "answer": "option1",
    "solution": "ত্রিভুজের যেকোনো দুটি বাহু যেখানে মিলিত হয় সেখানে সূক্ষ্মকোণ বা 'V' আকৃতির গঠন তৈরি হয়।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion172" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR09",
    "question": "'Hidden Figure' বা লুকানো চিত্র নির্ণয়ের ক্ষেত্রে প্রধান নিয়মটি কী?",
    "option1": "মূল প্রশ্নচিত্রটি নিখুঁতভাবে উত্তরচিত্রের কাঠামোর মধ্যে ঘূর্ণন ছাড়া বা থাকা অবস্থায় মিলে যাওয়া",
    "option2": "চিত্রটির আকার বড় বা ছোট করে নতুন রেখা যোগ করা",
    "option3": "চিত্রটির রং পরিবর্তন করা",
    "option4": "চিত্রের রেখা মুছে ফেলা",
    "answer": "option1",
    "solution": "লুকানো চিত্র পরীক্ষায় প্রশ্নচিত্রটির অবিকল আকৃতি কোনো পরিবর্তন ছাড়াই প্রদত্ত বিকল্প কাঠামোর মধ্যে খুঁজে বের করতে হয়।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion173" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR09",
    "question": "একটি রম্বস (Rhombus)-এর ভেতরে বিপরীত শীর্ষবিন্দু যুক্ত করলে কোন ধরণের ৪টি ত্রিভুজ পাওয়া যায়?",
    "option1": "সমকোণী ত্রিভুজ",
    "option2": "সমবাহু ত্রিভুজ",
    "option3": "স্থূলকোণী ত্রিভুজ",
    "option4": "বৃত্তীয় ত্রিভুজ",
    "answer": "option1",
    "solution": "রম্বসের কর্ণদ্বয় পরস্পরকে সমকোণে (৯০°) সমদ্বিখণ্ডিত করে, তাই ৪টি সমকোণী ত্রিভুজ গঠিত হয়।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion174" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR09",
    "question": "ইংরেজি বর্ণ 'H' তৈরি করতে নিচের কোনটি প্রয়োজন?",
    "option1": "দুটি সমান্তরাল উলম্ব রেখা ও মাঝখানে একটি অনুভূমিক রেখা",
    "option2": "তিনটি অনুভূমিক রেখা",
    "option3": "দুটি তির্যক রেখা",
    "option4": "একটি বৃত্ত ও একটি রেখা",
    "answer": "option1",
    "solution": "দুটি সোজা খাড়া রেখার মাঝামাঝি একটি অনুভূমিক যুক্ত রেখা টেনে 'H' আকৃতি তৈরি হয়।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion175" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR09",
    "question": "একটি সামান্তরিক ও ত্রিভুজের সমন্বয়ে তৈরি চিত্রে 'T' আকৃতি পেতে কোন ধরনের সংযোগ প্রয়োজন?",
    "option1": "একটি অনুভূমিক রেখার ওপর লম্বভাবে থাকা রেখা",
    "option2": "দুটি গোলক রেখা",
    "option3": "দুটি স্পর্শক রেখা",
    "option4": "একটি বৃত্ত চাপ",
    "answer": "option1",
    "solution": "একটি সমতল বাহুর ওপর অন্য একটি বাহু ৯০ ডিগ্রি কোণে থাকলে 'T' বা লম্ব রূপ দেখা যায়।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion176" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR09",
    "question": "একটি ট্র্যাপিজিয়ামকে (Trapezium) দুটি সমান্তরাল বাহুর মধ্যে লম্ব টেনে বিভক্ত করলে কোন দুটি চিত্র লুকানো অবস্থায় পাওয়া যায়?",
    "option1": "আয়তক্ষেত্র ও ত্রিভুজ",
    "option2": "বৃত্ত ও বর্গক্ষেত্র",
    "option3": "কেবল দুটি বৃত্ত",
    "option4": "কেবল ষড়ভুজ",
    "answer": "option1",
    "solution": "ট্র্যাপিজিয়ামের ভেতর থেকে লম্ব টানলে একটি আয়তক্ষেত্র/বর্গক্ষেত্র এবং এক বা দুটি সমকোণী ত্রিভুজ নির্গত হয়।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion177" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR09",
    "question": "একটি ইংরেজি 'E' আকৃতির চিত্রে কয়টি অনুভূমিক (Horizontal) রেখাংশ লুকানো থাকে?",
    "option1": "3টি",
    "option2": "2টি",
    "option3": "4টি",
    "option4": "1টি",
    "answer": "option1",
    "solution": "'E' বর্ণটিতে ১টি উলম্ব রেখা এবং ডানদিকে ৩টি অনুভূমিক সমান্তরাল বাহু থাকে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion178" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR09",
    "question": "একটি চক্রের (Wheel) স্পোকগুলির মধ্যে কোন আকৃতিটি বারবার পুনরাবৃত্ত অবস্থায় লুকানো থাকে?",
    "option1": "বৃত্তকলা (Sector of a circle)",
    "option2": "বর্গক্ষেত্র",
    "option3": "রম্বস",
    "option4": "আয়তক্ষেত্র",
    "answer": "option1",
    "solution": "চক্রের কেন্দ্র থেকে পরিধি পর্যন্ত বিস্তৃত স্পোকগুলি চাকাটিকে একাধিক 'বৃত্তকলা' বা পাই-স্লাইস আকৃতিতে ভাগ করে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion179" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR09",
    "question": "একটি পিনরামিডের (Pyramid - বর্গাকার ভিত্তি) দ্বিমাত্রিক পার্শ্বীয় দৃশ্য (Side View)-এ কোন চিত্রটি লুকানো থাকে?",
    "option1": "ত্রিভুজ",
    "option2": "বৃত্ত",
    "option3": "বর্গক্ষেত্র",
    "option4": "অষ্টভুজ",
    "answer": "option1",
    "solution": "বর্গাকার পিরামিডের পার্শ্বীয় তলগুলি ত্রিভুজাকার হওয়ায় সামনে থেকে দেখলে ত্রিভুজ দৃশ্যমান হয়।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion180" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR09",
    "question": "একটি অ্যারো বা তীরচিহ্নের (➔) মাথায় প্রধানত কোন জ্যামিতিক চিত্রটি অন্তর্ভুক্ত থাকে?",
    "option1": "ত্রিভুজ",
    "option2": "বৃত্ত",
    "option3": "বর্গক্ষেত্র",
    "option4": "অর্ধবৃত্ত",
    "answer": "option1",
    "solution": "তীরচিহ্নের অগ্রভাগ বা মাথাটি একটি ত্রিভুজাকার আকৃতি দ্বারা গঠিত হয়।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion181" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR10",
    "question": "একটি বর্গাকার কাগজকে মাঝখান থেকে বাম থেকে ডানে ভাঁজ করে একটি বৃত্তাকার ছিদ্র করা হলো। কাগজটি খুললে মোট কতটি ছিদ্র দেখা যাবে?",
    "option1": "2টি",
    "option2": "1টি",
    "option3": "4টি",
    "option4": "3টি",
    "answer": "option1",
    "solution": "একবার ভাঁজ (2-fold) করে ছিদ্র করলে কাগজটি খোলার পর ভাঁজের দু'পাশে ২টি ছিদ্র তৈরি হবে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion182" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR10",
    "question": "একটি কাগজকে পরপর দুবার ভাঁজ করে (কোয়ার্টার বা ১/৪ অংশে) কোণায় একটি ত্রিভুজাকারে কাটা হলো। সম্পূর্ণ কাগজটি খুললে কী আকৃতি গঠিত হবে?",
    "option1": "মাঝখানে একটি রম্বস বা চতুর্ভুজ ছিদ্র",
    "option2": "মাঝখানে একটি বৃত্ত",
    "option3": "কেবল একটি ত্রিভুজ",
    "option4": "কাগজের চার কোণায় চারটি বৃত্ত",
    "answer": "option1",
    "solution": "৪ ভাঁজের কেন্দ্রের কোণায় ত্রিভুজ কাটলে কাগজ খোলার পর কেন্দ্রের ৪টি অংশ মিলে একটি চতুর্ভুজ বা রম্বস আকৃতির ছিদ্র তৈরি করে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion183" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR10",
    "question": "কাগজ ভাঁজ ও কাটার (Paper Folding and Cutting) প্রশ্ন সমাধানের ক্ষেত্রে প্রধানত কোন জ্যামিতিক নীতির প্রয়োগ ঘটে?",
    "option1": "প্রতিচ্ছবি বা প্রতিফলন (Symmetry & Mirror Image)",
    "option2": "ঘূর্ণন (Rotation)",
    "option3": "স্থানান্তর (Translation)",
    "option4": "সংকোচন (Contraction)",
    "answer": "option1",
    "solution": "প্রতিটি ভাঁজ একটি দর্পণ (Mirror Line) হিসেবে কাজ করে, তাই ভাঁজ খোলার সাথে সাথে দর্পণ বা জল প্রতিচ্ছবির মতো রেখা তৈরি হয়।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion184" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR10",
    "question": "একটি বৃত্তাকার কাগজকে অর্ধেক ভাঁজ করা হলো, এরপর পুনরায় অর্ধেক ভাঁজ করে ১/৪ অংশ তৈরি করে একটি ছিদ্র করা হলো। কাগজটি সম্পূর্ণ খুললে মোট কতটি ছিদ্র দেখা যাবে?",
    "option1": "4টি",
    "option2": "2টি",
    "option3": "8টি",
    "option4": "6টি",
    "answer": "option1",
    "solution": "কাগজটি ৪টি স্তরে (4 layers) বিভক্ত হওয়ায় ১টি ছিদ্র খোলার পর ৪টি ছিদ্র হিসেবে দৃশ্যমান হবে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion185" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR10",
    "question": "একটি বর্গাকার কাগজকে চার ভাঁজ করে বন্ধ কোণায় (Center point) একটি অর্ধবৃত্ত কাটলে কাগজ খোলার পর কেন্দ্রে কী আকৃতি দেখা যাবে?",
    "option1": "একটি সম্পূর্ণ বৃত্ত",
    "option2": "দুটি অর্ধবৃত্ত",
    "option3": "একটি বর্গক্ষেত্র",
    "option4": "চারটি পৃথক বৃত্ত",
    "answer": "option1",
    "solution": "কেন্দ্রের প্রতিটি ভাঁজের ৪টি অংশ মিলে ১টি সম্পূর্ণ বৃত্তাকার ছিদ্র তৈরি করবে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion186" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR10",
    "question": "একটি কাগজকে দুবার ভাঁজ করে ৩টি ছিদ্র করা হলো। কাগজটি সম্পূর্ণ খুললে মোট কতটি ছিদ্র থাকবে?",
    "option1": "12টি",
    "option2": "6টি",
    "option3": "8টি",
    "option4": "9টি",
    "answer": "option1",
    "solution": "দুবার ভাঁজ করলে স্তরের সংখ্যা হয় ৪ (২ × ২)। সুতরাং ৩টি ছিদ্র খোলার পর ৩ × ৪ = ১২টি ছিদ্র হবে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion187" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR10",
    "question": "স্বচ্ছ (Transparent) কাগজের ওপর একটি চিত্র আঁকা আছে। কাগজটি নির্দেশিত বিন্দুযুক্ত রেখা (Dotted Line) বরাবর ভাঁজ করলে কী ঘটবে?",
    "option1": "উভয় পাশের চিত্র একে অপরের ওপর সমাপতিত (Overlap) হবে",
    "option2": "একপাশের চিত্র মুছে যাবে",
    "option3": "চিত্রটির আকার ছোট হয়ে যাবে",
    "option4": "চিত্রটির কোনো পরিবর্তন হবে না",
    "answer": "option1",
    "solution": "স্বচ্ছ কাগজ ভাঁজ করলে একপাশের চিত্র অন্যপাশের চিত্রের ওপর আয়নার প্রতিচ্ছবির মতো বসে যুক্ত চিত্র গঠন করে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion188" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR10",
    "question": "একটি আয়তাকার কাগজকে ৩ বার সমান দুই ভাগে ভাঁজ করা হলে শেষ ধাপে মোট কতগুলি স্তর (Layers) তৈরি হবে?",
    "option1": "8টি",
    "option2": "6টি",
    "option3": "4টি",
    "option4": "16টি",
    "answer": "option1",
    "solution": "প্রতিটি ভাঁজে স্তর দ্বিগুণ হয়: ১ম ভাঁজে ২, ২য় ভাঁজে ৪, ৩য় ভাঁজে ২^৩ = ৮টি স্তর।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion189" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR10",
    "question": "কাগজের খোলামুখের প্রান্তে (Open Edge) একটি 'V' আকৃতির কাট দেওয়া হলে এবং এটি দুবার ভাঁজ করা থাকলে খোলার পর কয়টি 'V' বা রম্বস আকৃতি তৈরি হবে?",
    "option1": "2টি V-আকৃতি",
    "option2": "1টি রম্বস",
    "option3": "4টি V-আকৃতি",
    "option4": "3টি V-আকৃতি",
    "answer": "option1",
    "solution": "খোলামুখের প্রান্তে কাট দিলে ভাঁজ খোলার পর আলাদা আলাদা ২ বা ৪টি কাটা দাগ দেখা যায়, যা কেন্দ্রে না থাকলে জোড়া লেগে রম্বস গঠন করে না।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion190" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR10",
    "question": "একটি ত্রিভুজাকার কাগজকে উপর থেকে নিচে ভাঁজ করা হলে এবং নিচে ১টি ছিদ্র করা হলে, খোলার পর নিচের ছিদ্রটির প্রতিচ্ছবি কোথায় দেখা যাবে?",
    "option1": "কাগজটির ওপরের অংশে",
    "option2": "কাগজটির ডানদিকে",
    "option3": "কাগজটির বামদিকে",
    "option4": "একই জায়গায় ২টি ছিদ্র",
    "answer": "option1",
    "solution": "উপর-নিচে ভাঁজ করার কারণে জল প্রতিচ্ছবি (Water Image) বা উলম্ব প্রতিফলনের নিয়মে ওপরের অংশে ছিদ্রটি ফুটে উঠবে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion191" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR10",
    "question": "একটি বর্গাকার কাগজকে কর্ণের (Diagonal) রেখা বরাবর ভাঁজ করা হলে কাগজটি কী আকৃতি ধারণ করে?",
    "option1": "ত্রিভুজ",
    "option2": "আয়তক্ষেত্র",
    "option3": "সামান্তরিক",
    "option4": "ট্র্যাপিজিয়াম",
    "answer": "option1",
    "solution": "বর্গক্ষেত্রের বিপরীত কোণ দুটিকে কর্ণে ভাঁজ করলে এটি একটি সমদ্বিবাহু সমকোণী ত্রিভুজে পরিণত হয়।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion192" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR10",
    "question": "একটি কাগজকে দুবার ভাঁজ করার পর 'L' আকৃতির কাট দেওয়া হলো। ভাঁজ খোলার পর এটি মূলত কোন ধরনের সমন্বিত আকৃতি তৈরি করবে?",
    "option1": "বর্গক্ষেত্র বা রম্বস ছাঁট",
    "option2": "বৃত্তাকার ছাঁট",
    "option3": "একটি দীর্ঘ সরলরেখা",
    "option4": "কোনো পরিবর্তন হবে না",
    "answer": "option1",
    "solution": "L-কাটের চারদিকের প্রতিফলন মিলে একটি চৌকো বা বর্গাকার খাঁজ তৈরি করে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion193" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR10",
    "question": "কাগজ ভাঁজ করার পর কাটাকাটির সমস্যা সমাধানের সবচেয়ে সহজ কৌশল কোনটি?",
    "option1": "শেষ ভাঁজ থেকে উল্টো ক্রমে (Reverse Order) দর্পণ/জল প্রতিচ্ছবি অঙ্কন করা",
    "option2": "প্রথম ভাঁজ থেকে দেখা",
    "option3": "কাগজের আকার গণনা করা",
    "option4": "ক্ষেত্রফল নির্ণয় করা",
    "answer": "option1",
    "solution": "কাগজ খোলার প্রক্রিয়া সবসময় শেষ ভাঁজের বিপরীত ধাপে আয়নার প্রতিচ্ছবির নিয়ম মেনে ধাপে ধাপে সমাধান করতে হয়।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion194" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR10",
    "question": "একটি বর্গাকার কাগজকে চার ভাঁজ করে বাইরের খোলা সীমানায় (Outer Edge) অর্ধবৃত্তাকারে কাটলে খোলার পর বাইরে কী দেখা যাবে?",
    "option1": "চারটি বাইরের বাহুতে ১টি করে অর্ধবৃত্তাকার খাঁজ",
    "option2": "মাঝখানে ১টি বড় বৃত্ত",
    "option3": "মাঝখানে ৪টি ছোট বৃত্ত",
    "option4": "কাগজটি ২টি টুকরো হয়ে যাবে",
    "answer": "option1",
    "solution": "বাইরের সীমানায় কাটলে প্রতিটি প্রান্ত বা বাহুতে একটি করে অর্ধবৃত্তাকার কাটা অংশ তৈরি হয়।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion195" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR10",
    "question": "একটি বর্গাকার কাগজকে অনুভূমিকভাবে (Horizontally) মাঝখান থেকে ভাঁজ করলে শীর্ষদেশ ও পাদদেশের সম্পর্ক কী রূপ নেয়?",
    "option1": "পাদদেশ ও শীর্ষদেশ সমাপতিত হয়ে উলম্ব প্রতিচ্ছবি (Water Image) দেখায়",
    "option2": "পার্শ্বীয় পরিবর্তন (Mirror Image) ঘটে",
    "option3": "কোনো প্রতিচ্ছবি তৈরি হয় না",
    "option4": "আকার ৪ গুণ বড় হয়",
    "answer": "option1",
    "solution": "অনুভূমিক ভাঁজে ওপরের অংশ নিচে নেমে আসে যা উলম্ব বা জল প্রতিচ্ছবির সামঞ্জস্য প্রদর্শন করে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion196" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR10",
    "question": "একটি কাগজকে ৩টি ভাঁজ দিয়ে সমপরিমাণ ৮টি ভাগে ভাগ করে প্রতিটি স্তরে ১টি তারকা চিহ্ন কাটলে মোট তারকা সংখ্যা কত হবে?",
    "option1": "8টি",
    "option2": "4টি",
    "option3": "3টি",
    "option4": "16টি",
    "answer": "option1",
    "solution": "কাগজটিতে মোট ৮টি স্তর সৃষ্টি হওয়ায় ১টি কাট ৮টি পূর্ণ তারকায় পরিণত হবে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion197" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR10",
    "question": "কোনো বর্গাকার কাগজের চার কোণ ভাঁজ করে কেন্দ্রে মেলানো হলে, কাগজটি খোলার পর ভাঁজের রেখাগুলি কী আকৃতি তৈরি করে?",
    "option1": "একটি অভ্যন্তরীণ বর্গক্ষেত্র ও দুটি কর্ণরেখা",
    "option2": "একটি বৃত্ত",
    "option3": "চারটি বৃত্ত",
    "option4": "কেবল একটি সরলরেখা",
    "answer": "option1",
    "solution": "চার কোণ কেন্দ্রে ভাঁজ করলে একটি ভেতরের বর্গাকার অংশ এবং কর্ণ বরাবর ভাঁজের দাগ বা ডায়াগোনাল লাইন ফুটে ওঠে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion198" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR10",
    "question": "যদি কোনো কাগজকে বাম দিক থেকে ডান দিকে ভাঁজ করা হয় (Vertical Fold), তবে খোলার সময় প্রতিচ্ছবিটির ধরণ কেমন হবে?",
    "option1": "পার্শ্বীয় প্রতিচ্ছবি (Mirror Image)",
    "option2": "জল প্রতিচ্ছবি (Water Image)",
    "option3": "কোনো পরিবর্তন হবে না",
    "option4": "উদ্বৃত্ত পরিবর্তন",
    "answer": "option1",
    "solution": "খাড়া বা উলম্ব ভাঁজ রেখা (Vertical fold) দর্পণের মতো কাজ করে, ফলে ডান-বাম পার্শ্বীয় পরিবর্তন ঘটে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion199" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR10",
    "question": "একটি গোলাকার কাগজের পরিধি বরাবর ৩টি ছোট কোণযুক্ত চেরা (Notch) দিলে এবং ১ বার ভাঁজ করা থাকলে মোট কতটি চেরা দৃশ্যমান হবে?",
    "option1": "6টি",
    "option2": "3টি",
    "option3": "9টি",
    "option4": "12টি",
    "answer": "option1",
    "solution": "একবার ভাঁজ করার ফলে স্তরের সংখ্যা ২। অতএব ৩টি কাট খোলার পর ৩ × ২ = ৬টি চেরা তৈরি করবে।"
  },
  {
    "_id": { "$oid": "reasoningmocktestquestion200" },
    "type": "mocktest",
    "subject": "reasoning",
    "topic": "CR10",
    "question": "একটি স্বচ্ছ বর্গাকার কাগজের ডান অর্ধে 'F' লেখা আছে। কাগজটি ডান দিক থেকে বাম দিকে ভাঁজ করলে 'F' অক্ষরটি কেমন দেখাবে?",
    "option1": "ꟻ (পার্শ্বীয়ভাবে উল্টে যাবে)",
    "option2": "F (একই থাকবে)",
    "option3": "Ⅎ (নিচে উল্টে যাবে)",
    "option4": "E-এর মতো দেখাবে",
    "answer": "option1",
    "solution": "ডান থেকে বামে উলম্ব ভাঁজের কারণে 'F' অক্ষরটির পার্শ্বীয় উল্টায়ন (Lateral Inversion) ঘটে 'ꟻ' রূপ নেবে।"
  },



  {
    "_id": { "$oid": "englishmocktestquestion01" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE01",
    "question": "What is the synonym of the word 'ABANDON'?",
    "option1": "Keep",
    "option2": "Adopt",
    "option3": "Forsake",
    "option4": "Cherish",
    "answer": "option3",
    "solution": "'Abandon' শব্দের অর্থ হলো পরিত্যাগ করা। 'Forsake' শব্দের অর্থও ত্যাগ করা বা ছেড়ে দেওয়া।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion02" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE01",
    "question": "Choose the correct antonym of 'BENEVOLENT'.",
    "option1": "Kind",
    "option2": "Generous",
    "option3": "Malevolent",
    "option4": "Helpful",
    "answer": "option3",
    "solution": "'Benevolent' শব্দের অর্থ দয়ালু বা হিতৈষী। এর বিপরীত শব্দ হলো 'Malevolent' (বিদ্বেষপরায়ণ বা পরশ্রীকাতর)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion03" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE01",
    "question": "Select the synonym for 'CANDID'.",
    "option1": "Secretive",
    "option2": "Deceitful",
    "option3": "Frank",
    "option4": "Shy",
    "answer": "option3",
    "solution": "'Candid' শব্দের অর্থ অকপট বা স্পষ্টভাষী। 'Frank' শব্দের অর্থও উন্মুক্ত বা স্পষ্টভাষী।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion04" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE01",
    "question": "Find the antonym of the word 'DILIGENT'.",
    "option1": "Hardworking",
    "option2": "Industrious",
    "option3": "Lazy",
    "option4": "Attentive",
    "answer": "option3",
    "solution": "'Diligent' শব্দের অর্থ পরিশ্রমী। এর সঠিক বিপরীত শব্দ হলো 'Lazy' (আলেসে বা অলস)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion05" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE01",
    "question": "What is the synonym of 'EAGER'?",
    "option1": "Indifferent",
    "option2": "Apathetic",
    "option3": "Keen",
    "option4": "Reluctant",
    "answer": "option3",
    "solution": "'Eager' শব্দের অর্থ আগ্রহান্বিত বা উৎসুক। 'Keen' শব্দের অর্থও তীব্র বা উৎসুক।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion06" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE01",
    "question": "Identify the antonym for 'FRAGILE'.",
    "option1": "Brittle",
    "option2": "Delicate",
    "option3": "Robust",
    "option4": "Weak",
    "answer": "option3",
    "solution": "'Fragile' শব্দের অর্থ ভঙ্গুর বা সহজে ভেঙে যায় এমন। এর বিপরীত শব্দ হলো 'Robust' (শক্তিশালী বা মজবুত)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion07" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE01",
    "question": "Choose the synonym of 'GENUINE'.",
    "option1": "Fake",
    "option2": "Counterfeit",
    "option3": "Authentic",
    "option4": "Artificial",
    "answer": "option3",
    "solution": "'Genuine' শব্দের অর্থ খাঁটি বা আসল। 'Authentic' শব্দের অর্থও নির্ভরযোগ্য বা প্রামাণিক/আসল।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion08" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE01",
    "question": "What is the antonym of 'HOSTILE'?",
    "option1": "Aggressive",
    "option2": "Unfriendly",
    "option3": "Friendly",
    "option4": "Antagonistic",
    "answer": "option3",
    "solution": "'Hostile' শব্দের অর্থ শত্রুতাপূর্ণ। এর সঠিক বিপরীত শব্দ হলো 'Friendly' (বন্ধুভাবাপন্ন)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion09" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE01",
    "question": "Select the synonym of 'IMMENSE'.",
    "option1": "Tiny",
    "option2": "Small",
    "option3": "Huge",
    "option4": "Limited",
    "answer": "option3",
    "solution": "'Immense' শব্দের অর্থ বিশাল বা সুদূরপ্রসারী। 'Huge' শব্দের অর্থও প্রকাণ্ড বা বিশাল।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion10" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE01",
    "question": "Choose the antonym for 'JUBILANT'.",
    "option1": "Joyful",
    "option2": "Ecstatic",
    "option3": "Depressed",
    "option4": "Triumphant",
    "answer": "option3",
    "solution": "'Jubilant' শব্দের অর্থ উল্লসিত বা আনন্দিত। এর বিপরীত শব্দ হলো 'Depressed' (বিষণ্ণ বা হতাশাগ্রস্ত)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion11" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE01",
    "question": "What is the synonym of 'LETHARGIC'?",
    "option1": "Energetic",
    "option2": "Active",
    "option3": "Sluggish",
    "option4": "Lively",
    "answer": "option3",
    "solution": "'Lethargic' শব্দের অর্থ অলস বা নিস্তেজ। 'Sluggish' শব্দের অর্থও মন্দা বা অলস।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion12" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE01",
    "question": "Find the antonym of 'MANDATORY'.",
    "option1": "Compulsory",
    "option2": "Obligatory",
    "option3": "Optional",
    "option4": "Required",
    "answer": "option3",
    "solution": "'Mandatory' শব্দের অর্থ বাধ্যতামূলক। এর বিপরীত শব্দ হলো 'Optional' (ঐচ্ছিক)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion13" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE01",
    "question": "Select the synonym of 'NOVICE'.",
    "option1": "Expert",
    "option2": "Professional",
    "option3": "Beginner",
    "option4": "Veteran",
    "answer": "option3",
    "solution": "'Novice' শব্দের অর্থ শিক্ষানবিস বা নতুন। 'Beginner' শব্দের অর্থও আরম্ভকারী বা নতুন শেখা ব্যক্তি।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion14" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE01",
    "question": "What is the antonym of 'OBSOLETE'?",
    "option1": "Outdated",
    "option2": "Old-fashioned",
    "option3": "Modern",
    "option4": "Ancient",
    "answer": "option3",
    "solution": "'Obsolete' শব্দের অর্থ সেকেলে বা অপ্রচলিত। এর বিপরীত শব্দ হলো 'Modern' (আধুনিক)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion15" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE01",
    "question": "Choose the synonym for 'PRECARIOUS'.",
    "option1": "Safe",
    "option2": "Secure",
    "option3": "Risky",
    "option4": "Stable",
    "answer": "option3",
    "solution": "'Precarious' শব্দের অর্থ অনিশ্চিত বা বিপজ্জনক। 'Risky' শব্দের অর্থও ঝুঁকিপূর্ণ।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion16" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE01",
    "question": "Identify the antonym of 'RELUCTANT'.",
    "option1": "Unwilling",
    "option2": "Hesitant",
    "option3": "Willing",
    "option4": "Resistant",
    "answer": "option3",
    "solution": "'Reluctant' শব্দের অর্থ অনিচ্ছুক। এর সঠিক বিপরীত শব্দ হলো 'Willing' (ইচ্ছুক)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion17" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE01",
    "question": "Select the synonym of 'TRANSIENT'.",
    "option1": "Permanent",
    "option2": "Eternal",
    "option3": "Temporary",
    "option4": "Lasting",
    "answer": "option3",
    "solution": "'Transient' শব্দের অর্থ ক্ষণস্থায়ী। 'Temporary' শব্দের অর্থও অস্থায়ী বা ক্ষণস্থায়ী।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion18" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE01",
    "question": "What is the antonym for 'VANISH'?",
    "option1": "Disappear",
    "option2": "Fade",
    "option3": "Appear",
    "option4": "Evaporate",
    "answer": "option3",
    "solution": "'Vanish' শব্দের অর্থ অদৃশ্য হওয়া। এর বিপরীত শব্দ হলো 'Appear' (দৃশ্যমান হওয়া বা আবির্ভূত হওয়া)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion19" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE01",
    "question": "Choose the synonym of 'WISDOM'.",
    "option1": "Folly",
    "option2": "Ignorance",
    "option3": "Knowledge",
    "option4": "Stupidity",
    "answer": "option3",
    "solution": "'Wisdom' শব্দের অর্থ প্রজ্ঞা বা জ্ঞান। 'Knowledge' শব্দের অর্থ জ্ঞান বা বিজ্ঞতা।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion20" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE01",
    "question": "Find the antonym of the word 'ZEAL'.",
    "option1": "Enthusiasm",
    "option2": "Passion",
    "option3": "Apathy",
    "option4": "Eagerness",
    "answer": "option3",
    "solution": "'Zeal' শব্দের অর্থ প্রবল উৎসাহ বা উদ্দীপনা। এর বিপরীত শব্দ হলো 'Apathy' (অনৌৎসুক্য বা উদাসীনতা)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion21" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE02",
    "question": "What is the meaning of the idiom 'A bed of roses'?",
    "option1": "A difficult situation",
    "option2": "A garden full of flowers",
    "option3": "An easy and comfortable situation",
    "option4": "A state of confusion",
    "answer": "option3",
    "solution": "'A bed of roses' বাগধারাটির অর্থ হলো আরামদায়ক বা সুবিধাজনক পরিস্থিতি (An easy and comfortable situation)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion22" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE02",
    "question": "Select the correct meaning of the idiom 'At the eleventh hour'.",
    "option1": "At 11 o'clock sharp",
    "option2": "Early in the morning",
    "option3": "At the very last moment",
    "option4": "At midnight",
    "answer": "option3",
    "solution": "'At the eleventh hour' বাগধারাটির অর্থ শেষ মুহূর্তে (At the very last moment)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion23" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE02",
    "question": "What does the phrase 'Apple of one's eye' mean?",
    "option1": "A red apple",
    "option2": "An eye disease",
    "option3": "Very dear or favorite person",
    "option4": "An enemy",
    "answer": "option3",
    "solution": "'Apple of one's eye' বাগধারাটির অর্থ অত্যন্ত প্রিয় বা নয়নের মণি (Very dear or favorite person)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion24" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE02",
    "question": "Choose the correct meaning of 'Beat around the bush'.",
    "option1": "To cut the bushes in a garden",
    "option2": "To search for a lost item",
    "option3": "To avoid talking about the main topic directly",
    "option4": "To speak very clearly and directly",
    "answer": "option3",
    "solution": "'Beat around the bush' মানে আসল কথা এড়িয়ে ঘুরিয়ে-ফিরিয়ে কথা বলা (Avoid main topic)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion25" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE02",
    "question": "What is the meaning of the phrase 'A blessing in disguise'?",
    "option1": "A hidden curse",
    "option2": "A sudden disaster",
    "option3": "A good outcome from something that initially seemed bad",
    "option4": "A holy prayer",
    "answer": "option3",
    "solution": "'A blessing in disguise' এর অর্থ ছদ্মবেশে আশীর্বাদ, অর্থাৎ শুরুতে খারাপ মনে হলেও পরে ভালো ফল দেওয়া।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion26" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE02",
    "question": "Select the correct meaning of 'Burn the midnight oil'.",
    "option1": "To waste fuel",
    "option2": "To light a lamp at night",
    "option3": "To work or study late into the night",
    "option4": "To sleep early",
    "answer": "option3",
    "solution": "'Burn the midnight oil' মানে গভীর রাত পর্যন্ত পড়াশোনা বা কাজ করা (Study/work late at night)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion27" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE02",
    "question": "What does 'Break a leg' mean in English idioms?",
    "option1": "To injure someone physically",
    "option2": "To fail in an exam",
    "option3": "Good luck (used to wish performers)",
    "option4": "To run very fast",
    "answer": "option3",
    "solution": "'Break a leg' একটি জনপ্রিয় বাগধারা যা সাধারণত পারফর্ম করার আগে 'শুভকামনা' (Good luck) জানাতে ব্যবহৃত হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion28" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE02",
    "question": "Choose the correct meaning of 'By hooks or by crook'.",
    "option1": "By using legal ways only",
    "option2": "By playing sports",
    "option3": "By any means, fair or foul",
    "option4": "By hard work only",
    "answer": "option3",
    "solution": "'By hooks or by crook' বাগধারাটির অর্থ যে কোনো উপায়ে, সৎ বা অসৎ যাই হোক না কেন (By any means)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion29" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE02",
    "question": "What is the meaning of 'Cry over spilt milk'?",
    "option1": "To clean the floor",
    "option2": "To buy fresh milk",
    "option3": "To regret about past mistakes that cannot be undone",
    "option4": "To cry loudly",
    "answer": "option3",
    "solution": "'Cry over spilt milk' এর অর্থ অতীত ভুল বা অপ্রাপ্তি নিয়ে বৃথা আফসোস করা।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion30" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE02",
    "question": "Select the meaning of the idiom 'Once in a blue moon'.",
    "option1": "Every full moon night",
    "option2": "Frequently",
    "option3": "Very rarely",
    "option4": "Never",
    "answer": "option3",
    "solution": "'Once in a blue moon' বাগধারাটির অর্থ কদাচিৎ বা অত্যন্ত কদাচিৎ (Very rarely)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion31" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE02",
    "question": "What does 'To add fuel to the fire' mean?",
    "option1": "To extinguish a fire",
    "option2": "To cook food quickly",
    "option3": "To make a bad situation worse",
    "option4": "To start a fire",
    "answer": "option3",
    "solution": "'To add fuel to the fire' শব্দের অর্থ আগুনে ঘি ঢালা, অর্থাৎ খারাপ পরিস্থিতিকে আরও খারাপ করা।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion32" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE02",
    "question": "Choose the correct meaning of 'Piece of cake'.",
    "option1": "A slice of sweet food",
    "option2": "A birthday celebration",
    "option3": "A very easy task",
    "option4": "A difficult challenge",
    "answer": "option3",
    "solution": "'Piece of cake' বাগধারাটির অর্থ অতি সহজ কাজ (A very easy task)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion33" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE02",
    "question": "What is the meaning of 'Spill the beans'?",
    "option1": "To drop food on the table",
    "option2": "To cook vegetables",
    "option3": "To reveal a secret accidentally or prematurely",
    "option4": "To keep a secret safe",
    "answer": "option3",
    "solution": "'Spill the beans' এর অর্থ গোপন তথ্য বা গোপন কথা ফাঁস করে দেওয়া (Reveal a secret)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion34" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE02",
    "question": "Select the meaning of 'To call it a day'.",
    "option1": "To name a day after someone",
    "option2": "To wake up early",
    "option3": "To stop working on something for the rest of the day",
    "option4": "To work whole night",
    "answer": "option3",
    "solution": "'To call it a day' বাগধারাটির অর্থ দিনের মতো কাজ বন্ধ রাখা বা ইস্তফা দেওয়া।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion35" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE02",
    "question": "What does 'Through thick and thin' mean?",
    "option1": "In fat and thin bodies",
    "option2": "Through dense forests",
    "option3": "Under all circumstances, good or bad",
    "option4": "Only in prosperous times",
    "answer": "option3",
    "solution": "'Through thick and thin' বাগধারাটির অর্থ যেকোনো পরিস্থিতিতে, সুখে-দুঃখে সবসময়ে (Under all circumstances)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion36" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE02",
    "question": "Choose the correct meaning of 'Cock and bull story'.",
    "option1": "A story about farm animals",
    "option2": "A true incident",
    "option3": "An absurd and unbelievable story",
    "option4": "A bedtime story for kids",
    "answer": "option3",
    "solution": "'Cock and bull story' মানে গাঁজাখুরি বা অবিশ্বাস্য গল্প (An absurd and unbelievable story)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion37" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE02",
    "question": "What is the meaning of the idiom 'Bury the hatchet'?",
    "option1": "To dig a hole",
    "option2": "To hide a weapon",
    "option3": "To make peace and forget old quarrels",
    "option4": "To start a new fight",
    "answer": "option3",
    "solution": "'Bury the hatchet' বাগধারাটির অর্থ শত্রুতা ভুলে যাওয়া বা শান্তি স্থাপন করা (Make peace)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion38" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE02",
    "question": "Select the correct meaning of 'Face the music'.",
    "option1": "To listen to pleasant songs",
    "option2": "To attend a concert",
    "option3": "To accept the unpleasant consequences of one's actions",
    "option4": "To play musical instruments",
    "answer": "option3",
    "solution": "'Face the music' বাগধারাটির অর্থ নিজের কৃতকর্মের অপ্রিয় পরিণতি বা শাস্তি মেনে নেওয়া।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion39" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE02",
    "question": "What does the phrase 'A red-letter day' stand for?",
    "option1": "A day when you receive a letter written in red ink",
    "option2": "A dangerous day",
    "option3": "A memorable or important day",
    "option4": "A day full of anger",
    "answer": "option3",
    "solution": "'A red-letter day' বাগধারাটির অর্থ স্মরণীয় বা গুরুত্বপূর্ণ দিন (A memorable/important day)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion40" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE02",
    "question": "Find the meaning of 'Crocodile tears'.",
    "option1": "Tears shed by reptiles",
    "option2": "Genuine sorrow",
    "option3": "False expression of grief",
    "option4": "Heavy rain",
    "answer": "option3",
    "solution": "'Crocodile tears' বাগধারাটির অর্থ কপট বা ভুয়ো দুঃখ প্রকাশ (False expression of grief)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion41" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE03",
    "question": "One who believes in the existence of God is called a:",
    "option1": "Atheist",
    "option2": "Agnotic",
    "option3": "Theist",
    "option4": "Bigot",
    "answer": "option3",
    "solution": "ঈশ্বর বা ঈশ্বরাস্তিত্বে বিশ্বাসী ব্যক্তিকে 'Theist' (আস্তিক) বলা হয়। যে বিশ্বাস করে না তাকে 'Atheist' (নাস্তিক) বলা হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion42" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE03",
    "question": "A life history of a person written by himself is known as:",
    "option1": "Biography",
    "option2": "Calligraphy",
    "option3": "Autobiography",
    "option4": "Bibliography",
    "answer": "option3",
    "solution": "নিজের লেখা নিজের জীবনকাহিনীকে 'Autobiography' (আত্মজীবনী) বলা হয়। অন্যের লেখা জীবনকাহিনী হলো 'Biography'।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion43" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE03",
    "question": "A handwriting or print that is impossible or difficult to read is:",
    "option1": "Eligible",
    "option2": "Illegible",
    "option3": "Inaudible",
    "option4": "Edible",
    "answer": "option2",
    "solution": "যে হাতের লেখা পড়া কষ্টকর বা অসম্ভব তাকে 'Illegible' (অস্পষ্ট/অপাঠ্য) বলা হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion44" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE03",
    "question": "A person who can neither read nor write is called:",
    "option1": "Literate",
    "option2": "Illiterate",
    "option3": "Scholar",
    "option4": "Ignorant",
    "answer": "option2",
    "solution": "যে ব্যক্তি পড়তে বা লিখতে পারে না তাকে 'Illiterate' (নিরক্ষর) বলা হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion45" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE03",
    "question": "That which is fit to be eaten is called:",
    "option1": "Audible",
    "option2": "Portable",
    "option3": "Edible",
    "option4": "Legible",
    "answer": "option3",
    "solution": "যা খাওয়ার উপযোগী বা ভোজ্য তাকে 'Edible' বলা হয়। পান করার উপযোগী হলে 'Potable' বলা হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion46" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE03",
    "question": "A person who looks at the bright side of things is a/an:",
    "option1": "Pessimist",
    "option2": "Pacifist",
    "option3": "Optimist",
    "option4": "Altruist",
    "answer": "option3",
    "solution": "সবকিছুর উজ্জ্বল বা আশাব্যঞ্জক দিক দেখা ব্যক্তিকে 'Optimist' (আশাবাদী) বলে। অন্ধকার দিক দেখলে 'Pessimist' (নিরাশাবাদী) বলে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion47" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE03",
    "question": "One who eats everything (both plants and meat) is known as:",
    "option1": "Herbivorous",
    "option2": "Carnivorous",
    "option3": "Omnivorous",
    "option4": "Cannibal",
    "answer": "option3",
    "solution": "যে উদ্ভিদ ও মাংস উভয় প্রকার খাদ্যই গ্রহণ করে তাকে 'Omnivorous' (সর্বভুক) বলা হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion48" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE03",
    "question": "A remedy for all diseases or difficulties is termed as:",
    "option1": "Antidote",
    "option2": "Panacea",
    "option3": "Antibiotic",
    "option4": "Placebo",
    "answer": "option2",
    "solution": "সব রোগের সর্বরোগহর ঔষধ বা দূরীকরণের উপায়কে 'Panacea' (মহৌষধ) বলা হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion49" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE03",
    "question": "A sound or voice that cannot be heard is called:",
    "option1": "Inaudible",
    "option2": "Audible",
    "option3": "Infallible",
    "option4": "Invisible",
    "answer": "option1",
    "solution": "যে শব্দ শোনা যায় না বা অশ্রুত তাকে 'Inaudible' বলা হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion50" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE03",
    "question": "A person who loves books and collects them is a/an:",
    "option1": "Bibliophile",
    "option2": "Philanthropist",
    "option3": "Misanthrope",
    "option4": "Optimist",
    "answer": "option1",
    "solution": "বইপ্রেমী বা যিনি বই সংগ্রহ করতে ভালোবাসেন তাকে 'Bibliophile' (গ্রন্থপ্রেমিক) বলা হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion51" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE03",
    "question": "A place where birds are kept is called a/an:",
    "option1": "Apiary",
    "option2": "Aquarium",
    "option3": "Aviary",
    "option4": "Sanctuary",
    "answer": "option3",
    "solution": "পাখি রাখার স্থানকে 'Aviary' (পক্ষীশালা) বলে। আর মৌমাছি রাখার স্থানকে 'Apiary' বলে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion52" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE03",
    "question": "One who works for the welfare and rights of women is a:",
    "option1": "Feminist",
    "option2": "Egoist",
    "option3": "Chauvinist",
    "option4": "Misogynist",
    "answer": "option1",
    "solution": "নারীদের অধিকার ও কল্যাণের পক্ষে কাজ করা ব্যক্তিকে 'Feminist' (নারীবাদী) বলা হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion53" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE03",
    "question": "A system of government by a single ruler with absolute power is:",
    "option1": "Democracy",
    "option2": "Autocracy",
    "option3": "Bureaucracy",
    "option4": "Oligarchy",
    "answer": "option2",
    "solution": "একজনের একক ও একচ্ছত্র শাসনব্যবস্থাকে 'Autocracy' (একনায়কতন্ত্র) বলা হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion54" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE03",
    "question": "One who never makes a mistake is termed as:",
    "option1": "Infallible",
    "option2": "Impeccable",
    "option3": "Ineligible",
    "option4": "Indelible",
    "answer": "option1",
    "solution": "যিনি কোনো ভুল করেন না বা অমোঘ তাকে 'Infallible' (ভুলত্রুটিহীন) বলা হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion55" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE03",
    "question": "An animal that lives both on land and in water is a/an:",
    "option1": "Reptile",
    "option2": "Aquatic",
    "option3": "Amphibian",
    "option4": "Mammal",
    "answer": "option3",
    "solution": "ডাঙ্গা ও জল উভয় স্থানেই বাস করতে পারা প্রাণীদের 'Amphibian' (উভচর) বলা হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion56" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE03",
    "question": "A period of one hundred years is known as a:",
    "option1": "Decade",
    "option2": "Fortnight",
    "option3": "Century",
    "option4": "Millennium",
    "answer": "option3",
    "solution": "১০০ বছরের সময়কালকে 'Century' (শতাব্দী) বলা হয়। ১০ বছরের সময়কাল হলো 'Decade' (দশক)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion57" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE03",
    "question": "One who goes on a foot journey to a holy place is a:",
    "option1": "Pilgrim",
    "option2": "Tourist",
    "option3": "Passenger",
    "option4": "Immigrant",
    "answer": "option1",
    "solution": "পবিত্র কোনো ধর্মস্থানে যাত্রা করা বা ভ্রমণকারী ব্যক্তিকে 'Pilgrim' (তীর্থযাত্রী) বলে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion58" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE03",
    "question": "Something that cannot be seen with the eyes is:",
    "option1": "Transparent",
    "option2": "Opaque",
    "option3": "Invisible",
    "option4": "Translucent",
    "answer": "option3",
    "solution": "যা খালি চোখে দেখা যায় না তাকে 'Invisible' (অদৃশ্য) বলা হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion59" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE03",
    "question": "A person who hates mankind is called a:",
    "option1": "Philanthropist",
    "option2": "Altruist",
    "option3": "Misanthrope",
    "option4": "Optimist",
    "answer": "option3",
    "solution": "যে মানবজাতিকে ঘৃণা করে তাকে 'Misanthrope' (মানববিদ্বেষী) বলা হয়। মানবধীতৈষীকে 'Philanthropist' বলা হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion60" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE03",
    "question": "A government run by officials and civil servants is:",
    "option1": "Monarchy",
    "option2": "Democracy",
    "option3": "Bureaucracy",
    "option4": "Anarchy",
    "answer": "option3",
    "solution": "সরকারি আমলা ও কর্মকর্তাদের দ্বারা পরিচালিত শাসনব্যবস্থাকে 'Bureaucracy' (আমলাতন্ত্র) বলা হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion61" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE04",
    "question": "Fill in the blank: The manager refused to ______ the demand of the workers.",
    "option1": "exceed",
    "option2": "accept",
    "option3": "accede",
    "option4": "access",
    "answer": "option3",
    "solution": "'Accede to' একটি সঠিক শব্দগুচ্ছ যার অর্থ কোনো দাবি মেনে নেওয়া বা সম্মত হওয়া। প্রসঙ্গের ভিত্তিতে 'accede' সবচেয়ে উপযুক্ত।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion62" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE04",
    "question": "Choose the contextually correct word: Heavy rainfall will ______ the crop yield this season.",
    "option1": "effect",
    "option2": "affect",
    "option3": "defect",
    "option4": "infect",
    "answer": "option2",
    "solution": "'Affect' হলো ক্রিয়া (Verb) যার অর্থ প্রভাব ফেলা। 'Effect' সাধারণত বিশেষ্য (Noun)। এখানে ক্রিয়া পদ প্রয়োজন হওয়ায় 'affect' সঠিক।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion63" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE04",
    "question": "Complete the sentence: Her ______ performance in the play earned her a standing ovation.",
    "option1": "childish",
    "option2": "childlike",
    "option3": "childproof",
    "option4": "childless",
    "answer": "option2",
    "solution": "'Childlike' এর অর্থ নিষ্পাপ বা প্রশংসনীয় সরলতা, যা প্রশংসায় ব্যবহৃত হয়। অন্যদিকে 'childish' (বাচ্চামো) নেতিবাচক অর্থে ব্যবহৃত হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion64" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE04",
    "question": "Which word fits best: The principal complimented her on her ______ dress.",
    "option1": "compliment",
    "option2": "complement",
    "option3": "complimentary",
    "option4": "complementary",
    "answer": "option3",
    "solution": "'Complimentary' মানে প্রসংশনীয় বা বিনামূল্যে প্রাপ্ত। অন্যদিকে 'Complementary' মানে পরিপূরক। পোশাকের প্রশংসার ক্ষেত্রে 'complimentary' মানানসই।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion65" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE04",
    "question": "Fill in the blank with the appropriate word: He is an ______ scientist known all over the world.",
    "option1": "imminent",
    "option2": "eminent",
    "option3": "emanate",
    "option4": "illusionary",
    "answer": "option2",
    "solution": "'Eminent' মানে বিখ্যাত বা প্রখ্যাত। 'Imminent' মানে আসন্ন বা যা শীঘ্রই ঘটতে যাচ্ছে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion66" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE04",
    "question": "Select the correct option: The doctor advised him to keep his wound ______.",
    "option1": "clean",
    "option2": "clear",
    "option3": "neat",
    "option4": "pure",
    "answer": "option1",
    "solution": "ক্ষত বা জখম পরিষ্কার রাখার প্রসঙ্গে নির্দিষ্টভাবে 'clean' ব্যবহার করা হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion67" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE04",
    "question": "Complete the sentence: Due to his illness, he was unable to ______ the examination.",
    "option1": "give",
    "option2": "take",
    "option3": "sit in",
    "option4": "appear at",
    "answer": "option4",
    "solution": "পরীক্ষায় বসা বা উপস্থিত হওয়ার ইংরেজি হলো 'appear at' বা 'take' an exam (ইংরেজিতে ছাত্ররা পরীক্ষা 'take' করে, আর শিক্ষক পরীক্ষা 'give' করেন)। এখানে 'appear at' সবচেয়ে নিখুঁত।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion68" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE04",
    "question": "Fill in the blank: The jury reached a ______ verdict after hours of deliberation.",
    "option1": "unanimous",
    "option2": "anonymous",
    "option3": "ambiguous",
    "option4": "analogous",
    "answer": "option1",
    "solution": "'Unanimous' অর্থ সর্বসম্মত। জুড়ি বিচারকরা একসাথে একমত হয়ে রায় দিলে তাকে 'unanimous verdict' বলা হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion69" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE04",
    "question": "Select the contextually right word: He made a ______ attempt to rescue the drowning child.",
    "option1": "heroic",
    "option2": "heroism",
    "option3": "hero",
    "option4": "heroically",
    "answer": "option1",
    "solution": "এখানে 'attempt' (Noun)-কে বর্ণনা করতে Adjective প্রয়োজন, যা হলো 'heroic' (বীরত্বপূর্ণ)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion70" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE04",
    "question": "Fill in the blank: The government tried to ______ the spread of false news.",
    "option1": "check",
    "option2": "inspect",
    "option3": "examine",
    "option4": "verify",
    "answer": "option1",
    "solution": "প্রসঙ্গ অনুযায়ী কোনো খারাপ কিছুকে নিয়ন্ত্রণে আনা বা বাধা দেওয়ার অর্থে 'check' শব্দটি ব্যবহৃত হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion71" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE04",
    "question": "Choose the right fit: She has a very ______ taste in art and literature.",
    "option1": "refined",
    "option2": "purified",
    "option3": "filtered",
    "option4": "cleared",
    "answer": "option1",
    "solution": "শিল্প ও সাহিত্যের রুচি বা পছন্দের ক্ষেত্রে মার্জিত বা উন্নত বোঝাতে 'refined' ব্যবহৃত হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion72" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE04",
    "question": "Complete the statement: The police managed to ______ the stolen jewelry from the thief.",
    "option1": "discover",
    "option2": "invent",
    "option3": "recover",
    "option4": "uncover",
    "answer": "option3",
    "solution": "হারিয়ে যাওয়া বা চুরি হওয়া জিনিস উদ্ধার করার অর্থে 'recover' ব্যবহৃত হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion73" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE04",
    "question": "Which word fills the blank best? Her parents gave their ______ to the marriage proposal.",
    "option1": "assent",
    "option2": "ascent",
    "option3": "accent",
    "option4": "descent",
    "answer": "option1",
    "solution": "'Assent' অর্থ সম্মতি বা অনুমোদন। 'Ascent' অর্থ ওপরে ওঠা এবং 'Accent' হলো উচ্চারণের ধরণ।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion74" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE04",
    "question": "Choose the contextual word: The flood caused ______ damage to the local infrastructure.",
    "option1": "extensive",
    "option2": "expensive",
    "option3": "expressive",
    "option4": "exclusive",
    "answer": "option1",
    "solution": "ব্যাপক ক্ষয়ক্ষতি বোঝাতে 'extensive damage' ব্যবহার করা সর্বাধিক গ্রহণযোগ্য।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion75" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE04",
    "question": "Select the correct option: It is not ______ to speak loudly in a quiet library.",
    "option1": "apposite",
    "option2": "appropriate",
    "option3": "opposite",
    "option4": "aptitude",
    "answer": "option2",
    "solution": "পরিস্থিতির সাথে সামঞ্জস্যপূর্ণ বা উপযুক্ত বোঝাতে 'appropriate' শব্দটি বসে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion76" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE04",
    "question": "Fill in the blank: The new regulation will come into ______ from next month.",
    "option1": "affect",
    "option2": "effect",
    "option3": "effort",
    "option4": "efficiency",
    "answer": "option2",
    "solution": "'Come into effect' একটি স্থির বাক্যাংশ (Idiomatic phrase) যার অর্থ কার্যকর হওয়া।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion77" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE04",
    "question": "Choose the best option: The soldier showed exemplary ______ on the battlefield.",
    "option1": "bravery",
    "option2": "brave",
    "option3": "bravely",
    "option4": "bravado",
    "answer": "option1",
    "solution": "এখানে বীরত্ব বা সাহস বোঝাতে Noun পদ প্রয়োজন, তাই 'bravery' বসবে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion78" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE04",
    "question": "Fill in the blank: I cannot ______ with such harsh terms and conditions.",
    "option1": "comply",
    "option2": "conform",
    "option3": "adhere",
    "option4": "abide",
    "answer": "option1",
    "solution": "'Comply' এর সাথে অনুসর্গ হিসেবে 'with' বসে। (Comply with = মেনে চলা)। 'Adhere' এর সাথে 'to' এবং 'Abide' এর সাথে 'by' বসে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion79" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE04",
    "question": "Select the correct word: The witness gave a ______ account of the accident.",
    "option1": "vivid",
    "option2": "vital",
    "option3": "vague",
    "option4": "verbal",
    "answer": "option1",
    "solution": "'Vivid' অর্থ স্পষ্ট ও জীবন্ত। দুর্ঘটনার স্পষ্ট বিবরণ বোঝাতে 'vivid account' সবচেয়ে উপযুক্ত।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion80" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE04",
    "question": "Complete the sentence: He was charged with theft because he tried to ______ public funds.",
    "option1": "embezzle",
    "option2": "invest",
    "option3": "allocate",
    "option4": "donate",
    "answer": "option1",
    "solution": "'Embezzle' অর্থ আত্মসাৎ করা। সরকারি বা পাবলিক ফান্ড চুরি/আত্মসাৎ করার সঠিক আইনি ও প্রাসঙ্গিক শব্দ হলো 'embezzle'।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion81" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE05",
    "question": "Find the correctly spelled word.",
    "option1": "Acommodate",
    "option2": "Acommodate",
    "option3": "Accommodate",
    "option4": "Accomodate",
    "answer": "option3",
    "solution": "সঠিক বানান হলো 'Accommodate' (বাসস্থান দেওয়া বা সংস্থান করা)। এতে দুটো 'c' এবং দুটো 'm' থাকে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion82" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE05",
    "question": "Choose the correctly spelled word.",
    "option1": "Embarass",
    "option2": "Embarrass",
    "option3": "Embaras",
    "option4": "Emberrass",
    "answer": "option2",
    "solution": "সঠিক বানান হলো 'Embarrass' (লজ্জিত করা)। এতে দুটো 'r' এবং দুটো 's' থাকে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion83" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE05",
    "question": "Identify the correctly spelled word.",
    "option1": "Maintenance",
    "option2": "Maintainance",
    "option3": "Maintenence",
    "option4": "Mentenance",
    "answer": "option1",
    "solution": "সঠিক বানান হলো 'Maintenance' (রক্ষণাবেক্ষণ)। মনে রাখবেন 'Maintain' হলেও শব্দটির সঠিক রূপ 'Maintenance'।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion84" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE05",
    "question": "Select the correctly spelled word.",
    "option1": "Occurance",
    "option2": "Occurrence",
    "option3": "Occurence",
    "option4": "Ocurrence",
    "answer": "option2",
    "solution": "সঠিক বানান হলো 'Occurrence' (ঘটনা)। এতে দুটো 'c', দুটো 'r' এবং শেষে '-ence' থাকে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion85" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE05",
    "question": "Find the word that is spelled correctly.",
    "option1": "Neseccary",
    "option2": "Neccesary",
    "option3": "Necessary",
    "option4": "Necassary",
    "answer": "option3",
    "solution": "সঠিক বানান হলো 'Necessary' (প্রয়োজনীয়)। এতে একটি 'c' এবং দুটো 's' থাকে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion86" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE05",
    "question": "Choose the correctly spelled word.",
    "option1": "Separate",
    "option2": "Seperate",
    "option3": "Saperate",
    "option4": "Seprate",
    "answer": "option1",
    "solution": "সঠিক বানান হলো 'Separate' (পৃথক করা)। 'par' অংশটি খেয়াল রাখুন (S-e-p-a-r-a-t-e)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion87" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE05",
    "question": "Select the correctly spelled word.",
    "option1": "Privilege",
    "option2": "Priviledge",
    "option3": "Privelege",
    "option4": "Privlege",
    "answer": "option1",
    "solution": "সঠিক বানান হলো 'Privilege' (বিশেষ অধিকার)। এতে কোনো 'd' নেই।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion88" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE05",
    "question": "Identify the word with the correct spelling.",
    "option1": "Recieve",
    "option2": "Receeve",
    "option3": "Receive",
    "option4": "Recive",
    "answer": "option3",
    "solution": "সঠিক বানান হলো 'Receive' (গ্রহণ করা)। ইংরেজি গ্রামারের নিয়ম 'i' before 'e' except after 'c' অনুযায়ী 'c'-এর পর 'ei' হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion89" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE05",
    "question": "Choose the correct spelling.",
    "option1": "Committee",
    "option2": "Comitee",
    "option3": "Commitee",
    "option4": "Comittee",
    "answer": "option1",
    "solution": "সঠিক বানান হলো 'Committee' (সমিতি বা কমিটি)। এতে দুটো 'm', দুটো 't', এবং দুটো 'e' থাকে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion90" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE05",
    "question": "Find the correctly spelled word.",
    "option1": "Guerilla",
    "option2": "Gorilla",
    "option3": "Guerilla / Gorilla",
    "option4": "Guerrilla",
    "answer": "option4",
    "solution": "গেরিলা যুদ্ধ অর্থে সঠিক ইংরেজি বানান হলো 'Guerrilla'। এতে দুটো 'r' এবং দুটো 'l' থাকে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion91" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE05",
    "question": "Select the correctly spelled word.",
    "option1": "Liaison",
    "option2": "Liason",
    "option3": "Liaisom",
    "option4": "Liaizon",
    "answer": "option1",
    "solution": "সঠিক বানান হলো 'Liaison' (যোগাযোগ বা মেলবন্ধন)। এতে দুটো 'i' রয়েছে (L-i-a-i-s-o-n)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion92" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE05",
    "question": "Identify the word that is correctly spelled.",
    "option1": "Bureaucracy",
    "option2": "Beuraucracy",
    "option3": "Bureaucracy",
    "option4": "Burocracy",
    "answer": "option1",
    "solution": "সঠিক বানান হলো 'Bureaucracy' (আমলাতন্ত্র)। স্পেলিং গঠনের সময় B-u-r-e-a-u অংশটি খেয়াল রাখুন।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion93" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE05",
    "question": "Choose the correct spelling.",
    "option1": "Manoeuvre",
    "option2": "Maneuver",
    "option3": "Maneuvre",
    "option4": "Manoeuver",
    "answer": "option1",
    "solution": "ব্রিটিশ ইংরেজিতে সঠিক বানান হলো 'Manoeuvre' (কৌশল বা মহড়া)। (আমেরিকান ইংরেজিতে এটি Maneuver)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion94" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE05",
    "question": "Find the correctly spelled word.",
    "option1": "Questionaire",
    "option2": "Questionnaire",
    "option3": "Questionair",
    "option4": "Questionnair",
    "answer": "option2",
    "solution": "সঠিক বানান হলো 'Questionnaire' (প্রশ্নাবলী)। এতে দুটো 'n' থাকে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion95" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE05",
    "question": "Select the correctly spelled word.",
    "option1": "Diarrhoea",
    "option2": "Diarrhea",
    "option3": "Diarhoea",
    "option4": "Diarrhea",
    "answer": "option1",
    "solution": "ব্রিটিশ স্ট্যান্ডার্ড ইংরেজিতে সঠিক বানান 'Diarrhoea' (ডায়রিয়া)। এতে দুটো 'r' এবং 'hoe' অংশ থাকে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion96" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE05",
    "question": "Choose the correctly spelled word.",
    "option1": "Hierarchy",
    "option2": "Heirarchy",
    "option3": "Hierarcy",
    "option4": "Hierachy",
    "answer": "option1",
    "solution": "সঠিক বানান হলো 'Hierarchy' (শ্রেণিবিভাগ বা উচ্চানুক্রম)। 'ie' ক্রমানুসারে থাকে (H-i-e-r-a-r-c-h-y)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion97" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE05",
    "question": "Identify the word with the correct spelling.",
    "option1": "Mischievous",
    "option2": "Mischievious",
    "option3": "Mischivous",
    "option4": "Mischevous",
    "answer": "option1",
    "solution": "সঠিক বানান হলো 'Mischievous' (দুষ্টু বা ক্ষতিকর)। এতে 'ie' পর '-vous' থাকে, অতিরিক্ত কোনো 'i' থাকে না।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion98" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE05",
    "question": "Choose the correct spelling.",
    "option1": "Conscientious",
    "option2": "Conscientous",
    "option3": "Conscientious",
    "option4": "Conscientious",
    "answer": "option1",
    "solution": "সঠিক বানান হলো 'Conscientious' (বিবেকবান বা দায়িত্বশীল)। Con-sci-en-tious।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion99" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE05",
    "question": "Find the correctly spelled word.",
    "option1": "Millennium",
    "option2": "Millenium",
    "option3": "Milenium",
    "option4": "Millennum",
    "answer": "option1",
    "solution": "সঠিক বানান হলো 'Millennium' (সহস্রাব্দ)। এতে দুটো 'l' এবং দুটো 'n' থাকে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion100" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE05",
    "question": "Select the correctly spelled word.",
    "option1": "Perseverance",
    "option2": "Perseverence",
    "option3": "Perserverance",
    "option4": "Perseverence",
    "answer": "option1",
    "solution": "সঠিক বানান হলো 'Perseverance' (অধ্যবসায়)। শেষ অংশটি '-ance' (P-e-r-s-e-v-e-r-a-n-c-e)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion101" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE06",
    "question": "Find the part with an error: 'Neither of the two candidates (1) / have submitted (2) / their resume (3) / No error (4)'",
    "option1": "Neither of the two candidates",
    "option2": "have submitted",
    "option3": "their resume",
    "option4": "No error",
    "answer": "option2",
    "solution": "'Neither of' থাকলে Verb সবসময় Singular হয়। তাই 'have submitted'-এর পরিবর্তে 'has submitted' হবে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion102" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE06",
    "question": "Identify the error: 'He is superior (1) / than me (2) / in intelligence (3) / No error (4)'",
    "option1": "He is superior",
    "option2": "than me",
    "option3": "in intelligence",
    "option4": "No error",
    "answer": "option2",
    "solution": "Superior, inferior, senior, junior ইত্যাদি শব্দগুলোর পর 'than' বসে না, Preposition 'to' ব্যবহৃত হয়। তাই 'than me'-এর জায়গায় 'to me' হবে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion103" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE06",
    "question": "Spot the error: 'One of my friend (1) / is going to (2) / London tomorrow (3) / No error (4)'",
    "option1": "One of my friend",
    "option2": "is going to",
    "option3": "London tomorrow",
    "option4": "No error",
    "answer": "option1",
    "solution": "'One of the/my' এরপর Noun সবসময় Plural হয়। তাই 'One of my friend'-এর বদলে 'One of my friends' লিখতে হবে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion104" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE06",
    "question": "Find the error: 'The sceneries of (1) / Kashmir (2) / are very charming (3) / No error (4)'",
    "option1": "The sceneries of",
    "option2": "Kashmir",
    "option3": "are very charming",
    "option4": "No error",
    "answer": "option1",
    "solution": "'Scenery' একটি Uncountable Noun, যার প্লুরাল ফর্ম হয় না। সঠিক বাক্যটি হবে 'The scenery of Kashmir is very charming'।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion105" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE06",
    "question": "Identify the error: 'Unless you do not work hard, (1) / you cannot (2) / pass the examination (3) / No error (4)'",
    "option1": "Unless you do not work hard,",
    "option2": "you cannot",
    "option3": "pass the examination",
    "option4": "No error",
    "answer": "option1",
    "solution": "'Unless' নিজেই একটি না-বাচক (Negative) শব্দ। তাই এর সাথে আলাদা করে 'do not' ব্যবহার করা ভুল। সঠিক হবে 'Unless you work hard'।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion106" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE06",
    "question": "Find the error: 'The cattle (1) / is grazing (2) / in the field (3) / No error (4)'",
    "option1": "The cattle",
    "option2": "is grazing",
    "option3": "in the field",
    "option4": "No error",
    "answer": "option2",
    "solution": "'Cattle' শব্দটি দেখতে Singular হলেও এটি আসলে Plural Noun। তাই এর পর 'is'-এর জায়গায় 'are' হবে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion107" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE06",
    "question": "Spot the error: 'She has been (1) / suffering from fever (2) / since three days (3) / No error (4)'",
    "option1": "She has been",
    "option2": "suffering from fever",
    "option3": "since three days",
    "option4": "No error",
    "answer": "option3",
    "solution": "নির্দিষ্ট সময়সীমা বা Period of time (যেমন: 3 days) বোঝাতে 'for' ব্যবহৃত হয়। তাই 'since three days'-এর জায়গায় 'for three days' হবে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion108" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE06",
    "question": "Identify the part with error: 'He discussed about (1) / the matter (2) / with his friends (3) / No error (4)'",
    "option1": "He discussed about",
    "option2": "the matter",
    "option3": "with his friends",
    "option4": "No error",
    "answer": "option1",
    "solution": "'Discuss' ভার্বের পর কোনো Preposition (যেমন 'about') বসে না। সরাসরি Object বসে। তাই 'about' বাদ যাবে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion109" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE06",
    "question": "Spot the error: 'I prefer tea (1) / than (2) / coffee (3) / No error (4)'",
    "option1": "I prefer tea",
    "option2": "than",
    "option3": "coffee",
    "option4": "No error",
    "answer": "option2",
    "solution": "'Prefer' ভার্বের পর তুলনা করার জন্য 'than' নয়, 'to' ব্যবহৃত হয়। সঠিক রূপ: 'prefer tea to coffee'।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion110" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE06",
    "question": "Find the error: 'The news (1) / are (2) / true (3) / No error (4)'",
    "option1": "The news",
    "option2": "are",
    "option3": "true",
    "option4": "No error",
    "answer": "option2",
    "solution": "'News' শব্দটি Plural দেখালেও এটি একটি Singular Noun। তাই এর পর Singular verb 'is' হবে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion111" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE06",
    "question": "Identify the error: 'No sooner did I reach the station (1) / when (2) / the train left (3) / No error (4)'",
    "option1": "No sooner did I reach the station",
    "option2": "when",
    "option3": "the train left",
    "option4": "No error",
    "answer": "option2",
    "solution": "'No sooner... did/had' গঠনরীতির ক্ষেত্রে Conjunction হিসেবে 'than' বসে, 'when' নয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion112" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE06",
    "question": "Find the error: 'Each of the girls (1) / have done (2) / her homework (3) / No error (4)'",
    "option1": "Each of the girls",
    "option2": "have done",
    "option3": "her homework",
    "option4": "No error",
    "answer": "option2",
    "solution": "'Each of' থাকলে সাবজেক্ট অনুযায়ী Verb সবসময় Singular হয়। তাই 'have done'-এর পরিবর্তে 'has done' হবে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion113" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE06",
    "question": "Spot the error: 'He walked (1) / ten miles (2) / by foot (3) / No error (4)'",
    "option1": "He walked",
    "option2": "ten miles",
    "option3": "by foot",
    "option4": "No error",
    "answer": "option3",
    "solution": "পায়ে হেঁটে যাওয়ার ক্ষেত্রে Idiomatic phrase হলো 'on foot', 'by foot' নয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion114" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE06",
    "question": "Identify the error: 'Although he worked hard, (1) / but he (2) / failed the exam (3) / No error (4)'",
    "option1": "Although he worked hard,",
    "option2": "but he",
    "option3": "failed the exam",
    "option4": "No error",
    "answer": "option2",
    "solution": "'Although' বা 'Even though'-এর সাথে বাক্য শুরু হলে দ্বিতীয় অংশে 'but' বসে না, শুধু Comma (,) অথবা 'yet' বসে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion115" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE06",
    "question": "Spot the error: 'Supposing if (1) / it rains, (2) / what will we do? (3) / No error (4)'",
    "option1": "Supposing if",
    "option2": "it rains,",
    "option3": "what will we do?",
    "option4": "No error",
    "answer": "option1",
    "solution": "'Supposing' এবং 'If' দুটোই একই অর্থ বহন করে। একসাথে এদের ব্যবহারকে Redundancy (অতিরিক্ত) বলা হয়। শুধু 'Supposing' বা 'If' হবে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion116" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE06",
    "question": "Find the error: 'The house with all its furniture (1) / were (2) / sold yesterday (3) / No error (4)'",
    "option1": "The house with all its furniture",
    "option2": "were",
    "option3": "sold yesterday",
    "option4": "No error",
    "answer": "option2",
    "solution": "যখন দুটি Subject 'with', 'along with', বা 'together with' দিয়ে যুক্ত হয়, তখন প্রথম Subject ('The house') অনুযায়ী Verb নির্ধারিত হয়। তাই 'were'-এর বদলে 'was' হবে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion117" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE06",
    "question": "Identify the error: 'She is more cleverer (1) / than her (2) / sister (3) / No error (4)'",
    "option1": "She is more cleverer",
    "option2": "than her",
    "option3": "sister",
    "option4": "No error",
    "answer": "option1",
    "solution": "একই সাথে দুটি Comparative degree ব্যবহার করা যাবে না (Double Comparative error)। 'more cleverer'-এর জায়গায় 'cleverer' হবে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion118" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE06",
    "question": "Spot the error: 'He has been living in Kolkata (1) / since (2) / five years (3) / No error (4)'",
    "option1": "He has been living in Kolkata",
    "option2": "since",
    "option3": "five years",
    "option4": "No error",
    "answer": "option2",
    "solution": "'Five years' একটি নির্দিষ্ট সময়সীমা (Duration), কোনো নির্দিষ্ট শুরুর পয়েন্ট নয়। তাই 'since'-এর পরিবর্তে 'for' বসবে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion119" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE06",
    "question": "Find the error: 'The teacher made the students (1) / to write (2) / an essay (3) / No error (4)'",
    "option1": "The teacher made the students",
    "option2": "to write",
    "option3": "an essay",
    "option4": "No error",
    "answer": "option2",
    "solution": "Causative verb 'Make'-এর পর Bare Infinitive (To ছাড়া Verb) বসে। তাই 'to write'-এর জায়গায় শুধু 'write' হবে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion120" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE06",
    "question": "Identify the error: 'He gave me (1) / many advices (2) / regarding the exam (3) / No error (4)'",
    "option1": "He gave me",
    "option2": "many advices",
    "option3": "regarding the exam",
    "option4": "No error",
    "answer": "option2",
    "solution": "'Advice' একটি Uncountable Noun, যার সাথে 's/es' যোগ করে Plural করা যায় না। বহুবচন বোঝাতে 'many pieces of advice' বলতে হবে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion121" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE07",
    "question": "Improve the bracketed part: He **(is working)** in this factory since 2018.",
    "option1": "has been working",
    "option2": "was working",
    "option3": "worked",
    "option4": "No improvement",
    "answer": "option1",
    "solution": "অতীতে শুরু হয়ে বর্তমানেও চলছে এবং সাথে 'since/for' যুক্ত থাকলে Present Perfect Continuous tense ব্যবহৃত হয়। তাই 'has been working' হবে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion122" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE07",
    "question": "Improve the bracketed part: The tea is **(too hot that)** I cannot drink it.",
    "option1": "so hot that",
    "option2": "very hot that",
    "option3": "much hot that",
    "option4": "No improvement",
    "answer": "option1",
    "solution": "পরবর্তীতে 'that... cannot' স্ট্রাকচার থাকলে তার পূর্বে 'so... that' গঠন অনুসরণ করা হয় (So + Adjective + that)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion123" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE07",
    "question": "Improve the bracketed part: If I **(was)** a bird, I would fly in the sky.",
    "option1": "am",
    "option2": "were",
    "option3": "had been",
    "option4": "No improvement",
    "answer": "option2",
    "solution": "কাল্পনিক বা অসম্ভব শর্তযুক্ত বাক্যে (Subjunctive Mood) Subject যাই হোক না কেন Verb সবসময় 'were' ব্যবহৃত হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion124" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE07",
    "question": "Improve the bracketed part: The passenger **(disembarked from)** the train as soon as it stopped.",
    "option1": "alighted from",
    "option2": "got down of",
    "option3": "stepped down from",
    "option4": "No improvement",
    "answer": "option1",
    "solution": "বাস, ট্রেন বা বিমান থেকে নামার ক্ষেত্রে সবচেয়ে সঠিক ও মানানসই শব্দ হলো 'alight from'।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion125" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE07",
    "question": "Improve the bracketed part: She did not **(hardly study)** for the exam.",
    "option1": "hardly studied",
    "option2": "study hardly",
    "option3": "hardly study",
    "option4": "study at all",
    "answer": "option3",
    "solution": "'Hardly' নিজেই একটি Negative Adverb। তাই এর আগে 'did not' বসে না। 'She hardly studied' অথবা 'She did not study at all' বলা যায়, যা অনুযায়ী বিকল্প ৩ বা 'hardly study' ব্যবহার প্রমার্জনযোগ্য।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion126" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE07",
    "question": "Improve the bracketed part: I am accustomed **(to get up)** early in the morning.",
    "option1": "to getting up",
    "option2": "with getting up",
    "option3": "for getting up",
    "option4": "No improvement",
    "answer": "option1",
    "solution": "'Accustomed to', 'look forward to', 'used to'-এর পর Verb থাকলে তার সাথে '-ing' যুক্ত হয় (Gerund)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion127" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE07",
    "question": "Improve the bracketed part: The teacher as well as the students **(were present)** in the hall.",
    "option1": "was present",
    "option2": "are present",
    "option3": "have present",
    "option4": "No improvement",
    "answer": "option1",
    "solution": "দুটি Noun/Pronoun যখন 'as well as' দিয়ে যুক্ত হয়, তখন প্রথম Subject ('The teacher') অনুযায়ী Verb Singular হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion128" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE07",
    "question": "Improve the bracketed part: He is **(enough tall)** to reach the upper shelf.",
    "option1": "tall enough",
    "option2": "taller enough",
    "option3": "too tall",
    "option4": "No improvement",
    "answer": "option1",
    "solution": "'Enough' শব্দটি কোনো Adjective-কে Modify করলে তা Adjective-এর পরে বসে (Adjective + Enough)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion129" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE07",
    "question": "Improve the bracketed part: The patient died before the doctor **(arrived)**.",
    "option1": "had arrived",
    "option2": "arrived",
    "option3": "has arrived",
    "option4": "No improvement",
    "answer": "option2",
    "solution": "Past Perfect-এর নিয়মে 'before'-এর আগের অংশটি Past Perfect হলে 'before'-এর পরের অংশটি Past Indefinite (V2) হয়। তাই 'arrived' সঠিক আছে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion130" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE07",
    "question": "Improve the bracketed part: He **(has left)** Kolkata yesterday.",
    "option1": "left",
    "option2": "had left",
    "option3": "is leaving",
    "option4": "No improvement",
    "answer": "option1",
    "solution": "বাক্যে অতীতের নির্দিষ্ট সময় (যেমন: yesterday, ago, last year) উল্লেখ থাকলে বাক্যটি Simple Past Tense হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion131" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE07",
    "question": "Improve the bracketed part: Neither the teacher nor the students **(was present)** in the class.",
    "option1": "were present",
    "option2": "is present",
    "option3": "are present",
    "option4": "No improvement",
    "answer": "option1",
    "solution": "'Neither... nor' দ্বারা দুটি Subject যুক্ত হলে Verb সবসময় নিকটতম Subject ('the students') অনুযায়ী নির্ধারিত হয়। তাই 'were present' হবে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion132" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE07",
    "question": "Improve the bracketed part: Walk carefully lest you **(should fall)** down.",
    "option1": "will fall",
    "option2": "fall",
    "option3": "should fall",
    "option4": "No improvement",
    "answer": "option3",
    "solution": "'Lest' যুক্ত বাক্যাংশে Subject-এর পর সবসময় Modal auxiliary হিসেবে 'should' ব্যবহৃত হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion133" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE07",
    "question": "Improve the bracketed part: I am looking forward to **(meet)** you soon.",
    "option1": "meeting",
    "option2": "met",
    "option3": "have met",
    "option4": "No improvement",
    "answer": "option1",
    "solution": "'Look forward to' বাগধারাটির পর সবসময় Verb-এর সাথে '-ing' (Gerund) যুক্ত হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion134" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE07",
    "question": "Improve the bracketed part: This is **(the most unique)** opportunity for you.",
    "option1": "a unique",
    "option2": "an unique",
    "option3": "most unique",
    "option4": "No improvement",
    "answer": "option1",
    "solution": "'Unique' হলো Absolute Adjective, যার কোনো Comparative বা Superlative রূপ হয় না। এছাড়া 'U'-এর উচ্চারণ 'ইউ' এর মতো হওয়ায় পূর্বে 'a' বসে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion135" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE07",
    "question": "Improve the bracketed part: The small child was **(run over)** by a speeding car.",
    "option1": "run down",
    "option2": "run into",
    "option3": "run across",
    "option4": "No improvement",
    "answer": "option4",
    "solution": "গাড়ি বা যানবাহনের নিচে চাপা পড়া বোঝাতে 'run over' Phrasal verb-টি একদম সঠিক।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion136" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE07",
    "question": "Improve the bracketed part: Every student must bring **(their)** own notebook.",
    "option1": "his or her",
    "option2": "our",
    "option3": "your",
    "option4": "No improvement",
    "answer": "option1",
    "solution": "ফরমাল ব্যাকরণে 'Every student' (Singular) অনুসরণ করার জন্য Singular possessive pronoun 'his or her' সবচেয়ে নিখুঁত।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion137" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE07",
    "question": "Improve the bracketed part: I would rather die **(than to beg)**.",
    "option1": "than beg",
    "option2": "then beg",
    "option3": "than begging",
    "option4": "No improvement",
    "answer": "option1",
    "solution": "'Would rather... than' গঠনের পর Bare Infinitive (To ছাড়া Verb) ব্যবহৃত হয়। তাই 'than beg' সঠিক।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion138" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE07",
    "question": "Improve the bracketed part: He **(denied)** to accept the invitation.",
    "option1": "refused",
    "option2": "declined",
    "option3": "rejected",
    "option4": "No improvement",
    "answer": "option1",
    "solution": "কোনো প্রস্তাব বা আমন্ত্রণ প্রত্যাখ্যান করা বোঝাতে 'refused' বা 'declined' বসে। অনুরোধ বা অফার সরাসরি প্রত্যাখ্যান করতে 'refused' বা 'refused to accept' সঠিক।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion139" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE07",
    "question": "Improve the bracketed part: No sooner had he entered the room **(when)** the phone rang.",
    "option1": "than",
    "option2": "then",
    "option3": "before",
    "option4": "No improvement",
    "answer": "option1",
    "solution": "'No sooner had...' পেয়ারিং কনজাংশনে দ্বিতীয় অংশে সর্বদাই 'than' ব্যবহৃত হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion140" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE07",
    "question": "Improve the bracketed part: My elder brother is senior **(than me by)** two years.",
    "option1": "to me by",
    "option2": "from me by",
    "option3": "than I by",
    "option4": "No improvement",
    "answer": "option1",
    "solution": "Senior, junior, superior ইত্যাদি ল্যাটিন অ্যাডজেক্টিভগুলির পর 'than'-এর বদলে 'to' বসে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion141" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE08",
    "question": "Identify the part of speech of the underlined word: 'Honesty is the best **policy**.'",
    "option1": "Noun",
    "option2": "Adjective",
    "option3": "Verb",
    "option4": "Adverb",
    "answer": "option1",
    "solution": "'Policy' একটি গুণ বা ধারণা বোঝায় এমন Abstract Noun। এটি বাক্যটির পরিপূরক (Complement) হিসেবে ব্যবহৃত হয়েছে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion142" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE08",
    "question": "Identify the part of speech of the underlined word: 'She ran **fast** to catch the bus.'",
    "option1": "Adjective",
    "option2": "Adverb",
    "option3": "Verb",
    "option4": "Noun",
    "answer": "option2",
    "solution": "এখানে 'fast' শব্দটি 'ran' (Verb)-কে Modify করছে, অর্থাৎ সে কীভাবে দৌড়েছিল তা বোঝাচ্ছে। তাই এটি Adverb।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion143" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE08",
    "question": "Identify the part of speech of the underlined word: 'This is a **fast** train.'",
    "option1": "Noun",
    "option2": "Adverb",
    "option3": "Adjective",
    "option4": "Verb",
    "answer": "option3",
    "solution": "এখানে 'fast' শব্দটি 'train' (Noun)-এর বৈশিষ্ট্য বা গুণ প্রকাশ করছে। তাই এটি Adjective।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion144" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE08",
    "question": "Identify the part of speech of the underlined word: 'Hurrah! **We** won the match.'",
    "option1": "Interjection",
    "option2": "Pronoun",
    "option3": "Noun",
    "option4": "Conjunction",
    "answer": "option2",
    "solution": "'We' শব্দটি একাধিক ব্যক্তির নাম/Noun-এর পরিবর্তে বসেছে। তাই এটি Personal Pronoun।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion145" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE08",
    "question": "Identify the part of speech of the underlined word: '**Alas!** He has lost his father.'",
    "option1": "Conjunction",
    "option2": "Preposition",
    "option3": "Interjection",
    "option4": "Adverb",
    "answer": "option3",
    "solution": "'Alas!' শব্দটি তীব্র দুঃখ বা আবেগ প্রকাশ করতে ব্যবহৃত হয়েছে, তাই এটি Interjection।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion146" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE08",
    "question": "Identify the part of speech of the underlined word: 'He tried hard **but** failed.'",
    "option1": "Preposition",
    "option2": "Conjunction",
    "option3": "Adverb",
    "option4": "Pronoun",
    "answer": "option2",
    "solution": "'But' শব্দটি দুটি স্বতন্ত্র Clause বা বক্তব্যকে সংযুক্ত করছে, তাই এটি Coordinating Conjunction।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion147" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE08",
    "question": "Identify the part of speech of the underlined word: 'The book is **on** the table.'",
    "option1": "Adverb",
    "option2": "Preposition",
    "option3": "Conjunction",
    "option4": "Adjective",
    "answer": "option2",
    "solution": "'On' শব্দটি 'book' এবং 'table' Noun দুটির মধ্যে অবস্থানগত সম্পর্ক স্থাপন করছে, তাই এটি Preposition।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion148" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE08",
    "question": "Identify the part of speech of the underlined word: 'I **water** the plants every morning.'",
    "option1": "Noun",
    "option2": "Verb",
    "option3": "Adjective",
    "option4": "Adverb",
    "answer": "option2",
    "solution": "এখানে 'water' শব্দটির দ্বারা পানি দেওয়ার কাজ বা Action বোঝাচ্ছে। তাই এটি Verb হিসেবে ব্যবহৃত হয়েছে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion149" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE08",
    "question": "Identify the part of speech of the underlined word: 'Give me some **water** to drink.'",
    "option1": "Noun",
    "option2": "Verb",
    "option3": "Adjective",
    "option4": "Adverb",
    "answer": "option1",
    "solution": "এখানে 'water' একটি বস্তুর নাম বা Material Noun হিসেবে ব্যবহৃত হয়েছে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion150" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE08",
    "question": "Identify the part of speech of the underlined word: 'She sang **sweetly**.'",
    "option1": "Adjective",
    "option2": "Noun",
    "option3": "Adverb",
    "option4": "Verb",
    "answer": "option3",
    "solution": "'Sweetly' শব্দটি 'sang' (Verb)-কে Modify করে গান গাওয়ার ধরন বোঝাচ্ছে। তাই এটি Adverb of Manner।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion151" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE08",
    "question": "Identify the part of speech of the underlined word: 'He gave me a **gold** ring.'",
    "option1": "Noun",
    "option2": "Adjective",
    "option3": "Preposition",
    "option4": "Pronoun",
    "answer": "option2",
    "solution": "'Gold' সাধারণত Noun হলেও এখানে এটি 'ring' (Noun)-এর উপাদান/গুণ প্রকাশ করায় Noun Adjunct বা Adjective হিসেবে কাজ করছে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion152" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE08",
    "question": "Identify the part of speech of the underlined word: 'They **themselves** admitted their mistake.'",
    "option1": "Relative Pronoun",
    "option2": "Emphatic Pronoun",
    "option3": "Demonstrative Pronoun",
    "option4": "Indefinite Pronoun",
    "answer": "option2",
    "solution": "যখন '-self/-selves' যুক্ত Pronoun কোনো Subject-এর ঠিক পর বসে জোর দেওয়ার জন্য ব্যবহৃত হয়, তখন তাকে Emphatic Pronoun বলে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion153" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE08",
    "question": "Identify the part of speech of the underlined word: 'There is **little** hope of his recovery.'",
    "option1": "Adjective",
    "option2": "Adverb",
    "option3": "Noun",
    "option4": "Pronoun",
    "answer": "option1",
    "solution": "'Little' শব্দটি 'hope' (Uncountable Noun)-এর পরিমাণ নির্দেশ করছে, তাই এটি Quantitative Adjective।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion154" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE08",
    "question": "Identify the part of speech of the underlined word: 'He came **after** I had left.'",
    "option1": "Preposition",
    "option2": "Conjunction",
    "option3": "Adverb",
    "option4": "Adjective",
    "answer": "option2",
    "solution": "এখানে 'after' শব্দ দুটি আলাদা Clause (He came + I had left) যোগ করেছে, তাই এটি Subordinating Conjunction।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion155" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE08",
    "question": "Identify the part of speech of the underlined word: 'He arrived soon **after**.'",
    "option1": "Preposition",
    "option2": "Conjunction",
    "option3": "Adverb",
    "option4": "Noun",
    "answer": "option3",
    "solution": "এখানে 'after'-এর পর কোনো Noun বা Clause নেই। এটি 'arrived' (Verb) কখন ঘটেছিল তা বোঝাচ্ছে, তাই এটি Adverb of Time।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion156" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE08",
    "question": "Identify the part of speech of the underlined word: 'Iron is a useful **metal**.'",
    "option1": "Proper Noun",
    "option2": "Common Noun",
    "option3": "Material Noun",
    "option4": "Abstract Noun",
    "answer": "option2",
    "solution": "'Metal' শব্দটি দিয়ে একশ্রেণীর সাধারণ ধাতুকে বোঝায়, তাই এটি Common Noun। (এখানে 'Iron' হলো Material Noun)।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion157" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE08",
    "question": "Identify the part of speech of the underlined word: 'The boy **who** stood first is my brother.'",
    "option1": "Demonstrative Pronoun",
    "option2": "Relative Pronoun",
    "option3": "Interrogative Pronoun",
    "option4": "Personal Pronoun",
    "answer": "option2",
    "solution": "'Who' শব্দটি পূর্বে উল্লিখিত Antecedent 'boy'-কে নির্দেশ করছে এবং দুটি অংশকে যুক্ত করেছে, তাই এটি Relative Pronoun।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion158" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE08",
    "question": "Identify the part of speech of the underlined word: 'He is **very** intelligent.'",
    "option1": "Adjective",
    "option2": "Adverb",
    "option3": "Verb",
    "option4": "Noun",
    "answer": "option2",
    "solution": "'Very' শব্দটি 'intelligent' (Adjective)-এর তীব্রতা বা মাত্রা বাড়িয়ে প্রকাশ করছে। তাই এটি Adverb of Degree।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion159" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE08",
    "question": "Identify the part of speech of the underlined word: 'Let us go out for a **walk**.'",
    "option1": "Verb",
    "option2": "Noun",
    "option3": "Adjective",
    "option4": "Adverb",
    "answer": "option2",
    "solution": "এখানে 'walk'-এর আগে Article 'a' বসেছে। Article + Noun নিয়ম অনুযায়ী 'walk' শব্দটি Noun হিসেবে ব্যবহৃত হয়েছে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion160" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE08",
    "question": "Identify the part of speech of the underlined word: 'It was a **remarkable** achievement.'",
    "option1": "Noun",
    "option2": "Adjective",
    "option3": "Adverb",
    "option4": "Verb",
    "answer": "option2",
    "solution": "'Remarkable' শব্দটি 'achievement' (Noun)-এর বৈশিষ্ট্য প্রকাশ করায় এটি Adjective।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion161" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE09",
    "question": "Change the voice: 'She sings a sweet song.'",
    "option1": "A sweet song is sung by her.",
    "option2": "A sweet song was sung by her.",
    "option3": "A sweet song has been sung by her.",
    "option4": "A sweet song is being sung by her.",
    "answer": "option1",
    "solution": "Present Indefinite Tense-এর Passive voice গঠন: Object + am/is/are + V3 + by + Subject। তাই সঠিক উত্তর: 'A sweet song is sung by her.'"
  },
  {
    "_id": { "$oid": "englishmocktestquestion162" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE09",
    "question": "Change the voice: 'He opened the door.'",
    "option1": "The door is opened by him.",
    "option2": "The door was opened by him.",
    "option3": "The door had been opened by him.",
    "option4": "The door was being opened by him.",
    "answer": "option2",
    "solution": "Past Indefinite Tense-এর Passive voice গঠন: Object + was/were + V3 + by + Subject। তাই সঠিক উত্তর: 'The door was opened by him.'"
  },
  {
    "_id": { "$oid": "englishmocktestquestion163" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE09",
    "question": "Change the voice: 'They are playing cricket.'",
    "option1": "Cricket was being played by them.",
    "option2": "Cricket is played by them.",
    "option3": "Cricket is being played by them.",
    "option4": "Cricket has been played by them.",
    "answer": "option3",
    "solution": "Present Continuous Tense-এর Passive voice গঠন: Object + am/is/are + being + V3 + by + Subject।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion164" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE09",
    "question": "Change the voice: 'Shut the door.'",
    "option1": "Let the door be shut.",
    "option2": "The door should be shutted.",
    "option3": "Let the door shutted.",
    "option4": "You are requested to shut door.",
    "answer": "option1",
    "solution": "Imperative Sentence-এর আদেশমূলক বাক্যের Passive voice গঠন: Let + Object + be + V3। ('Shut'-এর তিন রূপই 'shut')।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion165" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE09",
    "question": "Change the voice: 'Who wrote this book?'",
    "option1": "By whom was this book written?",
    "option2": "By whom is this book written?",
    "option3": "Who was this book written by?",
    "option4": "By who was this book written?",
    "answer": "option1",
    "solution": "Interrogative Sentence-এ 'Who' থাকলে Passive-এ 'By whom' দিয়ে শুরু হয় এবং Past Indefinite অনুযায়ী Auxiliary verb 'was' ব্যবহৃত হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion166" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE09",
    "question": "Change the voice: 'I have finished the work.'",
    "option1": "The work was finished by me.",
    "option2": "The work has been finished by me.",
    "option3": "The work had been finished by me.",
    "option4": "The work is finished by me.",
    "answer": "option2",
    "solution": "Present Perfect Tense-এর Passive voice গঠন: Object + has/have + been + V3 + by + Subject।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion167" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE09",
    "question": "Change the voice: 'Please help me.'",
    "option1": "I am requested to help you.",
    "option2": "You are requested to help me.",
    "option3": "Let me be helped.",
    "option4": "You are ordered to help me.",
    "answer": "option2",
    "solution": "Imperative Sentence-এ 'Please' থাকলে 'You are requested to' দিয়ে Passive রূপান্তর করা হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion168" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE09",
    "question": "Change the voice: 'The doctor was examining the patient.'",
    "option1": "The patient is being examined by the doctor.",
    "option2": "The patient was examined by the doctor.",
    "option3": "The patient was being examined by the doctor.",
    "option4": "The patient had been examined by the doctor.",
    "answer": "option3",
    "solution": "Past Continuous Tense-এর Passive voice গঠন: Object + was/were + being + V3 + by + Subject।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion169" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE09",
    "question": "Change the voice: 'They will complete the project tomorrow.'",
    "option1": "The project will be completed by them tomorrow.",
    "option2": "The project would be completed by them tomorrow.",
    "option3": "The project is completed by them tomorrow.",
    "option4": "The project will have been completed by them tomorrow.",
    "answer": "option1",
    "solution": "Simple Future Tense-এর Passive voice গঠন: Object + shall/will + be + V3 + by + Subject।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion170" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE09",
    "question": "Change the voice: 'I know him.'",
    "option1": "He is known by me.",
    "option2": "He is known to me.",
    "option3": "He was known to me.",
    "option4": "He is known with me.",
    "answer": "option2",
    "solution": "'Know' ভার্বের পর Passive Voice-এ 'by'-এর স্থানে Preposition 'to' বসে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion171" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE09",
    "question": "Change the voice: 'One should keep one's promises.'",
    "option1": "Promises should be kept by one.",
    "option2": "Promises should be kept.",
    "option3": "One's promises should be kept.",
    "option4": "Promises should keep.",
    "answer": "option2",
    "solution": "অনির্দিষ্ট Subject যেমন 'One' বা 'People' থাকলে Passive-এ তা বাদ দেওয়া শ্রেয়। নিয়ম: Subject + Modal + be + V3 ('Promises should be kept')।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion172" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE09",
    "question": "Change the voice: 'Smoke filled the room.'",
    "option1": "The room was filled by smoke.",
    "option2": "The room was filled with smoke.",
    "option3": "The room was filled in smoke.",
    "option4": "The room is filled with smoke.",
    "answer": "option2",
    "solution": "'Fill' ভার্বের পর Passive Voice-এ 'by'-এর বদলে Preposition 'with' ব্যবহৃত হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion173" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE09",
    "question": "Change the voice: 'Do you play football?'",
    "option1": "Is football played by you?",
    "option2": "Was football played by you?",
    "option3": "Is football being played by you?",
    "option4": "Does football played by you?",
    "answer": "option1",
    "solution": "Present Indefinite Interrogative-এর Passive রূপ: Am/Is/Are + Object + V3 + by + Subject?"
  },
  {
    "_id": { "$oid": "englishmocktestquestion174" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE09",
    "question": "Change the voice: 'His behavior shocked me.'",
    "option1": "I was shocked by his behavior.",
    "option2": "I was shocked at his behavior.",
    "option3": "I am shocked at his behavior.",
    "option4": "I was shocked with his behavior.",
    "answer": "option2",
    "solution": "আচরণ বা ঘটনার ক্ষেত্রে 'Shock' ভার্বের পর Passive Voice-এ 'at' প্রিপজিশন বসে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion175" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE09",
    "question": "Change the voice: 'The news surprised us.'",
    "option1": "We were surprised at the news.",
    "option2": "We were surprised by the news.",
    "option3": "We are surprised at the news.",
    "option4": "We were surprised with the news.",
    "answer": "option1",
    "solution": "'Surprise' ভার্বের পর খবরের বা বস্তুর ক্ষেত্রে Passive-এ 'at' ব্যবহৃত হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion176" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE09",
    "question": "Change the voice: 'Never tell a lie.'",
    "option1": "Let a lie never be told.",
    "option2": "A lie should never be told.",
    "option3": "You are requested not to tell a lie.",
    "option4": "Let not a lie told.",
    "answer": "option1",
    "solution": "Imperative Negative Sentence-এর ক্ষেত্রে 'Let + Object + never + be + V3' অনুসরণ করা হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion177" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE09",
    "question": "Change the voice: 'He had already painted the wall.'",
    "option1": "The wall has already been painted by him.",
    "option2": "The wall had already been painted by him.",
    "option3": "The wall was already painted by him.",
    "option4": "The wall had been already painted by him.",
    "answer": "option2",
    "solution": "Past Perfect Tense-এর Passive voice গঠন: Object + had + already + been + V3 + by + Subject।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion178" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE09",
    "question": "Change the voice: 'They made him captain.'",
    "option1": "He was made captain by them.",
    "option2": "Captain was made him by them.",
    "option3": "He is made captain by them.",
    "option4": "He was made to be captain by them.",
    "answer": "option1",
    "solution": "Factitive Object (Captain)-এর বদলে মূল Object (him -> He)-কে Passive Voice-এর Subject করতে হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion179" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE09",
    "question": "Change the voice: 'Honey tastes sweet.'",
    "option1": "Honey is sweet when it is tasted.",
    "option2": "Honey is tasted sweet.",
    "option3": "Honey was sweet when tasted.",
    "option4": "Sweet is tasted by honey.",
    "answer": "option1",
    "solution": "Quasi-passive verb-এর Passive রূপের সাধারণ গঠন: Subject + Be Verb + Adjective + when + it/they + Be Verb + V3।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion180" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE09",
    "question": "Change the voice: 'You must write the answer in ink.'",
    "option1": "The answer must be written in ink by you.",
    "option2": "The answer must written in ink by you.",
    "option3": "The answer should be written in ink by you.",
    "option4": "The answer must be write in ink by you.",
    "answer": "option1",
    "solution": "Modal Auxiliary (must)-এর Passive voice গঠন: Object + Modal + be + V3 + by + Subject।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion181" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE10",
    "question": "Change the speech: He said, 'I am writing a letter.'",
    "option1": "He said that he is writing a letter.",
    "option2": "He said that he was writing a letter.",
    "option3": "He said that I was writing a letter.",
    "option4": "He told that he wrote a letter.",
    "answer": "option2",
    "solution": "Reporting verb অতীতে (said) থাকায় Present Continuous tense পরিবর্তিত হয়ে Past Continuous tense (was writing) হবে এবং 'I' পরিবর্তিত হয়ে 'he' হবে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion182" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE10",
    "question": "Change the speech: She said to me, 'Where do you live?'",
    "option1": "She asked me where I lived.",
    "option2": "She asked me where I live.",
    "option3": "She asked me where did I live.",
    "option4": "She told me where I lived.",
    "answer": "option1",
    "solution": "Interrogative sentence-এ 'said to' বদলে 'asked' হয়, Wh-word অপরিবর্তিত থাকে এবং প্রশ্নবোধক বাক্যটি Assertive (Subject + Verb) হয়ে যায়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion183" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE10",
    "question": "Change the speech: The teacher said, 'The Earth revolves around the Sun.'",
    "option1": "The teacher said that the Earth revolved around the Sun.",
    "option2": "The teacher said that the Earth revolves around the Sun.",
    "option3": "The teacher told that the Earth is revolving around the Sun.",
    "option4": "The teacher said that the Earth has revolved around the Sun.",
    "answer": "option2",
    "solution": "চিরন্তন সত্য (Universal Truth) প্রকাশ করলে Direct speech-এর tense-এর কোনো পরিবর্তন হয় না।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion184" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE10",
    "question": "Change the speech: He said, 'Hurrah! We have won the match.'",
    "option1": "He exclaimed with joy that they had won the match.",
    "option2": "He exclaimed with sorrow that they had won the match.",
    "option3": "He said with joy that we have won the match.",
    "option4": "He exclaimed with joy that they have won the match.",
    "answer": "option1",
    "solution": "Exclamatory sentence-এ 'Hurrah!' থাকলে 'exclaimed with joy' বসে এবং Present Perfect (have won) পরিবর্তিত হয়ে Past Perfect (had won) হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion185" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE10",
    "question": "Change the speech: Father said to me, 'Do not waste your time.'",
    "option1": "Father advised me not to waste my time.",
    "option2": "Father ordered me to not waste my time.",
    "option3": "Father told me do not waste my time.",
    "option4": "Father advised me to not waste your time.",
    "answer": "option1",
    "solution": "Imperative sentence-এ উপদেশ বোঝালে 'advised' বসে এবং না-বাচক বাক্যে 'not to' + Verb-এর Base form যুক্ত হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion186" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE10",
    "question": "Change the speech: She said, 'I bought a car yesterday.'",
    "option1": "She said that she bought a car the previous day.",
    "option2": "She said that she had bought a car the previous day.",
    "option3": "She said that she had bought a car yesterday.",
    "option4": "She told that she has bought a car the previous day.",
    "answer": "option2",
    "solution": "Simple Past tense পরিবর্তিত হয়ে Past Perfect tense (had bought) হয় এবং 'yesterday' পরিবর্তিত হয়ে 'the previous day' হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion187" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE10",
    "question": "Change the speech: Ram said to Shyam, 'Are you going to school today?'",
    "option1": "Ram asked Shyam if he was going to school that day.",
    "option2": "Ram asked Shyam if was he going to school that day.",
    "option3": "Ram asked Shyam that if he was going to school today.",
    "option4": "Ram told Shyam whether he is going to school that day.",
    "answer": "option1",
    "solution": "Yes/No প্রশ্নবোধক বাক্যে Conjunction হিসেবে 'if' বা 'whether' বসে এবং 'today' বদলে 'that day' হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion188" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE10",
    "question": "Change the speech: The captain said to the soldiers, 'Attack the enemy.'",
    "option1": "The captain requested the soldiers to attack the enemy.",
    "option2": "The captain commanded the soldiers to attack the enemy.",
    "option3": "The captain advised the soldiers to attack the enemy.",
    "option4": "The captain told the soldiers for attacking the enemy.",
    "answer": "option2",
    "solution": "সেনাপতির আদেশ বোঝাতে 'commanded' বা 'ordered' ব্যবহৃত হয় এবং Verb-এর আগে 'to' বসে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion189" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE10",
    "question": "Change the speech: He says, 'I am very busy now.'",
    "option1": "He says that he was very busy then.",
    "option2": "He says that he is very busy now.",
    "option3": "He said that he was very busy then.",
    "option4": "He says that I am very busy now.",
    "answer": "option2",
    "solution": "Reporting verb Present tense-এ (says) থাকলে Indirect speech-এ Reported speech-এর Tense ও সময়সূচক শব্দ (now) পরিবর্তিত হয় না।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion190" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE10",
    "question": "Change the speech: She said, 'May God bless you!'",
    "option1": "She prayed that God might bless me.",
    "option2": "She wished that God may bless me.",
    "option3": "She prayed that God would bless me.",
    "option4": "She asked God to bless me.",
    "answer": "option1",
    "solution": "Optative sentence-এ প্রার্থনা বোঝালে 'prayed' বসে এবং 'May' পরিবর্তিত হয়ে 'might' হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion191" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE10",
    "question": "Change the speech: He said, 'Alas! I am ruined.'",
    "option1": "He exclaimed with sorrow that he was ruined.",
    "option2": "He exclaimed with joy that he was ruined.",
    "option3": "He said with sorrow that I am ruined.",
    "option4": "He cried out that he is ruined.",
    "answer": "option1",
    "solution": "'Alas!' দ্বারা দুঃখ প্রকাশ পায়, তাই 'exclaimed with sorrow' ব্যবহার করে Simple Present-কে Simple Past (was ruined)-এ রূপান্তর করতে হবে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion192" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE10",
    "question": "Change the speech: 'What a beautiful sight it is!' he said.",
    "option1": "He exclaimed that it is a very beautiful sight.",
    "option2": "He exclaimed that it was a very beautiful sight.",
    "option3": "He said that what a beautiful sight it was.",
    "option4": "He exclaimed with joy that it was beautiful sight.",
    "answer": "option2",
    "solution": "Exclamatory sentence থেকে Assertive রূপান্তরের সময় 'What a' বদলে 'a very' আসে এবং Present tense টি Past tense-এ পরিবর্তিত হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion193" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE10",
    "question": "Change the speech: He said to me, 'I will help you tomorrow.'",
    "option1": "He told me that he would help me the next day.",
    "option2": "He told me that I would help him the next day.",
    "option3": "He said to me that he will help me tomorrow.",
    "option4": "He told me that he should help me the following day.",
    "answer": "option1",
    "solution": "'will' পরিবর্তিত হয়ে 'would' হয়, 'said to me' বদলে 'told me' হয় এবং 'tomorrow' পরিবর্তিত হয়ে 'the next day' হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion194" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE10",
    "question": "Change the speech: She said, 'I can solve this puzzle.'",
    "option1": "She said that she could solve that puzzle.",
    "option2": "She said that she can solve this puzzle.",
    "option3": "She told that she could solve this puzzle.",
    "option4": "She said that I could solve that puzzle.",
    "answer": "option1",
    "solution": "Modal verb 'can' পরিবর্তিত হয়ে 'could' হয় এবং 'this' পরিবর্তিত হয়ে 'that' হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion195" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE10",
    "question": "Change the speech: He said to her, 'Please give me your pen.'",
    "option1": "He requested her to give him her pen.",
    "option2": "He asked her to give me her pen.",
    "option3": "He ordered her to give him his pen.",
    "option4": "He requested her that give him her pen.",
    "answer": "option1",
    "solution": "অনুরোধমূলক (Please) Imperative sentence-এ 'requested' বসে এবং Linking word হিসেবে 'to' যুক্ত হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion196" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE10",
    "question": "Change the speech: My friend said, 'Let us go for a walk.'",
    "option1": "My friend proposed that we should go for a walk.",
    "option2": "My friend ordered that we should go for a walk.",
    "option3": "My friend said that let us go for a walk.",
    "option4": "My friend proposed to go for a walk.",
    "answer": "option1",
    "solution": "'Let us' দিয়ে প্রস্তাব বোঝালে Reporting verb বদলে 'proposed' বা 'suggested' হয় এবং Conjunction 'that'-এর পর 'we should / they should' বসে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion197" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE10",
    "question": "Change the speech: The doctor said to the patient, 'Take this medicine twice a day.'",
    "option1": "The doctor advised the patient to take that medicine twice a day.",
    "option2": "The doctor ordered the patient to take this medicine twice a day.",
    "option3": "The doctor told the patient take that medicine twice a day.",
    "option4": "The doctor advised the patient taking that medicine twice a day.",
    "answer": "option1",
    "solution": "চিকিৎসকের পরামর্শের ক্ষেত্রে 'advised' বসে এবং 'this' পরিবর্তিত হয়ে 'that' হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion198" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE10",
    "question": "Change the speech: He asked, 'Must I leave so soon?'",
    "option1": "He asked if he had to leave so soon.",
    "option2": "He asked that must he leave so soon.",
    "option3": "He asked if he must leave so soon.",
    "option4": "He asked whether he has to leave so soon.",
    "answer": "option1",
    "solution": "বাধ্যবাধকতা অর্থে 'must' পরিবর্তিত হয়ে Tense অনুযায়ী 'had to' ব্যবহৃত হয়।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion199" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE10",
    "question": "Change the speech: She said, 'I had already left when he arrived.'",
    "option1": "She said that she had already left when he arrived.",
    "option2": "She said that she left when he had arrived.",
    "option3": "She said that she has already left when he arrived.",
    "option4": "She told that she had already left when he had arrived.",
    "answer": "option1",
    "solution": "Past Perfect tense (had left) Indirect speech-এ অপরিবর্তিত থাকে।"
  },
  {
    "_id": { "$oid": "englishmocktestquestion200" },
    "type": "mocktest",
    "subject": "english",
    "topic": "CE10",
    "question": "Change the speech: The teacher said, 'Honesty is the best policy.'",
    "option1": "The teacher said that honesty is the best policy.",
    "option2": "The teacher said that honesty was the best policy.",
    "option3": "The teacher told honesty is the best policy.",
    "option4": "The teacher said that honesty had been the best policy.",
    "answer": "option1",
    "solution": "'Honesty is the best policy' একটি চিরন্তন প্রবাদ (Proverb/Moral truth), তাই Tense-এর কোনো পরিবর্তন হবে না।"
  },




  {
    "_id": { "$oid": "gkmocktestquestion01" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG01",
    "question": "পশ্চিমবঙ্গের দীর্ঘতম নদী কোনটি?",
    "option1": "তিস্তা",
    "option2": "দামোদর",
    "option3": "ভাগীরথী- হুগলী",
    "option4": "রূপনারায়ণ",
    "answer": "option3",
    "solution": "ভাগীরথী-হুগলী নদী হলো পশ্চিমবঙ্গের দীর্ঘতম নদী (দৈর্ঘ্য প্রায় ৫২৪ কিমি)।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion02" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG01",
    "question": "ভারতের কোন রাজ্যে সুন্দরবন জাতীয় উদ্যান অবস্থিত?",
    "option1": "উড়িষ্যা",
    "option2": "আসাম",
    "option3": "পশ্চিমবঙ্গ",
    "option4": "মেঘালয়",
    "answer": "option3",
    "solution": "সুন্দরবন জাতীয় উদ্যান পশ্চিমবঙ্গের দক্ষিণ ২৪ পরগনা জেলায় অবস্থিত। এটি রয়্যাল বেঙ্গল টাইগার এবং ম্যানগ্রোভ অরণ্যের জন্য বিখ্যাত।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion03" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG01",
    "question": "'বাংলার দুঃখ' নামে কোন নদী পরিচিত?",
    "option1": "তিস্তা",
    "option2": "মহামায়া",
    "option3": "দামোদর",
    "option4": "মহানন্দা",
    "answer": "option3",
    "solution": "অতীতের ভয়াবহ বন্যার কারণে দামোদর নদীকে 'বাংলার দুঃখ' বলা হতো।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion04" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG01",
    "question": "ক্যালশিয়াম ও চুন সমৃদ্ধ মাটি ভারতে কী নামে পরিচিত?",
    "option1": "লেটেরাইট মাটি",
    "option2": "পলি মাটি",
    "option3": "পেডোকাল মাটি",
    "option4": "কৃষ্ণ মাটি",
    "answer": "option3",
    "solution": "শুষ্ক ও শুষ্কপ্রায় অঞ্চলের ক্যালশিয়াম কার্বোনেট সমৃদ্ধ মাটিকে পেডোকাল (Pedocal) মাটি বলা হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion05" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG01",
    "question": "ভারতের বৃহত্তম জাতীয় উদ্যান (National Park) কোনটি?",
    "option1": "জিম করবেট",
    "option2": "কাজিরাঙা",
    "option3": "হেমিছ জাতীয় উদ্যান",
    "option4": "গির জাতীয় উদ্যান",
    "answer": "option3",
    "solution": "লাদাখে অবস্থিত হেমিছ (Hemis) জাতীয় উদ্যান ভারতের বৃহত্তম জাতীয় উদ্যান।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion06" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG01",
    "question": "পশ্চিমবঙ্গের জলবায়ু প্রধানত কোন ধরনের?",
    "option1": "উষ্ণ ও শুষ্ক",
    "option2": "ভূমধ্যসাগরীয়",
    "option3": "ক্রান্তীয় মৌসুমি",
    "option4": "তুন্দ্রা জলবায়ু",
    "answer": "option3",
    "solution": "পশ্চিমবঙ্গের জলবায়ু প্রধানত ক্রান্তীয় মৌসুমি (Tropical Monsoon) প্রকৃতির।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion07" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG01",
    "question": "ভারতের সাথে দীর্ঘতম আন্তর্জাতিক সীমানা ভাগ করে নিয়েছে কোন প্রতিবেশী দেশ?",
    "option1": "চীন",
    "option2": "পাকিস্তান",
    "option3": "বাংলাদেশ",
    "option4": "নেপাল",
    "answer": "option3",
    "solution": "ভারতের সাথে বাংলাদেশের আন্তর্জাতিক সীমানা সবচেয়ে দীর্ঘ (প্রায় ৪,০৯৬.৭ কিমি)।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion08" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG01",
    "question": "তুলা চাষের জন্য কোন মাটি সবচেয়ে উপযোগী?",
    "option1": "পলি মাটি",
    "option2": "লাল মাটি",
    "option3": "কৃষ্ণ বা রেগুর মাটি",
    "option4": "লেটেরাইট মাটি",
    "answer": "option3",
    "solution": "কৃষ্ণ মাটি (Black Soil বা Regur) জল ধারণ ক্ষমতার জন্য কার্পাস বা তুলা চাষের জন্য শ্রেষ্ঠ।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion09" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG01",
    "question": "কাজিরাঙা জাতীয় উদ্যান কোন রাজ্যে অবস্থিত এবং কিসের জন্য বিখ্যাত?",
    "option1": "পশ্চিমবঙ্গ - বাঘ",
    "option2": "আসাম - একশৃঙ্গ গণ্ডার",
    "option3": "গুজরাট - সিংহ",
    "option4": "উত্তরাখণ্ড - হাতি",
    "answer": "option2",
    "solution": "কাজিরাঙা জাতীয় উদ্যান আসামে অবস্থিত এবং এটি একশৃঙ্গ গণ্ডারের জন্য পৃথিবী বিখ্যাত।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion10" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG01",
    "question": "উত্তরবঙ্গের প্রধান নদী কোনটি?",
    "option1": "মতুয়া",
    "option2": "জলঢাকা",
    "option3": "তিস্তা",
    "option4": "কালজানি",
    "answer": "option3",
    "solution": "তিস্তা হলো উত্তরবঙ্গের প্রধান ও সবচেয়ে গুরুত্বপূর্ণ নদী। একে 'ত্রাসের নদী'ও বলা হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion11" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG01",
    "question": "পশ্চিমবঙ্গের সাথে মোট কয়টি প্রতিবেশী রাজ্যের সীমানা রয়েছে?",
    "option1": "৩টি",
    "option2": "৪টি",
    "option3": "৫টি",
    "option4": "৬টি",
    "answer": "option3",
    "solution": "পশ্চিমবঙ্গের সাথে ৫টি প্রতিবেশী রাজ্যের সীমানা রয়েছে: ওড়িশা, ঝাড়খণ্ড, বিহার, সিকিম এবং অসম।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion12" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG01",
    "question": "ভারতে গ্রীষ্মকালে উত্তর-পশ্চিম অংশে প্রবাহিত তীব্র শুষ্ক ও উত্তপ্ত বায়ুকে কী বলে?",
    "option1": "আঁধি",
    "option2": "কালবৈশাখী",
    "option3": "লু (Loo)",
    "option4": "চিনুক",
    "answer": "option3",
    "solution": "গ্রীষ্মকালে উত্তর ও উত্তর-পশ্চিম ভারতে প্রবাহিত অত্যন্ত উষ্ণ ও শুষ্ক বায়ুকে 'লু' বলা হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion13" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG01",
    "question": "জলদাপাড়া জাতীয় উদ্যান পশ্চিমবঙ্গের কোন জেলায় অবস্থিত?",
    "option1": "দার্জিলিং",
    "option2": "জলপাইগুড়ি",
    "option3": "আলিপুরদুয়ার",
    "option4": "কোচবিহার",
    "answer": "option3",
    "solution": "জলদাপাড়া জাতীয় উদ্যান পশ্চিমবঙ্গের আলিপুরদুয়ার জেলায় তোর্সা নদীর তীরে অবস্থিত।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion14" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG01",
    "question": "কোন প্রণালী ভারত ও শ্রীলঙ্কাকে পৃথক করেছে?",
    "option1": "১০ ডিগ্রি চ্যানেল",
    "option2": "জিব্রাল্টার প্রণালী",
    "option3": "প্রণালী/পক প্রণালী (Palk Strait)",
    "option4": "মালক্কার প্রণালী",
    "answer": "option3",
    "solution": "পক প্রণালী এবং মান্নার উপসাগর ভারত ও শ্রীলঙ্কাকে ভৌগোলিকভাবে পৃথক করেছে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion15" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG01",
    "question": "পশ্চিমবঙ্গের রাঢ় অঞ্চলের মাটি প্রধানত কোন ধরনের?",
    "option1": "পলি মাটি",
    "option2": "পডসল মাটি",
    "option3": "লেটেরাইট (লাল) মাটি",
    "option4": "লবণাক্ত মাটি",
    "answer": "option3",
    "solution": "পশ্চিমবঙ্গের পশ্চিমের রাঢ় অঞ্চল লোহা সমৃদ্ধ লাল বা লেটেরাইট মাটি দিয়ে গঠিত।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion16" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG01",
    "question": "এশিয়াটিক লায়ন (Asiatic Lion)-এর প্রাকৃতিক বাসস্থান কোন জাতীয় উদ্যান?",
    "option1": "কাঞ্চনজঙ্ঘা জাতীয় উদ্যান",
    "option2": "বান্দীপুর জাতীয় উদ্যান",
    "option3": "গির জাতীয় উদ্যান",
    "option4": "রণথম্বোর জাতীয় উদ্যান",
    "answer": "option3",
    "solution": "গুজরাটের গির (Gir) জাতীয় উদ্যান হলো এশিয়াটিক লায়নের একমাত্র প্রাকৃতিক আবাসস্থল।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion17" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG01",
    "question": "ভারতের কোন রাজ্যে সর্বাধিক বৃষ্টিপাত হয়?",
    "option1": "পশ্চিমবঙ্গ",
    "option2": "আসাম",
    "option3": "মেঘালয়",
    "option4": "কেরল",
    "answer": "option3",
    "solution": "মেঘালয় রাজ্যের চেরাপুঞ্জির নিকটস্থ মসিনরামে (Mawsynram) ভারতে তথা বিশ্বে সর্বাধিক গড় বার্ষিক বৃষ্টিপাত হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion18" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG01",
    "question": "নর্মদা ও তাপ্তি নদী কোন সাগরে পতিত হয়েছে?",
    "option1": "বঙ্গোপসাগর",
    "option2": "ভারত মহাসাগর",
    "option3": "আরব সাগর",
    "option4": "খাম্বাত উপসাগর",
    "answer": "option3",
    "solution": "পশ্চিমবাহিনী নদী নর্মদা ও তাপ্তি গ্রস্ত উপত্যকার মধ্য দিয়ে প্রবাহিত হয়ে আরব সাগরে পতিত হয়েছে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion19" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG01",
    "question": "পশ্চিমবঙ্গের সাথে সবচেয়ে দীর্ঘ সীমানা রয়েছে কোন প্রতিবেশী রাজ্যের?",
    "option1": "উড়িষ্যা",
    "option2": "বিহার",
    "option3": "ঝাড়খণ্ড",
    "option4": "সিকিম",
    "answer": "option3",
    "solution": "পশ্চিমবঙ্গের সাথে ঝাড়খণ্ড রাজ্যের সীমানা রেখা সবচেয়ে দীর্ঘ (প্রায় ৫০০ কিমি)।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion20" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG01",
    "question": "ভারতের প্রথম জাতীয় উদ্যান কোনটি?",
    "option1": "কানহা জাতীয় উদ্যান",
    "option2": "কাজিরাঙা জাতীয় উদ্যান",
    "option3": "জিম করবেট জাতীয় উদ্যান",
    "option4": "সুন্দরবন জাতীয় উদ্যান",
    "answer": "option3",
    "solution": "১৯৩৬ সালে প্রতিষ্ঠিত হেইলি ন্যাশনাল পার্ক (বর্তমান 'জিম করবেট জাতীয় উদ্যান', উত্তরাখণ্ড) ভারতের প্রথম জাতীয় উদ্যান।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion21" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG02",
    "question": "কাকে 'বাংলার নবজাগরণের জনক' বা 'আধুনিক ভারতের জনক' বলা হয়?",
    "option1": "ঈশ্বরচন্দ্র বিদ্যাসাগর",
    "option2": "স্বামী বিবেকানন্দ",
    "option3": "রাজা রামমোহন রায়",
    "option4": "রবীন্দ্রনাথ ঠাকুর",
    "answer": "option3",
    "solution": "রাজা রামমোহন রায়কে কুসংস্কার দূরীকরণ, সতীদাহ প্রথা রদ এবং আধুনিক শিক্ষার প্রসারে অবদানের জন্য 'বাংলার নবজাগরণের জনক' বলা হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion22" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG02",
    "question": "১৮৫৬ সালে কার প্রচেষ্টায় বিধবা বিবাহ আইন (Widow Remarriage Act) পাশ হয়?",
    "option1": "দেবেন্দ্রনাথ ঠাকুর",
    "option2": "কেশবচন্দ্র সেন",
    "option3": "ঈশ্বরচন্দ্র বিদ্যাসাগর",
    "option4": "রামকৃষ্ণ পরমহংস",
    "answer": "option3",
    "solution": "পণ্ডিত ঈশ্বরচন্দ্র বিদ্যাসাগরের অদম্য প্রচেষ্টা ও সামাজিক আন্দোলনের ফলে লর্ড ক্যানিং-এর আমলে ১৮৫৬ সালে বিধবা বিবাহ আইন সম্মত হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion23" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG02",
    "question": "'ইয়ং বেঙ্গল' (Young Bengal) আন্দোলনের প্রবক্তা কে ছিলেন?",
    "option1": "ডিরোজিও (Henry Louis Vivian Derozio)",
    "option2": "ডেভিড হেয়ার",
    "option3": "রসিককৃষ্ণ মল্লিক",
    "option4": "রামতনু লাহিড়ী",
    "answer": "option1",
    "solution": "হিন্দু কলেজের শিক্ষক হেনরি লুই ভিভিয়ান ডিরোজিও কুসংস্কার ও জাতিভেদের বিরুদ্ধে তরুণদের ঐক্যবদ্ধ করে 'ইয়ং বেঙ্গল' আন্দোলন শুরু করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion24" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG02",
    "question": "নেতাজি সুভাষচন্দ্র বসু ১৯৩৯ সালে কোন রাজনৈতিক দল গঠন করেছিলেন?",
    "option1": "আজাদ হিন্দ ফৌজ",
    "option2": "স্বরাজ দল",
    "option3": "ফরওয়ার্ড ব্লক (Forward Bloc)",
    "option4": "গদর পার্টি",
    "answer": "option3",
    "solution": "কনগ্রেসে মতভেদের পর সভাপতি পদ ত্যাগ করে নেতাজি ১৯৩৯ সালে 'ফরওয়ার্ড ব্লক' নামক নতুন রাজনৈতিক দল গঠন করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion25" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG02",
    "question": "১৯০৫ সালে বঙ্গভঙ্গের আদেশ জারি করেছিলেন কোন ভাইসরয়?",
    "option1": "লর্ড রিপন",
    "option2": "লর্ড ডালহৌসি",
    "option3": "লর্ড কার্জন",
    "option4": "লর্ড হার্ডিঞ্জ",
    "answer": "option3",
    "solution": "লর্ড কার্জন জাতীয়তাবাদী আন্দোলন দুর্বল করার লক্ষ্যে ১৯০৫ সালের ১৬ই অক্টোবর আনুষ্ঠানিকভাবে বঙ্গভঙ্গ কার্যকর করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion26" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG02",
    "question": "'অনুশীলন সমিতি' (Anushilan Samiti) কে প্রতিষ্ঠা করেছিলেন?",
    "option1": "বারীন্দ্রকুমার ঘোষ",
    "option2": "প্রমথনাথ মিত্র (P. Mitra)",
    "option3": "ক্ষুদিরাম বসু",
    "option4": "সূর্য সেন",
    "answer": "option2",
    "solution": "১৯০২ সালে ব্যারিস্টার প্রমথনাথ মিত্র (পি. মিত্র), সতীশচন্দ্র বসু এবং অরবিন্দ ঘোষের সহযোগিতায় ঢাকায় ও কলকাতায় অনুশীলন সমিতি প্রতিষ্ঠিত হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion27" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG02",
    "question": "১৯৩০ সালের চট্টগ্রাম অস্ত্রাগার লুণ্ঠনের নেতৃত্ব কে দিয়েছিলেন?",
    "option1": "ভগৎ সিং",
    "option2": "চন্দ্রশেখর আজাদ",
    "option3": "সূর্য সেন (মাষ্টারদা)",
    "option4": "বিনয় বসু",
    "answer": "option3",
    "solution": "'মাষ্টারদা' সূর্য সেনের নেতৃত্বে ইন্ডিয়ান রিপাবলিকান আর্মি ১৯৩০ সালের ১৮ই এপ্রিল চট্টগ্রাম অস্ত্রাগার লুণ্ঠন করে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion28" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG02",
    "question": "১৯৩০ সালে লেখক সচেতানে (Writer's Building) ঐতিহাসিক অভিযানের সাথে জড়িত তিনজন বিপ্লবীর নাম কী?",
    "option1": "ক্ষুদিরাম, প্রফুল্ল ও ভগৎ সিং",
    "option2": "সূর্য সেন, প্রীতিলতা ও কল্পনা দত্ত",
    "option3": "বিনয়, বাদল ও দিনেশ",
    "option4": "যতীন্দ্রনাথ, রাসবিহারী ও অরবিন্দ",
    "answer": "option3",
    "solution": "বিনয় বসু, বাদল গুপ্ত এবং দিনেশ গুপ্ত ১৯৩০ সালের ৮ই ডিসেম্বর রাইটার্স বিল্ডিংয়ে প্রবেশ করে সিম্পসনকে হত্যা করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion29" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG02",
    "question": "১৮২৯ সালে রামমোহন রায়ের সহযোগিতায় কোন গভর্নর জেনারেল সতীদাহ প্রথা রদ করেন?",
    "option1": "লর্ড ডালহৌসি",
    "option2": "লর্ড কর্নওয়ালিস",
    "option3": "লর্ড উইলিয়াম বেন্টিঙ্ক",
    "option4": "লর্ড ওয়েলেসলি",
    "answer": "option3",
    "solution": "লর্ড উইলিয়াম বেন্টিঙ্ক ১৭ নম্বর রেগুলেশন জারি করে ১৮২৯ সালে সতীদাহ প্রথা আইনিভাবে নিষিদ্ধ করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion30" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG02",
    "question": "রবীন্দ্রনাথ ঠাকুর কত সালে এবং কোন গ্রন্থের জন্য নোবেল পুরস্কার পান?",
    "option1": "১৯১১ - গোরা",
    "option2": "১৯১২ - ঘরে বাইরে",
    "option3": "১৯১৩ - গীতাঞ্জলি",
    "option4": "১৯১৫ - সোনার তরী",
    "answer": "option3",
    "solution": "রবীন্দ্রনাথ ঠাকুর ১৯১৩ সালে তাঁর কাব্যগ্রন্থ 'গীতাঞ্জলি' (Song Offerings)-এর জন্য এশিয়ার প্রথম সাহিত্যিক হিসেবে নোবেল পুরস্কার পান।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion31" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG02",
    "question": "'বন্দে মাতরম্' জাতীয় সংগীতটি কোন উপন্যাসের অন্তর্গত?",
    "option1": "দেবী চৌধুরাণী",
    "option2": "কপালকুণ্ডলা",
    "option3": "আনন্দমঠ",
    "option4": "বিষবৃক্ষ",
    "answer": "option3",
    "solution": "বঙ্কিমচন্দ্র চট্টোপাধ্যায়ের ১৮৮২ সালে রচিত 'আনন্দমঠ' উপন্যাস থেকে ঐতিহাসিক দেশাত্মবোধক গান 'বন্দে মাতরম্' নেওয়া হয়েছে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion32" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG02",
    "question": "১৮৯৩ সালের বিখ্যাত শিকাগো বিশ্ব ধর্ম সম্মেলনে কে ভাষণ দিয়েছিলেন?",
    "option1": "রামকৃষ্ণ পরমহংস",
    "option2": "স্বামী বিবেকানন্দ",
    "option3": "কেশবচন্দ্র সেন",
    "option4": "শ্রী অরবিন্দ",
    "answer": "option2",
    "solution": "স্বামী বিবেকানন্দ ১৮৯৩ সালের ১১ই সেপ্টেম্বর আমেরিকার শিকাগোতে আয়োজিত বিশ্ব ধর্ম মহাসভায় 'Brothers and Sisters of America' সম্বোধনে ঐতিহাসিক ভাষণ দেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion33" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG02",
    "question": "কাজী নজরুল ইসলাম সম্পাদিত বিখ্যাত পত্রিকার নাম কী?",
    "option1": "সংবাদ কৌমুমুদী",
    "option2": "সঞ্জীবনী",
    "option3": "ধূমকেতু",
    "option4": "যুগান্তর",
    "answer": "option3",
    "solution": "'বিদ্রোহী কবি' কাজী নজরুল ইসলাম ১৯২২ সালে অর্ধ-সাপ্তাহিক পত্রিকা 'ধূমকেতু' প্রকাশ করেন, যা বিপ্লবী ভাবধারায় পূর্ণ ছিল।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion34" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG02",
    "question": "ক্ষুদিরাম বসু ও প্রফুল্ল চাকী কাকে হত্যার উদ্দেশ্যে মজফফরপুরে বোমা হামলা করেছিলেন?",
    "option1": "স্যার কার্জন উইলি",
    "option2": "লর্ড হার্ডিঞ্জ",
    "option3": "কিং্সফোর্ড (Kingsford)",
    "option4": "সন্ডার্স",
    "answer": "option3",
    "solution": "১৯০৮ সালের ৩০শে এপ্রিল অত্যাচারী ম্যাজিস্ট্রেট কিংসফোর্ডকে হত্যার উদ্দেশ্যে ক্ষুদিরাম ও প্রফুল্ল চাকী তাঁর গাড়িতে বোমা ছোড়েন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion35" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG02",
    "question": "পাহাড়তলী ইউরোপিয়ান ক্লাব আক্রমণের নেতৃত্ব দিয়ে কোন নারী বিপ্লবী শহীদ হন?",
    "option1": "কল্পনা দত্ত",
    "option2": "বীণা দাস",
    "option3": "প্রীতিলতা ওয়াদ্দেদার",
    "option4": "সুহাসিনী গ্যাঙ্গুলি",
    "answer": "option3",
    "solution": "মাষ্টারদা সূর্য সেনের নির্দেশে ১৯৩২ সালে প্রীতিলতা ওয়াদ্দেদার ইউরোপিয়ান ক্লাব আক্রমণ করেন এবং ধরা পড়ার ভয়ে পটাশিয়াম সায়ানাইড খেয়ে আত্মবলি দেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion36" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG02",
    "question": "১৮১৭ সালে হিন্দু কলেজ (বর্তমান প্রেসিডেন্সি বিশ্ববিদ্যালয়) প্রতিষ্ঠায় কার অবদান ছিল?",
    "option1": "ঈশ্বরচন্দ্র বিদ্যাসাগর",
    "option2": "ডেভিড হেয়ার ও রামমোহন রায়",
    "option3": "স্যার উইলিয়াম জোন্স",
    "option4": "ড্রিঙ্কওয়াটার বিটন",
    "answer": "option2",
    "solution": "১৮১৭ সালে ডেভিড হেয়ার, রাজা রামমোহন রায় এবং স্যার হাইড ইস্টের যৌথ উদ্যোগে কলকাতায় 'হিন্দু কলেজ' প্রতিষ্ঠিত হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion37" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG02",
    "question": "'বাঘাযতীন' নামে কে পরিচিত ছিলেন?",
    "option1": "যতীন্দ্রমোহন সেনগুপ্ত",
    "option2": "যতীন্দ্রনাথ মুখোপাধ্যায়",
    "option3": "যতীন্দ্রনাথ দাস",
    "option4": "রাসবিহারী বসু",
    "answer": "option2",
    "solution": "বিপ্লবী যতীন্দ্রনাথ মুখোপাধ্যায় ১৯০৬ সালে একা বাঘ মেরে আত্মরক্ষা করার সাহসিকতার জন্য 'বাঘাযতীন' উপাধি পান।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion38" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG02",
    "question": "জগদীশচন্দ্র বসু গাছের যে প্রাণ আছে তা পরিমাপের জন্য কোন যন্ত্রটি আবিষ্কার করেন?",
    "option1": "সিসমোগ্রাফ",
    "option2": "ক্রেসকোগ্রাফ (Crescograph)",
    "option3": "স্পিগমোম্যানোমিটার",
    "option4": "ক্রোনোমিটার",
    "answer": "option2",
    "solution": "বিখ্যাত বাঙালি বিজ্ঞানী স্যার জগদীশচন্দ্র বসু উদ্ভিদের বৃদ্ধি ও সংবেদনশীলতা মাপার জন্য 'ক্রেসকোগ্রাফ' যন্ত্রটি উদ্ভাবন করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion39" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG02",
    "question": "'আర్య সমাজ' বা 'ব্রহ্ম সমাজ'-এর মধ্যে রামমোহন রায় ১৮২৮ সালে কোনটি প্রতিষ্ঠা করেছিলেন?",
    "option1": "প্রার্থনা সমাজ",
    "option2": "আರ್ಯ সমাজ",
    "option3": "ব্রহ্ম সমাজ (Brahmo Samaj)",
    "option4": "ধর্ম সভা",
    "answer": "option3",
    "solution": "রাজা রামমোহন রায় ১৮১৫ সালে আত্মীয় সভা এবং পরবর্তীতে ১৮২৮ সালে একেশ্বরবাদের বার্তা ছড়াতে 'ব্রহ্ম সমাজ' প্রতিষ্ঠা করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion40" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG02",
    "question": "'দেশবন্ধু' নামে পরিচিত ভারতের কোন বিখ্যাত বাঙালি স্বাধীনতা সংগ্রামী?",
    "option1": "সুভাষচন্দ্র বসু",
    "option2": "চিত্তরঞ্জন দাস",
    "option3": "সুরেন্দ্রনাথ বন্দ্যোপাধ্যায়",
    "option4": "আশুতোষ মুখোপাধ্যায়",
    "answer": "option2",
    "solution": "বিখ্যাত আইনজীবী ও স্বরাজ দলের প্রতিষ্ঠাতা চিত্তরঞ্জন দাসকে তাঁর উদারতা ও ত্যাগের জন্য জনগণ 'দেশবন্ধু' উপাধিতে ভূষিত করে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion41" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG03",
    "question": "পশ্চিমবঙ্গ সরকারের 'কন্যাশ্রী প্রকল্প' কত সালে চালু হয়?",
    "option1": "২০১১ সালে",
    "option2": "২০১২ সালে",
    "option3": "২০১৩ সালে",
    "option4": "২০১৫ সালে",
    "answer": "option3",
    "solution": "বাল্যবিবাহ রোধ এবং মেয়েদের উচ্চশিক্ষায় উৎসাহিত করতে ২০১৩ সালের ১লা অক্টোবর 'কন্যাশ্রী প্রকল্প' চালু করা হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion42" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG03",
    "question": "জাতিসংঘ (UN) থেকে পশ্চিমবঙ্গ সরকারের কোন প্রকল্প আন্তর্জাতিক 'Public Service Award' (প্রথম পুরস্কার) পেয়েছে?",
    "option1": "সবুজ সাথী",
    "option2": "রূপশ্রী",
    "option3": "কন্যাশ্রী",
    "option4": "স্বাস্থ্য সাথী",
    "answer": "option3",
    "solution": "২০১৭ সালে জাতিসংঘ (United Nations) বিশ্বমঞ্চে কন্যাশ্রী প্রকল্পকে প্রথম স্থান দিয়ে সম্মানিত করে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion43" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG03",
    "question": "'সবুজ সাথী' প্রকল্পের আওতায় ছাত্র-ছাত্রীদের কী প্রদান করা হয়?",
    "option1": "পাঠ্যবই",
    "option2": "ট্যাব/স্মার্টফোন",
    "option3": "সাইকেল",
    "option4": "স্কুল ব্যাগ",
    "answer": "option3",
    "solution": "নবম থেকে দ্বাদশ শ্রেণির শিক্ষার্থীদের স্কুলে যাতায়াতের সুবিধার্থে বিনামূল্যে বাইসাইকেল প্রদান করা হয় সবুজ সাথী প্রকল্পের মাধ্যমে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion44" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG03",
    "question": "পশ্চিমবঙ্গ সরকারের 'রূপশ্রী' প্রকল্পের মূল উদ্দেশ্য কী?",
    "option1": "মেয়েদের খেলাধুলায় আর্থিক সাহায্য",
    "option2": "দরিদ্র পরিবারের প্রাপ্তবয়স্ক মেয়েদের বিয়ের জন্য আর্থিক সাহায্য",
    "option3": "মহিলাদের বিনামূল্যে স্বাস্থ্য বীমা",
    "option4": "মহিলা উদ্যোক্তাদের ঋণ প্রদান",
    "answer": "option2",
    "solution": "দরিদ্র পরিবারের ১৮ বছর বা তার বেশি বয়সি মেয়েদের বিবাহের জন্য এককালীন ২৫,০০০ টাকা আর্থিক সহায়তা দেওয়া হয় রূপশ্রী প্রকল্পে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion45" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG03",
    "question": "'স্বাস্থ্য সাথী' প্রকল্পের আওতায় প্রতিটি পরিবারকে বার্ষিক সর্বোচ্চ কত টাকা পর্যন্ত স্বাস্থ্য বীমা প্রদান করা হয়?",
    "option1": "২ লক্ষ টাকা",
    "option2": "৩ লক্ষ টাকা",
    "option3": "৫ লক্ষ টাকা",
    "option4": "১০ লক্ষ টাকা",
    "answer": "option3",
    "solution": "স্বাস্থ্য সাথী প্রকল্পের মাধ্যমে প্রতিটি পরিবারকে মাধ্যমিক ও তৃতীয় পর্যায়ের চিকিৎসার জন্য বার্ষিক ৫ লক্ষ টাকা পর্যন্ত ক্যাশলেস স্বাস্থ্য বীমা দেওয়া হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion46" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG03",
    "question": "পশ্চিমবঙ্গ সরকারের 'লক্ষ্মীর ভান্ডার' প্রকল্প কত সালে শুরু হয়?",
    "option1": "২০১৯ সালে",
    "option2": "২০২০ সালে",
    "option3": "২০২১ সালে",
    "option4": "২০২২ সালে",
    "answer": "option3",
    "solution": "পরিবারের মহিলা প্রধানদের সামাজিক ও আর্থিক সুরক্ষার জন্য ২০২১ সালের সেপ্টেম্বরে 'লক্ষ্মীর ভান্ডার' প্রকল্প আনুষ্ঠানিকভাবে চালু হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion47" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG03",
    "question": "দ্বাদশ শ্রেণির শিক্ষার্থীদের স্মার্টফোন বা ট্যাব কেনার জন্য 'চোখের আলো' বা 'তরুণের স্বপ্ন' কোন প্রকল্পের মাধ্যমে ১০,০০০ টাকা দেওয়া হয়?",
    "option1": "চোখের আলো",
    "option2": "তরুণের স্বপ্ন",
    "option3": "শিক্ষাশ্রী",
    "option4": "ঐক্যশ্রী",
    "answer": "option2",
    "solution": "'তরুণের স্বপ্ন' প্রকল্পের অধীনে দ্বাদশ শ্রেণির শিক্ষার্থীদের ডিজিটাল শিক্ষার সুবিধার্থে ট্যাব বা মোবাইল কেনার জন্য এককালীন ১০,০০০ টাকা দেওয়া হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion48" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG03",
    "question": "'কৃষক বন্ধু' প্রকল্পের আওতায় নিবন্ধিত কৃষকদের প্রাকৃতিক কারণে মৃত্যু হলে পরিবারকে কত টাকা আর্থিক সাহায্য দেওয়া হয়?",
    "option1": "১ লক্ষ টাকা",
    "option2": "২ লক্ষ টাকা",
    "option3": "৩ লক্ষ টাকা",
    "option4": "৫০,০০০ টাকা",
    "answer": "option2",
    "solution": "কৃষক বন্ধু (নতুন) প্রকল্পের অধীনে ১৮ থেকে ৬০ বছর বয়সি কোনো কৃষকের মৃত্যু হলে তাঁর পরিবারকে এককালীন ২ লক্ষ টাকা প্রদান করা হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion49" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG03",
    "question": "পশ্চিমবঙ্গের সংখ্যালঘু ছাত্র-ছাত্রীদের স্কলারশিপ প্রদানের জন্য কোন প্রকল্প চালু করা হয়েছে?",
    "option1": "শিক্ষাশ্রী",
    "option2": "মেধাশ্রী",
    "option3": "ঐক্যশ্রী",
    "option4": "সবুজ সাথী",
    "answer": "option3",
    "solution": "পশ্চিমবঙ্গের সংখ্যালঘু সম্প্রদায়ভুক্ত (মুসলিম, খ্রিস্টান, শিখ, বৌদ্ধ, পার্সি, জৈন) শিক্ষার্থীদের মেধা ও আর্থিক সহায়তার জন্য 'ঐক্যশ্রী' প্রকল্প পরিচালিত হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion50" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG03",
    "question": "তপশিলি জাতি (SC) ও তপশিলি উপজাতি (ST) শিক্ষার্থীদের ৫ম থেকে ৮ম শ্রেণি পর্যন্ত বৃত্তির জন্য কোন প্রকল্প চালু আছে?",
    "option1": "শিক্ষাশ্রী",
    "option2": "মেধাশ্রী",
    "option3": "ঐক্যশ্রী",
    "option4": "কন্যাশ্রী",
    "answer": "option1",
    "solution": "SC এবং ST সম্প্রদায়ের ৫ম থেকে ৮ম শ্রেণির শিক্ষার্থীদের ড্রপআউট রোধে 'শিক্ষাশ্রী' প্রকল্পের মাধ্যমে অনুদান দেওয়া হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion51" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG03",
    "question": "পশ্চিমবঙ্গের অর্থনৈতিক দিক থেকে সবচেয়ে গুরুত্বপূর্ণ কৃষিজাত ফসল কোনটি, যা সর্বোচ্চ রাজস্ব ও কর্মসংস্থান জোগায়?",
    "option1": "গম",
    "option2": "ধান",
    "option3": "চা",
    "option4": "আম",
    "answer": "option2",
    "solution": "ধান হলো পশ্চিমবঙ্গের প্রধান খাদ্য ও অর্থকরী শস্য। উৎপাদন ও চাষের পরিমাণের দিক থেকে এটি রাজ্যের কৃষি অর্থনীতির মূল ভিত্তি।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion52" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG03",
    "question": "পশ্চিমবঙ্গের কোন অঞ্চল 'চা শিল্প' এবং পর্যটন অর্থনীতির জন্য বিখ্যাত?",
    "option1": "রাঢ় অঞ্চল",
    "option2": "সুন্দরবন",
    "option3": "উত্তরবঙ্গের ডুয়ার্স ও দার্জিলিং",
    "option4": "উপকূলীয় সমভূমি",
    "answer": "option3",
    "solution": "দার্জিলিং এবং তরাই-ডুয়ার্স অঞ্চল চায়ের গুণগত মান এবং প্রাকৃতিক সৌন্দর্যের ওপর ভিত্তি করে পর্যটন অর্থনীতির গুরুত্বপূর্ণ ভূমিকা পালন করে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion53" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG03",
    "question": "সরকারি পরিষেবা সরাসরি জনগণের দুয়ারে পৌঁছে দিতে পশ্চিমবঙ্গ সরকার কোন কর্মসূচি শুরু করে?",
    "option1": "পাড়ায় সমাধান",
    "option2": "দুয়ারে সরকার",
    "option3": "আমার গ্রাম আমার সড়ক",
    "option4": "পথশ্রী",
    "answer": "option2",
    "solution": "২০২০ সালের ১লা ডিসেম্বর থেকে রাজ্য সরকারের বিভিন্ন জনকল্যাণমুখী প্রকল্পের সুবিধা বাড়ি বাড়ি পৌছে দিতে 'দুয়ারে সরকার' শিবির চালু হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion54" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG03",
    "question": "পশ্চিমবঙ্গের প্রথম এবং ভারতের অন্যতম প্রধান পাট শিল্প কেন্দ্র কোথায় গড়ে উঠেছিল?",
    "option1": "হলদিয়া",
    "option2": "রিশড়া",
    "option3": "দুর্গাপুর",
    "option4": "আসানসোল",
    "answer": "option2",
    "solution": "১৮৫৫ সালে জর্জ অকল্যান্ডের উদ্যোগে হুগলি জেলার রিশড়ায় ভারতের প্রথম আধুনিক পাটকল স্থাপিত হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion55" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG03",
    "question": "উচ্চশিক্ষার জন্য শিক্ষার্থীদের ১০ লক্ষ টাকা পর্যন্ত নমনীয় সুদে ঋণ দিতে পশ্চিমবঙ্গ সরকার কোন কার্ড ব্যবস্থা চালু করেছে?",
    "option1": "স্টুডেন্ট ক্রেডিট কার্ড",
    "option2": "স্মার্ট এডুকেশন কার্ড",
    "option3": "যুবশ্রী কার্ড",
    "option4": "বিদ্যাশ্রী কার্ড",
    "answer": "option1",
    "solution": "পশ্চিমবঙ্গ সরকার ২০২১ সালে 'Student Credit Card Scheme' চালু করে, যার মাধ্যমে ১০ লক্ষ টাকা পর্যন্ত শিক্ষা ঋণ পাওয়া যায়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion56" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG03",
    "question": "'সমব্যথী' প্রকল্প পশ্চিমবঙ্গ সরকার কোন উদ্দেশ্যে চালু করেছে?",
    "option1": "গৃহহীনদের ঘর বানাতে",
    "option2": "দরিদ্র পরিবারের নিকটজনের অন্ত্যেষ্টিক্রিয়ার জন্য আর্থিক সাহায্য দিতে",
    "option3": "প্রতিবন্ধী ব্যক্তিদের ভাতা দিতে",
    "option4": "বন্যা দুর্গতদের সাহায্য করতে",
    "answer": "option2",
    "solution": "দরিদ্র পরিবারের সদস্যের মৃত্যুর পর সৎকার বা অন্ত্যেষ্টিক্রিয়ার জন্য 'সমব্যথী' প্রকল্পের মাধ্যমে এককালীন ২,০০০ টাকা দেওয়া হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion57" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG03",
    "question": "পশ্চিমবঙ্গের প্রধান সামুদ্রিক ও ইন্ডাস্ট্রিয়াল বন্দর কেন্দ্র কোনটি?",
    "option1": "ফারাক্কা",
    "option2": "কলকাতা ও হলদিয়া বন্দর",
    "option3": "কোলাঘাট",
    "option4": "ব্যান্ডেল",
    "answer": "option2",
    "solution": "কলকাতা পোর্ট ট্রাস্ট (শ্যামাপ্রসাদ মুখার্জি পোর্ট) এবং হলদিয়া ডক কমপ্লেক্স রাজ্যের বৈদেশিক বাণিজ্য ও অর্থব্যবস্থার প্রধান কেন্দ্র।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion58" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG03",
    "question": "পশ্চিমবঙ্গের কোন শহরকে 'ভারতের রূঢ়' (Ruhr of India) বলা হয়, যা রাজ্যের শিল্প অর্থনীতির কেন্দ্রবিন্দু?",
    "option1": "শিলিগুড়ি",
    "option2": "খড়গপুর",
    "option3": "দুর্গাপুর",
    "option4": "হাওড়া",
    "answer": "option3",
    "solution": "প্রচুর লোহা-ইস্পাত শিল্প এবং কয়লা সম্পদের নৈকট্যের কারণে দুর্গাপুরকে 'ভারতের রূঢ়' বলা হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion59" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG03",
    "question": "পশ্চিমবঙ্গ সরকারের 'কর্মসংস্থান ব্যাংক' বা 'যুবশ্রী' প্রকল্পের প্রধান লক্ষ্য কী?",
    "option1": "কৃষকদের বীজ সরবরাহ",
    "option2": "বেকার যুবকদের কর্মসংস্থান প্রশিক্ষণ ও আর্থিক সহায়তা",
    "option3": "বৃদ্ধদের পেনশন প্রদান",
    "option4": "মহিলাদের তাঁত শিল্পে ঋণ প্রদান",
    "answer": "option2",
    "solution": "নথিভুক্ত বেকার যুবক-যুবতীদের কর্মসংস্থানের সুযোগ সৃষ্টি এবং দক্ষতা বৃদ্ধির জন্য 'যুবশ্রী' প্রকল্প চালু করা হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion60" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG03",
    "question": "OBC শ্রেণিভুক্ত শিক্ষার্থীদের অর্থনৈতিক সহায়তার জন্য পশ্চিমবঙ্গ সরকার কোন নতুন স্কলারশিপ চালু করেছে?",
    "option1": "ঐক্যশ্রী",
    "option2": "মেধাশ্রী",
    "option3": "শিক্ষাশ্রী",
    "option4": "কন্যাশ্রী K3",
    "answer": "option2",
    "solution": "OBC শিক্ষার্থীদের (বিশেষ করে ১ম থেকে ৮ম শ্রেণি পর্যন্ত) আর্থিক সহায়তা প্রদানের জন্য 'মেধাশ্রী' প্রকল্প চালু করা হয়েছে।"
  },{
    "_id": { "$oid": "gkmocktestquestion61" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG04",
    "question": "১৯২১ সালে সিন্ধু সভ্যতার অন্যতম প্রধান কেন্দ্র 'হড়প্পা' কে আবিষ্কার করেন?",
    "option1": "রাখালদাস বন্দ্যোপাধ্যায়",
    "option2": "দয়ারাম সাহানি",
    "option3": "স্যার জন মার্শাল",
    "option4": "আর. এস. বিস্ত",
    "answer": "option2",
    "solution": "১৯২১ সালে প্রত্নতত্ত্ববিদ দয়ারাম সাহানি পাঞ্জাবের মন্টগোমারি জেলায় (বর্তমান পাকিস্তান) হড়প্পা সভ্যতা আবিষ্কার করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion62" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG04",
    "question": "সিন্ধু সভ্যতার বিখ্যাত 'মহেঞ্জোদাড়ো' কেন্দ্রটি কার নেতৃত্বে আবিষ্কৃত হয়?",
    "option1": "দয়ারাম সাহানি",
    "option2": "রাখালদাস বন্দ্যোপাধ্যায়",
    "option3": "অরিয়েল স্টাইন",
    "option4": "জে. পি. জোশী",
    "answer": "option2",
    "solution": "১৯২২ সালে প্রখ্যাত বাঙালি প্রত্নতত্ত্ববিদ রাখালদাস বন্দ্যোপাধ্যায় সিন্ধুর লারকানা জেলায় মহেঞ্জোদাড়ো আবিষ্কার করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion63" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG04",
    "question": "সিন্ধু সভ্যতার একমাত্র বন্দর শহর বা পোতাশ্রয় (Dockyard) কোনটি ছিল?",
    "option1": "কালীবঙ্গান",
    "option2": "ধোলাভিরা",
    "option3": "লোথাল",
    "option4": "বনওয়ালী",
    "answer": "option3",
    "solution": "গুজরাটের ভোগাবোর নদীর তীরে অবস্থিত 'লোথাল' ছিল সিন্ধু সভ্যতার প্রাচীনতম কৃত্রিম প্রথিত পোতাশ্রয় বা বন্দর।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion64" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG04",
    "question": "মৌর্য বংশের প্রতিষ্ঠাতা কে ছিলেন?",
    "option1": "চন্দ্রগুপ্ত মৌর্য",
    "option2": "বিন্দুসার",
    "option3": "অশোক",
    "option4": "বৃহদ্রথ",
    "answer": "option1",
    "solution": "চাণক্যের (কৌটিল্য) সহায়তায় নন্দ বংশের শেষ রাজা ধননন্দকে পরাজিত করে চন্দ্রগুপ্ত মৌর্য খ্রিস্টপূর্ব ৩২২ অব্দে মৌর্য সাম্রাজ্য প্রতিষ্ঠা করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion65" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG04",
    "question": "প্রাচীন গ্রন্থ 'অর্থশাস্ত্র' কার রচনা?",
    "option1": "মেগাস্থিনিস",
    "option2": "কৌটিল্য (চাণক্য)",
    "option3": "কালিদাস",
    "option4": "বাণভট্ট",
    "answer": "option2",
    "solution": "চন্দ্রগুপ্ত মৌর্যের প্রধানমন্ত্রী চাণক্য বা কৌটিল্য রাজনীতি ও শাসনব্যবস্থার ওপর বিখ্যাত গ্রন্থ 'অর্থশাস্ত্র' রচনা করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion66" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG04",
    "question": "মেগাস্থিনিস কার রাজসভায় গ্রিক দূত হিসেবে ভারতে এসেছিলেন?",
    "option1": "সমুদ্রগুপ্ত",
    "option2": "দ্বিতীয় চন্দ্রগুপ্ত",
    "option3": "চন্দ্রগুপ্ত মৌর্য",
    "option4": "অশোক",
    "answer": "option3",
    "solution": "সেলিউকাস নিকেটোরের দূত হিসেবে মেগাস্থিনিস চন্দ্রগুপ্ত মৌর্যের রাজসভায় আসেন এবং 'ইন্ডিকা' গ্রন্থটি রচনা করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion67" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG04",
    "question": "সম্রাট অশোক কত খ্রিস্টপূর্বাব্দে ঐতিহাসিক কলিঙ্গ যুদ্ধ জয় করেছিলেন?",
    "option1": "২৬১ খ্রিস্টপূর্বাব্দে",
    "option2": "২৭৩ খ্রিস্টপূর্বাব্দে",
    "option3": "২৩২ খ্রিস্টপূর্বাব্দে",
    "option4": "৩২৬ খ্রিস্টপূর্বাব্দে",
    "answer": "option1",
    "solution": "সিংহাসনে আরোহণের ৮ম বর্ষে অর্থাৎ ২৬১ খ্রিস্টপূর্বাব্দে সম্রাট অশোক কলিঙ্গ আক্রমণ ও জয় করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion68" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG04",
    "question": "গুপ্ত বংশের প্রকৃত প্রতিষ্ঠাতা কাকে মনে করা হয়?",
    "option1": "শ্রীগুপ্ত",
    "option2": "প্রথম চন্দ্রগুপ্ত",
    "option3": "সমুদ্রগুপ্ত",
    "option4": "দ্বিতীয় চন্দ্রগুপ্ত",
    "answer": "option2",
    "solution": "যদিও শ্রীগুপ্ত বংশের প্রতিষ্ঠাতা, তবে 'মহারাজাধিরাজ' উপাধি গ্রহণকারী প্রথম চন্দ্রগুপ্তকেই গুপ্ত সাম্রাজ্যের প্রকৃত প্রতিষ্ঠাতা ধরা হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion69" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG04",
    "question": "ভারতের ইতিহাসবিদ ভি. এ. স্মিথ কাকে 'ভারতের নেপোলিয়ন' বলে আখ্যায়িত করেছেন?",
    "option1": "স্কন্দগুপ্ত",
    "option2": "সমুদ্রগুপ্ত",
    "option3": "চন্দ্রগুপ্ত মৌর্য",
    "option4": "হর্ষবর্ধন",
    "answer": "option2",
    "solution": "বিশাল সামরিক বিজয় এবং সাম্রাজ্য বিস্তারের জন্য ইতিহাসবিদ ভি. এ. স্মিথ সমুদ্রগুপ্তকে 'ভারতের নেপোলিয়ন' বলেছেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion70" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG04",
    "question": "'ইলাহাবাদ প্রশস্তি' বা 'আল্লাহাবাদ স্তম্ভলেখ' কার দ্বারা রচিত?",
    "option1": "কালিদাস",
    "option2": "হরিষেণ",
    "option3": "রবি কীর্তি",
    "option4": "বাণভট্ট",
    "answer": "option2",
    "solution": "সমুদ্রগুপ্তের সভাকবি হরিষেণ সংস্কৃত ভাষায় আল্লাহাবাদ প্রশস্তি রচনা করেন, যা থেকে সমুদ্রগুপ্তের জয়গাথা জানা যায়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion71" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG04",
    "question": "চীনা পরিব্রাজক ফাহিয়েন (Faxian) কার রাজত্বকালে ভারতে আসেন?",
    "option1": "প্রথম চন্দ্রগুপ্ত",
    "option2": "সমুদ্রগুপ্ত",
    "option3": "দ্বিতীয় চন্দ্রগুপ্ত (বিক্রমাদিত্য)",
    "option4": "কুমারগুপ্ত",
    "answer": "option3",
    "solution": "দ্বিতীয় চন্দ্রগুপ্ত বা বিক্রমাদিত্যের শাসনকালে (৩৯৯-৪১২ খ্রিস্টাব্দ) চীনা পর্যটক ফাহিয়েন ভারতে আগমন করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion72" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG04",
    "question": "প্রাচীন বিখ্যাত নালন্দা বিশ্ববিদ্যালয় কোন গুপ্ত শাসকের আমলে প্রতিষ্ঠিত হয়েছিল?",
    "option1": "সমুদ্রগুপ্ত",
    "option2": "প্রথম কুমারগুপ্ত",
    "option3": "স্কন্দগুপ্ত",
    "option4": "বুদ্ধগুপ্ত",
    "answer": "option2",
    "solution": "পঞ্চম শতাব্দীতে গুপ্ত সম্রাট প্রথম কুমারগুপ্ত (মহেন্দ্রাদিত্য) বিখ্যাত নালন্দা মহাবিহার বা বিশ্ববিদ্যালয় প্রতিষ্ঠা করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion73" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG04",
    "question": "কোন গুপ্ত সম্রাটকে মধ্য এশিয়ার বরবর 'হুণ আক্রমণ' সফলভাবে প্রতিহত করার জন্য 'ভারতের রক্ষাকর্তা' বলা হয়?",
    "option1": "স্কন্দগুপ্ত",
    "option2": "সমুদ্রগুপ্ত",
    "option3": "দ্বিতীয় চন্দ্রগুপ্ত",
    "option4": "প্রথম কুমারগুপ্ত",
    "answer": "option1",
    "solution": "বীরত্বের সাথে হুণদের পরাস্ত করে গুপ্ত সাম্রাজ্য রক্ষা করার জন্য স্কন্দগুপ্তকে 'ভারতের রক্ষাকর্তা' বলা হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion74" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG04",
    "question": "বাংলার প্রথম স্বাধীন ও সার্বভৌম নরপতি কে ছিলেন?",
    "option1": "শশাঙ্ক",
    "option2": "গোপাল",
    "option3": "ধর্মপাল",
    "option4": "লক্ষ্মণসেন",
    "answer": "option1",
    "solution": "সপ্তম শতকের প্রথমার্ধে গৌড় রাজ শশাঙ্ক প্রথম সমগ্র বাংলাকে ঐক্যবদ্ধ করে স্বাধীন গৌড় রাজ্য প্রতিষ্ঠা করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion75" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG04",
    "question": "গৌড়রাজ শশাঙ্কের রাজধানী কোথায় ছিল?",
    "option1": "পাণ্ডুয়া",
    "option2": "কর্ণসুবর্ণ",
    "option3": "বিক্রমপুর",
    "option4": "গৌড়",
    "answer": "option2",
    "solution": "শশাঙ্কের রাজধানী ছিল বর্তমান মুর্শিদাবাদ জেলার কানসোনা বা 'কর্ণসুবর্ণ'।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion76" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG04",
    "question": "বাংলার পাল বংশের প্রতিষ্ঠাতা কে ছিলেন?",
    "option1": "ধর্মপাল",
    "option2": "দেবপাল",
    "option3": "গোপাল",
    "option4": "মহীপাল",
    "answer": "option3",
    "solution": "মাৎস্যন্যায়ের অবসান ঘটিয়ে আনুমানিক ৭৫০ খ্রিস্টাব্দে বাংলার ভূস্বামী ও গণ্যমান্য ব্যক্তিবর্গের দ্বারা নির্বাচিত হয়ে গোপাল পাল বংশের প্রতিষ্ঠা করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion77" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG04",
    "question": "বিখ্যাত 'বিক্রমশীল মহাবিহার' বা বিশ্ববিদ্যালয় কে স্থাপন করেন?",
    "option1": "গোপাল",
    "option2": "ধর্মপাল",
    "option3": "দেবপাল",
    "option4": "রামপাল",
    "answer": "option2",
    "solution": "পাল বংশের অন্যতম শ্রেষ্ঠ শাসক ধর্মপাল বিহারের ভাগলপুরে বিক্রমশীল বুদ্ধ মহাবিহার প্রতিষ্ঠা করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion78" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG04",
    "question": "পাল রাজত্বকালে উত্তরবঙ্গে ঘটে যাওয়া বিখ্যাত কৃষক বিদ্রোহটির নাম কী?",
    "option1": "সন্ন্যাসী বিদ্রোহ",
    "option2": "কৈবর্ত বিদ্রোহ",
    "option3": "সাঁওতাল বিদ্রোহ",
    "option4": "মুণ্ডা বিদ্রোহ",
    "answer": "option2",
    "solution": "দ্বিতীয় মহীপালের রাজত্বকালে দিব্যক, রুdoc ও ভীমের নেতৃত্বে কৈবর্তরা পাল শক্তির বিরুদ্ধে সফল বিদ্রোহ গড়ে তোলে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion79" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG04",
    "question": "'রামচরিত' মহাকাব্যের রচয়িতা কে?",
    "option1": "সন্ধ্যাকর নন্দী",
    "option2": "জয়দেব",
    "option3": "ধোয়ী",
    "option4": "বাণভট্ট",
    "answer": "option1",
    "solution": "পাল রাজা রামপালের সভাকবি সন্ধ্যাকর নন্দী সংস্কৃত ভাষায় দ্ব্যর্থবোধক কাব্য 'রামচরিত' রচনা করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion80" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG04",
    "question": "কোন গুজরাটি কবি পাল রাজা ধর্মপালকে 'উত্তরাপথস্বামী' উপাধিতে ভূষিত করেছিলেন?",
    "option1": "সোড্ডল",
    "option2": "রাজশেখর",
    "option3": "কলহন",
    "option4": "বিলহন",
    "answer": "option1",
    "solution": "একাদশ শতকের গুজরাটি কবি সোড্ডল তাঁর 'উদয়সুন্দরীকথা' কাব্যে ধর্মপালকে সমগ্র উত্তর ভারতের অধিপতি বা 'উত্তরাপথস্বামী' হিসেবে বর্ণনা করেছেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion81" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG05",
    "question": "বিশ্বের সর্বোচ্চ পর্বতশৃঙ্গ 'মাউন্ট এভারেস্ট' হিমালয়ের কোন অংশে অবস্থিত?",
    "option1": "হিমাদ্রি বা উচ্চ হিমালয়",
    "option2": "হিমাচল বা মধ্য হিমালয়",
    "option3": "শিবালিক বা বাহ্যিক হিমালয়",
    "option4": "ট্রান্স হিমালয়",
    "answer": "option1",
    "solution": "মাউন্ট এভারেস্ট, কাঞ্চনজঙ্ঘা ইত্যাদি উচ্চতম শৃঙ্গগুলি হিমালয়ের 'হিমাদ্রি' (Great Himalayas) অংশে অবস্থিত।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion82" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG05",
    "question": "ভারতের সর্বোচ্চ পর্বতশৃঙ্গ কোনটি?",
    "option1": "কাঞ্চনজঙ্ঘা",
    "option2": "গডউইন অস্টিন (K2)",
    "option3": "নন্দাদেবী",
    "option4": "আনাইমুদি",
    "answer": "option2",
    "solution": "কারাকোরাম পর্বতশ্রেণীর গডউইন অস্টিন বা K2 (৮,৬১১ মিটার) ভারতের সর্বোচ্চ শৃঙ্গ।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion83" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG05",
    "question": "দক্ষিণ ভারতের দীর্ঘতম নদী কোনটি, যাকে 'দক্ষিণ ভারতের গঙ্গা' বলা হয়?",
    "option1": "কৃষ্ণা",
    "option2": "কাবেরী",
    "option3": "গোদাavari (গোদাভরী)",
    "option4": "নর্মদা",
    "answer": "option3",
    "solution": "গোদাভরী (১,৪৬৫ কিমি) দক্ষিণ ভারতের দীর্ঘতম নদী হওয়ায় একে 'দক্ষিণ ভারতের গঙ্গা' বা 'বৃদ্ধ গঙ্গা' বলা হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion84" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG05",
    "question": "ভারতের কোন রাজ্যকে 'ধানের ভাণ্ডার' বা ধান উৎপাদনে প্রথম বলা হয়?",
    "option1": "উত্তর প্রদেশ",
    "option2": "পশ্চিমবঙ্গ",
    "option3": "পাঞ্জাব",
    "option4": "অন্ধ্র প্রদেশ",
    "answer": "option2",
    "solution": "ভারতের মধ্যে পশ্চিমবঙ্গ সর্বাপেক্ষা বেশি পরিমাণ ধান উৎপাদন করে প্রথম স্থানে রয়েছে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion85" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG05",
    "question": "ভারতের প্রাচীনতম কয়লাখনি কোনটি?",
    "option1": "ঝরিয়া",
    "option2": "রাণীগঞ্জ",
    "option3": "বোকারো",
    "option4": "সিংরৌলি",
    "answer": "option2",
    "solution": "পশ্চিমবঙ্গের পশ্চিম বর্ধমান জেলায় অবস্থিত 'রাণীগঞ্জ' কয়লাখনি হলো ভারতের প্রাচীনতম খনি (১৭৭৪ সালে উত্তোলন শুরু)।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion86" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG05",
    "question": "হিমালয় পর্বতমালা ভূমিরূপের দিক থেকে কোন শ্রেণীর পর্বত?",
    "option1": "ক্ষয়জাত পর্বত",
    "option2": "স্তূপ পর্বত",
    "option3": "নবীন ভঙ্গিল পর্বত",
    "option4": "আগ্নেয় পর্বত",
    "answer": "option3",
    "solution": "টেথিস সাগরের পলিমাটি ইউরেশীয় ও ভারতীয় প্লেটের চাপে ভাঁজ হয়ে গঠিত 'নবীন ভঙ্গিল পর্বত' হলো হিমালয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion87" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG05",
    "question": "সিন্ধু নদ ভারতের কেবল একটি কেন্দ্রশাসিত অঞ্চলের মধ্য দিয়ে প্রবাহিত হয়েছে, সেটি কোনটি?",
    "option1": "জম্মু ও কাশ্মীর",
    "option2": "লাদাখ",
    "option3": "হিমাচল প্রদেশ",
    "option4": "চণ্ডীগড়",
    "answer": "option2",
    "solution": "সিন্ধু নদ তিব্বত থেকে উৎপন্ন হয়ে ভারতের কেবল লাদাখ কেন্দ্রশাসিত অঞ্চলের মধ্য দিয়ে প্রবাহিত হয়ে পাকিস্তানে প্রবেশ করেছে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion88" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG05",
    "question": "ভারতের বৃহত্তম খনিজ তেল উত্তোলক কেন্দ্র বা তেলক্ষেত্র কোনটি?",
    "option1": "ডিগবয়",
    "option2": "বম্বে হাই (Bombay High)",
    "option3": "অঙ্কলেশ্বর",
    "option4": "নাহরকাটিয়া",
    "answer": "option2",
    "solution": "মুম্বাই উপকূলে আরব সাগরে অবস্থিত 'বম্বে হাই' ভারতের বৃহত্তম খনিজ তেল উৎপাদন কেন্দ্র।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion89" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG05",
    "question": "ভারতের কোন রাজ্য গমের উৎপাদনে প্রথম স্থান অধিকার করে?",
    "option1": "পাঞ্জাব",
    "option2": "হরিয়ানা",
    "option3": "উত্তর প্রদেশ",
    "option4": "মধ্য প্রদেশ",
    "answer": "option3",
    "solution": "মোট গম উৎপাদনের পরিমাণে উত্তর প্রদেশ ভারতে প্রথম (তবে হেক্টর প্রতি উৎপাদনে পাঞ্জাব শীর্ষ স্থানে)।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion90" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG05",
    "question": "আরাবল্লী পর্বতের সর্বোচ্চ শৃঙ্গের নাম কী?",
    "option1": "গুরুশিখর",
    "option2": "ধূপগড়",
    "option3": "দোদাবেত্তা",
    "option4": "কালসুবাই",
    "answer": "option1",
    "solution": "আরাবল্লী ভারতের প্রাচীনতম ক্ষয়জাত ভঙ্গিল পর্বত, এবং এর সর্বোচ্চ শৃঙ্গ 'গুরুশিখর' (১,৭২২ মিটার)।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion91" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG05",
    "question": "উৎপত্তিস্থলে গঙ্গা নদী কী নামে পরিচিত?",
    "option1": "পদ্মা",
    "option2": "ভাগীরথী",
    "option3": "মেঘনা",
    "option4": "অলকনন্দা",
    "answer": "option2",
    "solution": "গঙ্গোত্রী হিমবাহের গোমুখ গুহা থেকে উৎপত্তির সময় গঙ্গা নদীর নাম 'ভাগীরথী'।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion92" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG05",
    "question": "ঝাড়খণ্ডের 'ঝরিয়া' অঞ্চল কোন খনিজ সম্পদের উত্তোলনের জন্য প্রসিদ্ধ?",
    "option1": "লোহা",
    "option2": "তামা",
    "option3": "কয়লা",
    "option4": "অভ্র",
    "answer": "option3",
    "solution": "ঝাড়খণ্ডের ঝরিয়া ভারতের অন্যতম সমৃদ্ধ উৎকৃষ্ট মানের প্রাইম কোকিং কয়লা উৎপাদক ক্ষেত্র।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion93" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG05",
    "question": "'সোনালী তন্তু' (Golden Fibre) কাকে বলা হয়?",
    "option1": "তুলা",
    "option2": "পাট",
    "option3": "রেশম",
    "option4": "চা",
    "answer": "option2",
    "solution": "অর্থনৈতিক গুরুত্ব এবং সোনালী রঙের জন্য পাটকে 'সোনালী তন্তু' বলা হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion94" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG05",
    "question": "ব্রহ্মপুত্র নদী তিব্বতে কী নামে পরিচিত?",
    "option1": "দিহাং",
    "option2": "সাংপো (Tsangpo)",
    "option3": "যমুনা",
    "option4": "মেঘনা",
    "answer": "option2",
    "solution": "ব্রহ্মপুত্র নদী তিব্বতের চেমায়ুংদুং হিমবাহ থেকে উৎপন্ন হয়ে তিব্বতে 'সাংপো' নামে প্রবাহিত হয়েছে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion95" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG05",
    "question": "ভারতের প্রধান তামা উৎপাদনকারী ক্ষেত্র 'ক্ষেত্রী' (Khetri) কোন রাজ্যে অবস্থিত?",
    "option1": "ঝাড়খণ্ড",
    "option2": "মধ্য প্রদেশ",
    "option3": "রাজস্থান",
    "option4": "ওড়িশা",
    "answer": "option3",
    "solution": "রাজস্থানের ঝুনঝুনু জেলায় অবস্থিত 'ক্ষেত্রী' তামার খনির জন্য বিখ্যাত।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion96" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG05",
    "question": "কোন ধরনের ফসল 'রবি ফসল' (Rabi Crop) এর উদাহরণ?",
    "option1": "ধান",
    "option2": "গম",
    "option3": "পাট",
    "option4": "তুলা",
    "answer": "option2",
    "solution": "শীতকালে রোপণ করা ফসলকে রবি ফসল বলে; যেমন— গম, সরিষা, ছোলা ইত্যাদি।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion97" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG05",
    "question": "পশ্চিমঘাট পর্বতমালার সর্বোচ্চ শৃঙ্গ কোনটি?",
    "option1": "দোদাবেত্তা",
    "option2": "আনাইমুদি",
    "option3": "মহাবালেশ্বর",
    "option4": "গুরুশিখর",
    "answer": "option2",
    "solution": "আনাইমুদি (২,৬৯৫ মিটার) পশ্চিমঘাট পর্বতমালা তথা সমগ্র দক্ষিণ ভারতের সর্বোচ্চ শৃঙ্গ।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion98" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG05",
    "question": "আসামের 'ডিগবয়' কিসের জন্য বিখ্যাত?",
    "option1": "কয়লা খনি",
    "option2": "ভারতের প্রথম খনিজ তেল শোধনাগার ও তেলক্ষেত্র",
    "option3": "লোহা আকরিক",
    "option4": "ইউরেনিয়াম খনি",
    "answer": "option2",
    "solution": "১৯০১ সালে আসামের ডিগবয়ে ভারতের প্রাচীনতম তথা প্রথম খনিজ তেল শোধনাগার চালু হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion99" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG05",
    "question": "কোন নদীকে 'পবিত্রতার দিক থেকে' দক্ষিণ ভারতের গঙ্গা বলে এবং যা বারো মাস জল বহন করে?",
    "option1": "কৃষ্ণা",
    "option2": "নর্মদা",
    "option3": "কাবেরী",
    "option4": "তাপ্তি",
    "answer": "option3",
    "solution": "ধর্মীয় পবিত্রতার জন্য 'কাবেরী' নদীকে দক্ষিণ ভারতের গঙ্গা বলা হয়। এটি বছরের দুবার মৌসুমি বৃষ্টিপাতের ফলে জলপূর্ণ থাকে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion100" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG05",
    "question": "ভারতের উচ্চতম গিরিপথ (Pass) কোনটি?",
    "option1": "নাথু লা",
    "option2": "জোজি লা",
    "option3": "উমলিং লা (Umling La)",
    "option4": "শিপকি লা",
    "answer": "option3",
    "solution": "লাদাখে অবস্থিত উমলিং লা (১৯,০২৪ ফুট) ভারতের তথা বিশ্বের সর্বোচ্চ মোটরযোগ্য সড়ক ও গিরিপথ।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion101" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG06",
    "question": "ভারতীয় সংবিধানের প্রস্তাবনাকে (Preamble) সংবিধানের 'আত্মা' ও 'চাবিকাঠি' বলে কে অভিহিত করেছিলেন?",
    "option1": "ড. বি. আর. আম্বেদকর",
    "option2": "জওহরলাল নেহেরু",
    "option3": "কে. এম. মুন্সী",
    "option4": "স্যার আর্নেস্ট বার্কার",
    "answer": "option1",
    "solution": "ড. বি. আর. আম্বেদকর এবং বহু সংবিধান বিশেষজ্ঞ প্রস্তাবনাকে ভারতীয় সংবিধানের 'আত্মা' (Soul of the Constitution) বলে উল্লেখ করেছেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion102" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG06",
    "question": "কততম সংবিধান সংশোধনীর মাধ্যমে প্রস্তাবনায় 'সমাজতান্ত্রিক' (Socialist), 'ধর্মনিরপেক্ষ' (Secular) এবং 'সংহতি' (Integrity) শব্দগুলি যুক্ত করা হয়?",
    "option1": "৪৪তম সংশোধনী (১৯৭৮)",
    "option2": "৪২তম সংশোধনী (১৯৭৬)",
    "option3": "৮৬তম সংশোধনী (২০০২)",
    "option4": "৭৩তম সংশোধনী (১৯৯২)",
    "answer": "option2",
    "solution": "১৯৭৬ সালের ৪২তম সংবিধান সংশোধনী আইনের মাধ্যমে প্রস্তাবনায় 'Socialist', 'Secular' এবং 'Integrity' শব্দ তিনটি যুক্ত করা হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion103" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG06",
    "question": "ভারতীয় সংবিধানে বর্তমানে মোট কয়টি মৌলিক অধিকার (Fundamental Rights) রয়েছে?",
    "option1": "৭টি",
    "option2": "৬টি",
    "option3": "১১টি",
    "option4": "১০টি",
    "answer": "option2",
    "solution": "মূল সংবিধানে ৭টি মৌলিক অধিকার ছিল, কিন্তু ১৯৭৮ সালের ৪৪তম সংশোধনীর মাধ্যমে সম্পত্তির অধিকার বাদ দেওয়ায় বর্তমানে ৬টি মৌলিক অধিকার রয়েছে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion104" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG06",
    "question": "সংবিধানের কোন অনুচ্ছেদে (Article) 'আইনের চোখে সমতা' (Equality before law) বর্ণিত রয়েছে?",
    "option1": "১৪ নম্বর অনুচ্ছেদ",
    "option2": "১৯ নম্বর অনুচ্ছেদ",
    "option3": "২১ নম্বর অনুচ্ছেদ",
    "option4": "৩২ নম্বর অনুচ্ছেদ",
    "answer": "option1",
    "solution": "১৪ নম্বর অনুচ্ছেদে আইনের চোখে সমতা এবং আইন কর্তৃক সমানভাবে সংরক্ষিত হওয়ার অধিকার সুনিশ্চিত করা হয়েছে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion105" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG06",
    "question": "অস্পৃশ্যতা দূরীকরণ (Abolition of Untouchability) সংবিধানের কত নম্বর অনুচ্ছেদে বলা হয়েছে?",
    "option1": "১৫ নম্বর অনুচ্ছেদ",
    "option2": "১৬ নম্বর অনুচ্ছেদ",
    "option3": "১৭ নম্বর অনুচ্ছেদ",
    "option4": "১৮ নম্বর অনুচ্ছেদ",
    "answer": "option3",
    "solution": "১৭ নম্বর অনুচ্ছেদে অস্পৃশ্যতা বিলুপ্ত করা হয়েছে এবং যেকোনো রূপে এর আচরণকে দণ্ডনীয় অপরাধ বলে ঘোষণা করা হয়েছে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion106" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG06",
    "question": "সংবিধানের ২১A অনুচ্ছেদে শিশুদের কোন মৌলিক অধিকারের কথা বলা হয়েছে?",
    "option1": "শোষণের বিরুদ্ধে অধিকার",
    "option2": "বিনামূল্যে ও বাধ্যতামূলক শিক্ষার অধিকার",
    "option3": "ধর্মীয় স্বাধীনতার অধিকার",
    "option4": "সংস্কৃতি ও শিক্ষার অধিকার",
    "answer": "option2",
    "solution": "২০০২ সালের ৮৬তম সংশোধনীর মাধ্যমে ২১A অনুচ্ছেদে ৬ থেকে ১৪ বছর বয়সি শিশুদের বাধ্যতামূলক ও বিনামূল্যে শিক্ষা মৌলিক অধিকারের অন্তর্ভুক্ত করা হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion107" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG06",
    "question": "ড. বি. আর. আম্বেদকর সংবিধানের কোন অনুচ্ছেদকে 'সংবিধানের হৃদয় ও আত্মা' (Heart and Soul of the Constitution) বলেছেন?",
    "option1": "১৪ নম্বর অনুচ্ছেদ",
    "option2": "১৯ নম্বর অনুচ্ছেদ",
    "option3": "২১ নম্বর অনুচ্ছেদ",
    "option4": "৩২ নম্বর অনুচ্ছেদ",
    "answer": "option4",
    "solution": "৩২ নম্বর অনুচ্ছেদের মাধ্যমে নাগরিকরা মৌলিক অধিকার রক্ষায় সুপ্রিম কোর্টের দ্বারস্থ হতে পারেন, তাই একে 'হৃদয় ও আত্মা' বলা হয়েছে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion108" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG06",
    "question": "সংবিধানের কোন অংশ (Part) এবং অনুচ্ছেদে নির্দেশমূলক নীতি (Directive Principles of State Policy) বর্ণিত রয়েছে?",
    "option1": "Part III (অনুচ্ছেদ ১২-৩৫)",
    "option2": "Part IV (অনুচ্ছেদ ৩৬-৫১)",
    "option3": "Part IVA (অনুচ্ছেদ ৫১A)",
    "option4": "Part V (অনুচ্ছেদ ৫২-১৫১)",
    "answer": "option2",
    "solution": "সংবিধানের Part IV-এর ৩৬ থেকে ৫১ নম্বর অনুচ্ছেদে রাষ্ট্র পরিচালনার নির্দেশমূলক নীতিসমূহ (DPSP) স্থান পেয়েছে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion109" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG06",
    "question": "নির্দেশমূলক নীতিসমূহ (DPSP) কোন দেশের সংবিধান থেকে গৃহীত হয়েছে?",
    "option1": "যুক্তরাষ্ট্র (USA)",
    "option2": "আয়ারল্যান্ড (Ireland)",
    "option3": "যুক্তরাজ্য (UK)",
    "option4": "রাশিয়া (USSR)",
    "answer": "option2",
    "solution": "ভারতীয় সংবিধানে নির্দেশমূলক নীতি ধারণাটি আয়ারল্যান্ডের সংবিধান থেকে নেওয়া হয়েছে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion110" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG06",
    "question": "সংবিধানের কত নম্বর অনুচ্ছেদে 'সমান দেওয়ানি বিধি' (Uniform Civil Code - UCC) এর উল্লেখ রয়েছে?",
    "option1": "৪০ নম্বর অনুচ্ছেদ",
    "option2": "৪৪ নম্বর অনুচ্ছেদ",
    "option3": "৪৮ নম্বর অনুচ্ছেদ",
    "option4": "৫০ নম্বর অনুচ্ছেদ",
    "answer": "option2",
    "solution": "৪৪ নম্বর অনুচ্ছেদে ভারতের সমস্ত নাগরিকের জন্য একই দেওয়ানি বিধি (UCC) চালুর নির্দেশমূলক নীতি দেওয়া হয়েছে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion111" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG06",
    "question": "গ্রাম পঞ্চায়েত গঠন (Organization of Village Panchayats) নির্দেশমূলক নীতির কত নম্বর অনুচ্ছেদে উল্লেখ আছে?",
    "option1": "৩৯ নম্বর অনুচ্ছেদ",
    "option2": "৪০ নম্বর অনুচ্ছেদ",
    "option3": "৪৩ নম্বর অনুচ্ছেদ",
    "option4": "৪৫ নম্বর অনুচ্ছেদ",
    "answer": "option2",
    "solution": "৪০ নম্বর অনুচ্ছেদে স্বায়ত্তশাসিত সংস্থা হিসেবে গ্রাম পঞ্চায়েত গড়ে তোলার জন্য পদক্ষেপ নেওয়ার কথা বলা আছে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion112" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG06",
    "question": "সংবিধানের কোন অনুচ্ছেদে বিচারবিভাগকে শাসনবিভাগ থেকে পৃথক (Separation of Judiciary from Executive) করার কথা বলা হয়েছে?",
    "option1": "৪৫ নম্বর অনুচ্ছেদ",
    "option2": "৪৮ নম্বর অনুচ্ছেদ",
    "option3": "৫০ নম্বর অনুচ্ছেদ",
    "option4": "৫১ নম্বর অনুচ্ছেদ",
    "answer": "option3",
    "solution": "৫০ নম্বর অনুচ্ছেদে রাষ্ট্রের জনসেবায় বিচারবিভাগকে শাসনবিভাগ থেকে স্বাধীন ও পৃথক রাখার নির্দেশ রয়েছে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion113" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG06",
    "question": "বর্তমানে ভারতীয় সংবিধানে মৌলিক কর্তব্যের (Fundamental Duties) সংখ্যা কয়টি?",
    "option1": "৮টি",
    "option2": "১০টি",
    "option3": "১১টি",
    "option4": "১২টি",
    "answer": "option3",
    "solution": "১৯৭৬ সালে ১০টি মৌলিক কর্তব্য যুক্ত করা হয়েছিল; পরবর্তীতে ২০০২ সালের ৮৬তম সংশোধনীর মাধ্যমে আরও ১টি যুক্ত হয়ে মোট সংখ্যা দাঁড়ায় ১১টি।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion114" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG06",
    "question": "মৌলিক কর্তব্য সংবিধানে যুক্ত করার সুপারিশ কোন কমিটির দ্বারা হয়েছিল?",
    "option1": "স্বরণ সিং কমিটি (Swaran Singh Committee)",
    "option2": "ভার্মা কমিটি",
    "option3": "সরকারিয়া কমিশন",
    "option4": "বলবন্ত রায় মেহতা কমিটি",
    "answer": "option1",
    "solution": "১৯৭৬ সালে সরদার স্বরণ সিং কমিটির সুপারিশের ভিত্তিতে ৪২তম সংবিধান সংশোধনীর মাধ্যমে মৌলিক কর্তব্য যুক্ত করা হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion115" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG06",
    "question": "মৌলিক কর্তব্য সংবিধানের কোন অংশে এবং অনুচ্ছেদে রয়েছে?",
    "option1": "Part III, অনুচ্ছেদ ১২",
    "option2": "Part IV, অনুচ্ছেদ ৫১",
    "option3": "Part IVA, অনুচ্ছেদ ৫১A",
    "option4": "Part V, অনুচ্ছেদ ৫২A",
    "answer": "option3",
    "solution": "সংবিধানের IV-A অংশে ৫১A নম্বর অনুচ্ছেদের আওতায় সকল মৌলিক কর্তব্য সন্নিবেশিত।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion116" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG06",
    "question": "মৌলিক অধিকার ধারণাসমূহ কোন দেশের সংবিধান অনুসরণ করে গৃহীত হয়েছে?",
    "option1": "যুক্তরাষ্ট্র (USA)",
    "option2": "ব্রিটেন (UK)",
    "option3": "কানাডা (Canada)",
    "option4": "ফ্রান্স (France)",
    "answer": "option1",
    "solution": "আমেরিকার যুক্তরাষ্ট্রের (USA) 'Bill of Rights' অনুসরণ করে ভারতের সংবিধানে মৌলিক অধিকার যুক্ত করা হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion117" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG06",
    "question": "জরুরি অবস্থা জারিকালে সংবিধানের কোন মৌলিক অধিকারগুলি স্থগিত (Suspend) করা যায় না?",
    "option1": "১৪ ও ১৫ নম্বর অনুচ্ছেদ",
    "option2": "১৯ ও ২০ নম্বর অনুচ্ছেদ",
    "option3": "২০ ও ২১ নম্বর অনুচ্ছেদ",
    "option4": "২২ ও ২৩ নম্বর অনুচ্ছেদ",
    "answer": "option3",
    "solution": "৪৪তম সংশোধনী অনুসারে জাতীয় জরুরি অবস্থার সময়েও অনুচ্ছেদ ২০ (অপরাধের জন্য দণ্ড প্রদান) এবং অনুচ্ছেদ ২১ (জীবন ও ব্যক্তিগত স্বাধীনতার অধিকার) স্থগিত করা যায় না।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion118" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG06",
    "question": "সংবিধানের ২৪ নম্বর অনুচ্ছেদ অনুসারে কত বছরের কম বয়সি শিশুদের ঝুঁকিপূর্ণ কাজে বা কারখানায় নিযুক্ত করা নিষিদ্ধ?",
    "option1": "১২ বছর",
    "option2": "১৪ বছর",
    "option3": "১৬ বছর",
    "option4": "১৮ বছর",
    "answer": "option2",
    "solution": "২৪ নম্বর অনুচ্ছেদে ১৪ বছরের কম বয়সি শিশুদের কারখানা, খনি বা অন্য যেকোনো ঝুঁকিপূর্ণ কাজে নিয়োগ নিষিদ্ধ করা হয়েছে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion119" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG06",
    "question": "মৌলিক অধিকার হনন হলে নাগরিক সরাসরি সুপ্রিম কোর্টে যেতে পারেন কত নম্বর অনুচ্ছেদ অনুযায়ী?",
    "option1": "২২৬ নম্বর অনুচ্ছেদ",
    "option2": "৩২ নম্বর অনুচ্ছেদ",
    "option3": "১৩৬ নম্বর অনুচ্ছেদ",
    "option4": "১৪৩ নম্বর অনুচ্ছেদ",
    "answer": "option2",
    "solution": "৩২ নম্বর অনুচ্ছেদের দ্বারা সুপ্রিম কোর্ট এবং ২২৬ নম্বর অনুচ্ছেদের দ্বারা হাইকোর্ট মৌলিক অধিকার রক্ষায় নির্দেশ/লেখ (Writ) জারি করতে পারে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion120" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG06",
    "question": "কোন অধিকারকে ১৯৭৮ সালের ৪৪তম সংবিধান সংশোধনীর মাধ্যমে মৌলিক অধিকার থেকে বাদ দিয়ে আইনি অধিকারে (Legal Right) পরিণত করা হয়েছে?",
    "option1": "স্বাধীনতার অধিকার",
    "option2": "শোষণের বিরুদ্ধে অধিকার",
    "option3": "সম্পত্তির অধিকার",
    "option4": "ধর্মীয় স্বাধীনতার অধিকার",
    "answer": "option3",
    "solution": "সম্পত্তির অধিকারকে অনুচ্ছেদ ৩১ থেকে বাদ দিয়ে বর্তমানে ৩০০০A নম্বর অনুচ্ছেদে একটি সাধারণ আইনি অধিকার (Legal Right) হিসেবে রাখা হয়েছে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion121" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG07",
    "question": "ভারতের সাংবিধানিক প্রধান বা নামসর্বস্ব প্রধান কে?",
    "option1": "প্রধানমন্ত্রী",
    "option2": "রাষ্ট্রপতি",
    "option3": "উপরাষ্ট্রপতি",
    "option4": "প্রধান বিচারপতি",
    "answer": "option2",
    "solution": "ভারতের রাষ্ট্রপতি হলেন রাষ্ট্রের সাংবিধানিক বা নামসর্বস্ব প্রধান (De jure head), তবে প্রকৃত শাসনক্ষমতা থাকে প্রধানমন্ত্রীর নেতৃত্বাধীন মন্ত্রীপরিষদের হাতে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion122" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG07",
    "question": "ভারতের রাষ্ট্রপতিকে পদচ্যুত করার পদ্ধতিকে (Impeachment) সংবিধানের কত নম্বর অনুচ্ছেদে বর্ণিত করা হয়েছে?",
    "option1": "৫২ নম্বর অনুচ্ছেদ",
    "option2": "৫৪ নম্বর অনুচ্ছেদ",
    "option3": "৬১ নম্বর অনুচ্ছেদ",
    "option4": "৭২ নম্বর অনুচ্ছেদ",
    "answer": "option3",
    "solution": "সংবিধান লঙ্ঘনের অভিযোগে অনুচ্ছেদ ৬১ অনুযায়ী সংসদের যেকোনো কক্ষে রাষ্ট্রপতির ইমপিচমেন্ট প্রস্তাব আনা যায়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion123" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG07",
    "question": "লোকসভার সভাপতিত্ব কে করেন?",
    "option1": "রাষ্ট্রপতি",
    "option2": "উপরাষ্ট্রপতি",
    "option3": "স্পিকার (অধ্যক্ষ)",
    "option4": "প্রধানমন্ত্রী",
    "answer": "option3",
    "solution": "লোকসভার অধিবেশন পরিচালনা ও সভাপতিত্ব করেন লোকসভার স্পিকার (অধ্যক্ষ)।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion124" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG07",
    "question": "রাজ্যসভার পদাধিকারবলে সভাপতি (Ex-officio Chairman) কে হন?",
    "option1": "রাষ্ট্রপতি",
    "option2": "উপরাষ্ট্রপতি",
    "option3": "প্রধানমন্ত্রী",
    "option4": "স্পিকার",
    "answer": "option2",
    "solution": "সংবিধানের ৬৪ নম্বর অনুচ্ছেদ অনুযায়ী ভারতের উপরাষ্ট্রপতি পদাধিকারবলে রাজ্যসভার সভাপতি হন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion125" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG07",
    "question": "ভারতের অর্থবিল (Money Bill) কেবল সংসেদের কোন কক্ষে প্রথম পেশ করা যায়?",
    "option1": "রাজ্যসভায়",
    "option2": "লোকসভায়",
    "option3": "যেকোনো কক্ষে",
    "option4": "যৌথ অধিবেশনে",
    "answer": "option2",
    "solution": "অর্থবিল কেবল লোকসভায় উত্থাপন করা যায়। রাজ্যসভা অর্থবিল সর্বোচ্চ ১৪ দিন আটকে রাখতে পারে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion126" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG07",
    "question": "কোনো বিল অর্থবিল (Money Bill) কি না, সে বিষয়ে চূড়ান্ত সিদ্ধান্ত কে নেন?",
    "option1": "রাষ্ট্রপতি",
    "option2": "প্রধানমন্ত্রী",
    "option3": "অর্থমন্ত্রী",
    "option4": "লোকসভার স্পিকার",
    "answer": "option4",
    "solution": "অনুচ্ছেদ ১১০(৩) অনুযায়ী কোনো বিল অর্থবিল কি না, সে বিষয়ে লোকসভার স্পিকারের সিদ্ধান্তই চূড়ান্ত।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion127" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG07",
    "question": "সংসদের দুটি কক্ষের যৌথ অধিবেশনে (Joint Sitting) কে সভাপতিত্ব করেন?",
    "option1": "রাষ্ট্রপতি",
    "option2": "উপরাষ্ট্রপতি",
    "option3": "লোকসভার স্পিকার",
    "option4": "প্রধানমন্ত্রী",
    "answer": "option3",
    "solution": "অনুচ্ছেদ ১০৮ অনুযায়ী রাষ্ট্রপতি যৌথ অধিবেশন আহ্বান করেন, তবে সভাপতিত্ব করেন লোকসভার স্পিকার।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion128" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG07",
    "question": "সুপ্রিম কোর্টের প্রধান বিচারপতি ও অন্যান্য বিচারপতিদের কে নিযুক্ত করেন?",
    "option1": "প্রধানমন্ত্রী",
    "option2": "রাষ্ট্রপতি",
    "option3": "আইনমন্ত্রী",
    "option4": "সংসদ",
    "answer": "option2",
    "solution": "সংবিধানের ১২৪(২) অনুচ্ছেদ অনুযায়ী ভারতের রাষ্ট্রপতি সুপ্রিম কোর্টের বিচারপতিদের নিয়োগ করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion129" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG07",
    "question": "সুপ্রিম কোর্টের বিচারপতিদের অবসর গ্রহণের বয়স কত?",
    "option1": "৬০ বছর",
    "option2": "৬২ বছর",
    "option3": "৬৫ বছর",
    "option4": "৭০ বছর",
    "answer": "option3",
    "solution": "সুপ্রিম কোর্টের বিচারপতিরা ৬৫ বছর বয়সে এবং হাইকোর্টের বিচারপতিরা ৬২ বছর বয়সে অবসর নেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion130" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG07",
    "question": "ভারতের অ্যাটর্নি জেনারেল (Attorney General) কে নিযুক্ত করেন?",
    "option1": "প্রধানমন্ত্রী",
    "option2": "রাষ্ট্রপতি",
    "option3": "সুপ্রিম কোর্টের প্রধান বিচারপতি",
    "option4": "আইন কমিশন",
    "answer": "option2",
    "solution": "অনুচ্ছেদ ৭৬ অনুযায়ী রাষ্ট্রপতি ভারতের সর্বোচ্চ আইন কর্মকর্তা বা অ্যাটর্নি জেনারেলকে নিয়োগ করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion131" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG07",
    "question": "কেন্দ্রীয় মন্ত্রীপরিষদ যৌথভাবে (Collectively Responsible) কার কাছে দায়বদ্ধ থাকে?",
    "option1": "রাষ্ট্রপতি",
    "option2": "প্রধানমন্ত্রী",
    "option3": "লোকসভা",
    "option4": "সংসদের যৌথ অধিবেশন",
    "answer": "option3",
    "solution": "সংবিধানের ৭৫(৩) অনুচ্ছেদ অনুযায়ী কেন্দ্রীয় মন্ত্রীপরিষদ যৌথভাবে লোকসভার নিকট জবাবদিহি করতে বাধ্য থাকে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion132" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG07",
    "question": "রাষ্ট্রপতি কতজন সদস্যকে রাজ্যসভায় মনোনীত করতে পারেন?",
    "option1": "২ জন",
    "option2": "১০ জন",
    "option3": "১২ জন",
    "option4": "১৪ জন",
    "answer": "option3",
    "solution": "সাহিত্য, বিজ্ঞান, কলা ও সমাজসেবায় বিশেষ অবদানের জন্য রাষ্ট্রপতি রাজ্যসভায় ১২ জন সদস্যকে মনোনীত করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion133" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG07",
    "question": "রাজ্যসভা একটি স্থায়ী কক্ষ। এর সদস্যদের কার্যকালের মেয়াদ কত বছর?",
    "option1": "৪ বছর",
    "option2": "৫ বছর",
    "option3": "৬ বছর",
    "option4": "স্থায়ী, কোনো নির্দিষ্ট মেয়াদ নেই",
    "answer": "option3",
    "solution": "রাজ্যসভা কখনো ভেঙে দেওয়া যায় না। এর সদস্যদের কার্যকাল ৬ বছর এবং প্রতি ২ বছর অন্তর ১/৩ অংশ সদস্য অবসর নেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion134" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG07",
    "question": "রাষ্ট্রপতি পদে প্রতিদ্বন্দ্বিতা করার জন্য ন্যূনতম কত বছর বয়স হওয়া প্রয়োজন?",
    "option1": "২৫ বছর",
    "option2": "৩০ বছর",
    "option3": "৩৫ বছর",
    "option4": "৪০ বছর",
    "answer": "option3",
    "solution": "রাষ্ট্রপতি ও উপরাষ্ট্রপতি পদে নির্বাচিত হতে ন্যূনতম ৩৫ বছর বয়স হতে হয় (লোকসভার ক্ষেত্রে ২৫ বছর ও রাজ্যসভার ক্ষেত্রে ৩০ বছর)।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion135" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG07",
    "question": "কোনো অধ্যাদেশ (Ordinance) জারি করার ক্ষমতা রাষ্ট্রপতির সংবিধানের কত নম্বর অনুচ্ছেদে রয়েছে?",
    "option1": "১১২ নম্বর অনুচ্ছেদ",
    "option2": "১২৩ নম্বর অনুচ্ছেদ",
    "option3": "১৪৩ নম্বর অনুচ্ছেদ",
    "option4": "২১৩ নম্বর অনুচ্ছেদ",
    "answer": "option2",
    "solution": "সংসদের অধিবেশন বন্ধ থাকাকালীন জরুরি প্রয়োজনে রাষ্ট্রপতি ১২৩ নম্বর অনুচ্ছেদ অনুযায়ী অর্ডিন্যান্স জারি করতে পারেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion136" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG06",
    "question": "ভারতের সর্বোচ্চ আদালত কোনটি, যা সংবিধানের অভিভাবক হিসেবে কাজ করে?",
    "option1": "হাইকোর্ট",
    "option2": "সুপ্রিম কোর্ট",
    "option3": "সংসদ",
    "option4": "আইন কমিশন",
    "answer": "option2",
    "solution": "সুপ্রিম কোর্ট হলো ভারতের বিচারব্যবস্থার শীর্ষ আদালত এবং মৌলিক অধিকার ও সংবিধানের চূড়ান্ত রক্ষক ও ব্যাখ্যা কর্তা।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion137" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG07",
    "question": "ভারতের নিয়ন্ত্রণ ও মহাগণনা পরীক্ষক (CAG)-কে কে নিযুক্ত করেন?",
    "option1": "প্রধানমন্ত্রী",
    "option2": "লোকসভার স্পিকার",
    "option3": "রাষ্ট্রপতি",
    "option4": "অর্থমন্ত্রী",
    "answer": "option3",
    "solution": "সংবিধানের ১৪৮ অনুচ্ছেদ অনুযায়ী রাষ্ট্রপতি CAG (Comptroller and Auditor General) নিয়োগ করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion138" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG07",
    "question": "জরুরি অবস্থা (National Emergency) জারি করার ক্ষমতা সংবিধানের কত নম্বর অনুচ্ছেদে রাষ্ট্রপতিকে দেওয়া হয়েছে?",
    "option1": "৩৫২ নম্বর অনুচ্ছেদ",
    "option2": "৩৫৬ নম্বর অনুচ্ছেদ",
    "option3": "৩৬০ নম্বর অনুচ্ছেদ",
    "option4": "৩৬৮ নম্বর অনুচ্ছেদ",
    "answer": "option1",
    "solution": "৩৫২ (জাতীয় জরুরি অবস্থা), ৩৫৬ (রাজ্যে রাষ্ট্রপতি শাসন) এবং ৩৬০ (আর্থিক জরুরি অবস্থা)।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion139" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG07",
    "question": "ভারতের সশস্ত্র বাহিনীর (Army, Navy, Air Force) সর্বাধিনায়ক (Supreme Commander) কে?",
    "option1": "প্রধান সেনাপতি (CDS)",
    "option2": "প্রধানমন্ত্রী",
    "option3": "প্রতিরক্ষামন্ত্রী",
    "option4": "রাষ্ট্রপতি",
    "answer": "option4",
    "solution": "সংবিধানের ৫৩(২) অনুচ্ছেদ অনুযায়ী রাষ্ট্রপতি ভারতের তিন বাহিনীর সর্বাধিনায়ক।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion140" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG07",
    "question": "স্বাধীন ভারতের প্রথম উপরাষ্ট্রপতি ও রাজ্যসভার প্রথম সভাপতি কে ছিলেন?",
    "option1": "ড. রাজেন্দ্র প্রসাদ",
    "option2": "ড. সর্বপল্লী রাধাকৃষ্ণন",
    "option3": "জহুরলাল নেহেরু",
    "option4": "সরদার বল্লভভাই প্যাটেল",
    "answer": "option2",
    "solution": "ড. সর্বপল্লী রাধাকৃষ্ণন ছিলেন ভারতের প্রথম উপরাষ্ট্রপতি এবং সেই সূত্রে রাজ্যসভার প্রথম সভাপতি।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion141" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG08",
    "question": "পশ্চিমবঙ্গের ত্রিস্তর পঞ্চায়েত ব্যবস্থার সর্বনিম্ন বা প্রথম স্তর কোনটি?",
    "option1": "পঞ্চায়েত সমিতি",
    "option2": "গ্রাম পঞ্চায়েত",
    "option3": "জেলা পরিষদ",
    "option4": "গ্রাম সভা",
    "answer": "option2",
    "solution": "পশ্চিমবঙ্গের ত্রিস্তর পঞ্চায়েত ব্যবস্থার সর্বনিম্ন স্তর হলো গ্রাম পঞ্চায়েত, মধ্যবর্তী স্তর পঞ্চায়েত সমিতি এবং শীর্ষ স্তর হলো জেলা পরিষদ।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion142" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG08",
    "question": "পশ্চিমবঙ্গ পঞ্চায়েত আইন কত সালে পাস হয়েছিল?",
    "option1": "১৯৫৭ সালে",
    "option2": "১৯৭৩ সালে",
    "option3": "১৯৭৮ সালে",
    "option4": "১৯৯২ সালে",
    "answer": "option2",
    "solution": "পশ্চিমবঙ্গ পঞ্চায়েত আইন ১৯৭৩ সালে পাস হয় এবং এই আইনের ভিত্তিতেই রাজ্যটিতে বর্তমান ত্রিস্তর পঞ্চায়েত কাঠামো গড়ে উঠেছে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion143" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG08",
    "question": "পশ্চিমবঙ্গে পাস হওয়া ১৯৭৩ সালের পঞ্চায়েত আইনের ভিত্তিতে প্রথম নির্বাচন কত সালে অনুষ্ঠিত হয়?",
    "option1": "১৯৭৩ সালে",
    "option2": "১৯৭৫ সালে",
    "option3": "১৯৭৮ সালে",
    "option4": "১৯৮২ সালে",
    "answer": "option3",
    "solution": "১৯৭৮ সালে পশ্চিমবঙ্গে ১৯৭৩ সালের আইন অনুযায়ী প্রথম গণতান্ত্রিক ত্রিস্তর পঞ্চায়েত নির্বাচন অনুষ্ঠিত হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion144" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG08",
    "question": "ভারতের সংবিধানে কততম সংশোধনীর মাধ্যমে পঞ্চায়েতি রাজ ব্যবস্থাকে সাংবিধানিক স্বীকৃতি দেওয়া হয়?",
    "option1": "৪২তম সংশোধনী",
    "option2": "৪৪তম সংশোধনী",
    "option3": "৭৩তম সংশোধনী",
    "option4": "৭৪তম সংশোধনী",
    "answer": "option3",
    "solution": "১৯৯২ সালের ৭৩তম সংবিধান সংশোধনীর মাধ্যমে ভারতীয় সংবিধানে পঞ্চায়েতি রাজ ব্যবস্থাকে সাংবিধানিক মর্যাদা দেওয়া হয় (Part IX)।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion145" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG08",
    "question": "গ্রাম পঞ্চায়েতের প্রশাসনিক প্রধান বা রাজনৈতিক কার্যনির্বাহী প্রধান কে?",
    "option1": "বি.ডি.ও (BDO)",
    "option2": "প্রধান",
    "option3": "সভাপতি",
    "option4": "সবাপতি",
    "answer": "option2",
    "solution": "গ্রাম পঞ্চায়েতের নির্বাচিত সদস্যদের মধ্য থেকে একজন 'প্রধান' নির্বাচিত হন, যিনি গ্রাম পঞ্চায়েতের প্রশাসনিক প্রধান হিসেবে দায়িত্ব পালন করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion146" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG08",
    "question": "ব্লক বা সমষ্টি উন্নয়ন পর্যায়ে অবস্থিত পঞ্চায়েত ব্যবস্থার দ্বিতীয় বা মধ্যবর্তী স্তরটির নাম কী?",
    "option1": "গ্রাম পঞ্চায়েত",
    "option2": "পঞ্চায়েত সমিতি",
    "option3": "জেলা পরিষদ",
    "option4": "আঞ্চলিক পরিষদ",
    "answer": "option2",
    "solution": "ব্লক বা সমষ্টি উন্নয়ন স্তরে পঞ্চায়েত ব্যবস্থার মধ্যবর্তী স্তর হিসেবে 'পঞ্চায়েত সমিতি' কাজ করে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion147" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG08",
    "question": "পঞ্চায়েত সমিতির পদাধিকারবলে এক্সিকিউটিভ অফিসার বা প্রধান পদস্থ সরকারি আধিকারিক কে হন?",
    "option1": "মহকুমা শাসক (SDO)",
    "option2": "জেলা শাসক (DM)",
    "option3": "ব্লক উন্নয়ন আধিকারিক (BDO)",
    "option4": "সভাধিপতি",
    "answer": "option3",
    "solution": "ব্লক ডেভেলপমেন্ট অফিসার (BDO) পদাধিকারবলে সংশ্লিষ্ট পঞ্চায়েত সমিতির প্রধান কার্যনির্বাহী আধিকারিক (Executive Officer) হিসেবে কাজ করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion148" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG08",
    "question": "পশ্চিমবঙ্গের পঞ্চায়েত ব্যবস্থার সর্বোচ্চ বা শীর্ষ স্তরের নাম কী?",
    "option1": "জেলা পরিষদ",
    "option2": "মহকুমা পরিষদ",
    "option3": "পঞ্চায়েত সমিতি",
    "option4": "জেলা সংসদ",
    "answer": "option1",
    "solution": "জেলা স্তরে অবস্থিত পঞ্চায়েত ব্যবস্থার সর্বোচ্চ বা শীর্ষ স্তরকে 'জেলা পরিষদ' বলা হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion149" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG08",
    "question": "জেলা পরিষদের রাজনৈতিক প্রধান বা নির্বাচিত প্রধান কর্মকর্তা কে?",
    "option1": "জেলা শাসক (DM)",
    "option2": "সভাধিপতি",
    "option3": "সভাপতি",
    "option4": "সহ-সভাধিপতি",
    "answer": "option2",
    "solution": "জেলা পরিষদের নির্বাচিত সদস্যদের মধ্য থেকে নির্বাচিত 'সভাধিপতি' হলেন জেলা পরিষদের প্রধান।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion150" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG08",
    "question": "জেলা পরিষদের পদাধিকারবলে এক্সিকিউটিভ অফিসার (Executive Officer) হিসেবে কে দায়িত্ব পালন করেন?",
    "option1": "সভাধিপতি",
    "option2": "জেলা শাসক (District Magistrate)",
    "option3": "মহকুমা শাসক (SDO)",
    "option4": "বি.ডি.ও (BDO)",
    "answer": "option2",
    "solution": "সংশ্লিষ্ট জেলার জেলা শাসক (DM) পদাধিকারবলে জেলা পরিষদের মুখ্য কার্যনির্বাহী আধিকারিক (Executive Officer) হিসেবে দায়িত্ব পালন করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion151" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG08",
    "question": "পশ্চিমবঙ্গের কোণ জেলা বা অঞ্চলে জেলা পরিষদের পরিবর্তে 'মহকুমা পরিষদ' কার্যকর রয়েছে?",
    "option1": "কালিম্পং",
    "option2": "দার্জিলিং (শিলিগুড়ি মহকুমা)",
    "option3": "আলিপুরদুয়ার",
    "option4": "পশ্চিম মেদিনীপুর",
    "answer": "option2",
    "solution": "দার্জিলিং পার্বত্য পরিষদের বিশেষ ব্যবস্থার কারণে শিলিগুড়ি মহকুমার জন্য জেলা পরিষদের পরিবর্তে 'শিলিগুড়ি মহকুমা পরিষদ' গঠিত হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion152" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG08",
    "question": "সাধারণত পঞ্চায়েতের বিভিন্ন স্তরের নির্বাচিত সদস্যদের কার্যকালের মেয়াদ কত বছর?",
    "option1": "৪ বছর",
    "option2": "৫ বছর",
    "option3": "৬ বছর",
    "option4": "৩ বছর",
    "answer": "option2",
    "solution": "সংবিধানের ৭৩তম সংশোধনী অনুযায়ী পঞ্চায়েতের সকল স্তরের নির্বাচিত সদস্যদের সাধারণ কার্যকালের মেয়াদ ৫ বছর।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion153" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG08",
    "question": "পঞ্চায়েত নির্বাচনে প্রতিদ্বন্দ্বিতা করার জন্য প্রার্থীর ন্যূনতম কত বছর বয়স হতে হয়?",
    "option1": "১৮ বছর",
    "option2": "২১ বছর",
    "option3": "২৫ বছর",
    "option4": "৩০ বছর",
    "answer": "option2",
    "solution": "ভোট দেওয়ার ন্যূনতম বয়স ১৮ বছর হলেও পঞ্চায়েত নির্বাচনে প্রার্থী হিসেবে প্রতিদ্বন্দ্বিতা করতে ন্যূনতম ২১ বছর বয়স হওয়া প্রয়োজন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion154" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG08",
    "question": "গ্রাম পঞ্চায়েত এলাকার ভোটারদের নিয়ে গঠিত সর্বজনীন সংস্থাকে কী বলা হয়?",
    "option1": "গ্রাম সংসদ",
    "option2": "গ্রাম সভা",
    "option3": "ন্যায় পঞ্চায়েত",
    "option4": "ব্লক সভা",
    "answer": "option2",
    "solution": "একটি গ্রাম পঞ্চায়েত এলাকার সমস্ত নিবন্ধিত ভোটারদের নিয়ে 'গ্রাম সভা' গঠিত হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion155" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG08",
    "question": "পশ্চিমবঙ্গে প্রতিটি বুথ বা নির্বাচকমণ্ডলীর নিবন্ধিত ভোটারদের নিয়ে গঠিত সংস্থাকে কী বলা হয়?",
    "option1": "গ্রাম সভা",
    "option2": "গ্রাম সংসদ",
    "option3": "আঞ্চলিক সভা",
    "option4": "পঞ্চায়েত সমিতি",
    "answer": "option2",
    "solution": "১৯৯৪ সালের আইন সংশোধনীর মাধ্যমে গ্রাম পঞ্চায়েতের প্রতিটি নির্বাচনী আসনে (বুথ স্তরে) নিবন্ধিত ভোটারদের নিয়ে 'গ্রাম সংসদ' গঠিত হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion156" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG08",
    "question": "সংবিধানের কোন তপশিলে (Schedule) পঞ্চায়েতের কার্যাবলী ও ২৯টি বিষয় অন্তর্ভুক্ত করা হয়েছে?",
    "option1": "নবম তপশিল",
    "option2": "দশম তপশিল",
    "option3": "একাদশ তপশিল (11th Schedule)",
    "option4": "দ্বাদশ তপশিল (12th Schedule)",
    "answer": "option3",
    "solution": "১৯৯২ সালের ৭৩তম সংবিধান সংশোধনীর মাধ্যমে একাদশ তপশিল যুক্ত করে পঞ্চায়েতের আওতায় ২৯টি বিষয়ের উল্লেখ করা হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion157" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG08",
    "question": "পশ্চিমবঙ্গে পঞ্চায়েতের স্থানীয় নির্বাচন পরিচালনার দায়িত্ব কার ওপর ন্যস্ত থাকে?",
    "option1": "ভারতের নির্বাচন কমিশন",
    "option2": "রাজ্য নির্বাচন কমিশন (State Election Commission)",
    "option3": "রাজ্যপাল",
    "option4": "পঞ্চায়েত ও গ্রামোন্নয়ন বিভাগ",
    "answer": "option2",
    "solution": "সংবিধানের ২৪৩K অনুচ্ছেদ অনুসারে রাজ্যের পঞ্চায়েত ও পৌরসভা নির্বাচন পরিচালনা করে 'রাজ্য নির্বাচন কমিশন'।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion158" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG08",
    "question": "ভারতে গণতান্ত্রিক বিকেন্দ্রীকরণ এবং ত্রিস্তর পঞ্চায়েত ব্যবস্থার সুপারিশ কোন কমিটি প্রথম করেছিল?",
    "option1": "অশোক মেহতা কমিটি",
    "option2": "বলবন্ত রাই মেহতা কমিটি",
    "option3": "এল. এম. সিংভি কমিটি",
    "option4": "জি. ভি. কে. রাও কমিটি",
    "answer": "option2",
    "solution": "১৯৫৭ সালে গঠিত বলবন্ত রাই মেহতা কমিটি ভারতে প্রথম ত্রিস্তর বিশিষ্ট পঞ্চায়েতি রাজ ব্যবস্থার সুপারিশ করে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion159" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG08",
    "question": "পশ্চিমবঙ্গের পঞ্চায়েতি রাজ সংস্থায় মহিলাদের জন্য বর্তমানে কত শতাংশ আসন সংরক্ষিত?",
    "option1": "৩৩%",
    "option2": "৫০%",
    "option3": "৪০%",
    "option4": "৩০%",
    "answer": "option2",
    "solution": "পশ্চিমবঙ্গে পঞ্চায়েতের সমস্ত স্তরে মহিলাদের জন্য আসন সংরক্ষণ ৫০ শতাংশ করা হয়েছে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion160" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG08",
    "question": "গ্রাম পঞ্চায়েতের সভায় কে সভাপতিত্ব করেন?",
    "option1": "বি.ডি.ও (BDO)",
    "option2": "উপ-প্রধান",
    "option3": "প্রধান",
    "option4": "পঞ্চায়েত সচিব",
    "answer": "option3",
    "solution": "গ্রাম পঞ্চায়েতের সাধারণ ও বিশেষ সকল বৈঠকে সভাপতিত্ব করেন নির্বাচিত গ্রাম পঞ্চায়েত প্রধান (তাঁর অনুপস্থিতিতে উপ-প্রধান)।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion161" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG09",
    "question": "শূন্যস্থানে আলোর বেগ কত?",
    "option1": "3 × 10^8 m/s",
    "option2": "3 × 10^5 m/s",
    "option3": "332 m/s",
    "option4": "1.5 × 10^8 m/s",
    "answer": "option1",
    "solution": "শূন্যস্থানে বা বায়ুতে আলোর বেগ সবচেয়ে বেশি, যা প্রায় ৩ × ১০^৮ মিটার/সেকেন্ড (বা ৩ লক্ষ কিমি/সেকেন্ড)।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion162" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG09",
    "question": "মরীচিকা (Mirage) সৃষ্টির মূল কারণ আলোর কোন প্রাকৃতিক ঘটনা?",
    "option1": "প্রতিফলন",
    "option2": "প্রতিসরণ",
    "option3": "অভ্যন্তরীণ পূর্ণ প্রতিফলন",
    "option4": "বিক্ষিপণ",
    "answer": "option3",
    "solution": "মরুভূমিতে বায়ুমণ্ডলের ঘনত্বের তারতম্যের কারণে আলোর 'অভ্যন্তরীণ পূর্ণ প্রতিফলন' (Total Internal Reflection)-এর ফলে মরীচিকা সৃষ্টি হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion163" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG09",
    "question": "শব্দ তরঙ্গ কোন ধরনের তরঙ্গ?",
    "option1": "অনুপ্রস্থ তরঙ্গ",
    "option2": "অনুদৈর্ঘ্য যান্ত্রিক তরঙ্গ",
    "option3": "তড়িৎচৌম্বকীয় তরঙ্গ",
    "option4": "বেতার তরঙ্গ",
    "answer": "option2",
    "solution": "শব্দ হলো এক প্রকার অনুদৈর্ঘ্য স্থিতিস্থাপক বা যান্ত্রিক তরঙ্গ, যা চলাচলের জন্য জড় মাধ্যমের প্রয়োজন হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion164" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG09",
    "question": "মানুষের কান কত কম্পাঙ্কের (Frequency) শব্দ শুনতে পায় (শ্রাব্য শব্দ)?",
    "option1": "20 Hz এর কম",
    "option2": "20 Hz থেকে 20,000 Hz",
    "option3": "20,000 Hz এর বেশি",
    "option4": "50,000 Hz এর বেশি",
    "answer": "option2",
    "solution": "মানুষের শ্রবণযোগ্য শব্দের কম্পাঙ্কের সীমা হলো ২০ হার্টজ (Hz) থেকে ২০,০০০ হার্টজ (20 kHz)।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion165" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG09",
    "question": "SI পদ্ধতিতে তাপমাত্রার (Temperature) একক কী?",
    "option1": "কেলভিন (K)",
    "option2": "সেলসিয়াস (°C)",
    "option3": "ফারেনহাইট (°F)",
    "option4": "ক্যালোরি",
    "answer": "option1",
    "solution": "আন্তর্জাতিক একক পদ্ধতিতে (SI) তাপমাত্রার মৌলিক একক হলো 'কেলভিন' (Kelvin)।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion166" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG09",
    "question": "উষ্ণতা বৃদ্ধির সাথে সাথে তরলে শব্দের বেগের কী পরিবর্তন ঘটে?",
    "option1": "হ্রাস পায়",
    "option2": "বৃদ্ধি পায়",
    "option3": "একই থাকে",
    "option4": "প্রথম বাড়ে পরে কমে",
    "answer": "option2",
    "solution": "সাধারণত মাধ্যম বা তরলের তাপমাত্রা বৃদ্ধি পেলে স্থিতিস্থাপকতা ও ঘনত্বের পরিবর্তনের ফলে শব্দের বেগ বৃদ্ধি পায়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion167" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG09",
    "question": "তড়িৎ প্রবাহমাত্রার (Electric Current) SI একক কী?",
    "option1": "ভোল্ট (Volt)",
    "option2": "অ্যাম্পিয়ার (Ampere)",
    "option3": "ওহম (Ohm)",
    "option4": "কুলম্ব (Coulomb)",
    "answer": "option2",
    "solution": "তড়িৎ প্রবাহমাত্রার SI একক হলো 'অ্যাম্পিয়ার' (A)। ওহম হলো রোধের একক এবং ভোল্ট হলো বিভব প্রভেদের একক।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion168" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG09",
    "question": "তড়িৎ রোধের (Electrical Resistance) একক কোনটি?",
    "option1": "ওহম (Ohm)",
    "option2": "ওয়াট (Watt)",
    "option3": "জুল (Joule)",
    "option4": "ফার্যাড (Farad)",
    "answer": "option1",
    "solution": "পরিভাষায় পরিবাহীর প্রবাহে বাধা দেওয়ার ধর্মকে রোধ বলে এবং এর SI একক হলো ওহম (Ω)।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion169" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG09",
    "question": "খাবারের লবণের (Common Salt) রাসায়নিক নাম ও সংকেত কী?",
    "option1": "সোডিয়াম কার্বোনেট (Na2CO3)",
    "option2": "সোডিয়াম ক্লোরাইড (NaCl)",
    "option3": "পটাশিয়াম ক্লোরাইড (KCl)",
    "option4": "ক্যালসিয়াম কার্বোনেট (CaCO3)",
    "answer": "option2",
    "solution": "সাধারণ খাবার লবণের রাসায়নিক নাম হলো সোডিয়াম ক্লোরাইড এবং এর সংকেত NaCl।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion170" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG09",
    "question": "বেকিং সোডা বা খাবার সোডার রাসায়নিক সংকেত কোনটি?",
    "option1": "Na2CO3",
    "option2": "NaHCO3",
    "option3": "NaOH",
    "option4": "Ca(OH)2",
    "answer": "option2",
    "solution": "খাবার সোডার রাসায়নিক নাম সোডিয়াম বাইকার্বোনেট এবং এর সংকেত NaHCO3।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion171" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG09",
    "question": "গাড়ির পেছনের দৃশ্য দেখার জন্য (Rear View Mirror) কোন ধরণের দর্পণ ব্যবহার করা হয়?",
    "option1": "উত্তল দর্পণ (Convex Mirror)",
    "option2": "অবতল দর্পণ (Concave Mirror)",
    "option3": "সমতল দর্পণ (Plain Mirror)",
    "option4": "বেলনাকার দর্পণ",
    "answer": "option1",
    "solution": "উত্তল দর্পণ বিস্তৃত এলাকার সোজা ও খর্বকায় প্রতিবিম্ব গঠন করে বলে যানবাহনের রেয়ার ভিউ মিরর হিসেবে ব্যবহৃত হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion172" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG09",
    "question": "শব্দ তরঙ্গ নিচের কোন মাধ্যমের মধ্য দিয়ে যেতে পারে না?",
    "option1": "কঠিন মাধ্যম",
    "option2": "তরল মাধ্যম",
    "option3": "গ্যাসীয় মাধ্যম",
    "option4": "শূন্য মাধ্যম (Vacuum)",
    "answer": "option4",
    "solution": "শব্দ যান্ত্রিক তরঙ্গ হওয়ায় এটি সঞ্চালনের জন্য মাধ্যমের প্রয়োজন, তাই শূন্য মাধ্যমে শব্দ চলাচল করতে পারে না।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion173" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG09",
    "question": "থার্মোমিটারে তাপমাত্রা পরিমাপের জন্য তরল হিসেবে কোনটি ব্যবহৃত হয়?",
    "option1": "জল",
    "option2": "অ্যালকোহল",
    "option3": "পারদ (Mercury)",
    "option4": "এসিড",
    "answer": "option3",
    "solution": "পারদ হলো একটি তরল ধাতু যার তাপ সুপরিবাহিতা ভালো এবং এটি কাঁচের গায়ে লেগে থাকে না, তাই থার্মোমিটারে পারদ ব্যবহৃত হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion174" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG09",
    "question": "বৈদ্যুতিক ফিউজ তার (Fuse Wire) সংকর ধাতুর তৈরি, এর বৈশিষ্ট্য কী হওয়া উচিত?",
    "option1": "উচ্চ গলনাঙ্ক ও উচ্চ রোধ",
    "option2": "নিম্ন গলনাঙ্ক ও উচ্চ রোধ",
    "option3": "নিম্ন গলনাঙ্ক ও নিম্ন রোধ",
    "option4": "উচ্চ গলনাঙ্ক ও নিম্ন রোধ",
    "answer": "option2",
    "solution": "ফিউজ তার সিসা ও টিনের সংকর ধাতু দিয়ে তৈরি হয়। এর রোধ উচ্চ এবং গলনাঙ্ক কম হওয়া প্রয়োজন যাতে অতিরিক্ত প্রবাহে দ্রুত গলে যায়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion175" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG09",
    "question": "ওয়াশিং সোডা বা কাপড় কাচার সোডার রাসায়নিক সংকেত কোনটি?",
    "option1": "Na2CO3.10H2O",
    "option2": "NaHCO3",
    "option3": "CaOCl2",
    "option4": "CuSO4.5H2O",
    "answer": "option1",
    "solution": "কাপড় কাচার সোডার রাসায়নিক নাম হলো সোডিয়াম কার্বোনেট ডেকাহাইড্রেট (Na2CO3.10H2O)।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion176" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG09",
    "question": "আকাশ নীল দেখায় আলোর কোন ধর্মের জন্য?",
    "option1": "প্রতিফলন",
    "option2": "প্রতিসরণ",
    "option3": "বিক্ষিপণ (Scattering)",
    "option4": "ব্যতিচার",
    "answer": "option3",
    "solution": "বায়ুমণ্ডলের সূক্ষ্ম ধূলিকণা দ্বারা কম তরঙ্গদৈর্ঘ্যের নীল আলোর বিক্ষেপণ (Scattering) সবচেয়ে বেশি হওয়ায় আকাশ নীল দেখায়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion177" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG09",
    "question": "রসায়নে 'কাস্টিক সোডা' (Caustic Soda)-র রাসায়নিক সংকেত কী?",
    "option1": "KOH",
    "option2": "NaOH",
    "option3": "Ca(OH)2",
    "option4": "NH4OH",
    "answer": "option2",
    "solution": "সোডিয়াম হাইড্রক্সাইড (NaOH)-কে সাধারণ পরিভাষায় কাস্টিক সোডা বলা হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion178" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG09",
    "question": "কোনো পরিবাহীর বিভব প্রভেদ (V) ও প্রবাহমাত্রার (I) সম্পর্ক নির্দেশক ওহমের সূত্র কোনটি?",
    "option1": "V = I / R",
    "option2": "V = IR",
    "option3": "I = VR",
    "option4": "R = VI",
    "answer": "option2",
    "solution": "ওহমের সূত্র অনুযায়ী নির্দিষ্ট উষ্ণতায় বিভব প্রভেদ (V) = প্রবাহমাত্রা (I) × রোধ (R)।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion179" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG09",
    "question": "'ব্লিসিং পাউডার' (Bleaching Powder)-এর রাসায়নিক নাম ও সংকেত কী?",
    "option1": "ক্যালসিয়াম হাইপোক্লোরাইড [CaOCl2]",
    "option2": "ক্যালসিয়াম কার্বোনেট [CaCO3]",
    "option3": "ক্যালসিয়াম সালফেট [CaSO4]",
    "option4": "ক্যালসিয়াম অক্সাইড [CaO]",
    "answer": "option1",
    "solution": "ব্লিসিং পাউডারের রাসায়নিক নাম ক্যালসিয়াম ক্লোরোহাইপোক্লোরাইড বা ক্যালসিয়াম হাইপোক্লোরাইড এবং সংকেত CaOCl(Cl) বা CaOCl2।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion180" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG09",
    "question": "কোনো বস্তুর উপর আলো পড়লে তা থেকে প্রতিফলিত আলো চোখে পৌঁছালে বস্তুটি দৃশ্যমান হয়। কিন্তু কাঁচের মধ্য দিয়ে আলো যাওয়ার ঘটনাকে কী বলে?",
    "option1": "প্রতিফলন",
    "option2": "প্রতিসরণ (Refraction)",
    "option3": "বিচ্ছুরণ",
    "option4": "শোষণ",
    "answer": "option2",
    "solution": "আলো যখন এক স্বচ্ছ মাধ্যম থেকে অন্য স্বচ্ছ মাধ্যমে প্রবেশ করে, তখন গতিপথের পরিবর্তনের ঘটনাকে আলোর প্রতিসরণ বলে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion181" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG10",
    "question": "রবীন্দ্রনাথ ঠাকুর কত সালে এবং কোন কাব্যগ্রন্থের জন্য নোবেল পুরস্কার পেয়েছিলেন?",
    "option1": "১৯১১ - গীতাঞ্জলি",
    "option2": "১৯১৩ - গীতাঞ্জলি",
    "option3": "১৯১৫ - বলাকা",
    "option4": "১৯১৩ - সোনার তরী",
    "answer": "option2",
    "solution": "রবীন্দ্রনাথ ঠাকুর ১৯১৩ সালে তাঁর 'গীতাঞ্জলি' (Gitanjali) কাব্যগ্রন্থের ইংরেজি অনুবাদের জন্য সাহিত্যে নোবেল পুরস্কার লাভ করেন। তিনি ছিলেন এশিয়ার প্রথম নোবেল বিজয়ী।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion182" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG10",
    "question": "প্রথম ভারতরত্ন পুরস্কার কত সালে প্রদান করা হয়েছিল?",
    "option1": "১৯৫০ সালে",
    "option2": "১৯৫২ সালে",
    "option3": "১৯৫৪ সালে",
    "option4": "১৯৫৬ সালে",
    "answer": "option3",
    "solution": "১৯৫৪ সালে ভারতের সর্বোচ্চ অসামরিক সম্মান 'ভারতরত্ন' চালু হয়। প্রথম বছর ড. সর্বপল্লী রাধাকৃষ্ণন, সি. রাজাগোপালাচারী এবং সি. ভি. রমন এই সম্মান পান।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion183" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG10",
    "question": "প্রথম ভারতীয় হিসেবে কে চলচ্চিত্রজগতের মর্যাদাপূর্ণ অস্কার (Oscar) পুরস্কার অর্জন করেন?",
    "option1": "সত্যজিৎ রায়",
    "option2": "ভানুমতী অাথাইয়া (Bhanu Athaiya)",
    "option3": "এ আর রহমান",
    "option4": "রেসুল পুকুট্টি",
    "answer": "option2",
    "solution": "১৯৮২ সালে 'গান্ধী' চলচ্চিত্রে সেরা কস্টিউম ডিজাইনের জন্য ভানু আথাইয়া প্রথম ভারতীয় হিসেবে অস্কার লাভ করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion184" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG10",
    "question": "ভারতের সাহিত্য জগতের সর্বোচ্চ সম্মান কোনটি?",
    "option1": "সাহিত্য একাডেমি পুরস্কার",
    "option2": "জ্ঞানপীঠ পুরস্কার (Jnanpith Award)",
    "option3": "সরস্বতী সম্মান",
    "option4": "ব্যাস সম্মান",
    "answer": "option2",
    "solution": "জ্ঞানপীঠ পুরস্কার হলো ভারতের সাহিত্যের ক্ষেত্রে প্রদান করা সর্বোচ্চ মর্যাদাপূর্ণ সাহিত্য সম্মান।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion185" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG10",
    "question": "প্রথম জ্ঞানপীঠ পুরস্কার বিজয়ী সাহিত্যিক কে ছিলেন?",
    "option1": "জি শঙ্কর গুরুপ (G. Sankara Kurup)",
    "option2": "তারাশঙ্কর বন্দ্যোপাধ্যায়",
    "option3": "আশাপূর্ণা দেবী",
    "option4": "উমাশঙ্কর জোশী",
    "answer": "option1",
    "solution": "১৯৬৫ সালে মালয়ালম ভাষার কবি জি শঙ্কর গুরুপ প্রথম জ্ঞানপীঠ পুরস্কার লাভ করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion186" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG10",
    "question": "প্রথম কোন মহিলা জ্ঞানপীঠ পুরস্কার পেয়েছিলেন?",
    "option1": "মহাশ্বেতা দেবী",
    "option2": "আশাপূর্ণা দেবী",
    "option3": "অমৃতা প্রীতম",
    "option4": "মহাদেবী বর্মা",
    "answer": "option2",
    "solution": "১৯৭৬ সালে বিশিষ্ট বাঙালি লেখিকা আশাপূর্ণা দেবী তাঁর 'প্রথম প্রতিশ্রুতি' উপন্যাসের জন্য প্রথম মহিলা হিসেবে জ্ঞানপীঠ পুরস্কার পান।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion187" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG10",
    "question": "অর্থনীতিতে নোবেল পুরস্কার লাভকারী প্রথম ভারতীয় (তথা এশীয়) কে?",
    "option1": "অভিজিৎ বন্দ্যোপাধ্যায়",
    "option2": "অমর্ত্য সেন",
    "option3": "মনমোহন সিং",
    "option4": "রঘুরান রাজন",
    "answer": "option2",
    "solution": "ড. অমর্ত্য সেন ১৯৯৮ সালে জনকল্যাণমূলক অর্থনীতিতে (Welfare Economics) অবদানের জন্য অর্থনীতিতে নোবেল পুরস্কার পান।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion188" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG10",
    "question": "বিজ্ঞানে রমন ক্রিয়ার (Raman Effect) আবিষ্কারের জন্য স্যার সি. ভি. রমন কত সালে পদার্থবিদ্যায় নোবেল পান?",
    "option1": "১৯২৮ সালে",
    "option2": "১৯৩০ সালে",
    "option3": "১৯৩৪ সালে",
    "option4": "১৯৪২ সালে",
    "answer": "option2",
    "solution": "১৯৩০ সালে স্যার সি. ভি. রমন প্রথম ভারতীয় বিজ্ঞানী হিসেবে পদার্থবিজ্ঞানে নোবেল পুরস্কার পান।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion189" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG10",
    "question": "ভারতের সর্বোচ্চ ক্রীড়া সম্মান 'মেজর ধ্যানচাঁদ খেলরত্ন' (পূর্বনাম রাজীব গান্ধী খেলরত্ন) প্রথম কে পেয়েছিলেন?",
    "option1": "শচীন তেন্ডুলকর",
    "option2": "বিশ্বনাথন আনন্দ",
    "option3": "কপিল দেব",
    "option4": "লিঅ্যান্ডার পেজ",
    "answer": "option2",
    "solution": "১৯৯১-৯২ সালে দাবা গ্র্যান্ডমাস্টার বিশ্বনাথন আনন্দ প্রথম খেলরত্ন পুরস্কার লাভ করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion190" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG10",
    "question": "চলচ্চিত্র ক্ষেত্রে ভারতের সর্বোচ্চ জাতীয় পুরস্কার কোনটি?",
    "option1": "ফিল্মফেয়ার পুরস্কার",
    "option2": "দাদাসাহেব ফালকে পুরস্কার",
    "option3": "জাতীয় চলচ্চিত্র পুরস্কার",
    "option4": "আইফা (IIFA) পুরস্কার",
    "answer": "option2",
    "solution": "ভারতীয় চলচ্চিত্রে আজীবন অসামান্য অবদানের জন্য দেওয়া 'দাদাসাহেব ফালকে পুরস্কার' হলো সিনেমা জগতের সর্বোচ্চ সরকারি সম্মান।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion191" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG10",
    "question": "প্রথম দাদাসাহেব ফালকে পুরস্কারে কাকে ভূষিত করা হয়েছিল?",
    "option1": "দেবিকা রানী",
    "option2": "পৃথ্বীরাজ কাপুর",
    "option3": "কানন দেবী",
    "option4": "সত্যজিৎ রায়",
    "answer": "option1",
    "solution": "১৯৬৯ সালে প্রথম দাদাসাহেব ফালকে পুরস্কার লাভ করেন অভিনেত্রী দেবিকা রানী।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion192" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG10",
    "question": "মরণোত্তর প্রথম ভারতরত্ন সম্মান কাকে দেওয়া হয়েছিল?",
    "option1": "সরদার বল্লভভাই প্যাটেল",
    "option2": "লাল বাহাদুর শাস্ত্রী",
    "option3": "কে. কামরাজ",
    "option4": "ড. বি. আর. আম্বেদকর",
    "answer": "option2",
    "solution": "১৯৬৬ সালে ভারতের সাবেক প্রধানমন্ত্রী লাল বাহাদুর শাস্ত্রীকে প্রথম মরণোত্তর ভারতরত্ন সম্মানে ভূষিত করা হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion193" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG10",
    "question": "শান্তির জন্য নোবেল পুরস্কার ভারতের কোন সংস্থা বা ব্যক্তি প্রথম পেয়েছিলেন?",
    "option1": "কৈলাশ সত্যার্থী",
    "option2": "মাদার তেরেসা",
    "option3": "মহাত্মা গান্ধী",
    "option4": "ডা. আবদুস সালাম",
    "answer": "option2",
    "solution": "১৯৭৯ সালে আর্ত ও মানবতার সেবায় অবদানের জন্য মাদার তেরেসা প্রথম শান্তির নোবেল পুরস্কার লাভ করেন।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion194" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG10",
    "question": "বিজ্ঞান ও প্রযুক্তির ক্ষেত্রে অবদানের জন্য ভারতে কোন মর্যাদাপূর্ণ পুরস্কার প্রদান করা হয়?",
    "option1": "শান্তিস্বরূপ ভাটনাগর পুরস্কার",
    "option2": "ধনবন্তরী পুরস্কার",
    "option3": "বোরলগ পুরস্কার",
    "option4": "কালিঙ্গ পুরস্কার",
    "answer": "option1",
    "solution": "CSIR দ্বারা প্রদত্ত 'শান্তিস্বরূপ ভাটনাগর পুরস্কার' ভারতের বিজ্ঞান ও প্রযুক্তি ক্ষেত্রের অন্যতম শীর্ষ সম্মান।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion195" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG10",
    "question": "প্রথম বিদেশী হিসেবে কাকে ভারতের সর্বোচ্চ সম্মান 'ভারতরত্ন' দেওয়া হয়েছিল?",
    "option1": "নেেলসন ম্যান্ডেলা",
    "option2": "খান আব্দুল গফফর খান",
    "option3": "মার্টিন লুথার কিং",
    "option4": "মাদার তেরেসা",
    "answer": "option2",
    "solution": "১৯৮৭ সালে 'সীমান্ত গান্ধী' নামে পরিচিত পাকিস্তানের খান আব্দুল গফফর খান প্রথম বিদেশী হিসেবে ভারতরত্ন পান (পরবর্তীতে ১৯৯০ সালে নেলসন ম্যান্ডেলা পান)।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion196" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG10",
    "question": "সাংবাদিকতা ও সাহিত্যের আন্তর্জাতিক ক্ষেত্রে বিশ্বখ্যাত 'পুলিৎজার পুরস্কার' (Pulitzer Prize) কোন দেশ প্রদান করে?",
    "option1": "যুক্তরাজ্য (UK)",
    "option2": "আমেরিকার যুক্তরাষ্ট্র (USA)",
    "option3": "সুইডেন",
    "option4": "ফ্রান্স",
    "answer": "option2",
    "solution": "সাংবাদিকতা, সাহিত্য ও সংগীতের ক্ষেত্রে কৃতিত্বের জন্য ১৯১৭ সাল থেকে মার্কিন যুক্তরাষ্ট্র পুলিৎজার পুরস্কার প্রদান করে আসছে।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion197" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG10",
    "question": "সাহিত্যে অবদানের জন্য 'বাংলা সাহিত্য একাডেমি পুরস্কার' প্রথম কত সালে প্রবর্তিত হয়েছিল?",
    "option1": "১৯৫৪ সালে",
    "option2": "১৯৫৫ সালে",
    "option3": "১৯৬০ সালে",
    "option4": "১৯৬২ সালে",
    "answer": "option2",
    "solution": "কেন্দ্রীয় সাহিত্য একাডেমি ১৯৫৫ সাল থেকে প্রতি বছর স্বীকৃত ২৪টি ভাষার বিশিষ্ট সাহিত্যকর্মের জন্য সাহিত্য একাডেমি পুরস্কার দিয়ে আসছে (প্রথম বাংলা পুরস্কৃত বই: জীবনানন্দ দাশের 'শ্রেষ্ঠ কবিতা')।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion198" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG10",
    "question": "বাংলা সাহিত্যে অবদানের জন্য 'রবীন্দ্র পুরস্কার' পশ্চিমবঙ্গ সরকার প্রথম কত সালে প্রদান শুরু করে?",
    "option1": "১৯৪৮ সালে",
    "option2": "১৯৫০ সালে",
    "option3": "১৯৫২ সালে",
    "option4": "১৯৫৫ সালে",
    "answer": "option2",
    "solution": "১৯৫০ সালে পশ্চিমবঙ্গ সরকার রবীন্দ্র পুরস্কার চালু করে। প্রথম বছর সতীন সেনগুপ্ত, নিহাররঞ্জন রায় ও সতী his (সতীন সেননাথ)-কে পুরস্কৃত করা হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion199" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG10",
    "question": "ক্রীড়া প্রশিক্ষক বা কোচদের অসামান্য অবদানের জন্য ভারত সরকার কোন পুরস্কার প্রদান করে?",
    "option1": "অর্জুন পুরস্কার",
    "option2": "দ্রোণাচার্য পুরস্কার",
    "option3": "ধ্যানচাঁদ পুরস্কার",
    "option4": "খেলরত্ন পুরস্কার",
    "answer": "option2",
    "solution": "১৯৮৫ সাল থেকে সফল ক্রীড়া প্রশিক্ষক (Coach)-দের সম্মান জানাতে 'দ্রোণাচার্য পুরস্কার' দেওয়া হয়।"
  },
  {
    "_id": { "$oid": "gkmocktestquestion200" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG200",
    "question": "বিশ্বের সবচেয়ে সম্মানজনক 'নোবেল পুরস্কার' কয়টি ক্ষেত্রে প্রদান করা হয়?",
    "option1": "৫টি",
    "option2": "৬টি",
    "option3": "৭টি",
    "option4": "৮টি",
    "answer": "option2",
    "solution": "পদার্থবিজ্ঞান, রসায়ন, চিকিৎসা, সাহিত্য, শান্তি এবং অর্থনীতি—এই মোট ৬টি বিভাগে নোবেল পুরস্কার দেওয়া হয়।"
  },






  
{/*
        {
    "_id": { "$oid": "gkmocktestquestion01" },
    "type": "mocktest",
    "subject": "gk",
    "topic": "CG01",
    "question": "",
    "option1": "",
    "option2": "",
    "option3": "",
    "option4": "",
    "answer": "option3",
    "solution": ""
  },
     
  */}

  




];

export default AllQuestions;